webpackJsonp([93],{

/***/ "++vR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingSquareSpinner_vue__ = __webpack_require__("6oYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_001b5612_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingSquareSpinner_vue__ = __webpack_require__("M7H8");
function injectStyle (ssrContext) {
  __webpack_require__("Dt+F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-001b5612"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingSquareSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_001b5612_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingSquareSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "+2Jl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+H61":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+N1L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Message = __webpack_require__("PFUe");

var _Message2 = _interopRequireDefault(_Message);

var _chatIcon = __webpack_require__("d1QR");

var _chatIcon2 = _interopRequireDefault(_chatIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Message: _Message2.default
  },
  props: {
    participants: {
      type: Array,
      required: true
    },
    messages: {
      type: Array,
      required: true
    },
    showTypingIndicator: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    alwaysScrollToBottom: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    _scrollDown: function _scrollDown() {
      this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight;
    },
    shouldScrollToBottom: function shouldScrollToBottom() {
      return this.alwaysScrollToBottom || this.$refs.scrollList.scrollTop > this.$refs.scrollList.scrollHeight - 600;
    },
    profile: function profile(author) {
      var profile = this.participants.find(function (profile) {
        return profile.id === author;
      });

      return profile || { imageUrl: '', name: '' };
    },
    chatImageUrl: function chatImageUrl(author) {
      return this.profile(author).imageUrl;
    },
    authorName: function authorName(author) {
      return this.profile(author).name;
    }
  },
  computed: {
    defaultChatIcon: function defaultChatIcon() {
      return _chatIcon2.default;
    }
  },
  mounted: function mounted() {
    this._scrollDown();
  },
  updated: function updated() {
    if (this.shouldScrollToBottom()) this.$nextTick(this._scrollDown());
  }
};

/***/ }),

/***/ "+S+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Doughnut"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], _this.defaultOptions, _this.options);
      _this.renderChart(_this.data, options);
    }, 600);
  }
}));

/***/ }),

/***/ "+UQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["HorizontalBar"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], _this.defaultOptions, _this.options);
      _this.renderChart(_this.data, options);
    }, 600);
  }
}));

/***/ }),

/***/ "+Uuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChart_vue__ = __webpack_require__("b6wd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b619d4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChart_vue__ = __webpack_require__("tgT1");
function injectStyle (ssrContext) {
  __webpack_require__("+Z7i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b619d4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+XJn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tag',
  data: function data() {
    return {
      deleted: false
    };
  },

  props: {
    name: {
      type: String
    },
    removable: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    tagClass: function tagClass() {
      return 'vuestic-tag-' + this.type + ' ' + (this.deleted ? 'vuestic-tag-deleted' : '');
    }
  },
  methods: {
    remove: function remove() {
      var _this = this;

      this.deleted = true;
      setTimeout(function () {
        _this.$emit('remove');
        _this.deleted = false;
      }, 500);
    }
  }
});

/***/ }),

/***/ "+Z7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+s3s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BreedingRhombusSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 150
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'breeding-rhombus-spinner-animation-child',
      rhombusesNum: 8
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.size / 7.5 + 'px',
        width: this.size / 7.5 + 'px',
        animationDuration: this.animationDuration + 'ms',
        top: this.size / 2.3077 + 'px',
        left: this.size / 2.3077 + 'px',
        backgroundColor: this.color
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        rhombusesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * (i + 1) + 'ms'
        }, this.rhombusStyle));
      }

      return rhombusesStyles;
    },
    bigRhombusStyle: function bigRhombusStyle() {
      return {
        height: this.size / 3 + 'px',
        width: this.size / 3 + 'px',
        animationDuration: '' + this.animationDuration,
        top: this.size / 3 + 'px',
        left: this.size / 3 + 'px',
        backgroundColor: this.color
      };
    }
  }

});

/***/ }),

/***/ "+vGB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/+s4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-mail",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Mail");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "/7ZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue__ = __webpack_require__("x2GM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f0094b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticScrollbar_vue__ = __webpack_require__("wXxr");
function injectStyle (ssrContext) {
  __webpack_require__("IXhG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f0094b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticScrollbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/Djh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalFind_vue__ = __webpack_require__("0A8z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46159d19_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalFind_vue__ = __webpack_require__("7/Sj");
function injectStyle (ssrContext) {
  __webpack_require__("NO4k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalFind_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46159d19_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalFind_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/LRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleSelect_vue__ = __webpack_require__("vE+0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ccba90a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleSelect_vue__ = __webpack_require__("xS68");
function injectStyle (ssrContext) {
  __webpack_require__("XZgk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ccba90a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/QL9":
/***/ (function(module, exports) {

module.exports = [{"x":0,"y":0},{"x":8,"y":12},{"x":16,"y":24},{"x":24,"y":36},{"x":32,"y":48},{"x":40,"y":60},{"x":48,"y":72},{"x":60,"y":84},{"x":72,"y":72},{"x":80,"y":60},{"x":88,"y":48},{"x":96,"y":36},{"x":104,"y":24},{"x":112,"y":12},{"x":120,"y":0},{"x":104,"y":0},{"x":88,"y":0},{"x":80,"y":12},{"x":72,"y":24},{"x":60,"y":36},{"x":48,"y":24},{"x":40,"y":10},{"x":32,"y":0},{"x":16,"y":0}]

/***/ }),

/***/ "/UaH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/WYu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0A8z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-find",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    data_length: {
      type: Number,
      default: 0
    },
    data_pid: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      pid: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Push", this.pid);
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "0GMg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleVerticalIndicator_vue__ = __webpack_require__("kT3b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_161a4e73_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleVerticalIndicator_vue__ = __webpack_require__("LIyU");
function injectStyle (ssrContext) {
  __webpack_require__("EGJn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-161a4e73"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleVerticalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_161a4e73_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleVerticalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0GYU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fingerprint-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.ringsStyles),function(rs,index){return _c('div',{key:index,staticClass:"spinner-ring",style:(rs)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Hnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-chat-window",class:{opened: _vm.isOpen, closed: !_vm.isOpen}},[_c('Zaglavlje',{attrs:{"title":_vm.title,"imageUrl":_vm.titleImageUrl,"onClose":_vm.onClose,"colors":_vm.colors},on:{"userList":_vm.handleUserListToggle}}),_vm._v(" "),(_vm.showUserList)?_c('UserList',{attrs:{"participants":_vm.participants}}):_vm._e(),_vm._v(" "),(!_vm.showUserList)?_c('MessageList',{attrs:{"messages":_vm.messages,"participants":_vm.participants,"showTypingIndicator":_vm.showTypingIndicator,"colors":_vm.colors,"alwaysScrollToBottom":_vm.alwaysScrollToBottom}}):_vm._e(),_vm._v(" "),(!_vm.showUserList)?_c('UserInput',{attrs:{"showEmoji":_vm.showEmoji,"onSubmit":_vm.onUserInputSubmit,"showFile":_vm.showFile,"placeholder":_vm.placeholder,"colors":_vm.colors}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Ohc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmojiPicker = __webpack_require__("ThK4");

var _EmojiPicker2 = _interopRequireDefault(_EmojiPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    EmojiPicker: _EmojiPicker2.default
  },
  data: function data() {
    return {
      isActive: false
    };
  },

  props: {
    onEmojiPicked: {
      type: Function,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  methods: {
    _openPicker: function _openPicker(e) {
      this.isActive = !this.isActive;
    },
    _handlePickerBlur: function _handlePickerBlur() {
      this.isActive = false;
    }
  }
};

/***/ }),

/***/ "0Zwo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalTrash_vue__ = __webpack_require__("fsNc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_334d5a7d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalTrash_vue__ = __webpack_require__("aemv");
function injectStyle (ssrContext) {
  __webpack_require__("Exjh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalTrash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_334d5a7d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalTrash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0jj4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{'vuestic-collapse__header--no-header': _vm.noHeader},on:{"click":function($event){_vm.emitHeader($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{class:{'vuestic-collapse__header__button btn btn-primary' : _vm.odobren, 
    'vuestic-collapse__header__button btn btn-warning': _vm.u_obradi,
    'vuestic-collapse__header__button btn btn-danger': _vm.zaprimljen,
    'vuestic-collapse__header__button btn btn-info': _vm.realizovan}},[_vm._t("header"),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px"},attrs:{"id":_vm.id}},[_vm._v(_vm._s(' | ')+_vm._s(_vm.status))]),_vm._v(" "),_c('div',{staticClass:"col-md-7 pull-right"},[(_vm.show && _vm.vise && (_vm.zaprimljen || _vm.u_obradi || _vm.realizovan))?_c('span',[_c('i',{staticClass:"fa fa-forward fa-lg icon-left wizard-back pull-left",attrs:{"title":"Više opcija","id":"forward"}})]):_vm._e(),_vm._v(" "),(_vm.show && !_vm.vise && (_vm.zaprimljen || _vm.u_obradi || _vm.realizovan))?_c('span',[_c('i',{staticClass:"fa fa-trash fa-lg icon-left wizard-back pull-left",attrs:{"title":"Obrišite uzorak","id":"trash"}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}}),_vm._v(" "),(_vm.show && !_vm.vise && (_vm.zaprimljen || _vm.u_obradi || _vm.realizovan))?_c('span',[_c('i',{staticClass:"fa fa-edit fa-lg icon-left wizard-back pull-left",attrs:{"title":"Uredite uzorak","id":"plus"}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}}),_vm._v(" "),(_vm.show && !_vm.vise && (_vm.zaprimljen || _vm.u_obradi || _vm.realizovan))?_c('span',[_c('i',{staticClass:"fa fa-commenting fa-lg icon-left wizard-back pull-left",attrs:{"title":"Unesite komentar","id":"commenting"}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}}),_vm._v(" "),(_vm.show && !_vm.vise && (_vm.zaprimljen || _vm.u_obradi || _vm.realizovan))?_c('span',[_c('i',{staticClass:"fa fa-barcode fa-lg icon-left wizard-back pull-left",attrs:{"title":"Printajte naljepnicu","id":"barcode"}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}}),_vm._v(" "),(_vm.show && !_vm.vise && (_vm.zaprimljen || _vm.u_obradi || _vm.realizovan))?_c('span',[_c('i',{staticClass:"fa fa-step-backward fa-lg icon-left wizard-back pull-left",attrs:{"title":"Zatvorite izbornik","id":"step-backward"}})]):_vm._e(),_vm._v(" "),(_vm.show && !_vm.odobren)?_c('span',[_c('i',{staticClass:"fa fa-check fa-lg icon-right wizard-back pull-right",attrs:{"title":"Odobrite rezultate","id":"check"}})]):_vm._e(),_vm._v(" "),(_vm.show && _vm.odobren)?_c('span',[_c('i',{staticClass:"fa fa-undo fa-lg icon-right wizard-back pull-right",attrs:{"title":"Vratite u rad","id":"undo"}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"col-md-3 pull-right",staticStyle:{"diplay":"inline-block","width":"25px"}}),_vm._v(" "),(_vm.show && _vm.odobren)?_c('span',[_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"color":"#f7cc36"},attrs:{"title":"Verifikacija nalaza","id":"file"}})]):_vm._e(),_vm._v(" "),(_vm.show && (_vm.zaprimljen || _vm.u_obradi || _vm.realizovan))?_c('span',[_c('i',{staticClass:"fa fa-save fa-lg icon-right wizard-back pull-right",attrs:{"title":"Sačuvajte izmjene","id":"save"}})]):_vm._e()])],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0umV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "11Ui":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1893":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'square-with-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "1Z18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"form-group dropdown"},[_c('button',{class:{'btn btn-primary btn-sm dropdown-toggle' : _vm.range_max === '',
    'btn btn-pale btn-sm dropdown-toggle' : _vm.range_max != ''
    },attrs:{"id":"itemsPerPageBtn","type":"button","disabled":false,"data-toggle":"dropdown"}},[_vm._v("\n    "+_vm._s(_vm.selected)+"\n    "),_c('i',{staticClass:"ion-ios-arrow-down arrow-down"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('a',{key:option.value,staticClass:"dropdown-item",on:{"click":function($event){_vm.selectedItemsPerPage(option.value)}}},[_vm._v(_vm._s(option.value))])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1ZnP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-modal-m',
  props: {
    transition: {
      type: String,
      default: 'modal'
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: 'POTVRDI'
    },
    cancelText: {
      type: String,
      default: 'ODUSTANI'
    },
    okClass: {
      type: String,
      default: 'btn btn-primary'
    },
    cancelClass: {
      type: String,
      default: 'btn btn-secondary'
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        'modal-lg': this.large,
        'modal-sm': this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += ' modal-open';
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, '');
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += ' modal-open';
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, '');
        }, this.duration);
      }
    }
  },
  methods: {
    ok: function ok() {
      this.$emit('ok');
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('yes', true);
      this.show = false;
    },
    cancel: function cancel() {
      this.$emit('cancel');
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('no', false);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('viseNo', false);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('viseKo', false);
      this.show = false;
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
    }
  }
});

/***/ }),

/***/ "1q7j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmojiIcon = __webpack_require__("kEJf");

var _EmojiIcon2 = _interopRequireDefault(_EmojiIcon);

var _FileIcons = __webpack_require__("aCP/");

var _FileIcons2 = _interopRequireDefault(_FileIcons);

var _SendIcon = __webpack_require__("7cnT");

var _SendIcon2 = _interopRequireDefault(_SendIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    EmojiIcon: _EmojiIcon2.default,
    FileIcons: _FileIcons2.default,
    SendIcon: _SendIcon2.default
  },
  props: {
    showEmoji: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    showFile: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    onSubmit: {
      type: Function,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Write a reply'
    },
    colors: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      file: null,
      inputActive: false
    };
  },

  methods: {
    cancelFile: function cancelFile() {
      this.file = null;
    },
    setInputActive: function setInputActive(onoff) {
      this.inputActive = onoff;
    },
    handleKey: function handleKey(event) {
      if (event.keyCode === 13 && !event.shiftKey) {
        this._submitText(event);
        event.preventDefault();
      }
    },
    _submitText: function _submitText(event) {
      var text = this.$refs.userInput.textContent;
      var file = this.file;
      if (file) {
        if (text && text.length > 0) {
          this.onSubmit({
            author: 'me',
            type: 'file',
            data: { text: text, file: file }
          });
          this.file = null;
          this.$refs.userInput.innerHTML = '';
        } else {
          this.onSubmit({
            author: 'me',
            type: 'file',
            data: { file: file }
          });
          this.file = null;
        }
      } else {
        if (text && text.length > 0) {
          this.onSubmit({
            author: 'me',
            type: 'text',
            data: { text: text }
          });
          this.$refs.userInput.innerHTML = '';
        }
      }
    },
    _handleEmojiPicked: function _handleEmojiPicked(emoji) {
      this.onSubmit({
        author: 'me',
        type: 'emoji',
        data: { emoji: emoji }
      });
    },
    _handleFileSubmit: function _handleFileSubmit(file) {
      this.file = file;
    }
  }
};

/***/ }),

/***/ "1wn0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
// Local Host Setup

// import axios from "axios";
// export const http = axios.create({ baseURL: "http://localhost:5009/" });
// export const apiUrl = "http://localhost:5009/uzorci/list/";
// export const apiUrlsve = "http://localhost:5009/uzorci/listsve/";
// export const apiUrlRez = "http://localhost:5009/rezultati/list/";
// export const apiUrlRezsve = "http://localhost:5009/rezultati/listsve/";
// export const apiUrloRez = "http://localhost:5009/rezultati/olist/";
// export const apiUrloRezsve = "http://localhost:5009/rezultati/olistsve/";
// export const apiUrlObrada = "http://localhost:5009/rezultati/nalazi/table/";
// export const apiUrlKont = "http://localhost:5009/kontrole/list";
// export const apiUrlPatient = "http://localhost:5009/pacijenti/detalji/";
// export const apiUrlNal = "http://localhost:5009/nalazi/list";
// export const apiUrlNalPre = "http://localhost:5009/nalazi/pregled";
// export const apiUrlOutbox = "http://localhost:5009/nalazi/outbox";
// export const apiUrlRac = "http://localhost:5009/uzorci/racuni/";
// export const barcode = "http://localhost:5009/images/barcodes/";
// export const server = "http://localhost:5009/";
// export const serverSocket = "http://localhost:5009/";

// Server Setup


const http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({ baseURL: "https://muminovic.atom-lis.com/" });
/* harmony export (immutable) */ __webpack_exports__["o"] = http;

const apiUrl = "https://muminovic.atom-lis.com/uzorci/list/";
/* harmony export (immutable) */ __webpack_exports__["a"] = apiUrl;

const apiUrlsve = "https://muminovic.atom-lis.com/uzorci/listsve/";
/* harmony export (immutable) */ __webpack_exports__["m"] = apiUrlsve;

const apiUrlRez = "https://muminovic.atom-lis.com/rezultati/list/";
/* harmony export (immutable) */ __webpack_exports__["i"] = apiUrlRez;

const apiUrlRezsve = "https://muminovic.atom-lis.com/rezultati/listsve/";
/* harmony export (immutable) */ __webpack_exports__["j"] = apiUrlRezsve;

const apiUrloRez = "https://muminovic.atom-lis.com/rezultati/olist/";
/* harmony export (immutable) */ __webpack_exports__["k"] = apiUrloRez;

const apiUrloRezsve = "https://muminovic.atom-lis.com/rezultati/olistsve/";
/* harmony export (immutable) */ __webpack_exports__["l"] = apiUrloRezsve;

const apiUrlObrada = "https://muminovic.atom-lis.com/rezultati/nalazi/table/";
/* harmony export (immutable) */ __webpack_exports__["e"] = apiUrlObrada;

const apiUrlKont = "https://muminovic.atom-lis.com/kontrole/list";
/* harmony export (immutable) */ __webpack_exports__["b"] = apiUrlKont;

const apiUrlPatient = "https://muminovic.atom-lis.com/pacijenti/detalji/";
/* harmony export (immutable) */ __webpack_exports__["g"] = apiUrlPatient;

const apiUrlNal = "https://muminovic.atom-lis.com/nalazi/list";
/* harmony export (immutable) */ __webpack_exports__["c"] = apiUrlNal;

const apiUrlNalPre = "https://muminovic.atom-lis.com/nalazi/pregled";
/* harmony export (immutable) */ __webpack_exports__["d"] = apiUrlNalPre;

const apiUrlOutbox = "https://muminovic.atom-lis.com/nalazi/outbox";
/* harmony export (immutable) */ __webpack_exports__["f"] = apiUrlOutbox;

const apiUrlRac = "https://muminovic.atom-lis.com/uzorci/racuni/";
/* harmony export (immutable) */ __webpack_exports__["h"] = apiUrlRac;

const barcode = "https://muminovic.atom-lis.com/images/barcodes/";
/* harmony export (immutable) */ __webpack_exports__["n"] = barcode;

const server = "https://muminovic.atom-lis.com/";
/* harmony export (immutable) */ __webpack_exports__["p"] = server;

const serverSocket = "https://muminovic.atom-lis.com/";
/* harmony export (immutable) */ __webpack_exports__["q"] = serverSocket;


/***/ }),

/***/ "2653":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCheckbox_vue__ = __webpack_require__("KzHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f1f4d75_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCheckbox_vue__ = __webpack_require__("Zjk8");
function injectStyle (ssrContext) {
  __webpack_require__("wK+U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f1f4d75_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "26I1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "27W7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "27rI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "opste-postavke",
  meta: {
    expanded: false,
    title: "Opšte postavke",
    iconClass: "vuestic-icon vuestic-icon-settings"
  },

  children: [{
    name: "lokacije",
    path: "/postavke/lokacije",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("postavke/lokacije/Lokacije"),
    meta: {
      title: "Lokacije",
      requiredAuth: true
    }
  }, {
    name: "doktori",
    path: "/postavke/doktori",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("postavke/doktori/Doktori"),
    meta: {
      title: "Doktori",
      requiredAuth: true
    }
  }, {
    name: "mjesta2",
    path: "/postavke/mjesta2",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("postavke/mjesta/Mjesta"),
    meta: {
      title: "Mjesta",
      requiredAuth: true
    }
  }, {
    name: "sekcije",
    path: "/postavke/sekcije",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("postavke/sekcije/Sekcije"),
    meta: {
      title: "Sekcije",
      requiredAuth: true
    }
  }, {
    name: "generalno",
    path: "/postavke/generalno",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("postavke/generalno/Generalno"),
    meta: {
      title: "Generalno",
      requiredAuth: true
    }
  }, {
    name: "paneli",
    path: "/postavke/paneli",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("postavke/paneli/Paneli"),
    meta: {
      title: "Paneli",
      requiredAuth: true
    }
  }, {
    name: "sajtovi",
    path: "/postavke/sites",
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("postavke/sites/Sites"),
    meta: {
      title: "Sites",
      requiredAuth: true
    }
  }]
});

/***/ }),

/***/ "2AFO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{
      'vuestic-collapse__header--no-header': _vm.noHeader,
    },on:{"click":function($event){_vm.onHeaderClick()}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{staticClass:"vuestic-collapse__header__button btn btn-primary",staticStyle:{"height":"40px","padding-top":"0.6rem"}},[_vm._t("header"),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(' | ')+_vm._s(_vm.godiste))]),_vm._v(" "),(!isNaN(_vm.cijena) && _vm.cijena > 0)?_c('div',{staticClass:"col-md-2 pull-right"},[_c('span',{staticStyle:{"text-align":"right","padding-top":"0"}},[_vm._v("\n          "+_vm._s(_vm.cijena)+"\n          "),_c('sup',[_vm._v("BAM")])])]):_vm._e(),_vm._v(" "),_vm._m(0)],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 pull-right"},[_c('span',{staticStyle:{"text-align":"right","padding-top":"0"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Bcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CirclesToRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    circleSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    },
    circlesNum: {
      type: Number,
      default: 3
    }
  },

  computed: {
    circleMarginLeft: function circleMarginLeft() {
      return this.circleSize * 1.125;
    },
    spinnertStyle: function spinnertStyle() {
      return {
        height: this.circleSize + 'px',
        width: (this.circleSize + this.circleMarginLeft) * this.circlesNum + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        height: this.circleSize + 'px',
        width: this.circleSize + 'px',
        marginLeft: this.circleMarginLeft + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = 150;

      for (var i = 1; i <= this.circlesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.circleStyle);

        circlesStyles.push(style);
      }

      return circlesStyles;
    }
  }
});

/***/ }),

/***/ "2FxJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'uzorci-pregled',
  path: '/uzorci/pregled',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('uzorci/pregled'),
  meta: {
    default: false,
    title: 'Uzorci',
    iconClass: 'fa fa-flask',
    requiredAuth: true
  }
});

/***/ }),

/***/ "2ab3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {
          wrapperClass: 'ui right floated pagination menu',
          activeClass: 'active large',
          disabledClass: 'disabled',
          pageClass: 'item',
          linkClass: 'icon item',
          paginationClass: 'ui bottom attached segment grid',
          paginationInfoClass: 'left floated left aligned six wide column',
          dropdownClass: 'ui search dropdown',
          icons: {
            first: 'angle double left icon',
            prev: 'left chevron icon',
            next: 'right chevron icon',
            last: 'angle double right icon'
          }
        };
      }
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable-pagination:',
      tablePagination: null
    };
  },
  computed: {
    totalPage: function totalPage() {
      return this.tablePagination === null ? 0 : this.tablePagination.last_page;
    },
    isOnFirstPage: function isOnFirstPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === 1;
    },
    isOnLastPage: function isOnLastPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === this.tablePagination.last_page;
    },
    notEnoughPages: function notEnoughPages() {
      return this.totalPage < this.onEachSide * 2 + 4;
    },
    windowSize: function windowSize() {
      return this.onEachSide * 2 + 1;
    },
    windowStart: function windowStart() {
      if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
        return 1;
      } else if (this.tablePagination.current_page >= this.totalPage - this.onEachSide) {
        return this.totalPage - this.onEachSide * 2;
      }

      return this.tablePagination.current_page - this.onEachSide;
    }
  },
  methods: {
    loadPage: function loadPage(page) {
      this.$emit(this.eventPrefix + 'change-page', page);
    },
    isCurrentPage: function isCurrentPage(page) {
      return page === this.tablePagination.current_page;
    },
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),

/***/ "2c2N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SquareWithIcon_vue__ = __webpack_require__("1893");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f44faa90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SquareWithIcon_vue__ = __webpack_require__("DDsN");
function injectStyle (ssrContext) {
  __webpack_require__("6rXJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SquareWithIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f44faa90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SquareWithIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2jJz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2u3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HalfCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderWidth: this.size / 10 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circle1Style: function circle1Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderTopColor: this.color
      }, this.circleStyle);
    },
    circle2Style: function circle2Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderBottomColor: this.color
      }, this.circleStyle);
    }
  }
});

/***/ }),

/***/ "2uUy":
/***/ (function(module, exports) {

module.exports = {"auth":{"login":{"Acme":{},"Login":{"trnslr001":"Dobrodošli!","trnslr002":"Prijava","trnslr003":"Korisničko ime","trnslr004":"Šifra","trnslr005":"Greška prilikom konekcije na DB!","trnslr006":"Korisnik nije pronađen!","trnslr007":"Unijeli ste pogrešnu šifru!"}}},"dashboard":{"data-visualisation-tab":{"DataVisualisation":{"trnslr001":"Statusi uzoraka","trnslr002":"Statusi rezultata","trnslr003":"Nema zaprimljenih uzoraka.","trnslr004":"Nema pristiglih rezultata.","trnslr005":"Zaprimljen","trnslr006":"U obradi","trnslr007":"Realizovan","trnslr008":"Obrađen","trnslr009":"Broj uzoraka","trnslr010":"Nema pristiglih rezultata.","trnslr011":"Nije odobren","trnslr012":"Odobren","trnslr013":"Broj uzoraka"}},"features-tab":{"FeaturesTab":{"trnslr001":"Statusi uzoraka","trnslr002":"Nema zaprimljenih uzoraka.","trnslr003":"Zaprimljeno","trnslr004":"Obrađeno","trnslr005":"Pacijenata"}},"Dashboard":{"trnslr001":"Danas","trnslr002":"Zadnjih 30 dana"},"DashboardInfoWidgets":{"trnslr001":"Danas zaprimljeno uzoraka","trnslr002":"Kompletirano uzoraka","trnslr003":"Kompletirano testova","trnslr004":"Korisnika","trnslr005":"Pacijenata"}},"kontrole":{"pregled":{"detalji":{},"Levey":{},"Pregled":{}},"unos":{"Unos":{}}},"layout":{"navbar":{"Navbar":{"trnslr001":"odobren","trnslr002":"realizovan","trnslr003":"Promijenite šifru","trnslr004":"Dodajte sliku","trnslr005":"Dodajte korisnika","trnslr006":"Uredite korisnike","trnslr007":"Moje postavke","trnslr008":"Odjava","trnslr009":"Build"}},"sidebar":{"Sidebar":{"trnslr001":"Pregled","trnslr002":"Pacijenti","trnslr003":"Unos","trnslr004":"Pregled","trnslr038":"Prijem","trnslr005":"Uzorci","trnslr006":"Unos","trnslr007":"Pregled","trnslr008":"Rezultati","trnslr009":"Pregled","trnslr010":"Verifikacija","trnslr011":"Nalazi","trnslr012":"Pregled","trnslr013":"Verifikacija","trnslr014":"Odlazna pošta","trnslr015":"Kontrole","trnslr016":"Unos","trnslr017":"Pregled","trnslr018":"Levey - J","trnslr019":"Izvještaji","trnslr020":"Opšte postavke","trnslr021":"Lokacije","trnslr022":"Doktori","trnslr023":"Sekcije","trnslr024":"Generalno","trnslr025":"Paneli","trnslr026":"Sites","trnslr027":"Definicija testova","trnslr028":"Laboratorijski testovi","trnslr029":"Ručni testovi","trnslr030":"Kalkulisani testovi","trnslr031":"Postavke aparata","trnslr032":"Aparati","trnslr033":"Testovi aparata","trnslr034":"Definicija kontrola","trnslr035":"Pomoć","trnslr036":"Mjesta","trnslr037":"Predračun"}},"AuthLayout":{},"Layout":{}},"nalaz":{},"nalazi":{},"pacijenti":{"pregled":{"detalji":{"trnslr001":"Jmbg","trnslr002":"Ime","trnslr003":"Prezime","trnslr004":"Spol","trnslr005":"Pušač","trnslr006":"Dijabetes","trnslr007":"Telefon","trnslr008":"Email","trnslr009":"Uredi","__comment":"Ne prevoditi...","trnslr010":"MUŠKI","trnslr011":"ŽENSKI","trnslr012":"DA","trnslr013":"NE","comment__":"...Kraj","trnslr014":"Uredite podatke o pacijentu","trnslr015":"Sačuvajte izmjene","trnslr016":"Nazad","trnslr017":"Pregled detalja za pacijenta:","trnslr018":"Vrijednost polja je obavezna!","trnslr019":"JMBG mora biti validan 13 cifreni broj!","trnslr020":"Email adresa nije validna!","trnslr021":"Telefonski broj nije validan!","trnslr022":"Spol može biti MUŠKI ili ŽENSKI!","trnslr023":"Vrijednost polja PUŠAČ može biti DA ili NE!","trnslr024":"Vrijednost polja DIJABETES može biti DA ili NE!","trnslr025":"Pacijent sa unesenim JMBG, već postoji u sistemu!","trnslr026":"Greška prilikom upisa!","trnslr027":"Unos uspješno obavljen!","trnslr028":"Mjesto stanovanja"},"PregledPacijenta":{"trnslr001":"Pretraga svih pacijenata"},"fields-definition":{"trnslr001":"ime","trnslr002":"prezime","trnslr007":"prijem","trnslr003":"uzorak","trnslr004":"jmbg","trnslr005":"spol","trnslr006":"akcija"}},"unos":{"UnosPacijenta":{"trnslr001":"Unos pacijenata","trnslr002":"Unesite JMBG pacijenta","trnslr003":"Unesite ime pacijenta","trnslr004":"Unesite prezime pacijenta","trnslr005":"Izaberite spol pacijenta","trnslr006":"Konzumira duhan","trnslr007":"Dijabetes","trnslr008":"Unesite kontakt telefon","trnslr009":"Unesite Email adresu","trnslr010":"Sačuvaj","trnslr011":"Polja JMBG, Ime, Prezime i Spol su obavezna!","trnslr012":"JMBG mora biti validan 13 cifreni broj!","trnslr013":"Email adresa nije validna!","trnslr014":"Telefonski broj nije validan!","trnslr015":"Pacijent već postoji!","trnslr016":"Greška prilikom upisa!","trnslr017":"Unos uspješno obavljen!","trnslr018":"Mjesto stanovanja pacijenta"}}},"pomoc":{"Pomoc":{"trnslr001":"Pomoć pri korištenju aplikacije","trnslr002":"Prijava incidenta","trnslr003":"Pregled incidenata","trnslr004":"Zahtjev za nadogradnjom","trnslr005":"Pregled zahtjeva","trnslr006":"Kontakt","trnslr007":"Korisnik","trnslr008":"Vrijeme","trnslr009":"Unesite naziv","trnslr010":"Izaberite prioritet","trnslr011":"Opišite incident","trnslr012":"Izaberite lokaciju","trnslr013":"Izaberite status","trnslr014":"Naziv","trnslr015":"Prioritet","trnslr016":"Status","trnslr017":"Nema dostupnih podataka.","trnslr018":"Unesite zahtjev","trnslr019":"Kontaktirajte nas","trnslr020":"Primalac","trnslr021":"Unesite kontakt telefon","trnslr022":"Unesite poruku","trnslr023":"AP Solutions d.o.o.","trnslr024":"Opišite incident!","trnslr025":"Unesite naziv!","trnslr026":"Greška prilikom upisa!","trnslr027":"Unos uspješno obavljen!","trnslr028":"Unesite zahtjev!","trnslr029":"Unesite naziv!","trnslr030":"Greška prilikom upisa!","trnslr031":"Uredite podatke","trnslr032":"Unesite telefonski broj!","trnslr033":"Telefonski broj nije validan!","trnslr034":"Greška prilikom slanja poruke!","trnslr035":"Poruka uspješno poslana!","trnslr036":"Izbornik","trnslr037":"Sačuvajte izmjene","trnslr038":"Sačuvaj","trnslr039":"Pošalji","trnslr040":"Unesite poruku!","trnslr041":"Uredi"}},"postavke":{"user":{"chpwd":{"trnslr001":"Promjena šifre","trnslr002":"Unesite trenutnu šifru","trnslr003":"Unesite novu šifru","trnslr004":"Potvrdite novu šifru","trnslr005":"Sačuvaj","trnslr006":"Sva polja su obavezna!","trnslr007":"Šifra nije validna!","trnslr008":"Nova šifra nije validirana!","trnslr009":"Greška prilikom upisa!","trnslr010":"Trenutna šifra nije ispravna!","trnslr011":"Izmjena uspješno obavljena!"},"avatar":{"trnslr001":"Izmjena slike","trnslr002":"Dodavanje slike","trnslr003":"Izaberi","trnslr004":"Sačuvaj","trnslr005":"Greška prilikom izmjene!","trnslr006":"Izmjena uspješno obavljena!"},"newUser":{"trnslr001":"Dodavanje korisnika","trnslr002":"Unesite ime","trnslr003":"Unesite prezime","trnslr004":"Unesite korisničko ime","trnslr005":"Unesite šifru","trnslr006":"Vrsta korisničkog računa","trnslr007":"Izaberite sajtove","trnslr008":"Sajt korisnika","trnslr009":"Sačuvaj","trnslr010":"Korisničko ime nije validno!","trnslr011":"Sva polja su obavezna!","trnslr012":"Šifra nije validna!","trnslr013":"Greška prilikom upisa!","trnslr014":"Unos uspješno obavljen!","trnslr015":"Korisnik već postoji!"},"edit":{"trnslr001":"Uređivanje korisnika","trnslr002":"Ime","trnslr003":"Prezime","trnslr004":"Email","trnslr005":"Uloga","trnslr006":"Uredi","trnslr007":"Akcija","trnslr008":"Uredite podatke","trnslr009":"Sačuvajte izmjene","trnslr010":"Greška prilikom upisa!","trnslr011":"Izmjena uspješno obavljena!","trnslr012":"Jeste li sigurni da želite obrisati zapis?","trnslr013":"Da","trnslr014":"Greška prilikom brisanja!","trnslr015":"Zapis uspješno obrisan!","trnslr016":"Brisanje zapisa","trnslr017":"Izbriši","trnslr018":"Unesite \"Da\" za nastavak","trnslr019":"Odustani","trnslr020":"Nastavi"},"settings":{"trnslr001":"Postavke prikaza","trnslr002":"Kartični prikaz rezultata testova","trnslr003":"Postavke jezika","trnslr004":"Bosanski jezik","trnslr005":"Hrvatski jezik","trnslr006":"Srpski jezik","trnslr007":"Engleski jezik","trnslr008":"Greška prilikom upisa!","trnslr009":"Izmjena uspješno obavljena!","trnslr010":"10 minuta","trnslr011":"30 minuta","trnslr012":"120 minuta","trnslr013":"480 minuta","trnslr014":"Automatska odjava u slučaju neaktivnosti"}}},"reports":{},"rezultati":{},"uzorci":{},"vuestic-components":{"trnslr001":"Pretraga"}}

/***/ }),

/***/ "3Alh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ScalingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1250
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "3IyO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_directives_Dropdown__ = __webpack_require__("OR0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("/7ZL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-multi-select',
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__["default"]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0_directives_Dropdown__["a" /* default */]
  },
  data: function data() {
    return {
      displayValue: '',
      validated: false
    };
  },

  props: {
    label: String,
    options: Array,
    value: Array,
    optionKey: String,
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'multiselect'
    }
  },
  mounted: function mounted() {
    this.$emit('input', this.value);
  },


  updated: function updated() {
    this.updateDisplayValue(this.value);
  },

  methods: {
    toggleSelection: function toggleSelection(option) {
      var newVal = this.isOptionSelected(option) ? this.deselectOption(option) : this.selectOption(option);
      this.updateDisplayValue(newVal);
      this.$emit('input', newVal);
    },
    isOptionSelected: function isOptionSelected(option) {
      return this.value.includes(option);
    },
    selectOption: function selectOption(option) {
      return this.value.concat(option);
    },
    deselectOption: function deselectOption(option) {
      return this.value.filter(function (item) {
        return item !== option;
      });
    },
    updateDisplayValue: function updateDisplayValue(newVal) {
      var _this = this;

      if (newVal.length > 2) {
        this.displayValue = newVal.length + ' od ' + this.options.length + ' odabrana';
      } else {
        this.displayValue = (this.optionKey ? newVal.map(function (item) {
          return item[_this.optionKey];
        }) : newVal).join(', ');
      }
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.displayValue;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.displayValue;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return 'The ' + this.name + ' field is required';
    }
  }
});

/***/ }),

/***/ "3Kyx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3lQg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4+0S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical"},[_c('div',{staticClass:"progress",class:_vm.size},[_c('div',{ref:"progressBar",staticClass:"progress-bar",style:('height: ' + _vm.value + '%')})]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.animatedValue + '%'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "41de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    var HORIZONTAL_LAYOUT = 'horizontal';
    var VERTICAL_LAYOUT = 'vertical';
    var initialLayout = binding.value.layout;
    var breakpoint = binding.value.breakPoint;

    var wizardLayout = initialLayout;

    var handleResize = function handleResize() {
      var width = window.innerWidth;
      var layout = width <= breakpoint ? HORIZONTAL_LAYOUT : VERTICAL_LAYOUT;
      if (wizardLayout !== layout) {
        wizardLayout = layout;
        vnode.context.$emit('wizardLayoutChange', wizardLayout);
      }
    };

    if (initialLayout === VERTICAL_LAYOUT) {
      handleResize();
      window.addEventListener('resize', handleResize);
    }
  }
});

/***/ }),

/***/ "4J7k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hollow-dots-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.dotsStyles),function(ds,index){return _c('div',{key:index,staticClass:"dot",style:(ds)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4S38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionSamplesEntry_vue__ = __webpack_require__("MMrO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e58d465_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionSamplesEntry_vue__ = __webpack_require__("WAyp");
function injectStyle (ssrContext) {
  __webpack_require__("Zgjs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionSamplesEntry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e58d465_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionSamplesEntry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4TJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__ = __webpack_require__("2ab3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Z/G":
/***/ (function(module, exports) {



function odrediDefaultSelection(manual, calculated) {
  if (!manual && !calculated) {
    return ["Lab", true, true];
  } else if (manual && !calculated) {
    return ["Man", true, true];
  } else if (!manual && calculated) {
    return ["Calc", true, true];
  } else if (manual && calculated) {
    return ["Calc", true, true];
  }
}

module.exports = {
  bihlab: function bihlab(test, godina, spol, drstanje, menopauza, manual, calculated) {
    switch (test) {
      default:
        return odrediDefaultSelection(manual, calculated);
        break;
    }
  }
};

/***/ }),

/***/ "4ZaD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteDropdown_vue__ = __webpack_require__("uM+q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_500903f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteDropdown_vue__ = __webpack_require__("rl1c");
function injectStyle (ssrContext) {
  __webpack_require__("mpGX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_500903f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4bUk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingBouncingCircleSpinner_vue__ = __webpack_require__("tcEG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_71ad57ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingBouncingCircleSpinner_vue__ = __webpack_require__("zoLB");
function injectStyle (ssrContext) {
  __webpack_require__("ksoB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71ad57ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingBouncingCircleSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_71ad57ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingBouncingCircleSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "4oxZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--text",style:(_vm.messageColors)},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.messageText)}}),_vm._v(" "),(_vm.data.meta)?_c('p',{staticClass:"sc-message--meta",style:({color: _vm.messageColors.color})},[_vm._v(_vm._s(_vm.data.meta))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5JeB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseUzorak_vue__ = __webpack_require__("bNsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490473fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseUzorak_vue__ = __webpack_require__("tdfJ");
function injectStyle (ssrContext) {
  __webpack_require__("vYUl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseUzorak_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490473fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseUzorak_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5RVo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5RVu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5cMN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal"},[(_vm.size != 'thick')?_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.animatedValue + '%'))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"progress",class:_vm.size},[_c('div',{ref:"progressBar",staticClass:"progress-bar",style:('width: ' + _vm.value + '%')},[(_vm.size == 'thick')?_c('span',{staticClass:"value",class:{hidden: _vm.animatedValue == _vm.min}},[_vm._v("\n        "+_vm._s(_vm.animatedValue + '%')+"\n      ")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "62HC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(!_vm.hidden)?_c('div',{staticClass:"vuestic-alert alert",class:_vm.alertClass},[_vm._t("default"),_vm._v(" "),(_vm.withCloseBtn)?_c('i',{staticClass:"fa fa-close alert-close",on:{"click":function($event){_vm.hide()}}}):_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "64Yn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "682E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pacijenti',
  meta: {
    expanded: false,
    title: 'Pacijenti',
    iconClass: 'fa fa-users'
  },

  children: [{
    name: 'pacijenti-unos',
    path: '/pacijenti/unos/',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('pacijenti/unos/UnosPacijenta'),
    meta: {
      title: 'Unos',
      requiredAuth: true
    },
    props: { default: true }
  }, {
    name: 'pacijenti-pregled',
    path: '/pacijenti/pregled/',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('pacijenti/pregled/PregledPacijenta'),
    meta: {
      title: 'Pregled',
      requiredAuth: true
    },
    props: { default: true }
  }, {
    name: 'pacijenti-prijem',
    path: '/pacijenti/prijem/',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('pacijenti/prijem/prijem'),
    meta: {
      title: 'Prijem',
      requiredAuth: true
    },
    props: { default: true }
  }]
});

/***/ }),

/***/ "6Dsq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalEdit_vue__ = __webpack_require__("LeSA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e2f62c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalEdit_vue__ = __webpack_require__("HHMU");
function injectStyle (ssrContext) {
  __webpack_require__("pZN+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e2f62c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6L27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalBarcode_vue__ = __webpack_require__("zGUs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c45f485_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalBarcode_vue__ = __webpack_require__("Frx4");
function injectStyle (ssrContext) {
  __webpack_require__("UO+Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c45f485_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalBarcode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6Qk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tree-category"},[_c('div',{staticClass:"vuestic-tree-category__header",on:{"click":function($event){_vm.isOpenCached = ! _vm.isOpenCached}}},[_c('div',{staticClass:"vuestic-tree-category__header-checkbox"},[_c('square-with-icon',{attrs:{"iconClass":_vm.checkboxIconClass}})],1),_vm._v(" "),(_vm.$slots.icon)?_c('div',{staticClass:"vuestic-tree-category__header-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vuestic-tree-category__header-label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])]),_vm._v(" "),(_vm.isOpenCached)?_c('div',{staticClass:"vuestic-tree-category__list-container"},[_c('div',{staticClass:"vuestic-tree-category__list-internal-container"},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6b69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      window: {
        width: 0,
        height: 0
      }
    };
  },

  name: "vuestic-widget",

  props: {
    headerText: {
      type: String,
      default: ""
    },
    spol: {
      type: String,
      default: ""
    },
    pagination: {
      type: Boolean,
      default: false
    },
    main: {
      type: Boolean,
      default: false
    },
    forward_disabled: {
      type: Boolean,
      default: false
    },
    backward_disabled: {
      type: Boolean,
      default: false
    },
    data_length: {
      type: Number,
      default: 0
    },
    rezultati_length: {
      type: Number,
      default: 0
    },
    data_min: {
      type: Number,
      default: 1
    },
    data_pid: {
      type: Number,
      default: 0
    },
    datum: {
      type: String,
      default: ""
    },
    today: {
      type: String,
      default: ""
    }
  },
  created: function created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    Sljedeci: function Sljedeci() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Sljedeci");
    },
    Prethodni: function Prethodni() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Prethodni");
    },
    Find: function Find() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Search");
    }
  }
});

/***/ }),

/***/ "6glc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-pre-loader"},[_c('canvas',{ref:"canvas"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6oYg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FulfillingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        backgroundColor: this.color
      };
    }
  }
});

/***/ }),

/***/ "6prA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"orientation-handler",rawName:"v-orientation-handler",value:({ layout: _vm.wizardLayout,  breakPoint: _vm.orientationBreakPoint }),expression:"{ layout: wizardLayout,  breakPoint: orientationBreakPoint }"}],staticClass:"wizard",class:_vm.computedLayout},[(_vm.computedLayout === 'horizontal')?_c('div',{staticClass:"indicator-container indicator-container-horizontal"},[(_vm.wizardType === 'simple')?_c('simple-horizontal-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e(),_vm._v(" "),(_vm.wizardType === 'rich')?_c('rich-horizontal-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.computedLayout === 'vertical')?_c('div',{staticClass:"indicator-container indicator-container-vertical"},[(_vm.wizardType === 'rich')?_c('rich-vertical-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e(),_vm._v(" "),(_vm.wizardType === 'simple')?_c('simple-vertical-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wizard-body"},[_vm._l((_vm.steps),function(step){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isStepShown(step)),expression:"isStepShown(step)"}],staticClass:"wizard-body-step"},[_vm._t(step.slot)],2)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.wizardCompleted),expression:"wizardCompleted"}],staticClass:"wizard-body-step"},[_vm._t(_vm.wizardCompletedSlotName)],2),_vm._v(" "),(!_vm.wizardCompleted)?_c('div',{staticClass:"wizard-body-actions"},[(_vm.backEnabled)?_c('div',{staticClass:"btn-container"},[(_vm.stepTri)?_c('div',[_c('button',{staticClass:"btn btn-secondary wizard-back pull-left",on:{"click":function($event){_vm.goBack()}}},[_c('span',{staticClass:"fa fa-step-backward"}),_vm._v(_vm._s(' nazad')+"\n          ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.isLastStep())?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-primary wizard-next pull-right",on:{"click":function($event){_vm.goNext()}}},[_c('span',{staticClass:"fa fa-step-forward"}),_vm._v(_vm._s(' Naprijed')+"\n          ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.currentStep == _vm.steps.length - 1 && _vm.$route.path.includes('/uzorci/unos'))?_c('div',{attrs:{"id":"wrapper"}},[_c('button',{staticClass:"btn btn-secondary wizard-next pull-right final-step",on:{"click":function($event){_vm.goBack2()}}},[_c('span',{staticClass:"fa fa-flask"}),_vm._v(_vm._s(' Dodaj')+"\n      ")])]):_vm._e(),_vm._v(" "),(_vm.currentStep == _vm.steps.length - 1 && _vm.$route.path.includes('/uzorci/unos'))?_c('br'):_vm._e(),_vm._v(" "),(_vm.currentStep == _vm.steps.length - 1)?_c('div',{attrs:{"id":"wrapper"}},[_c('button',{staticClass:"btn btn-primary wizard-next pull-right final-step",on:{"click":function($event){_vm.completeWizard()}}},[_c('span',{staticClass:"glyphicon glyphicon-ok"}),_vm._v(_vm._s(_vm.lastStepLabel)+"\n      ")])]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6rXJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7/CN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7/Sj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12 info-widget-inner"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pid),expression:"pid"}],staticStyle:{"font-size":"18px","color":"#e34a4a"},attrs:{"onpaste":"return false;","autocomplete":"off","id":"input-icon-left","title":" ","name":"input-icon-left","required":"","type":"number","min":"1","max":_vm.data_length},domProps:{"value":(_vm.pid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pid=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-sort-numeric-asc icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}}),_vm._v(" "),_c('i',{staticClass:"bar"})])])])])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":isNaN(_vm.pid) || _vm.pid == '' || _vm.pid > _vm.data_length},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "74xX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProfileCard_vue__ = __webpack_require__("dRu4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fba1606_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProfileCard_vue__ = __webpack_require__("t4Qc");
function injectStyle (ssrContext) {
  __webpack_require__("/UaH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProfileCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fba1606_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProfileCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "76ZA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "77C1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__("mUJ2")("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),

/***/ "7F3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__ = __webpack_require__("4TJE");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__["a" /* default */]]
});

/***/ }),

/***/ "7O4P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7anH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-user-input--picker-wrapper"},[(_vm.isActive)?_c('EmojiPicker',{attrs:{"onEmojiPicked":_vm.onEmojiPicked,"onBlur":_vm._handlePickerBlur}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"sc-user-input--emoji-icon-wrapper",on:{"click":function($event){$event.preventDefault();_vm._openPicker($event)}}},[_c('svg',{staticClass:"sc-user-input--emoji-icon",class:{active: _vm.isActive},attrs:{"version":"1.1","id":"Layer_2","xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","width":"37.393px","height":"37.393px","viewBox":"0 0 37.393 37.393","enableBackground":"new 0 0 37.393 37.393"}},[_c('g',[_c('path',{style:({fill: _vm.color}),attrs:{"d":"M18.696,37.393C8.387,37.393,0,29.006,0,18.696C0,8.387,8.387,0,18.696,0c10.31,0,18.696,8.387,18.696,18.696\n            C37.393,29.006,29.006,37.393,18.696,37.393z M18.696,2C9.49,2,2,9.49,2,18.696c0,9.206,7.49,16.696,16.696,16.696\n            c9.206,0,16.696-7.49,16.696-16.696C35.393,9.49,27.902,2,18.696,2z"}})]),_vm._v(" "),_c('g',[_c('circle',{style:({fill: _vm.color}),attrs:{"cx":"12.379","cy":"14.359","r":"1.938"}})]),_vm._v(" "),_c('g',[_c('circle',{style:({fill: _vm.color}),attrs:{"cx":"24.371","cy":"14.414","r":"1.992"}})]),_vm._v(" "),_c('g',[_c('path',{style:({fill: _vm.color}),attrs:{"d":"M18.035,27.453c-5.748,0-8.342-4.18-8.449-4.357c-0.286-0.473-0.135-1.087,0.338-1.373\n            c0.471-0.286,1.084-0.136,1.372,0.335c0.094,0.151,2.161,3.396,6.74,3.396c4.713,0,7.518-3.462,7.545-3.497\n            c0.343-0.432,0.973-0.504,1.405-0.161c0.433,0.344,0.505,0.973,0.161,1.405C27.009,23.374,23.703,27.453,18.035,27.453z"}})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7cnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SendIcon_vue__ = __webpack_require__("DSl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SendIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SendIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1d0c1c26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SendIcon_vue__ = __webpack_require__("bPlI");
function injectStyle (ssrContext) {
  __webpack_require__("gHiU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d0c1c26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SendIcon_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1d0c1c26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SendIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7jA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCommenting),expression:"showCommenting"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12 info-widget-inner"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"input-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.komentar),expression:"komentar"}],attrs:{"type":"text","required":""},domProps:{"value":(_vm.komentar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.komentar=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s('Komentar'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7uax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('div',{staticClass:"d-flex flex-md-row flex-column justify-content-md-between align-items-center"},[_c('filter-bar',{on:{"filter":_vm.onFilterSet}}),_vm._v(" "),_c('date-range',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],on:{"date-range":_vm.onDateRangeSet}}),_vm._v(" "),_c('items-per-page',{attrs:{"range_max":this.date_range.max,"range_min":this.date_range.min,"options":_vm.itemsPerPage,"defaultPerPage":_vm.perPage},on:{"items-per-page":_vm.onItemsPerPage}})],1),_vm._v(" "),_c('vuetable',{ref:"vuetable",attrs:{"apiUrl":_vm.apiUrl,"apiMode":_vm.apiMode,"fields":_vm.tableFields,"data":_vm.tableData,"dataTotal":_vm.dataCount,"dataManager":_vm.dataManager,"css":_vm.css.table,"data-path":"data","paginationPath":_vm.paginationPath,"appendParams":_vm.moreParams,"perPage":_vm.brStr,"datum":_vm.perPage,"token":_vm.token,"site":_vm.site},on:{"vuetable:cell-clicked":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return this$1.prikaziDetalje([args]);
},"vuetable:pagination-data":_vm.onPaginationData}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-4"},[_c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"onEachSide":_vm.onEachSide},on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1),_vm._v(" "),_c('vuestic-modal',{ref:"largeModalComment",attrs:{"show":_vm.show,"large":true,"okText":_vm.potvrdi,"cancelText":_vm.odustani,"transition":_vm.patient},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.modalTitle))]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12 info-widget-inner"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped first-td-padding"},[_c('thead',[_c('tr',[_c('td',[_vm._v("ID UZORKA")]),_vm._v(" "),_c('td',[_vm._v("datum")]),_vm._v(" "),_c('td',[_vm._v("vrijeme")]),_vm._v(" "),_c('td',[_vm._v("izbor")]),_vm._v(" "),_c('td')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.samples),function(sample){return _c('tr',[_c('td',[_vm._v(_vm._s(sample.id))]),_vm._v(" "),(_vm.danas === (sample.updated_at.slice(8,10) + '.' + sample.updated_at.slice(5,7)  + '.' + sample.updated_at.slice(0,4)))?_c('td',[_c('strong',[_vm._v(_vm._s(sample.updated_at.slice(8,10) + '.' + sample.updated_at.slice(5,7) + '.' + sample.updated_at.slice(0,4)))])]):_vm._e(),_vm._v(" "),(_vm.danas != (sample.updated_at.slice(8,10) + '.' + sample.updated_at.slice(5,7)  + '.' + sample.updated_at.slice(0,4)))?_c('td',[_vm._v(_vm._s(sample.updated_at.slice(8,10) + '.' + sample.updated_at.slice(5,7) + '.' + sample.updated_at.slice(0,4)))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.Test(sample.updated_at)))]),_vm._v(" "),_c('td',[(_vm.danas === (sample.updated_at.slice(8,10) + '.' + sample.updated_at.slice(5,7)  + '.' + sample.updated_at.slice(0,4)))?_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{staticClass:"form-check-input",attrs:{"id":sample._id,"type":"checkbox","checked":""},on:{"click":_vm.UpdateSamples}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":sample._id}},[_c('span',{staticClass:"abc-label-text"},[_vm._v("Uključi u predračun")])])]):_vm._e(),_vm._v(" "),(_vm.danas != (sample.updated_at.slice(8,10) + '.' + sample.updated_at.slice(5,7)  + '.' + sample.updated_at.slice(0,4)))?_c('div',{staticClass:"form-check abc-checkbox abc-checkbox-primary"},[_c('input',{staticClass:"form-check-input",attrs:{"id":sample._id,"type":"checkbox"},on:{"click":_vm.UpdateSamples}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":sample._id}},[_c('span',{staticClass:"abc-label-text"},[_vm._v("Uključi u predračun")])])]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"valid",attrs:{"align":"middle"}},[_vm._v("\": false}\">")])])}))])])])])])])])])]),_vm._v(" "),_c('vuestic-modal-s',{ref:"upozoriModal",attrs:{"force":true,"show":_vm.show,"closeIconShown":false,"okText":"nastavi","cancelText":_vm.odustani,"transition":_vm.patient,"cancelClass":'btn btn-sm btn-warning',"okClass":'btn btn-sm btn-primary'},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.modalTitle))]),_vm._v(" "),_c('div',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12 info-widget-inner"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("\n                    Pacijent:\n                    "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s(_vm.klijent))])]),_vm._v(" "),_c('h5',[_vm._v("Nisu kompletirani uzorci:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped first-td-padding"},[_c('thead',[_c('tr',[_c('td',[_vm._v("ID UZORKA")]),_vm._v(" "),_c('td',[_vm._v("STATUS")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.samples),function(sample){return _c('tr',[_c('td',[_vm._v(_vm._s(sample.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(sample.status))])])}))])])])])])])])])]),_vm._v(" "),_c('vuestic-modal-uzorci',{ref:"staticModalUzorci",attrs:{"show":_vm.show,"cancelText":"ODUSTANI","okText":"POTVRDI"},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s('Pacijent: ')),_c('span',{staticStyle:{"color":"#4ae387"}},[_vm._v(_vm._s(_vm.partials.pacijent))])]),_vm._v(" "),_c('div',[_c('vuestic-accordion-obrada',_vm._l((_vm.partials_array),function(element){return _c('vuestic-collapse-uzorak',{key:element,attrs:{"sample":element}},[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(element))]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"va-row"})])])}))],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7uh9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionObrada_vue__ = __webpack_require__("edCZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225c28fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionObrada_vue__ = __webpack_require__("fIK/");
function injectStyle (ssrContext) {
  __webpack_require__("lasC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionObrada_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225c28fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionObrada_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7yFm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8/T/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWizard_vue__ = __webpack_require__("mpwI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76bbf2f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWizard_vue__ = __webpack_require__("6prA");
function injectStyle (ssrContext) {
  __webpack_require__("GHKZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76bbf2f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWizard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76bbf2f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWizard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8278":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "85yt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps rich-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ height: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('i',{staticClass:"ion ion-md-close step-icon icon-cross"}),_vm._v(" "),_c('i',{staticClass:"ion ion-md-checkmark step-icon icon-check"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8AZa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-samples-entry-calendar",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "SAČUVAJ"
    },
    cancelText: {
      type: String,
      default: "ODUSTANI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sample: {
      type: String,
      default: ""
    },
    vrijeme: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      time: "",
      uzorak: "",
      config: {
        maxDate: new Date(),
        enableTime: true,
        inline: true,
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
            longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            longhand: ["Januar‎", "Februar‎", "Mart‎", "April‎", "Maj‎", "Juni‎", "Juli‎", "August‎", "Septembar‎", "Oktobar‎", "Novembar‎", "Decembar‎"]
          }
        }
      }
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    vrijeme: function vrijeme(newVal, oldVal) {
      this.time = newVal;
    },

    sample: function sample(newVal, oldVal) {
      this.uzorak = newVal;
    },

    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("setCalendar", this.uzorak, this.time);
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "8UFG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    messageColors: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "8cpX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8eHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalDrugoStanje_vue__ = __webpack_require__("o0ll");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3746f986_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalDrugoStanje_vue__ = __webpack_require__("Z3JB");
function injectStyle (ssrContext) {
  __webpack_require__("+2Jl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3746f986"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalDrugoStanje_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3746f986_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalDrugoStanje_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8ovZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FingerprintSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 9,
      containerPadding: 2
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        borderTopColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var ringBase = this.outerRingSize / this.ringsNum;
      var ringInc = ringBase;

      for (var i = 1; i <= this.ringsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * 50 + 'ms',
          height: ringBase + (i - 1) * ringInc + 'px',
          width: ringBase + (i - 1) * ringInc + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),

/***/ "8sJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-modal-s',
  props: {
    transition: {
      type: String,
      default: 'modal'
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: 'CONFIRM'
    },
    cancelText: {
      type: String,
      default: 'CANCEL'
    },
    okClass: {
      type: String,
      default: 'btn btn-primary'
    },
    cancelClass: {
      type: String,
      default: 'btn btn-secondary'
    },
    closeIconShown: {
      type: Boolean,
      default: true
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        'modal-lg': this.large,
        'modal-sm': this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += ' modal-open';
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, '');
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += ' modal-open';
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, '');
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === 'Escape') {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit('ok');
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('yesNalaz', true, this.transition);
      this.show = false;
      window.removeEventListener('keyup', this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit('cancel');
      this.show = false;
      window.removeEventListener('keyup', this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener('keyup', this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener('keyup', this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "8w6N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orbit-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"orbit one",style:(_vm.orbitStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit two",style:(_vm.orbitStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit three",style:(_vm.orbitStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8yMI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tree-root',
  methods: {
    collapse: function collapse() {
      var _this = this;

      this.$nextTick(function () {
        _this.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.collapse();
          }
        });
      });
    },
    expand: function expand() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.expand();
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "9AED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrbitSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "9BNn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sc-launcher",class:{opened: _vm.isOpen},style:({backgroundColor: _vm.colors.launcher.bg}),on:{"click":function($event){$event.preventDefault();_vm.isOpen ? _vm.close() : _vm.open()}}},[(_vm.newMessagesCount > 0 && !_vm.isOpen)?_c('div',{staticClass:"sc-new-messsages-count"},[_vm._v("\n      "+_vm._s(_vm.newMessagesCount)+"\n    ")]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"sc-open-icon",attrs:{"src":__webpack_require__("xc3+")}}),_vm._v(" "),_c('img',{staticClass:"sc-closed-icon",attrs:{"src":__webpack_require__("9QaW")}})]),_vm._v(" "),_c('ChatWindow',{attrs:{"messageList":_vm.messageList,"onUserInputSubmit":_vm.onMessageWasSent,"participants":_vm.participants,"title":_vm.chatWindowTitle,"titleImageUrl":_vm.titleImageUrl,"isOpen":_vm.isOpen,"onClose":_vm.close,"showEmoji":_vm.showEmoji,"showFile":_vm.showFile,"placeholder":_vm.placeholder,"showTypingIndicator":_vm.showTypingIndicator,"colors":_vm.colors,"alwaysScrollToBottom":_vm.alwaysScrollToBottom}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Hnf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9QaW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSItNDc0OS40OCAtNTAyMCAzNS4wMzYgMzUuMDM2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntmaWxsOiM0ZThjZmY7fS5je2NsaXAtcGF0aDp1cmwoI2EpO30uZHtmaWxsOiNmZmY7fS5le2ZpbGw6I2VmZjRmOTt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGNsYXNzPSJhIiBkPSJNMC0zOTkuNDc5SDE3LjU1NXYxNy41NTVIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMzk5LjQ3OSkiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDg4NiAtNTA3NSkiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NS4xMyA2NCkiPjxnIGNsYXNzPSJjIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj48cGF0aCBjbGFzcz0iZCIgZD0iTS0zODEuOTI0LTE5MC45NjJhOC43NzgsOC43NzgsMCwwLDAtOC43NzgtOC43NzgsOC43NzgsOC43NzgsMCwwLDAtOC43NzgsOC43NzgsOC43NDUsOC43NDUsMCwwLDAsMi4yNiw1Ljg3OXYxLjQ0MmMwLC44LjQ5MiwxLjQ1NywxLjEsMS40NTdoNS44M2EuODQzLjg0MywwLDAsMCwuMTgzLS4wMiw4Ljc3OCw4Ljc3OCwwLDAsMCw4LjE4NC04Ljc1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzk5LjQ3OSAxOTkuNzQpIi8+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiPjxwYXRoIGNsYXNzPSJlIiBkPSJNLTY4Ljc2My0xOTQuMDc5YTkuMjkyLDkuMjkyLDAsMCwxLDYuMzgtOC44ODhjLS4yNTItLjAyMi0uNTA2LS4wMzMtLjc2My0uMDMzYTguNzc0LDguNzc0LDAsMCwwLTguNzc4LDguNzc4QTkuNTA4LDkuNTA4LDAsMCwwLTY5LjctMTg4LjNjLjAwNSwwLDAsLjAwOSwwLC4wMS0uMzExLjM1Mi0xLjkyNCwyLjg0OS4wMjEsMi44NDloMi4yNWMtMS4yMy0uMDIyLDEuMjYzLTIuMTA3LjI2OS0zLjQ5NGE4LjIyNSw4LjIyNSwwLDAsMS0xLjYtNS4xNDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcxLjkyNCAyMDMpIi8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ "9mWQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollList",staticClass:"sc-message-list",style:({backgroundColor: _vm.colors.messageList.bg})},[_vm._l((_vm.messages),function(message,idx){return _c('Message',{key:idx,attrs:{"message":message,"chatImageUrl":_vm.chatImageUrl(message.author),"authorName":_vm.authorName(message.author),"colors":_vm.colors}})}),_vm._v(" "),_c('Message',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTypingIndicator !== ''),expression:"showTypingIndicator !== ''"}],attrs:{"message":{author: _vm.showTypingIndicator, type: 'typing'},"chatImageUrl":_vm.chatImageUrl(_vm.showTypingIndicator),"colors":_vm.colors}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9zCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "mjesta",
  path: "/postavke/mjesta",
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("postavke/mjesta/Mjesta"),
  meta: {
    default: false,
    expanded: false,
    title: "Mjesta",
    iconClass: "fa fa-map-marker",
    requiredAuth: true
  }
});

/***/ }),

/***/ "AKm5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Bubble"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], _this.defaultOptions, _this.options);
      _this.renderChart(_this.data, options);
    }, 600);
  }
}));

/***/ }),

/***/ "AO3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OrbitSpinner_vue__ = __webpack_require__("9AED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_60f241f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_OrbitSpinner_vue__ = __webpack_require__("8w6N");
function injectStyle (ssrContext) {
  __webpack_require__("NrN+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60f241f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OrbitSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_60f241f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_OrbitSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "AWw/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_tooltip__ = __webpack_require__("VN6J");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-popover',

  components: { VPopover: __WEBPACK_IMPORTED_MODULE_0_v_tooltip__["VPopover"] },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'auto'
    },
    popoverClass: {
      type: [String, Array],
      default: 'vuestic-tooltip'
    },
    autoHide: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isIconPresent: function isIconPresent() {
      return !!this.$slots.icon;
    }
  }
});

/***/ }),

/***/ "Avj+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AyHC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FingerprintSpinner_vue__ = __webpack_require__("8ovZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3d56d22d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FingerprintSpinner_vue__ = __webpack_require__("0GYU");
function injectStyle (ssrContext) {
  __webpack_require__("K8yz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d56d22d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FingerprintSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3d56d22d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FingerprintSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "B/7t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.sample.status != 'ODOBREN' && _vm.sample.status != 'VERIFICIRAN')?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B7xO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BAax":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BGuh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BKK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SelfBuildingSquareSpinner_vue__ = __webpack_require__("r8Mc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1328db14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SelfBuildingSquareSpinner_vue__ = __webpack_require__("c4i4");
function injectStyle (ssrContext) {
  __webpack_require__("hRNN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1328db14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SelfBuildingSquareSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1328db14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SelfBuildingSquareSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "BOqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePagination_vue__ = __webpack_require__("7F3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_61cc6771_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePagination_vue__ = __webpack_require__("Dwj0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_61cc6771_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BUgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circles-to-rhombuses-spinner",style:(_vm.spinnertStyle)},_vm._l((_vm.circlesStyles),function(cs,index){return _c('div',{key:index,staticClass:"circle",style:(cs)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BsSo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bueh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pregled',
  path: '/dashboard',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('dashboard/Dashboard'),
  meta: {
    default: true,
    title: 'Statistika',
    iconClass: 'vuestic-icon vuestic-icon-dashboard',
    requiredAuth: true
  }
});

/***/ }),

/***/ "C7Zy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalPatient_vue__ = __webpack_require__("jfpW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d05a6ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalPatient_vue__ = __webpack_require__("XLEJ");
function injectStyle (ssrContext) {
  __webpack_require__("5RVo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalPatient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d05a6ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalPatient_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "C8uP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CHUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  table: {
    tableClass: 'table table-striped',
    ascendingIcon: 'entypo entypo-up-dir',
    descendingIcon: 'entypo entypo-down-dir'
  },
  pagination: {
    wrapperClass: 'btn-group',
    activeClass: 'focus',
    disabledClass: 'disabled',
    pageClass: 'btn btn-primary hide-not-focused-btn',
    linkClass: 'btn btn-primary pagination-link-btn',
    icons: {
      first: 'fa fa-angle-double-left',
      prev: 'fa fa-angle-left',
      next: 'fa fa-angle-right',
      last: 'fa fa-angle-double-right'
    }
  }
});

/***/ }),

/***/ "CMJy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-delete",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.DeleteSample();

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    DeleteSample: function DeleteSample() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["o" /* http */].post("uzorci/delete", {
        id: this.$store.state.sid,
        email: this.$store.state.user,
        token: this.$store.state.token,
        site: this.$store.state.site
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Deleted", _this.$store.state.sid);

        _this.show = false;
      });
    }
  }
});

/***/ }),

/***/ "CTmQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPlus),expression:"showPlus"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ruler),expression:"ruler"}],staticClass:"col-md-12"},[_c('div',{staticClass:"testoviDiv",staticStyle:{"text-align":"center"}},[_vm._l((_vm.testovi),function(test){return _c('div',{class:{
                    'btn btn-primary btn-micro' : ((!test.disable || test.disable === undefined) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Lab'), 
                    'btn btn-warning btn-micro' : ((!test.disable || test.disable === undefined) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Calc'), 
                    'btn btn-secondary btn-micro' : ((!test.disable || test.disable === undefined) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Man'),
                    'disabled btn btn-primary btn-micro' : ((test.disable) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Lab'), 
                    'disabled btn btn-warning btn-micro' : ((test.disable ) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Calc'), 
                    'disabled btn btn-secondary btn-micro' : ((test.disable) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Man')},attrs:{"name":test.labassay},on:{"click":function($event){_vm.izbaciTest($event, test.disable)}}},[_vm._v(_vm._s(test.ime_testa))])}),_vm._v("  \n                  "),_c('hr')],2),_vm._v(" "),_c('div',_vm._l((Math.ceil(_vm.sviTestovi.length/100)),function(index){return _c('div',{staticClass:"table",staticStyle:{"text-align":"center"}},_vm._l(((_vm.sviTestovi.slice((index-1)*100,index*100))),function(test){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTest(_vm.$store.state.site, test.analit, _vm.ukGodina, _vm.spol, _vm.drstanje, _vm.menopauza, test.manual, test.calculated)[2] && !test.disabled),expression:"showTest($store.state.site, test.analit, ukGodina, spol, drstanje, menopauza, test.manual, test.calculated)[2] && !test.disabled"}],class:{'btn btn-primary btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Lab', 'btn btn-warning btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Calc', 'btn btn-secondary btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Man'},attrs:{"title":test.analit,"align":"middle","id":test.labassay},on:{"click":function($event){_vm.dodajTest($event, test)}}},[_vm._v(_vm._s(test.ime_testa))])}))})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},_vm._l((Math.ceil(_vm.basSviTestovi.length/100)),function(index){return _c('div',{staticClass:"table",staticStyle:{"text-align":"center"}},_vm._l(((_vm.basSviTestovi.slice((index-1)*100,index*100))),function(test){return _c('div',{class:{'btn btn-primary btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Lab', 'btn btn-warning btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Calc', 'btn btn-secondary btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Man'},attrs:{"title":test.analit,"align":"middle","id":test.labassay},on:{"click":function($event){_vm.dodajTest($event, test)}}},[_vm._v(_vm._s(test.ime_testa))])}))}))])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CWyX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CcVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tree-root"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CneO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorizontalProgressBar_vue__ = __webpack_require__("pr2e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_546334bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorizontalProgressBar_vue__ = __webpack_require__("5cMN");
function injectStyle (ssrContext) {
  __webpack_require__("iGdN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorizontalProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_546334bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorizontalProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "D8td":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2)])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{class:_vm.cancelClass,attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm.cancelText))])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DDsN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"square-with-icon"},[_c('span',{staticClass:"icon"},[_c('i',{class:_vm.iconClass,attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DJ83":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"semipolar-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.ringsStyles),function(rs,index){return _c('div',{key:index,staticClass:"ring",style:(rs)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DOc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pixel-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"pixel-spinner-inner",style:(_vm.spinnerInnerStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DSl7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    onClick: {
      type: Function,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  }
};

/***/ }),

/***/ "Dmbe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__ = __webpack_require__("6b69");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a341112_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__ = __webpack_require__("gZ+0");
function injectStyle (ssrContext) {
  __webpack_require__("NYsZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a341112"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a341112_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DqnR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseNalaz_vue__ = __webpack_require__("va7+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36175d78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseNalaz_vue__ = __webpack_require__("liXm");
function injectStyle (ssrContext) {
  __webpack_require__("b0BD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseNalaz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36175d78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseNalaz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Dt+F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_EXPAND_MENU_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_WITHOUT_ANIMATION; });
var TOGGLE_EXPAND_MENU_ITEM = 'TOGGLE_EXPAND_MENU_ITEM';

var CLOSE_MENU = 'CLOSE_MENU';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var TOGGLE_WITHOUT_ANIMATION = 'TOGGLE_WITHOUT_ANIMATION';

/***/ }),

/***/ "Dwj0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tablePagination && _vm.tablePagination.last_page > 1),expression:"tablePagination && tablePagination.last_page > 1"}],class:_vm.css.wrapperClass},[_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage(1)}}},[(_vm.css.icons.first != '')?_c('i',{class:[_vm.css.icons.first]}):_c('span',[_vm._v("«")])]),_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage('prev')}}},[(_vm.css.icons.next != '')?_c('i',{class:[_vm.css.icons.prev]}):_c('span',[_vm._v(" ‹")])]),_vm._v(" "),(_vm.notEnoughPages)?[_vm._l((_vm.totalPage),function(n){return [_c('a',{class:[_vm.css.pageClass, _vm.isCurrentPage(n) ? _vm.css.activeClass : ''],domProps:{"innerHTML":_vm._s(n)},on:{"click":function($event){_vm.loadPage(n)}}})]})]:[_vm._l((_vm.windowSize),function(n){return [_c('a',{class:[_vm.css.pageClass, _vm.isCurrentPage(_vm.windowStart+n-1) ? _vm.css.activeClass : ''],domProps:{"innerHTML":_vm._s(_vm.windowStart+n-1)},on:{"click":function($event){_vm.loadPage(_vm.windowStart+n-1)}}})]})],_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage('next')}}},[(_vm.css.icons.next != '')?_c('i',{class:[_vm.css.icons.next]}):_c('span',[_vm._v("› ")])]),_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage(_vm.totalPage)}}},[(_vm.css.icons.last != '')?_c('i',{class:[_vm.css.icons.last]}):_c('span',[_vm._v("»")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E5pB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-commenting",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: "SAČUVAJ"
    },
    cancelText: {
      type: String,
      default: "ZATVORI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sid: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      showCommenting: false,
      duration: 500,
      komentar: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.showCommenting) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    showCommenting: function showCommenting(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["o" /* http */].post("uzorci/komentar/" + this.sid + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {
        komentar: this.komentar
      }).then(function (res) {});
      this.showCommenting = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.showCommenting = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      var _this = this;

      this.showCommenting = true;
      window.addEventListener("keyup", this.listenKeyUp);

      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["o" /* http */].get("uzorci/komentar/" + this.sid + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
        _this.komentar = res.data.komentar;
      });
    },
    close: function close() {
      this.showCommenting = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "EGJn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EbRv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-chat"},[_c('div',{directives:[{name:"sticky-scroll",rawName:"v-sticky-scroll",value:({animate: true, duration: 500}),expression:"{animate: true, duration: 500}"}],staticClass:"chat-body",style:({'height': _vm.height})},_vm._l((_vm.value),function(message){return _c('div',{staticClass:"chat-message",class:{'yours': message.yours, 'alien': !message.yours}},[_vm._v("\n       "+_vm._s(message.text)+"\n    ")])})),_vm._v(" "),_c('div',{staticClass:"chat-controls"},[_c('fieldset',[_c('div',{staticClass:"form-group form-group-w-btn"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputMessage),expression:"inputMessage"}],attrs:{"required":"","title":""},domProps:{"value":(_vm.inputMessage)},on:{"keypress":function($event){_vm.keyHandler($event)},"input":function($event){if($event.target.composing){ return; }_vm.inputMessage=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Your message")]),_c('i',{staticClass:"bar"})]),_vm._v(" "),_c('div',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.sendMessage()}}},[_vm._v("Send")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EjTN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Exjh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FQl4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FY6O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeNode_vue__ = __webpack_require__("cWTx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a2cb279_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeNode_vue__ = __webpack_require__("cbJ5");
function injectStyle (ssrContext) {
  __webpack_require__("EjTN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeNode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a2cb279_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeNode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FaL3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-multi",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sample: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('SaveMulti', this.sample);
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "Frx4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBarcode),expression:"showBarcode"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"}),_vm._v(" "),(_vm.sid.length > 9)?_c('div',{staticClass:"col-sm-4"},[_c('barcode',{attrs:{"id":"barcode","value":_vm.sid,"options":{ displayValue: true , width: 1.25, fontSize: 20, textPosition: 'bottom',}}})],1):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v("\n                  "+_vm._s(_vm.cancelText)+"\n                ")]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v("\n                  "+_vm._s(_vm.okText)+"\n                ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GB0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'auth-layout'
});

/***/ }),

/***/ "GHKZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GI4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-rich-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "GKsR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GslS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_vuestic_components_vuestic_alert_VuesticAlert_vue__ = __webpack_require__("cfdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_vuestic_components_vuestic_chart_VuesticChart_vue__ = __webpack_require__("+Uuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_vuestic_components_vuestic_chat_VuesticChat_vue__ = __webpack_require__("oXux");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_vuestic_components_vuestic_checkbox_VuesticCheckbox_vue__ = __webpack_require__("2653");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_vuestic_components_vuestic_datatable_VuesticDataTable_vue__ = __webpack_require__("tZ2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_vuestic_components_vuestic_datatable_VuesticDataTablePacijent_vue__ = __webpack_require__("Jops");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_vuestic_components_vuestic_feed_VuesticFeed_vue__ = __webpack_require__("Q4Rp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_vuestic_components_vuestic_modal_VuesticModal_vue__ = __webpack_require__("NG7M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_vuestic_components_vuestic_modal_VuesticModalDrugoStanje_vue__ = __webpack_require__("8eHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_vuestic_components_vuestic_modal_VuesticModalMedium_vue__ = __webpack_require__("Wvsm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_vuestic_components_vuestic_modal_VuesticModalStatic_vue__ = __webpack_require__("aXvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_vuestic_components_vuestic_modal_VuesticModalPatient_vue__ = __webpack_require__("C7Zy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_dashboard_VuesticModalPatientsData_vue__ = __webpack_require__("fYdP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_vuestic_components_vuestic_modal_VuesticModalSamplesEntryCommenting_vue__ = __webpack_require__("u983");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_vuestic_components_vuestic_modal_VuesticModalSamplesEntryCalendar_vue__ = __webpack_require__("J6aD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_vuestic_components_vuestic_modal_VuesticModalBarcode_vue__ = __webpack_require__("6L27");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_vuestic_components_vuestic_modal_VuesticModalCommenting_vue__ = __webpack_require__("NKe1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_vuestic_components_vuestic_modal_VuesticModalPlus_vue__ = __webpack_require__("TGVY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_vuestic_components_vuestic_modal_VuesticModalTrash_vue__ = __webpack_require__("0Zwo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__ = __webpack_require__("IqWy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__ = __webpack_require__("VAWW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__ = __webpack_require__("74xX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__ = __webpack_require__("XznE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("/7ZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__ = __webpack_require__("/LRh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_vuestic_components_vuestic_input_select_VuesticInputSelect_vue__ = __webpack_require__("P2Ka");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_vuestic_components_vuestic_social_news_VuesticSocialNews_vue__ = __webpack_require__("anct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_vuestic_components_vuestic_switch_VuesticSwitch_vue__ = __webpack_require__("rhzU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_vuestic_components_vuestic_tabs_VuesticTabs_vue__ = __webpack_require__("LtNJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_vuestic_components_vuestic_tag_VuesticTag__ = __webpack_require__("aTa4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_vuestic_components_vuestic_tag_VuesticTagGroup__ = __webpack_require__("L2/I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_vuestic_components_vuestic_tooltip_VuesticTooltip_vue__ = __webpack_require__("PpPr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_vuestic_components_vuestic_popover_VuesticPopover_vue__ = __webpack_require__("wf/P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_components_vuestic_components_vuestic_widget_VuesticWidget_vue__ = __webpack_require__("Dmbe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_components_vuestic_components_vuestic_wizard_VuesticWizard_vue__ = __webpack_require__("8/T/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_components_vuestic_components_vuestic_medium_editor_VuesticMediumEditor_vue__ = __webpack_require__("d4/x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_components_vuestic_mixins_VuesticToasted__ = __webpack_require__("bhip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_components_vuestic_components_vuestic_site_SiteDropdown_vue__ = __webpack_require__("4ZaD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_components_vuestic_directives_Dropdown__ = __webpack_require__("SRTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_components_vuestic_components_vuestic_date_picker_VuesticDatePicker__ = __webpack_require__("UfMP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_components_vuestic_components_vuestic_tree_view_VuesticTreeRoot__ = __webpack_require__("hF5N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_src_components_vuestic_components_vuestic_tree_view_VuesticTreeNode__ = __webpack_require__("FY6O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_components_vuestic_components_vuestic_tree_view_VuesticTreeCategory__ = __webpack_require__("MCoA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_components_vuestic_components_vuestic_radio_button_VuesticRadioButton_vue__ = __webpack_require__("aj+k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_src_components_vuestic_components_vuestic_collapse_VuesticAccordion__ = __webpack_require__("WBzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_src_components_vuestic_components_vuestic_collapse_VuesticCollapse__ = __webpack_require__("x598");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_src_components_vuestic_components_vuestic_collapse_VuesticAccordionPatientInfo__ = __webpack_require__("xAVG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_src_components_vuestic_components_vuestic_collapse_VuesticAccordionSamplesEntry__ = __webpack_require__("4S38");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_src_components_vuestic_components_vuestic_collapse_VuesticCollapsePatientInfo__ = __webpack_require__("TS+I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_src_components_vuestic_components_vuestic_collapse_VuesticCollapseSamplesEntry__ = __webpack_require__("pmVg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_src_components_obrada_VuesticAccordionObrada__ = __webpack_require__("7uh9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_src_components_obrada_VuesticCollapseObrada__ = __webpack_require__("stge");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_src_components_obrada_VuesticCollapseNalaz__ = __webpack_require__("DqnR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_src_components_obrada_VuesticCollapseUzorak__ = __webpack_require__("5JeB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_src_components_obrada_VuesticModalDelete__ = __webpack_require__("ZctM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_src_components_obrada_VuesticModalEdit__ = __webpack_require__("6Dsq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_src_components_obrada_VuesticModalMulti__ = __webpack_require__("yJZO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_src_components_obrada_VuesticModalComment__ = __webpack_require__("n9oL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_src_components_obrada_VuesticModalMail__ = __webpack_require__("XDv4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_src_components_obrada_VuesticModalFind__ = __webpack_require__("/Djh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_src_components_obrada_VuesticModalUzorci__ = __webpack_require__("xBqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_src_components_obrada_VuesticModalError__ = __webpack_require__("biUo");

































































var VuesticComponentsPlugin = {
  install: function install(Vue, options) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0_src_components_vuestic_components_vuestic_alert_VuesticAlert_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_0_src_components_vuestic_components_vuestic_alert_VuesticAlert_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1_src_components_vuestic_components_vuestic_chart_VuesticChart_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_1_src_components_vuestic_components_vuestic_chart_VuesticChart_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2_src_components_vuestic_components_vuestic_chat_VuesticChat_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_2_src_components_vuestic_components_vuestic_chat_VuesticChat_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3_src_components_vuestic_components_vuestic_checkbox_VuesticCheckbox_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_3_src_components_vuestic_components_vuestic_checkbox_VuesticCheckbox_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_4_src_components_vuestic_components_vuestic_datatable_VuesticDataTable_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_4_src_components_vuestic_components_vuestic_datatable_VuesticDataTable_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_5_src_components_vuestic_components_vuestic_datatable_VuesticDataTablePacijent_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_5_src_components_vuestic_components_vuestic_datatable_VuesticDataTablePacijent_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_6_src_components_vuestic_components_vuestic_feed_VuesticFeed_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_6_src_components_vuestic_components_vuestic_feed_VuesticFeed_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_7_src_components_vuestic_components_vuestic_modal_VuesticModal_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_7_src_components_vuestic_components_vuestic_modal_VuesticModal_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_9_src_components_vuestic_components_vuestic_modal_VuesticModalMedium_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_9_src_components_vuestic_components_vuestic_modal_VuesticModalMedium_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_11_src_components_vuestic_components_vuestic_modal_VuesticModalPatient_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_11_src_components_vuestic_components_vuestic_modal_VuesticModalPatient_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_12_src_components_dashboard_VuesticModalPatientsData_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_12_src_components_dashboard_VuesticModalPatientsData_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_13_src_components_vuestic_components_vuestic_modal_VuesticModalSamplesEntryCommenting_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_13_src_components_vuestic_components_vuestic_modal_VuesticModalSamplesEntryCommenting_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_14_src_components_vuestic_components_vuestic_modal_VuesticModalSamplesEntryCalendar_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_14_src_components_vuestic_components_vuestic_modal_VuesticModalSamplesEntryCalendar_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_10_src_components_vuestic_components_vuestic_modal_VuesticModalStatic_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_10_src_components_vuestic_components_vuestic_modal_VuesticModalStatic_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_8_src_components_vuestic_components_vuestic_modal_VuesticModalDrugoStanje_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_8_src_components_vuestic_components_vuestic_modal_VuesticModalDrugoStanje_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_15_src_components_vuestic_components_vuestic_modal_VuesticModalBarcode_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_15_src_components_vuestic_components_vuestic_modal_VuesticModalBarcode_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_16_src_components_vuestic_components_vuestic_modal_VuesticModalCommenting_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_16_src_components_vuestic_components_vuestic_modal_VuesticModalCommenting_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_17_src_components_vuestic_components_vuestic_modal_VuesticModalPlus_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_17_src_components_vuestic_components_vuestic_modal_VuesticModalPlus_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_18_src_components_vuestic_components_vuestic_modal_VuesticModalTrash_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_18_src_components_vuestic_components_vuestic_modal_VuesticModalTrash_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_19_src_components_vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_19_src_components_vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_20_src_components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_20_src_components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_21_src_components_vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_21_src_components_vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_22_src_components_vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_22_src_components_vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_23_src_components_vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_23_src_components_vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_24_src_components_vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_24_src_components_vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_25_src_components_vuestic_components_vuestic_input_select_VuesticInputSelect_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_25_src_components_vuestic_components_vuestic_input_select_VuesticInputSelect_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_26_src_components_vuestic_components_vuestic_social_news_VuesticSocialNews_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_26_src_components_vuestic_components_vuestic_social_news_VuesticSocialNews_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_27_src_components_vuestic_components_vuestic_switch_VuesticSwitch_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_27_src_components_vuestic_components_vuestic_switch_VuesticSwitch_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_28_src_components_vuestic_components_vuestic_tabs_VuesticTabs_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_28_src_components_vuestic_components_vuestic_tabs_VuesticTabs_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_29_src_components_vuestic_components_vuestic_tag_VuesticTag__["default"].name, __WEBPACK_IMPORTED_MODULE_29_src_components_vuestic_components_vuestic_tag_VuesticTag__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_30_src_components_vuestic_components_vuestic_tag_VuesticTagGroup__["default"].name, __WEBPACK_IMPORTED_MODULE_30_src_components_vuestic_components_vuestic_tag_VuesticTagGroup__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_31_src_components_vuestic_components_vuestic_tooltip_VuesticTooltip_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_31_src_components_vuestic_components_vuestic_tooltip_VuesticTooltip_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_32_src_components_vuestic_components_vuestic_popover_VuesticPopover_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_32_src_components_vuestic_components_vuestic_popover_VuesticPopover_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_33_src_components_vuestic_components_vuestic_widget_VuesticWidget_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_33_src_components_vuestic_components_vuestic_widget_VuesticWidget_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_34_src_components_vuestic_components_vuestic_wizard_VuesticWizard_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_34_src_components_vuestic_components_vuestic_wizard_VuesticWizard_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_35_src_components_vuestic_components_vuestic_medium_editor_VuesticMediumEditor_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_35_src_components_vuestic_components_vuestic_medium_editor_VuesticMediumEditor_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_37_src_components_vuestic_components_vuestic_site_SiteDropdown_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_37_src_components_vuestic_components_vuestic_site_SiteDropdown_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_39_src_components_vuestic_components_vuestic_date_picker_VuesticDatePicker__["default"].name, __WEBPACK_IMPORTED_MODULE_39_src_components_vuestic_components_vuestic_date_picker_VuesticDatePicker__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_40_src_components_vuestic_components_vuestic_tree_view_VuesticTreeRoot__["default"].name, __WEBPACK_IMPORTED_MODULE_40_src_components_vuestic_components_vuestic_tree_view_VuesticTreeRoot__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_41_src_components_vuestic_components_vuestic_tree_view_VuesticTreeNode__["default"].name, __WEBPACK_IMPORTED_MODULE_41_src_components_vuestic_components_vuestic_tree_view_VuesticTreeNode__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_42_src_components_vuestic_components_vuestic_tree_view_VuesticTreeCategory__["default"].name, __WEBPACK_IMPORTED_MODULE_42_src_components_vuestic_components_vuestic_tree_view_VuesticTreeCategory__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_43_src_components_vuestic_components_vuestic_radio_button_VuesticRadioButton_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_43_src_components_vuestic_components_vuestic_radio_button_VuesticRadioButton_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_44_src_components_vuestic_components_vuestic_collapse_VuesticAccordion__["default"].name, __WEBPACK_IMPORTED_MODULE_44_src_components_vuestic_components_vuestic_collapse_VuesticAccordion__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_46_src_components_vuestic_components_vuestic_collapse_VuesticAccordionPatientInfo__["default"].name, __WEBPACK_IMPORTED_MODULE_46_src_components_vuestic_components_vuestic_collapse_VuesticAccordionPatientInfo__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_47_src_components_vuestic_components_vuestic_collapse_VuesticAccordionSamplesEntry__["default"].name, __WEBPACK_IMPORTED_MODULE_47_src_components_vuestic_components_vuestic_collapse_VuesticAccordionSamplesEntry__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_45_src_components_vuestic_components_vuestic_collapse_VuesticCollapse__["default"].name, __WEBPACK_IMPORTED_MODULE_45_src_components_vuestic_components_vuestic_collapse_VuesticCollapse__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_48_src_components_vuestic_components_vuestic_collapse_VuesticCollapsePatientInfo__["default"].name, __WEBPACK_IMPORTED_MODULE_48_src_components_vuestic_components_vuestic_collapse_VuesticCollapsePatientInfo__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_49_src_components_vuestic_components_vuestic_collapse_VuesticCollapseSamplesEntry__["default"].name, __WEBPACK_IMPORTED_MODULE_49_src_components_vuestic_components_vuestic_collapse_VuesticCollapseSamplesEntry__["default"]);

    Vue.component(__WEBPACK_IMPORTED_MODULE_50_src_components_obrada_VuesticAccordionObrada__["default"].name, __WEBPACK_IMPORTED_MODULE_50_src_components_obrada_VuesticAccordionObrada__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_51_src_components_obrada_VuesticCollapseObrada__["default"].name, __WEBPACK_IMPORTED_MODULE_51_src_components_obrada_VuesticCollapseObrada__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_52_src_components_obrada_VuesticCollapseNalaz__["default"].name, __WEBPACK_IMPORTED_MODULE_52_src_components_obrada_VuesticCollapseNalaz__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_53_src_components_obrada_VuesticCollapseUzorak__["default"].name, __WEBPACK_IMPORTED_MODULE_53_src_components_obrada_VuesticCollapseUzorak__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_54_src_components_obrada_VuesticModalDelete__["default"].name, __WEBPACK_IMPORTED_MODULE_54_src_components_obrada_VuesticModalDelete__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_55_src_components_obrada_VuesticModalEdit__["default"].name, __WEBPACK_IMPORTED_MODULE_55_src_components_obrada_VuesticModalEdit__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_56_src_components_obrada_VuesticModalMulti__["default"].name, __WEBPACK_IMPORTED_MODULE_56_src_components_obrada_VuesticModalMulti__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_57_src_components_obrada_VuesticModalComment__["default"].name, __WEBPACK_IMPORTED_MODULE_57_src_components_obrada_VuesticModalComment__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_58_src_components_obrada_VuesticModalMail__["default"].name, __WEBPACK_IMPORTED_MODULE_58_src_components_obrada_VuesticModalMail__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_59_src_components_obrada_VuesticModalFind__["default"].name, __WEBPACK_IMPORTED_MODULE_59_src_components_obrada_VuesticModalFind__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_60_src_components_obrada_VuesticModalUzorci__["default"].name, __WEBPACK_IMPORTED_MODULE_60_src_components_obrada_VuesticModalUzorci__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_61_src_components_obrada_VuesticModalError__["default"].name, __WEBPACK_IMPORTED_MODULE_61_src_components_obrada_VuesticModalError__["default"]);


    Vue.mixin(__WEBPACK_IMPORTED_MODULE_36_src_components_vuestic_mixins_VuesticToasted__["a" /* default */]);
    Vue.directive("dropdown", __WEBPACK_IMPORTED_MODULE_38_src_components_vuestic_directives_Dropdown__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (VuesticComponentsPlugin);

/***/ }),

/***/ "Gz5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GzhM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"},on:{"click":function($event){_vm.sessionExpiration($event)},"mousemove":function($event){_vm.sessionExpiration($event)}}},[(_vm.isAuth)?_c('auth-layout'):_c('layout')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H65f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RadarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 110
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      circlesNum: 4
    };
  },


  computed: {
    borderWidth: function borderWidth() {
      return this.size * 5 / 110;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleInnerContainerStyle: function circleInnerContainerStyle() {
      return {
        borderWidth: this.borderWidth + 'px'
      };
    },
    circleInnerStyle: function circleInnerStyle() {
      return {
        borderLeftColor: this.color,
        borderRightColor: this.color,
        borderWidth: this.borderWidth + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = this.animationDuration * 0.15;

      for (var i = 0; i < this.circlesNum; i++) {
        circlesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          padding: this.borderWidth * 2 * i + 'px',
          animationDelay: (i === this.circlesNum - 1 ? 0 : delay) + 'ms'
        }, this.circleStyle));
      }

      return circlesStyles;
    }
  }
});

/***/ }),

/***/ "HHMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ruler),expression:"ruler"}],staticClass:"col-md-12"},[_c('div',{staticClass:"testoviDiv",staticStyle:{"text-align":"center"}},[_vm._l((_vm.testovi),function(test){return _c('div',{key:test.labassay,class:{
                    'btn btn-primary btn-micro' : ((!test.disable || test.disable === undefined) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Lab'), 
                    'btn btn-warning btn-micro' : ((!test.disable || test.disable === undefined) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Calc'), 
                    'btn btn-secondary btn-micro' : ((!test.disable || test.disable === undefined) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Man'),
                    'disabled btn btn-primary btn-micro' : ((test.disable) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Lab'), 
                    'disabled btn btn-warning btn-micro' : ((test.disable ) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Calc'), 
                    'disabled btn btn-secondary btn-micro' : ((test.disable) && _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Man')},attrs:{"name":test.labassay},on:{"click":function($event){_vm.izbaciTest($event, test.disable)}}},[_vm._v(_vm._s(test.ime_testa))])}),_vm._v("  \n                  "),_c('hr')],2),_vm._v(" "),_c('div',_vm._l((Math.ceil(_vm.sviTestovi.length/100)),function(index){return _c('div',{key:index,staticClass:"table",staticStyle:{"text-align":"center"}},_vm._l(((_vm.sviTestovi.slice((index-1)*100,index*100))),function(test){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTest(_vm.$store.state.site, test.analit, _vm.ukGodina, _vm.spol, _vm.drstanje, _vm.menopauza, test.manual, test.calculated)[2] && !test.disabled),expression:"showTest($store.state.site, test.analit, ukGodina, spol, drstanje, menopauza, test.manual, test.calculated)[2] && !test.disabled"}],key:test.labassay,class:{'btn btn-primary btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Lab', 'btn btn-warning btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Calc', 'btn btn-secondary btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Man'},attrs:{"title":test.analit,"align":"middle","id":test.labassay},on:{"click":function($event){_vm.dodajTest($event, test)}}},[_vm._v(_vm._s(test.ime_testa))])}))})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},_vm._l((Math.ceil(_vm.basSviTestovi.length/100)),function(index){return _c('div',{key:index,staticClass:"table",staticStyle:{"text-align":"center"}},_vm._l(((_vm.basSviTestovi.slice((index-1)*100,index*100))),function(test){return _c('div',{key:test.labassay,class:{'btn btn-primary btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Lab', 'btn btn-warning btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Calc', 'btn btn-secondary btn-micro' : _vm.klasaTesta(test.analit, test.manual, test.calculated)[0] === 'Man'},attrs:{"title":test.analit,"align":"middle","id":test.labassay},on:{"click":function($event){_vm.dodajTest($event, test)}}},[_vm._v(_vm._s(test.ime_testa))])}))}))])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HMZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-accordion"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HmjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nalazi',
  meta: {
    expanded: false,
    title: 'Nalazi',
    iconClass: 'vuestic-icon vuestic-icon-forms'
  },

  children: [{
    name: 'nalazi-pregled',
    path: '/nalazi/pregled',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('nalazi/pregled/pregled'),
    meta: {
      title: 'Pregled',
      requiredAuth: true
    }
  }, {
    name: 'nalazi-verifikacija',
    path: '/nalazi/verifikacija',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('nalazi/verifikacija/verifikacija'),
    meta: {
      title: 'Verifikacija',
      requiredAuth: true
    }
  }, {
    name: 'nalazi-outbox',
    path: '/nalazi/outbox',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('nalazi/outbox/outbox'),
    meta: {
      title: 'Odlazna pošta',
      requiredAuth: true
    }
  }]
});

/***/ }),

/***/ "IAP7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IPbX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuestic_directives_Dropdown__ = __webpack_require__("SRTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("/7ZL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-input-select',
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__["default"]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0__vuestic_directives_Dropdown__["a" /* default */]
  },
  props: {
    label: String,
    options: Array,
    value: {
      default: '',
      required: true
    },
    optionKey: String,
    required: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: 'simple-select'
    }
  },
  data: function data() {
    return {
      validated: false,
      displayValue: this.value,
      selectedValue: this.value
    };
  },

  watch: {
    value: {
      handler: function handler(value) {
        if (this.optionKey) {
          this.selectedValue = value[this.optionKey];
          this.displayValue = value[this.optionKey];
        } else {
          this.displayValue = value || '';
          this.selectedValue = value || '';
        }
      },

      immediate: true
    }
  },
  computed: {
    filteredList: function filteredList() {
      var optionKey = this.optionKey;
      var displayValue = this.displayValue;
      if (displayValue === '') {
        return this.options;
      } else {
        return this.options.filter(function (item) {
          if (optionKey && item[optionKey]) {
            if (displayValue) {
              return item[optionKey].toLowerCase().search(displayValue.toLowerCase()) === 0;
            }
          } else {
            return item.toLowerCase().search(displayValue.toLowerCase()) === 0;
          }
        });
      }
    },
    isClearable: function isClearable() {
      return this.clearable && this.selectedValue !== '' && this.displayValue !== '' && this.selectedValue !== undefined;
    },
    placeholder: function placeholder() {
      if (this.optionKey && this.selectedValue) {
        return this.selectedValue[this.optionKey];
      } else {
        return this.selectedValue;
      }
    }
  },
  methods: {
    toggleSelection: function toggleSelection(option) {
      this.isOptionSelected(option) ? this.unselectOption() : this.selectOption(option);
    },
    unselectOption: function unselectOption() {
      this.selectedValue = '';
      this.$emit('input', this.selectedValue);
    },
    showDropdown: function showDropdown() {
      this.displayValue = '';
    },
    isOptionSelected: function isOptionSelected(option) {
      if (this.optionKey) {
        return this.selectedValue === option[this.optionKey];
      } else {
        return this.selectedValue === option;
      }
    },
    selectOption: function selectOption(option) {
      this.displayValue = option;
      this.selectedValue = this.displayValue;
      this.$emit('input', this.selectedValue);
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.value;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.value;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return 'The ' + this.name + ' field is required';
    }
  }
});

/***/ }),

/***/ "IXhG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IbS2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__ = __webpack_require__("iZBt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_135833e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__ = __webpack_require__("1Z18");
function injectStyle (ssrContext) {
  __webpack_require__("vTUu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-135833e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_135833e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_i18n__ = __webpack_require__("kmDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_menu__ = __webpack_require__("ZEli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getters__ = __webpack_require__("UjVw");










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: true,
  getters: __WEBPACK_IMPORTED_MODULE_8__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_4__modules_menu__["a" /* default */]
  },
  state: {
    userId: null,
    language: null,
    token: null,
    site: null,
    idleTime: null,
    displayItems: null,
    pid_bcode: null,

    connect: false,
    notify: false,
    notifym: false,

    alarms: [["Nema pristiglih odobrenja.", "Test"]],
    messages: [["Nema kompletiranih rezultata.", "Test"]],

    korisnici: 0,
    socketid: "",
    dropdown: "RADNA LISTA",
    filter: "",
    odobriSID: "",
    sid: ""
  },
  mutations: {
    changeSid: function changeSid(state, noviSID) {
      state.odobriSID = noviSID;
    },
    SID: function SID(state, sid) {
      state.sid = sid;
    },
    authUser: function authUser(state, userData) {
      state.userId = userData.userId;
      state.language = userData.language;
      state.token = userData.token;
      state.site = userData.site;
      state.idleTime = userData.idleTime;
      state.displayItems = userData.displayItems;
      state.pid_bcode = userData.pid_bcode;

      if (state.alarms[0][0].toString().length > 10) {
        if (state.language === "rs") {
          state.alarms = [["Нема пристиглих одобрења.", "Test"]];
        } else if (state.language === "en") {
          state.alarms = [["There are no approved results.", "Test"]];
        } else {
          state.alarms = [["Nema pristiglih odobrenja.", "Test"]];
        }
      }

      if (state.messages[0][0].toString().length > 10) {
        if (state.language === "rs") {
          state.messages = [["Нема комплетираних резултата.", "Test"]];
        } else if (state.language === "en") {
          state.messages = [["There are no completed results.", "Test"]];
        } else {
          state.messages = [["Nema kompletiranih rezultata.", "Test"]];
        }
      }
    },
    clearAuthData: function clearAuthData(state) {},
    changeSite: function changeSite(state, site) {
      state.site = site;
    },
    changeDropdown: function changeDropdown(state, dropdown) {
      state.dropdown = dropdown;
    },
    changeFilter: function changeFilter(state, filter) {
      state.filter = filter;
      if (filter != "") {}
    },
    resetSite: function resetSite(state) {
      state.alarms = [];
      state.messages = [];

      if (state.language === "rs") {
        state.alarms = [["Нема пристиглих одобрења.", "Test"]];
        state.messages = [["Нема комплетираних резултата.", "Test"]];
      } else if (state.language === "en") {
        state.alarms = [["There are no approved results.", "Test"]];
        state.messages = [["There are no completed results.", "Test"]];
      } else {
        state.alarms = [["Nema pristiglih odobrenja.", "Test"]];
        state.messages = [["Nema kompletiranih rezultata.", "Test"]];
      }

      state.notify = false;
      state.notifym = false;
    },
    resetLanguage: function resetLanguage(state, lng) {
      state.language = lng;

      if (state.alarms[0][0].toString().length > 10) {
        if (state.language === "rs") {
          state.alarms = [["Нема пристиглих одобрења.", "Test"]];
        } else if (state.language === "en") {
          state.alarms = [["There are no approved results.", "Test"]];
        } else {
          state.alarms = [["Nema pristiglih odobrenja.", "Test"]];
        }
      }

      if (state.messages[0][0].toString().length > 10) {
        if (state.language === "rs") {
          state.messages = [["Нема комплетираних резултата.", "Test"]];
        } else if (state.language === "en") {
          state.messages = [["There are no completed results.", "Test"]];
        } else {
          state.messages = [["Nema kompletiranih rezultata.", "Test"]];
        }
      }
    },
    resetidleTime: function resetidleTime(state, tm) {
      state.idleTime = tm;
    },

    SOCKET_CONNECT: function SOCKET_CONNECT(state, status) {
      state.connect = true;
    },
    SOCKET_ODOBREN: function SOCKET_ODOBREN(state, alarm) {
      if (alarm[1] === localStorage.getItem("site")) {
        var uslov = true;

        if (state.alarms[0][0].toString().length > 10) {
          state.alarms = [];
        }

        state.notify = true;
        var niz = [];

        state.alarms.forEach(function (member) {
          if (member[0] === alarm[0]) {
            uslov = false;
          }
        });

        if (uslov) {
          niz.push(alarm[0]);
          niz.push(alarm[2]);
          if (alarm[1] === localStorage.getItem("site")) {
            state.alarms.push(niz);
          } else {
            state.notify = false;
          }
        }
      }
    },
    SOCKET_KOMPLETIRAN: function SOCKET_KOMPLETIRAN(state, message) {
      if (message[1] === localStorage.getItem("site")) {
        var usl = true;

        if (state.messages[0][0].toString().length > 10) {
          state.messages = [];
        }

        state.notifym = true;
        var niz = [];

        state.messages.forEach(function (clan) {
          if (clan[0] === message[0]) {
            usl = false;
          }
        });

        if (usl) {
          niz.push(message[0]);
          niz.push(message[2]);

          if (message[1] === localStorage.getItem("site")) {
            state.messages.push(niz);
          } else {
            state.notifym = false;
          }
        }
      }
    },
    setujAlarme: function setujAlarme(state, element) {
      var niz = [];

      state.alarms.forEach(function (member) {
        if (member[0] != element[0]) {
          niz.push(member);
        }
      });

      state.alarms = niz;
      if (!niz.length) {
        state.notify = false;
        if (state.language === "rs") {
          var a = ["Нема пристиглих одобрења.", "Test"];
        } else if (state.language === "en") {
          var a = ["There are no approved results.", "Test"];
        } else {
          var a = ["Nema pristiglih odobrenja.", "Test"];
        }

        state.alarms.push(a);
      }
    },
    setujMessage: function setujMessage(state, element) {
      var niz = [];

      state.messages.forEach(function (member) {
        if (member[0] != element[0]) {
          niz.push(member);
        }
      });

      state.messages = niz;
      if (!niz.length) {
        state.notifym = false;
        if (state.language === "rs") {
          var b = ["Нема комплетираних резултата.", "Test"];
        } else if (state.language === "en") {
          var b = ["There are no completed results.", "Test"];
        } else {
          var b = ["Nema kompletiranih rezultata.", "Test"];
        }

        state.messages.push(b);
      }
    },
    SOCKET_GET: function SOCKET_GET(state, korisnici) {
      state.korisnici = korisnici;
    }
  },
  actions: {
    setSID: function setSID(_ref, element) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit("changeSid", element);
    },
    SetSample: function SetSample(_ref2, element) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      commit("SID", element);
    },
    dohvatiKorisnike: function dohvatiKorisnike(_ref3) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      this.emit("dohvati");
    },
    izbaciElement: function izbaciElement(_ref4, element) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      commit("setujAlarme", element);
    },
    izbaciElement2: function izbaciElement2(_ref5, element) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      commit("setujMessage", element);
    },
    setLogoutTimer: function setLogoutTimer(_ref6, expirationTime) {
      var commit = _ref6.commit;

      setTimeout(function () {
        commit("clearAuthData");
        __WEBPACK_IMPORTED_MODULE_5__config_config_js__["o" /* http */].post("logout/users", {
          user: localStorage.getItem("userId"),
          language: localStorage.getItem("language"),
          token: localStorage.getItem("token"),
          site: localStorage.getItem("site"),
          idleTime: localStorage.getItem("idleTime"),
          type: "automatic"
        }).then(function (res) {
          __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push("/auth/login");
        });
      }, expirationTime * 1000);
    },
    login: function login(_ref7, authData) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      __WEBPACK_IMPORTED_MODULE_5__config_config_js__["o" /* http */].post("login/users", {
        email: authData.email,
        password: authData.password,
        returnSecureToken: true
      }).then(function (res) {
        if (res.data.success === true) {
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.set(res.data.data.language);
          localStorage.setItem("userId", res.data.data.localId);
          localStorage.setItem("language", res.data.data.language);
          localStorage.setItem("token", res.data.data.idToken);
          localStorage.setItem("site", res.data.data.site);
          localStorage.setItem("idleTime", res.data.data.idleTime);
          commit("authUser", {
            userId: res.data.data.localId,
            language: res.data.data.language,
            token: res.data.data.idToken,
            site: res.data.data.site,
            idleTime: res.data.data.idleTime,
            displayItems: res.data.data.displayItems,
            pid_bcode: res.data.data.pid_bcode
          });

          if (res.data.data.localId === "prijem") {
            __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push("/prijem");
          } else {
            __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push("/");
          }
        } else {
          if (res.data.message === "Greška prilikom konekcije na DB.") {
            __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$emit("UserLoginDB", res.data.message);
          }
          if (res.data.message === "Korisnik nije pronađen.") {
            __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$emit("UserLoginFind", res.data.message);
          }
          if (res.data.message === "Pogrešna šifra.") {
            __WEBPACK_IMPORTED_MODULE_7__main__["bus"].$emit("UserLoginPass", res.data.message);
          }
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    autoLogin: function autoLogin(_ref8) {
      var commit = _ref8.commit;

      var userId = localStorage.getItem("userId");
      var language = localStorage.getItem("language");
      var site = localStorage.getItem("site");
      var idleTime = localStorage.getItem("idleTime");
      var token = localStorage.getItem("token");

      if (!token) {
        return;
      }

      if (userId === "prijem") {
        __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push("/prijem");
      } else {
        __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push("/");
      }

      commit("authUser", {
        userId: userId,
        language: language,
        token: token,
        site: site,
        idleTime: idleTime
      });
    },
    logout: function logout(_ref9, state) {
      var commit = _ref9.commit;

      commit("clearAuthData");

      __WEBPACK_IMPORTED_MODULE_5__config_config_js__["o" /* http */].post("logout/users", {
        user: localStorage.getItem("userId"),
        language: localStorage.getItem("language"),
        token: localStorage.getItem("token"),
        site: localStorage.getItem("site"),
        idleTime: localStorage.getItem("idleTime"),
        type: "manual"
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace("/auth/login");
      });
    },
    siteChange: function siteChange(_ref10, site) {
      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;

      localStorage.setItem("site", site);
      commit("changeSite", site);
    },
    dropdownChange: function dropdownChange(_ref11, dropdown) {
      var commit = _ref11.commit,
          dispatch = _ref11.dispatch;

      commit("changeDropdown", dropdown);
    },
    filterChange: function filterChange(_ref12, filter) {
      var commit = _ref12.commit,
          dispatch = _ref12.dispatch;

      commit("changeFilter", filter);
    },
    siteClear: function siteClear(_ref13, site) {
      var commit = _ref13.commit,
          dispatch = _ref13.dispatch;

      commit("resetSite");
    },
    languageChange: function languageChange(_ref14, lng) {
      var commit = _ref14.commit,
          dispatch = _ref14.dispatch;

      commit("resetLanguage", lng);
    },
    idleTimeChange: function idleTimeChange(_ref15, tm) {
      var commit = _ref15.commit,
          dispatch = _ref15.dispatch;

      commit("resetidleTime", tm);
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex_i18n__["a" /* default */].plugin, store);

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "IqWy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMultiSelect_vue__ = __webpack_require__("3IyO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c38866_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMultiSelect_vue__ = __webpack_require__("muhW");
function injectStyle (ssrContext) {
  __webpack_require__("27W7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c38866_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "J6aD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalSamplesEntryCalendar_vue__ = __webpack_require__("8AZa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2000f312_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalSamplesEntryCalendar_vue__ = __webpack_require__("vbMg");
function injectStyle (ssrContext) {
  __webpack_require__("76ZA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalSamplesEntryCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2000f312_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalSamplesEntryCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JC9T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_tooltip__ = __webpack_require__("VN6J");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tooltip',

  directives: { tooltip: __WEBPACK_IMPORTED_MODULE_1_v_tooltip__["VTooltip"] },

  computed: {
    tooltipOptions: function tooltipOptions() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultOptions, this.options);
    }
  },

  props: {
    options: {
      type: Object,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      defaultOptions: {
        classes: 'vuestic-tooltip'
      }
    };
  }
});

/***/ }),

/***/ "JFBt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JT6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CirclesToRhombusesSpinner_vue__ = __webpack_require__("2Bcf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_04f8cdd5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CirclesToRhombusesSpinner_vue__ = __webpack_require__("BUgK");
function injectStyle (ssrContext) {
  __webpack_require__("QUte")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04f8cdd5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CirclesToRhombusesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_04f8cdd5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CirclesToRhombusesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "JWHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bar",staticClass:"vuestic-progress-bar"},[(_vm.type == 'horizontal')?_c('horizontal-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"size":_vm.size,"color":_vm.color,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e(),_vm._v(" "),(_vm.type == 'vertical')?_c('vertical-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"size":_vm.size,"color":_vm.color,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e(),_vm._v(" "),(_vm.type == 'circle')?_c('circle-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"color":_vm.color,"background-color":_vm.backgroundColor,"start-color":_vm.startColor,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jf5X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue__ = __webpack_require__("Loij");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_43605298_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ChatWindow_vue__ = __webpack_require__("0Hnr");
function injectStyle (ssrContext) {
  __webpack_require__("8278")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43605298"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ChatWindow_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_43605298_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ChatWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Jops":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTablePacijent_vue__ = __webpack_require__("V7LR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_082268e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTablePacijent_vue__ = __webpack_require__("wEYn");
function injectStyle (ssrContext) {
  __webpack_require__("Jqid")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-082268e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTablePacijent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_082268e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTablePacijent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Jqid":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K/BQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TextMessage_vue__ = __webpack_require__("XEVv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TextMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TextMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_07dde37e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TextMessage_vue__ = __webpack_require__("4oxZ");
function injectStyle (ssrContext) {
  __webpack_require__("X11v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07dde37e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TextMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_07dde37e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TextMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "K4gw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K8yz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KGMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__ = __webpack_require__("2QDH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_types_HorizontalProgressBar_vue__ = __webpack_require__("CneO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_types_VerticalProgressBar_vue__ = __webpack_require__("axM2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_types_CircleProgressBar_vue__ = __webpack_require__("pqzW");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-progress-bar',
  components: {
    HorizontalBar: __WEBPACK_IMPORTED_MODULE_1__progress_types_HorizontalProgressBar_vue__["default"],
    VerticalBar: __WEBPACK_IMPORTED_MODULE_2__progress_types_VerticalProgressBar_vue__["default"],
    CircleBar: __WEBPACK_IMPORTED_MODULE_3__progress_types_CircleProgressBar_vue__["default"]
  },
  props: {
    type: {
      type: String,
      default: 'horizontal'
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    size: {
      type: String,
      default: 'basic'
    },
    colorName: {
      type: String,
      default: 'primary'
    },
    startColorName: {
      type: String,
      default: 'lighterGray'
    },
    backgroundColorName: {
      type: String,
      default: 'white'
    }
  },
  watch: {
    value: function value() {
      this.animateValue();
    }
  },
  methods: {
    animateValue: function animateValue() {
      var _this = this;

      var startValue = this.value;
      var valueMsecs = this.valueAnimationInterval / this.max;
      var delta = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default()(this.value - this.animatedValue);
      var valueInterval = setInterval(function () {
        if (!_this.$refs.bar) {
          clearInterval(valueInterval);
          return;
        }
        if (startValue !== _this.value || _this.animatedValue === _this.value) {
          clearInterval(valueInterval);
          if (_this.value === _this.max) {
            _this.isActive = false;
          }
        } else {
          _this.animatedValue += delta;
        }
      }, valueMsecs);
    }
  },
  data: function data() {
    return {
      value: 0,
      valueAnimationInterval: 2000,
      animatedValue: 0,
      isActive: false,
      startColor: this.$store.state.app.config.palette[this.startColorName],
      color: this.$store.state.app.config.palette[this.colorName],
      backgroundColor: this.$store.state.app.config.palette[this.backgroundColorName]
    };
  }
});

/***/ }),

/***/ "Kbmu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KyZu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KzHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function generateRandomId() {
  return Math.floor(Math.random() * Math.pow(10, 10));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-checkbox',
  props: {
    label: String,
    id: {
      type: String,
      default: function _default() {
        return 'label-' + generateRandomId();
      }
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    isCircle: {
      type: Boolean,
      default: false
    },
    brandColor: {
      type: String,
      default: 'primary',
      validator: function validator(value) {
        return ['primary', 'secondary', 'success', 'info', 'warning', 'danger'].indexOf(value) >= 0;
      }
    }
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
  mounted: function mounted() {
    this.$emit('change', this.checked);
  },

  methods: {
    onChange: function onChange(event) {
      this.$emit('change', event.target.checked);
    }
  },
  computed: {
    additionalClasses: function additionalClasses() {
      return [this.isCircle ? 'abc-checkbox-circle' : false, 'abc-checkbox-' + this.brandColor];
    }
  }
});

/***/ }),

/***/ "L2/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTagGroup_vue__ = __webpack_require__("UWEN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_128775a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTagGroup_vue__ = __webpack_require__("V5XA");
function injectStyle (ssrContext) {
  __webpack_require__("ceX3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTagGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_128775a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTagGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LEY3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-uzorci",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Partials");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "LIyU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps simple-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ height: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-line completed-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-indicator"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LYnd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue__ = __webpack_require__("MXoe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_113e1e3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SystemMessage_vue__ = __webpack_require__("T0T4");
function injectStyle (ssrContext) {
  __webpack_require__("lIal")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-113e1e3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SystemMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_113e1e3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SystemMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LeSA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__funkcije_shared_samples_js__ = __webpack_require__("R0++");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__funkcije_shared_samples_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__funkcije_shared_samples_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");


var _methods;





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-edit",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      ruler: false,
      duration: 500,

      ime: "",
      prezime: "",
      jmbg: "",
      spol: "",

      lokacija: "",
      drstanje: "",
      menstc: "",
      anticoag: "",
      menopauza: "",

      jmbgObj: {},
      jmbgDan: "",
      jmbgMjesec: "",
      jmbgGodina: "",
      ukGodina: "",

      tip: "",

      sekcija: [],
      izabraniTestovi: [],
      sviTestovi: [],
      sviRezultati: [],
      basSviTestovi: [],
      testovi: [],

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: (_methods = {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.EditSample();

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.GetSample();
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    EditSample: function EditSample() {},
    GetSample: function GetSample() {
      var _this = this;

      this.ruler = false;
      this.izabraniTestovi = [];
      this.sviTestovi = [];
      this.basSviTestovi = [];
      this.testovi = [];

      __WEBPACK_IMPORTED_MODULE_1__config_config_js__["o" /* http */].get("uzorci/show/" + this.$store.state.sid + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
        _this.ime = res.data.uzorak.patient.ime;
        _this.prezime = res.data.uzorak.patient.prezime;
        _this.jmbg = res.data.uzorak.patient.jmbg;
        _this.spol = res.data.uzorak.patient.spol;

        _this.lokacija = res.data.uzorak.lokacija.lokacija;
        _this.drstanje = res.data.uzorak.trudnica;
        _this.menstc = res.data.uzorak.menstc;
        _this.anticoag = res.data.uzorak.anticoag;
        _this.menopauza = res.data.uzorak.menopauza;
        _this.tip = res.data.uzorak.type;
        _this.sekcija = res.data.uzorak.sekcija;
        _this.izabraniTestovi = res.data.uzorak.tests;
        _this.sviRezultati = res.data.rezultat.rezultati;
        _this.ukupnaStarost();

        __WEBPACK_IMPORTED_MODULE_1__config_config_js__["o" /* http */].post("/uzorci/labassay/tip", {
          sekcija: _this.sekcija,
          token: _this.$store.state.token,
          tip: res.data.rezultat.rezultati[0].labassay.tip,
          site: _this.$store.state.site
        }).then(function (res) {
          if (res.data.success === false) {
            _this.sviTestovi = [];
          } else {
            _this.sviTestovi = [];

            res.data.testovi.forEach(function (element) {
              _this.basSviTestovi.push({
                labassay: element._id,
                ime_testa: element.naziv,
                cijena: element.price,
                analit: element.analit,
                sekcija: element.sekcija,
                manual: element.manual,
                calculated: element.calculated,
                calculatedTests: element.calculatedTests
              });

              if (Object(__WEBPACK_IMPORTED_MODULE_2__funkcije_shared_samples_js__["sampleSelection"])(_this.$store.state.site, element.analit, _this.ukGodina, _this.spol, _this.drstanje, _this.menopauza)[1]) {
                _this.sviTestovi.push({
                  disabled: element.disabled,
                  labassay: element._id,
                  ime_testa: element.naziv,
                  cijena: element.price,
                  analit: element.analit,
                  sekcija: element.sekcija,
                  manual: element.manual,
                  calculated: element.calculated,
                  calculatedTests: element.calculatedTests
                });
              }
            });
          }
        }).then(function (res) {
          var editable = true;
          _this.sviTestovi.forEach(function (element) {
            _this.izabraniTestovi.forEach(function (izabrani) {
              if (izabrani.labassay._id === element.labassay) {
                editable = false;

                _this.sviRezultati.forEach(function (rez) {
                  if (rez.labassay._id === element.labassay) {
                    if (rez.rezultat[rez.rezultat.length - 1].rezultat_f != "") {
                      editable = true;
                    }
                  }
                });

                _this.dodajTestInit(element.labassay, element.ime_testa, izabrani.labassay.manual, izabrani.status_t, editable);
              }
            });
          });

          for (var i = _this.sviTestovi.length - 1; i >= 0; i--) {
            for (var j = 0; j < _this.izabraniTestovi.length; j++) {
              if (_this.sviTestovi[i] && _this.sviTestovi[i].labassay === _this.izabraniTestovi[j].labassay._id) {
                _this.sviTestovi.splice(i, 1);
              }
            }
          }
        }).then(function (res) {
          _this.ruler = true;
          _this.show = true;
        });
      });
    },
    removeDuplicates: function removeDuplicates(originalArray, prop) {
      var newArray = [];
      var lookupObject = {};

      for (var i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
      }

      for (i in lookupObject) {
        newArray.push(lookupObject[i]);
      }
      return newArray;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "EditSample", function EditSample() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__config_config_js__["o" /* http */].post("/uzorci/update", {
      sid: this.$store.state.sid,
      jmbg: this.jmbg,
      testovi: this.testovi,
      token: this.$store.state.token,
      site: this.$store.state.site,
      spol: this.spol,
      trudnica: this.drstanje,
      menstc: this.menstc,
      anticoag: this.anticoag,
      menopauza: this.menopauza,
      jmbgObj: this.jmbgObj
    }).then(function (res) {
      if (res.data.success === true) {
        _this2.toastText = "Uzorak uspješno izmijenjen!";
        _this2.toastIcon = "fa-check";
        _this2.toastPosition = "top-right";
        _this2.className = "vuestic-toast-primary";

        _this2.showToast(_this2.toastText, {
          icon: _this2.toastIcon,
          position: _this2.toastPosition,
          duration: _this2.toastDuration,
          fullWidth: _this2.isToastFullWidth,
          className: _this2.className
        });

        _this2.show = false;
        __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("Edited", _this2.$store.state.sid);
      } else {
        _this2.toastText = "Greška prilikom izmjene uzorka!";
        _this2.toastIcon = "fa-remove";
        _this2.toastPosition = "top-right";
        _this2.className = "vuestic-toast-danger";

        _this2.showToast(_this2.toastText, {
          icon: _this2.toastIcon,
          position: _this2.toastPosition,
          duration: _this2.toastDuration,
          fullWidth: _this2.isToastFullWidth,
          className: _this2.className
        });
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "ukupnaStarost", function ukupnaStarost() {
    var str = "";
    var tmp = "";
    this.jmbgDan = this.jmbg.slice(0, 2);
    this.jmbgMjesec = this.jmbg.slice(2, 4);
    this.jmbgGodina = this.jmbg.slice(4, 7);

    if (this.jmbgGodina[0] === "9") {
      str = "1";
      tmp = this.jmbgGodina;
      this.jmbgGodina = str.concat(tmp);
    } else if (this.jmbgGodina[0] === "0") {
      str = "2";
      tmp = this.jmbgGodina;
      this.jmbgGodina = str.concat(tmp);
    } else {}

    var date = this.jmbgGodina + "-" + this.jmbgMjesec + "-" + this.jmbgDan;
    this.jmbgObj = this.dateDiff(date);
    this.ukGodina = this.jmbgObj.years + 1;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "dateDiff", function dateDiff(date) {
    date = date.split("-");
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    var day = today.getDate();
    var yy = parseInt(date[0]);
    var mm = parseInt(date[1]);
    var dd = parseInt(date[2]);
    var years, months, days;

    months = month - mm;

    if (day < dd) {
      months = months - 1;
    }

    years = year - yy;

    if (month * 100 + day < mm * 100 + dd) {
      years = years - 1;
      months = months + 12;
    }

    days = Math.floor((today.getTime() - new Date(yy + years, mm + months - 1, dd).getTime()) / (24 * 60 * 60 * 1000));

    return {
      years: years,
      months: months,
      days: days
    };
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "dodajTestInit", function dodajTestInit(event, ime, manual, status, editable) {
    var _this3 = this;

    if (this.testovi.length < 1) {
      this.placeholder = "";
    }

    var manual = false;
    var calculated = false;
    var kalkuliraniTestovi = [];
    var sekc = "";
    var anlit = "";
    var cost = "";

    if (!this.testovi.filter(function (test) {
      return test.labassay === event;
    }).length > 0) {
      this.sviTestovi.forEach(function (element) {
        if (event === element.labassay) {
          sekc = element.sekcija;
          anlit = element.analit;
          cost = element.cijena;
        }

        if (element.manual && event === element.labassay) {
          manual = true;
        }

        if (element.calculated && event === element.labassay) {
          calculated = true;

          element.calculatedTests.forEach(function (kalk) {
            kalk.sekcija = element.sekcija;
            kalk.calculated = false;
            kalk.calculatedTests = [];
            kalk.cijena = "0";
            kalk.disable = true;

            _this3.basSviTestovi.forEach(function (bastest) {
              if (bastest.labassay === kalk.labassay) {
                kalk.cijena = bastest.cijena;
                kalk.analit = bastest.analit;
              }
            });

            if (!_this3.testovi.filter(function (test) {
              return test.labassay === kalk.labassay;
            }).length > 0) {
              _this3.testovi.push(kalk);
            }

            kalkuliraniTestovi.push(kalk);
          });
        }
      });

      this.testovi.push({
        disable: editable,
        labassay: event,
        ime_testa: ime,
        cijena: cost,
        analit: anlit,
        sekcija: sekc,
        manual: manual,
        calculated: calculated,
        calculatedTests: kalkuliraniTestovi
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "dodajTest", function dodajTest(event) {
    var _this4 = this;

    if (this.testovi.length < 1) {
      this.placeholder = "";
    }
    var manual = false;
    var calculated = false;
    var kalkuliraniTestovi = [];
    var sekc = "";
    var anlit = "";
    var cost = "";

    if (!this.testovi.filter(function (test) {
      return test.labassay === event.target.id;
    }).length > 0) {
      this.sviTestovi.forEach(function (element) {
        if (event.target.id === element.labassay) {
          sekc = element.sekcija;
          anlit = element.analit;
          cost = element.cijena;
        }
        if (element.manual && event.target.id === element.labassay) {
          manual = true;
        }
        if (element.calculated && event.target.id === element.labassay) {
          calculated = true;

          element.calculatedTests.forEach(function (kalk) {
            kalk.sekcija = element.sekcija;
            kalk.calculated = false;
            kalk.calculatedTests = [];
            kalk.cijena = "0";

            _this4.basSviTestovi.forEach(function (bastest) {
              if (bastest.labassay === kalk.labassay) {
                kalk.cijena = bastest.cijena;
                kalk.analit = bastest.analit;
              }
            });

            if (!_this4.testovi.filter(function (test) {
              return test.labassay === kalk.labassay;
            }).length > 0) {
              _this4.testovi.push(kalk);
            }

            kalkuliraniTestovi.push(kalk);
            document.getElementById(kalk.labassay).className = "btn btn-info btn-micro";
          });
        }
      });

      this.testovi.push({
        labassay: event.target.id,
        ime_testa: event.target.innerText,
        cijena: cost,
        analit: anlit,
        sekcija: sekc,
        manual: manual,
        calculated: calculated,
        calculatedTests: kalkuliraniTestovi
      });

      document.getElementById(event.target.id).className = "btn btn-info btn-micro";
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "izbaciTest", function izbaciTest(event, disable) {
    if (disable != undefined && disable) {
      this.toastText = "Test nije moguće ukloniti!";
      this.toastIcon = "fa-warning";
      this.toastPosition = "top-right";
      this.className = "vuestic-toast-warning";

      this.showToast(this.toastText, {
        icon: this.toastIcon,
        position: this.toastPosition,
        duration: this.toastDuration,
        fullWidth: this.isToastFullWidth,
        className: this.className
      });
    } else {
      if (this.testovi.length < 2) {
        this.toastText = "Test nije moguće ukloniti! Zatvorite prozor i obrišite uzorak.";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      } else {
        var alert = false;
        var izbaciti = event.target.getAttribute("name");
        var count = 0;

        this.testovi.forEach(function (element) {
          if (element.calculated) {
            element.calculatedTests.forEach(function (kalk) {
              if (izbaciti === kalk.labassay) {
                count++;
              }
            });
          }
        });

        if (count > 0) {
          alert = false;
          this.toastText = "Test nije moguće ukloniti!";
          this.toastIcon = "fa-warning";
          this.toastPosition = "top-right";
          this.className = "vuestic-toast-warning";

          this.showToast(this.toastText, {
            icon: this.toastIcon,
            position: this.toastPosition,
            duration: this.toastDuration,
            fullWidth: this.isToastFullWidth,
            className: this.className
          });
        } else {
          alert = true;
        }

        if (alert) {
          if (this.testovi.length < 2) {
            this.placeholder = "Izaberite testove";
          }
          this.test = event.target.innerText;
          for (var i = 0; i < this.testovi.length; i++) {
            if (this.testovi[i].labassay === event.target.getAttribute("name")) {
              this.testovi.splice(i, 1);
              break;
            }
          }
          if (event.target.className === "btn btn-primary btn-micro") {
            document.getElementById(event.target.getAttribute("name")).className = "btn btn-primary btn-micro";
          }
          if (event.target.className === "btn btn-secondary btn-micro") {
            document.getElementById(event.target.getAttribute("name")).className = "btn btn-secondary btn-micro";
          }
          if (event.target.className === "btn btn-warning btn-micro") {
            document.getElementById(event.target.getAttribute("name")).className = "btn btn-warning btn-micro";
          }
        }
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "klasaTesta", function klasaTesta(naziv, manual, calculated) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__funkcije_shared_samples_js__["sampleSelection"])(this.$store.state.site, naziv, "", "", "", "", manual, calculated);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "showTest", function showTest(site, analit, godina, spol, drstanje, menopauza, manual, calculated) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__funkcije_shared_samples_js__["sampleSelection"])(site, analit, godina, spol, drstanje, menopauza, manual, calculated);
  }), _methods)
});

/***/ }),

/***/ "Lk68":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LlPC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Loij":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__("lwql");

var _Header2 = _interopRequireDefault(_Header);

var _MessageList = __webpack_require__("wyO6");

var _MessageList2 = _interopRequireDefault(_MessageList);

var _UserInput = __webpack_require__("WQZp");

var _UserInput2 = _interopRequireDefault(_UserInput);

var _UserList = __webpack_require__("uezS");

var _UserList2 = _interopRequireDefault(_UserList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Zaglavlje: _Header2.default,
    MessageList: _MessageList2.default,
    UserInput: _UserInput2.default,
    UserList: _UserList2.default
  },
  props: {
    showEmoji: {
      type: Boolean,
      default: false
    },
    showFile: {
      type: Boolean,
      default: false
    },
    participants: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    titleImageUrl: {
      type: String,
      default: ''
    },
    onUserInputSubmit: {
      type: Function,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    messageList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isOpen: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    placeholder: {
      type: String,
      default: 'Write a reply'
    },
    showTypingIndicator: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    alwaysScrollToBottom: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      showUserList: false
    };
  },

  computed: {
    messages: function messages() {
      var messages = this.messageList;

      return messages;
    }
  },
  methods: {
    handleUserListToggle: function handleUserListToggle(showUserList) {
      this.showUserList = showUserList;
    }
  }
};

/***/ }),

/***/ "LtNJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTabs_vue__ = __webpack_require__("MhID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa8bee2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTabs_vue__ = __webpack_require__("eSeH");
function injectStyle (ssrContext) {
  __webpack_require__("tj1/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa8bee2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "M7H8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fulfilling-square-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinner-inner",style:(_vm.spinnerInnerStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7d48b18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("GzhM");
function injectStyle (ssrContext) {
  __webpack_require__("7O4P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7d48b18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9yq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MCoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeCategory_vue__ = __webpack_require__("Rn6B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4ed4816_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeCategory_vue__ = __webpack_require__("6Qk6");
function injectStyle (ssrContext) {
  __webpack_require__("c6WB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4ed4816_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MEVT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navbar_Navbar__ = __webpack_require__("QI9S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidebar_Sidebar__ = __webpack_require__("jEUr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_directives_ResizeHandler__ = __webpack_require__("noQ4");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'layout',

  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_2__navbar_Navbar__["default"],
    Sidebar: __WEBPACK_IMPORTED_MODULE_3__sidebar_Sidebar__["default"]
  },
  directives: {
    resize: __WEBPACK_IMPORTED_MODULE_4_directives_ResizeHandler__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['sidebarOpened', 'toggleWithoutAnimation', 'isLoading']), {
    classObject: function classObject() {
      return {
        'sidebar-hidden': !this.toggleWithoutAnimation && !this.sidebarOpened,
        'sidebar-hidden sidebar-hidden_without-animation': this.toggleWithoutAnimation && !this.sidebarOpened
      };
    }
  })
});

/***/ }),

/***/ "MMrO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-accordion-samples-entry',
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastClickedTab: {}
    };
  },
  provide: function provide() {
    var _this = this;

    return {
      accordion: {
        onChildChange: function onChildChange(child, state) {
          return _this.onChildChange(child, state);
        }
      }
    };
  },

  methods: {
    onChildChange: function onChildChange(child, state) {
      if (this.expand) {
        return;
      }

      if (state === false) {
        return;
      }

      this.$children.forEach(function (collapse) {
        if (collapse === child) {
          return;
        }
        collapse.collapse();
      });
    }
  }
});

/***/ }),

/***/ "MXoe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "MhID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tabs',
  props: ['names', 'sekcija'],
  computed: {
    underscoreClass: function underscoreClass() {
      return 'underscore-' + this.names.length + '-' + this.names.indexOf(this.currentActive);
    }
  },
  created: function created() {},

  methods: {
    setActive: function setActive(name) {
      this.currentActive = name;
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('tabChanged', name);
    }
  },
  data: function data() {
    return {
      currentActive: this.sekcija
    };
  }
});

/***/ }),

/***/ "MjgR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MwS+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mwi8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'analize',
  path: '/postavke/analize',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('postavke/analize/Analize'),
  meta: {
    default: false,
    expanded: false,
    title: 'Reference',
    iconClass: 'glyphicon glyphicon-stats',
    requiredAuth: true
  }
});

/***/ }),

/***/ "N6Uh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FlowerSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      smallerDotAnimationBaseName: 'flower-spinner-smaller-dot-animation',
      biggerDotAnimationBaseName: 'flower-spinner-bigger-dot-animation',
      currentSmallerDotAnimationBaseName: '',
      currentBiggerDotAnimationBaseName: ''
    };
  },


  computed: {
    dotSize: function dotSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    dotsContainerStyle: function dotsContainerStyle() {
      return {
        width: this.dotSize + 'px',
        height: this.dotSize + 'px'
      };
    },
    smallerDotStyle: function smallerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentSmallerDotAnimationBaseName
      };
    },
    biggerDotStyle: function biggerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentBiggerDotAnimationBaseName
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentSmallerDotAnimationBaseName, this.generateSmallerDotKeyframes());
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentBiggerDotAnimationBaseName, this.generateBiggerDotKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentSmallerDotAnimationBaseName = this.smallerDotAnimationBaseName + '-' + Date.now();
      this.currentBiggerDotAnimationBaseName = this.biggerDotAnimationBaseName + '-' + Date.now();
    },
    generateSmallerDotKeyframes: function generateSmallerDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    },
    generateBiggerDotKeyframes: function generateBiggerDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                50% {\n                  transform: rotate(180deg);\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  transform: rotate(360deg);\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    }
  }
});

/***/ }),

/***/ "N84j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.file)?_c('div',{staticClass:"file-container",style:({backgroundColor: _vm.colors.userInput.text, color: _vm.colors.userInput.bg})},[_vm._m(0),_vm._v("\n    "+_vm._s(_vm.file.name)+"\n    "),_c('span',{staticClass:"delete-file-message",on:{"click":function($event){_vm.cancelFile()}}},[_c('img',{attrs:{"src":__webpack_require__("aLFs"),"alt":"close icon","height":"10","title":"Remove the file"}})])]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"sc-user-input",class:{active: _vm.inputActive},style:({background: _vm.colors.userInput.bg})},[_c('div',{ref:"userInput",staticClass:"sc-user-input--text",style:({color: _vm.colors.userInput.text}),attrs:{"role":"button","tabIndex":"0","contentEditable":"true","placeholder":_vm.placeholder},on:{"focus":function($event){_vm.setInputActive(true)},"blur":function($event){_vm.setInputActive(false)},"keydown":_vm.handleKey}}),_vm._v(" "),_c('div',{staticClass:"sc-user-input--buttons"},[_c('div',{staticClass:"sc-user-input--button"}),_vm._v(" "),(_vm.showEmoji)?_c('div',{staticClass:"sc-user-input--button"},[_c('EmojiIcon',{attrs:{"onEmojiPicked":_vm._handleEmojiPicked,"color":_vm.colors.userInput.text}})],1):_vm._e(),_vm._v(" "),(_vm.showFile)?_c('div',{staticClass:"sc-user-input--button"},[_c('FileIcons',{attrs:{"onChange":_vm._handleFileSubmit,"color":_vm.colors.userInput.text}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sc-user-input--button"},[_c('SendIcon',{attrs:{"onClick":_vm._submitText,"color":_vm.colors.userInput.text}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-file-message"},[_c('img',{attrs:{"src":__webpack_require__("w+sz"),"alt":"genericFileIcon","height":"15"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NG7M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModal_vue__ = __webpack_require__("dtfx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c3894aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModal_vue__ = __webpack_require__("St2u");
function injectStyle (ssrContext) {
  __webpack_require__("C8uP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c3894aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c3894aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bus", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("4TSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_vuestic_components_vuestic_components_plugin__ = __webpack_require__("GslS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_idle_vue__ = __webpack_require__("VsiT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_idle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_idle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_dialog__ = __webpack_require__("7VfX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuejs_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_liquor_tree__ = __webpack_require__("ZIfW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_crip_vue_notice__ = __webpack_require__("sLv0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_crip_vue_notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_crip_vue_notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_socket_io_client__ = __webpack_require__("DmT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_socket_io__ = __webpack_require__("hMcO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_socket_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_socket_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_flatpickr_component__ = __webpack_require__("B+20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_flatpickr_dist_flatpickr_css__ = __webpack_require__("K4gw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_flatpickr_dist_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_flatpickr_dist_flatpickr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_spinkit__ = __webpack_require__("iclY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_spinkit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_spinkit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_lodash__ = __webpack_require__("NETs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_beautiful_chat__ = __webpack_require__("zUV7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_beautiful_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_beautiful_chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_multiselect__);
























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_socket_io___default.a, __WEBPACK_IMPORTED_MODULE_13_socket_io_client___default()(__WEBPACK_IMPORTED_MODULE_15__config_config_js__["q" /* serverSocket */]), __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_crip_vue_notice___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vuejs_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_src_components_vuestic_components_vuestic_components_plugin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_liquor_tree__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_flatpickr_component___default.a);

var options = {
  name: "lodash"
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_lodash___default.a, options);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("multiselect", __WEBPACK_IMPORTED_MODULE_21_vue_multiselect___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("Spinner", __WEBPACK_IMPORTED_MODULE_18_vue_spinkit___default.a);

var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate___default.a, { fieldsBagName: "formFields" });

var eventsHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_idle_vue___default.a, {
  eventEmitter: eventsHub,
  idleTime: 28800000 });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_beautiful_chat___default.a);

Object(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

var mediaHandler = function mediaHandler() {
  if (window.matchMedia(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.config.windowMatchSizeLg).matches) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch("toggleSidebar", true);
  } else {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch("toggleSidebar", false);
  }
};

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("setLoading", true);
  next();
});

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].afterEach(function (to, from) {
  mediaHandler();
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit("setLoading", false);
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NKe1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalCommenting_vue__ = __webpack_require__("E5pB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ccd5ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalCommenting_vue__ = __webpack_require__("7jA5");
function injectStyle (ssrContext) {
  __webpack_require__("l7Wu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalCommenting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50ccd5ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalCommenting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NO4k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NPbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScalingSquaresSpinner_vue__ = __webpack_require__("3Alh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_82b59c7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ScalingSquaresSpinner_vue__ = __webpack_require__("f6HS");
function injectStyle (ssrContext) {
  __webpack_require__("MwS+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-82b59c7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScalingSquaresSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_82b59c7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ScalingSquaresSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "NQTJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NS1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var duration = binding.value.duration || 500;
    var isAnimated = binding.value.animate;

    var observer = new MutationObserver(scrollToBottom);
    var config = { childList: true };
    observer.observe(el, config);

    function animateScroll(duration) {
      var start = el.scrollTop;
      var end = el.scrollHeight;
      var change = end - start;
      var increment = 20;

      function easeInOut(currentTime, start, change, duration) {
        currentTime /= duration / 2;
        if (currentTime < 1) {
          return change / 2 * currentTime * currentTime + start;
        }
        currentTime -= 1;
        return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
      }

      function animate(elapsedTime) {
        elapsedTime += increment;
        var position = easeInOut(elapsedTime, start, change, duration);
        el.scrollTop = position;

        if (elapsedTime < duration) {
          setTimeout(function () {
            animate(elapsedTime);
          }, increment);
        }
      }

      animate(0);
    }

    function scrollToBottom() {
      if (isAnimated) {
        animateScroll(duration);
      } else {
        el.scrollTop = el.scrollHeight;
      }
    }
  }
});

/***/ }),

/***/ "NWbm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'assays',
  path: '/postavke/assays',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('assays/Assays'),
  meta: {
    default: false,
    expanded: false,
    title: 'Assays',
    iconClass: 'fa fa-font',
    requiredAuth: true
  }
});

/***/ }),

/***/ "NYsZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NbLI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NkBS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NoHb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Pie"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], _this.defaultOptions, _this.options);
      _this.renderChart(_this.data, options);
    }, 600);
  }
}));

/***/ }),

/***/ "NoRX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"looping-rhombuses-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.rhombusesStyles),function(rs,index){return _c('div',{staticClass:"rhombus",style:(rs),attrs:{"ikey":index}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NpL0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SemipolarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 5
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderTopColor: this.color,
        borderLeftColor: this.color
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var delayModifier = 0.1;
      var ringWidth = this.size * 0.05;
      var positionIncrement = ringWidth * 2;
      var sizeDecrement = this.size * 0.2;

      for (var i = 0; i < this.ringsNum; i++) {
        var computedSize = this.size - sizeDecrement * i + 'px';
        var computedPosition = positionIncrement * i + 'px';
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: this.animationDuration * delayModifier * (this.ringsNum - i - 1) + 'ms',
          height: computedSize,
          width: computedSize,
          left: computedPosition,
          top: computedPosition,
          borderWidth: ringWidth + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),

/***/ "NrN+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O3lU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__("mUJ2")("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),

/***/ "ONfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message"},[_c('div',{staticClass:"sc-message--content",class:{
      sent: _vm.message.author === 'me',
      received: _vm.message.author !== 'me' && _vm.message.type !== 'system',
      system: _vm.message.type === 'system'
    }},[(_vm.message.type !== 'system')?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.message.author),expression:"message.author"}],staticClass:"sc-message--avatar",style:({
      backgroundImage: ("url(" + _vm.chatImageUrl + ")")
    }),attrs:{"title":_vm.authorName}}):_vm._e(),_vm._v(" "),(_vm.message.type === 'text')?_c('TextMessage',{attrs:{"data":_vm.message.data,"messageColors":_vm.determineMessageColors()}}):(_vm.message.type === 'emoji')?_c('EmojiMessage',{attrs:{"data":_vm.message.data}}):(_vm.message.type === 'file')?_c('FileMessage',{attrs:{"data":_vm.message.data,"messageColors":_vm.determineMessageColors()}}):(_vm.message.type === 'typing')?_c('TypingMessage',{attrs:{"messageColors":_vm.determineMessageColors()}}):(_vm.message.type === 'system')?_c('SystemMessage',{attrs:{"data":_vm.message.data,"messageColors":_vm.determineMessageColors()}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OPCq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'vuestic-switch-2':_vm.value, 'vuestic-switch-1':!_vm.value,}},[_c('div',{staticClass:"vuestic-switch-option1 true-option",class:{'active': _vm.value},on:{"click":function($event){$event.preventDefault();_vm.setValue(true)}}},[_vm._t("trueTitle")],2),_vm._v(" "),_c('div',{staticClass:"vuestic-switch-option2 false-option",class:{'active': !_vm.value},on:{"click":function($event){$event.preventDefault();_vm.setValue(false)}}},[_vm._t("falseTitle")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OPFe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Expanding_vue__ = __webpack_require__("WHJM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25c89708_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Expanding_vue__ = __webpack_require__("v4fJ");
function injectStyle (ssrContext) {
  __webpack_require__("wxA5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25c89708"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Expanding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25c89708_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Expanding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OR0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var ddToggle = el.querySelector('.dropdown-toggle');
    var ddMenu = el.querySelector('.dropdown-menu');
    var closeOnMenuClick = binding.modifiers.closeOnMenuClick;

    ddToggle.addEventListener('click', function (evt) {
      evt.preventDefault();
      var isShown = el.classList.contains('show');
      setTimeout(function () {
        el.classList.toggle('show', !isShown);
        ddMenu.classList.toggle('show', !isShown);
      });
    });

    window.addEventListener('click', function () {
      el.classList.remove('show');
      ddMenu.classList.remove('show');
    });

    ddMenu.addEventListener('click', function (evt) {
      if (!closeOnMenuClick) {
        evt.stopPropagation();
      }
    });
  }
});

/***/ }),

/***/ "OtBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFixedHeader)?_c('div',[_c('div',{staticClass:"vuetable-head-wrapper"},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableHeaderClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){_vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{class:['vuetable-th-sequence', field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{class:['vuetable-th-'+field.name, field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{class:['vuetable-th-'+field.name, field.titleClass,  {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}})]]:_vm._e()]}),_vm._v(" "),(_vm.scrollVisible)?_c('th',{staticClass:"vuetable-gutter-col",style:({width: _vm.scrollBarWidth})}):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"vuetable-body-wrapper",style:({height: _vm.tableHeight})},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableBodyClass]},[_c('colgroup',[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[[_c('col',{class:['vuetable-th-'+field.name, field.titleClass],style:({width: field.width}),attrs:{"id":'_col_' + field.name}})]]:_vm._e()]})],2),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,index){return [_c('tr',{class:_vm.onRowClass(item, index),attrs:{"item-index":index,"render":_vm.onRowChanged(item)},on:{"dblclick":function($event){_vm.onRowDoubleClicked(item, $event)},"click":function($event){_vm.onRowClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(index))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){_vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":index,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{rowData:item,rowIndex:index,rowField:field.sortField})],2):_vm._e()]:[_c('td',{class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.renderNormalField(field, item))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){_vm.onDetailRowClick(item, $event)}}},[_c('transition',{attrs:{"name":_vm.detailRowTransition}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":index}})],1)])],1):_vm._e()]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields}},[_vm._v(_vm._s(_vm.noDataTemplate))])])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field){return [(field.visible)?_c('td',[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])])]):_c('table',{class:['vuetable', _vm.css.tableClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){_vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{class:['vuetable-th-sequence', field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{class:['vuetable-th-'+field.name, field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{class:['vuetable-th-'+field.name, field.titleClass,  {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}})]]:_vm._e()]})],2)]),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,index){return [_c('tr',{class:_vm.onRowClass(item, index),attrs:{"item-index":index,"render":_vm.onRowChanged(item)},on:{"dblclick":function($event){_vm.onRowDoubleClicked(item, $event)},"click":function($event){_vm.onRowClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(index))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){_vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":index,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{rowData:item,rowIndex:index,rowField:field.sortField})],2):_vm._e()]:[(_vm.hasCallback(field))?_c('td',{class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.callCallback(field, item))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)}}}):_c('td',{class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.getObjectValue(item, field.name, ''))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){_vm.onDetailRowClick(item, $event)}}},[_c('transition',{attrs:{"name":_vm.detailRowTransition}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":index}})],1)])],1):_vm._e()]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields},domProps:{"innerHTML":_vm._s(_vm.noDataTemplate)}})])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field){return [(field.visible)?_c('td',[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P2Ka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticInputSelect_vue__ = __webpack_require__("IPbX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb58ef0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticInputSelect_vue__ = __webpack_require__("PKLz");
function injectStyle (ssrContext) {
  __webpack_require__("Kbmu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticInputSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bb58ef0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticInputSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "P8iw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{'vuestic-collapse__header--no-header': _vm.noHeader},on:{"click":function($event){$event.preventDefault();_vm.onHeaderClick($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{staticClass:"vuestic-collapse__header__button btn btn-danger",staticStyle:{"height":"40px","padding-top":"0.6rem"}},[_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"col-md-7 icon-bar pull-right"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),(!_vm.hitan)?_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-star-o",attrs:{"id":"star-o"}})]):_vm._e(),_vm._v(" "),(_vm.hitan)?_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-star",attrs:{"id":"star"}})]):_vm._e()])],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-remove",attrs:{"id":"remove"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-commenting",attrs:{"id":"commenting"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-calendar",attrs:{"id":"calendar"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PFUe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Message_vue__ = __webpack_require__("Tk3j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_502954eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Message_vue__ = __webpack_require__("ONfT");
function injectStyle (ssrContext) {
  __webpack_require__("NbLI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Message_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_502954eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Message_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PKLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-simple-select"},[_c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.isBlocked",modifiers:{"isBlocked":true}}],staticClass:"form-group with-icon-right dropdown select-form-group",class:{'has-error': _vm.hasErrors()}},[_c('div',{staticClass:"input-group dropdown-toggle vuestic-simple-select__dropdown-toggle"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayValue),expression:"displayValue"}],class:{'has-value': !!_vm.value},attrs:{"name":_vm.name,"options":_vm.options},domProps:{"value":(_vm.displayValue)},on:{"focus":function($event){_vm.showDropdown()},"input":function($event){if($event.target.composing){ return; }_vm.displayValue=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v("\n          "+_vm._s(_vm.showRequiredError())+"\n        ")])]),_vm._v(" "),_c('i',{staticClass:"ion ion-ios-arrow-down icon-right input-icon vuestic-simple-select__dropdown-arrow",on:{"click":_vm.showDropdown}})]),_vm._v(" "),(_vm.isClearable)?_c('div',[_c('i',{staticClass:"fa fa-close icon-cross icon-right input-icon vuestic-simple-select__unselect",on:{"click":_vm.unselectOption}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dropdown-menu vuestic-simple-select__dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content vuestic-simple-select__dropdown-menu-content"},_vm._l((_vm.filteredList),function(option){return _c('div',{staticClass:"dropdown-item vuestic-simple-select__dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.toggleSelection(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.optionKey ? option[_vm.optionKey] : option))])])}))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PNnd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PpPr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTooltip_vue__ = __webpack_require__("JC9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3940a82b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTooltip_vue__ = __webpack_require__("ibxE");
function injectStyle (ssrContext) {
  __webpack_require__("UVSd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3940a82b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3940a82b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Q4Rp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFeed_vue__ = __webpack_require__("gvyn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1841c5aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFeed_vue__ = __webpack_require__("a5v7");
function injectStyle (ssrContext) {
  __webpack_require__("zfyz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1841c5aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QH5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rezultati-odobravanje',
  path: '/rezultati/verifikacija/',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('rezultati/verifikacija/verifikacija'),
  meta: {
    default: false,
    title: 'Rezultati',
    iconClass: 'vuestic-icon vuestic-icon-files',
    requiredAuth: true
  }
});

/***/ }),

/***/ "QI9S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("oK+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_486ec336_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("l4dW");
function injectStyle (ssrContext) {
  __webpack_require__("gZZu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_486ec336_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QUte":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qe9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-samples-entry-commenting",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "SAČUVAJ"
    },
    cancelText: {
      type: String,
      default: "ODUSTANI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sample: {
      type: String,
      default: ""
    },
    komentar: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      comment: "",
      uzorak: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    komentar: function komentar(newVal, oldVal) {
      this.comment = newVal;
    },

    sample: function sample(newVal, oldVal) {
      this.uzorak = newVal;
    },

    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");

      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("setComment", this.uzorak, this.comment);
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "R0++":
/***/ (function(module, exports, __webpack_require__) {

var c_samples = __webpack_require__("lptX");
var m_samples = __webpack_require__("noJ4");
var p_samples = __webpack_require__("rZpX");
var bhs_samples = __webpack_require__("4Z/G");

module.exports = {
  sampleSelection: function sampleSelection(site, test, godina, spol, drstanje, menopauza, manual, calculated) {

    switch (site) {
      case '5b6caf696a0f4166f4da989b':
        return c_samples.carovaclab(test, godina, spol, drstanje, menopauza, manual, calculated);
        break;

      case '5bc71402bf21a379083d6e07':
        return m_samples.medlab(test, godina, spol, drstanje, menopauza, manual, calculated);
        break;

      case '5bd40c16020d6d21bbaf610c':
        return p_samples.muminovic(test, godina, spol, drstanje, menopauza, manual, calculated);
        break;

      case '5c69f68c338fe912f99f833b':
        return bhs_samples.bihlab(test, godina, spol, drstanje, menopauza, manual, calculated);
        break;
    }
  }
};

/***/ }),

/***/ "REdK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v("\n                    "+_vm._s(_vm.okText)+"\n                  ")]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v("\n                    "+_vm._s(_vm.cancelText)+"\n                  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RLg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AtomSpinner_vue__ = __webpack_require__("VLQC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fd126ec0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_AtomSpinner_vue__ = __webpack_require__("jSLc");
function injectStyle (ssrContext) {
  __webpack_require__("M9yq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd126ec0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AtomSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fd126ec0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_AtomSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rn6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuestic_div_checkbox_SquareWithIcon_vue__ = __webpack_require__("2c2N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_checkbox_VuesticCheckbox__ = __webpack_require__("2653");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tree-category',
  components: { SquareWithIcon: __WEBPACK_IMPORTED_MODULE_0__vuestic_div_checkbox_SquareWithIcon_vue__["default"], VuesticCheckbox: __WEBPACK_IMPORTED_MODULE_1__vuestic_checkbox_VuesticCheckbox__["default"] },
  data: function data() {
    return {
      isOpenCached: false
    };
  },

  watch: {
    isOpen: {
      handler: function handler(isOpen) {
        this.isOpenCached = isOpen;
      },

      immediate: true
    }
  },
  props: {
    label: {
      type: [String, Number],
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkboxIconClass: function checkboxIconClass() {
      return this.isOpenCached ? 'ion ion-md-remove' : 'ion ion-md-add';
    }
  },
  methods: {
    collapse: function collapse() {
      var _this = this;

      this.isOpenCached = false;
      this.$nextTick(function () {
        _this.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.collapse();
          }
        });
      });
    },
    expand: function expand() {
      var _this2 = this;

      this.isOpenCached = true;
      this.$nextTick(function () {
        _this2.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.expand();
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "SB3Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SFyI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SRTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  bind: function bind(el, binding) {
    var dropdownToggle = el.querySelector('.dropdown-toggle');
    var dropdownToggleInput = el.querySelector('.dropdown-toggle input');
    var dropdownMenu = el.querySelector('.dropdown-menu');
    var dropdownItem = el.querySelector('.dropdown-menu-content');
    var dropdownIon = el.querySelector('.ion');
    var closeOnMenuClick = binding.modifiers.closeOnMenuClick;
    var isBlocked = binding.modifiers.isBlocked;
    if (dropdownToggle) {
      dropdownToggle.addEventListener('click', function (event) {
        event.preventDefault();
        var isShown = el.classList.contains('show');
        setTimeout(function () {
          if (isBlocked) {
            if (!isShown) {
              dropdownIon.classList.add('ion-ios-arrow-up');
              el.classList.toggle('show', !isShown);
              dropdownMenu.classList.toggle('show', !isShown);
            }
          } else {
            el.classList.toggle('show', !isShown);
            dropdownMenu.classList.toggle('show', !isShown);
          }
        });
      });
    }

    el.removeShow = function (event) {
      if (event.target !== dropdownToggleInput) {
        if (dropdownIon) {
          if (dropdownIon.classList.contains('ion-ios-arrow-up')) {
            dropdownIon.classList.remove('ion-ios-arrow-up');
          }
        }
        el.classList.remove('show');
        dropdownMenu.classList.remove('show');
      }
    };

    window.addEventListener('click', el.removeShow);
    if (dropdownMenu) {
      dropdownMenu.addEventListener('click', function (evt) {
        if (!closeOnMenuClick) {
          evt.stopPropagation();
        }
      });
    }

    if (dropdownItem) {
      dropdownItem.addEventListener('click', function () {
        if (dropdownIon) {
          if (dropdownIon.classList.contains('ion-ios-arrow-up')) {
            dropdownIon.classList.remove('ion-ios-arrow-up');
          }
        }
        dropdownMenu.classList.remove('show');
        el.classList.remove('show');
      });
    }
  },
  unbind: function unbind(el) {
    window.removeEventListener('click', el.removeShow);
  }
});

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "St2u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2)])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{class:_vm.cancelClass,attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm.cancelText))]),_vm._v(" "),(!_vm.okText.includes('!SHOW'))?_c('button',{class:_vm.okClass,attrs:{"type":"button"},on:{"click":_vm.ok}},[_vm._v(" "+_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T0T4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--system",style:(_vm.messageColors)},[_vm._v(_vm._s(_vm.data.text)),(_vm.data.meta)?_c('p',{staticClass:"sc-message--meta",style:({color: _vm.messageColors.color})},[_vm._v(_vm._s(_vm.data.meta))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T7Ne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BreedingRhombusSpinner_vue__ = __webpack_require__("+s3s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_94f1a59a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BreedingRhombusSpinner_vue__ = __webpack_require__("jbjO");
function injectStyle (ssrContext) {
  __webpack_require__("IAP7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94f1a59a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BreedingRhombusSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_94f1a59a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BreedingRhombusSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "TGVY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalPlus_vue__ = __webpack_require__("sidr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_179eee36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalPlus_vue__ = __webpack_require__("CTmQ");
function injectStyle (ssrContext) {
  __webpack_require__("BsSo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalPlus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_179eee36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalPlus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TGxb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TS+I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapsePatientInfo_vue__ = __webpack_require__("p3Qa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b6e60c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapsePatientInfo_vue__ = __webpack_require__("2AFO");
function injectStyle (ssrContext) {
  __webpack_require__("mjU6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapsePatientInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b6e60c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapsePatientInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TcP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-comment",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      komentar: "",
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.Comment();

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.GetComment();
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    GetComment: function GetComment() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["o" /* http */].get("uzorci/komentar/" + this.$store.state.sid + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
        _this.komentar = res.data.komentar;
        _this.show = true;
      });
    },
    Comment: function Comment() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["o" /* http */].post("uzorci/komentar/" + this.$store.state.sid + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {
        komentar: this.komentar
      }).then(function (res) {
        _this2.show = false;
      });
    }
  }
});

/***/ }),

/***/ "Td/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-flatpickr-component',_vm._g({staticClass:"vuestic-date-picker",class:{'has-value': _vm.valueProxy && _vm.valueProxy.length},attrs:{"config":_vm.fullConfig},model:{value:(_vm.valueProxy),callback:function ($$v) {_vm.valueProxy=$$v},expression:"valueProxy"}},_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TgKh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ThK4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue__ = __webpack_require__("mC5g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_27ef38d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmojiPicker_vue__ = __webpack_require__("i/C3");
function injectStyle (ssrContext) {
  __webpack_require__("tb/+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27ef38d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiPicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_27ef38d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmojiPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Tk3j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextMessage = __webpack_require__("K/BQ");

var _TextMessage2 = _interopRequireDefault(_TextMessage);

var _FileMessage = __webpack_require__("pAjY");

var _FileMessage2 = _interopRequireDefault(_FileMessage);

var _EmojiMessage = __webpack_require__("xemH");

var _EmojiMessage2 = _interopRequireDefault(_EmojiMessage);

var _TypingMessage = __webpack_require__("oSDv");

var _TypingMessage2 = _interopRequireDefault(_TypingMessage);

var _SystemMessage = __webpack_require__("LYnd");

var _SystemMessage2 = _interopRequireDefault(_SystemMessage);

var _chatIcon = __webpack_require__("d1QR");

var _chatIcon2 = _interopRequireDefault(_chatIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {};
  },

  components: {
    TextMessage: _TextMessage2.default,
    FileMessage: _FileMessage2.default,
    EmojiMessage: _EmojiMessage2.default,
    TypingMessage: _TypingMessage2.default,
    SystemMessage: _SystemMessage2.default
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    chatImageUrl: {
      type: String,
      default: _chatIcon2.default
    },
    colors: {
      type: Object,
      required: true
    },
    authorName: {
      type: String
    }
  },
  methods: {
    sentColorsStyle: function sentColorsStyle() {
      return {
        color: this.colors.sentMessage.text,
        backgroundColor: this.colors.sentMessage.bg
      };
    },
    receivedColorsStyle: function receivedColorsStyle() {
      return {
        color: this.colors.receivedMessage.text,
        backgroundColor: this.colors.receivedMessage.bg
      };
    },
    determineMessageColors: function determineMessageColors() {
      return this.message.author === 'me' ? this.sentColorsStyle() : this.receivedColorsStyle();
    }
  }
};

/***/ }),

/***/ "TqEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntersectingCirclesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    circleSize: function circleSize() {
      return this.size / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerBlockStyle: function spinnerBlockStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.circleSize + 'px',
        height: this.circleSize + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color
      };
    },
    circleStyles: function circleStyles() {
      var _this = this;

      var circlesPositions = [{ top: 0, left: 0 }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: 0, top: this.circleSize * -0.36 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: 0, top: this.circleSize * 0.36 + 'px' }];

      return circlesPositions.map(function (cp) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(cp, _this.circleStyle);
      });
    }
  }
});

/***/ }),

/***/ "TwIB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-header",style:({background: _vm.colors.header.bg, color: _vm.colors.header.text})},[(_vm.imageUrl)?_c('img',{staticClass:"sc-header--img",attrs:{"src":_vm.imageUrl,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sc-header--title",on:{"click":_vm.toggleUserList}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_c('div',{staticClass:"sc-header--close-button",on:{"click":_vm.onClose}},[_c('img',{attrs:{"src":__webpack_require__("xc3+"),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UO+Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UVSd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UW5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadarSpinner_vue__ = __webpack_require__("H65f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_862b026a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RadarSpinner_vue__ = __webpack_require__("tO3b");
function injectStyle (ssrContext) {
  __webpack_require__("lPhB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-862b026a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadarSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_862b026a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RadarSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "UWEN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuesticTag_vue__ = __webpack_require__("aTa4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tag-group',
  props: {
    removable: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array
    },
    type: {
      type: String,
      default: ''
    },
    uzorak: {
      type: String,
      default: ''
    },
    bundle: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VuesticTag: __WEBPACK_IMPORTED_MODULE_0__VuesticTag_vue__["default"]
  },
  methods: {
    removeTag: function removeTag(tagIndex, item, uzorak) {
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('removeTest', item, uzorak);
      this.$emit('input', this.value.filter(function (item, i) {
        return i !== tagIndex;
      }));
    }
  }
});

/***/ }),

/***/ "UfMP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDatePicker_vue__ = __webpack_require__("hF3+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e378fee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDatePicker_vue__ = __webpack_require__("Td/d");
function injectStyle (ssrContext) {
  __webpack_require__("7/CN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDatePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e378fee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDatePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuItems", function() { return menuItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleWithoutAnimation", function() { return toggleWithoutAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebarOpened", function() { return sidebarOpened; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "palette", function() { return palette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAuthenticated", function() { return isAuthenticated; });
var menuItems = function menuItems(state) {
  return state.menu.items;
};
var sidebarOpened = function sidebarOpened(state) {
  return state.app.sidebar.opened;
};
var toggleWithoutAnimation = function toggleWithoutAnimation(state) {
  return state.app.sidebar.withoutAnimation;
};
var config = function config(state) {
  return state.app.config;
};
var palette = function palette(state) {
  return state.app.config.palette;
};
var isLoading = function isLoading(state) {
  return state.app.isLoading;
};

var user = function user(state) {
  return state.user;
};
var isAuthenticated = function isAuthenticated(state) {
  return state.token !== null;
};



/***/ }),

/***/ "UpdR":
/***/ (function(module, exports) {

module.exports = {"auth":{"login":{"Acme":{},"Login":{"trnslr001":"Dobrodošli!","trnslr002":"Prijava","trnslr003":"Korisničko ime","trnslr004":"Šifra","trnslr005":"Greška prilikom konekcije na DB!","trnslr006":"Korisnik nije pronađen!","trnslr007":"Unijeli ste pogrešnu šifru!"}}},"dashboard":{"data-visualisation-tab":{"DataVisualisation":{"trnslr001":"Statusi uzoraka","trnslr002":"Statusi rezultata","trnslr003":"Nema zaprimljenih uzoraka.","trnslr004":"Nema pristiglih rezultata.","trnslr005":"Zaprimljen","trnslr006":"U obradi","trnslr007":"Realizovan","trnslr008":"Obrađen","trnslr009":"Broj uzoraka","trnslr010":"Nema pristiglih rezultata.","trnslr011":"Nije odobren","trnslr012":"Odobren","trnslr013":"Broj uzoraka"}},"features-tab":{"FeaturesTab":{"trnslr001":"Statusi uzoraka","trnslr002":"Nema zaprimljenih uzoraka.","trnslr003":"Zaprimljeno","trnslr004":"Obrađeno","trnslr005":"Pacijenata"}},"Dashboard":{"trnslr001":"Danas","trnslr002":"Zadnjih 30 dana"},"DashboardInfoWidgets":{"trnslr001":"Danas zaprimljeno uzoraka","trnslr002":"Kompletirano uzoraka","trnslr003":"Kompletirano testova","trnslr004":"Korisnika","trnslr005":"Pacijenata"}},"kontrole":{"pregled":{"detalji":{},"Levey":{},"Pregled":{}},"unos":{"Unos":{}}},"layout":{"navbar":{"Navbar":{"trnslr001":"odobren","trnslr002":"realizovan","trnslr003":"Promijenite šifru","trnslr004":"Dodajte sliku","trnslr005":"Dodajte korisnika","trnslr006":"Uredite korisnike","trnslr007":"Moje postavke","trnslr008":"Odjava","trnslr009":"Build"}},"sidebar":{"Sidebar":{"trnslr001":"Pregled","trnslr002":"Pacijenti","trnslr003":"Unos","trnslr004":"Pregled","trnslr038":"Prijem","trnslr005":"Uzorci","trnslr006":"Unos","trnslr007":"Pregled","trnslr008":"Rezultati","trnslr009":"Pregled","trnslr010":"Verifikacija","trnslr011":"Nalazi","trnslr012":"Pregled","trnslr013":"Verifikacija","trnslr014":"Odlazna pošta","trnslr015":"Kontrole","trnslr016":"Unos","trnslr017":"Pregled","trnslr018":"Levey - J","trnslr019":"Izvještaji","trnslr020":"Opšte postavke","trnslr021":"Lokacije","trnslr022":"Doktori","trnslr023":"Sekcije","trnslr024":"Generalno","trnslr025":"Paneli","trnslr026":"Sites","trnslr027":"Definicija testova","trnslr028":"Laboratorijski testovi","trnslr029":"Ručni testovi","trnslr030":"Kalkulisani testovi","trnslr031":"Postavke aparata","trnslr032":"Aparati","trnslr033":"Testovi aparata","trnslr034":"Definicija kontrola","trnslr035":"Pomoć","trnslr036":"Mjesta","trnslr037":"Predračun"}},"AuthLayout":{},"Layout":{}},"nalaz":{},"nalazi":{},"pacijenti":{"pregled":{"detalji":{"trnslr001":"Jmbg","trnslr002":"Ime","trnslr003":"Prezime","trnslr004":"Spol","trnslr005":"Pušač","trnslr006":"Dijabetes","trnslr007":"Telefon","trnslr008":"Email","trnslr009":"Uredi","__comment":"Ne prevoditi...","trnslr010":"MUŠKI","trnslr011":"ŽENSKI","trnslr012":"DA","trnslr013":"NE","comment__":"...Kraj","trnslr014":"Uredite podatke o pacijentu","trnslr015":"Sačuvajte izmjene","trnslr016":"Nazad","trnslr017":"Pregled detalja za pacijenta:","trnslr018":"Vrijednost polja je obavezna!","trnslr019":"JMBG mora biti validan 13 cifreni broj!","trnslr020":"Email adresa nije validna!","trnslr021":"Telefonski broj nije validan!","trnslr022":"Spol može biti MUŠKI ili ŽENSKI!","trnslr023":"Vrijednost polja PUŠAČ može biti DA ili NE!","trnslr024":"Vrijednost polja DIJABETES može biti DA ili NE!","trnslr025":"Pacijent sa unesenim JMBG, već postoji u sistemu!","trnslr026":"Greška prilikom upisa!","trnslr027":"Unos uspješno obavljen!","trnslr028":"Mjesto stanovanja"},"PregledPacijenta":{"trnslr001":"Pretraga svih pacijenata"},"fields-definition":{"trnslr001":"ime","trnslr002":"prezime","trnslr007":"prijem","trnslr003":"uzorak","trnslr004":"jmbg","trnslr005":"spol","trnslr006":"akcija"}},"unos":{"UnosPacijenta":{"trnslr001":"Unos pacijenata","trnslr002":"Unesite JMBG pacijenta","trnslr003":"Unesite ime pacijenta","trnslr004":"Unesite prezime pacijenta","trnslr005":"Izaberite spol pacijenta","trnslr006":"Konzumira duhan","trnslr007":"Dijabetes","trnslr008":"Unesite kontakt telefon","trnslr009":"Unesite Email adresu","trnslr010":"Sačuvaj","trnslr011":"Polja JMBG, Ime, Prezime i Spol su obavezna!","trnslr012":"JMBG mora biti validan 13 cifreni broj!","trnslr013":"Email adresa nije validna!","trnslr014":"Telefonski broj nije validan!","trnslr015":"Pacijent već postoji!","trnslr016":"Greška prilikom upisa!","trnslr017":"Unos uspješno obavljen!","trnslr018":"Mjesto stanovanja pacijenta"}}},"pomoc":{"Pomoc":{"trnslr001":"Pomoć pri korištenju aplikacije","trnslr002":"Prijava incidenta","trnslr003":"Pregled incidenata","trnslr004":"Zahtjev za nadogradnjom","trnslr005":"Pregled zahtjeva","trnslr006":"Kontakt","trnslr007":"Korisnik","trnslr008":"Vrijeme","trnslr009":"Unesite naziv","trnslr010":"Izaberite prioritet","trnslr011":"Opišite incident","trnslr012":"Izaberite lokaciju","trnslr013":"Izaberite status","trnslr014":"Naziv","trnslr015":"Prioritet","trnslr016":"Status","trnslr017":"Nema dostupnih podataka.","trnslr018":"Unesite zahtjev","trnslr019":"Kontaktirajte nas","trnslr020":"Primalac","trnslr021":"Unesite kontakt telefon","trnslr022":"Unesite poruku","trnslr023":"AP Solutions d.o.o.","trnslr024":"Opišite incident!","trnslr025":"Unesite naziv!","trnslr026":"Greška prilikom upisa!","trnslr027":"Unos uspješno obavljen!","trnslr028":"Unesite zahtjev!","trnslr029":"Unesite naziv!","trnslr030":"Greška prilikom upisa!","trnslr031":"Uredite podatke","trnslr032":"Unesite telefonski broj!","trnslr033":"Telefonski broj nije validan!","trnslr034":"Greška prilikom slanja poruke!","trnslr035":"Poruka uspješno poslana!","trnslr036":"Izbornik","trnslr037":"Sačuvajte izmjene","trnslr038":"Sačuvaj","trnslr039":"Pošalji","trnslr040":"Unesite poruku!","trnslr041":"Uredi"}},"postavke":{"user":{"chpwd":{"trnslr001":"Promjena šifre","trnslr002":"Unesite trenutnu šifru","trnslr003":"Unesite novu šifru","trnslr004":"Potvrdite novu šifru","trnslr005":"Sačuvaj","trnslr006":"Sva polja su obavezna!","trnslr007":"Šifra nije validna!","trnslr008":"Nova šifra nije validirana!","trnslr009":"Greška prilikom upisa!","trnslr010":"Trenutna šifra nije ispravna!","trnslr011":"Izmjena uspješno obavljena!"},"avatar":{"trnslr001":"Izmjena slike","trnslr002":"Dodavanje slike","trnslr003":"Izaberi","trnslr004":"Sačuvaj","trnslr005":"Greška prilikom izmjene!","trnslr006":"Izmjena uspješno obavljena!"},"newUser":{"trnslr001":"Dodavanje korisnika","trnslr002":"Unesite ime","trnslr003":"Unesite prezime","trnslr004":"Unesite korisničko ime","trnslr005":"Unesite šifru","trnslr006":"Vrsta korisničkog računa","trnslr007":"Izaberite sajtove","trnslr008":"Sajt korisnika","trnslr009":"Sačuvaj","trnslr010":"Korisničko ime nije validno!","trnslr011":"Sva polja su obavezna!","trnslr012":"Šifra nije validna!","trnslr013":"Greška prilikom upisa!","trnslr014":"Unos uspješno obavljen!","trnslr015":"Korisnik već postoji!"},"edit":{"trnslr001":"Uređivanje korisnika","trnslr002":"Ime","trnslr003":"Prezime","trnslr004":"Email","trnslr005":"Uloga","trnslr006":"Uredi","trnslr007":"Akcija","trnslr008":"Uredite podatke","trnslr009":"Sačuvajte izmjene","trnslr010":"Greška prilikom upisa!","trnslr011":"Izmjena uspješno obavljena!","trnslr012":"Jeste li sigurni da želite obrisati zapis?","trnslr013":"Da","trnslr014":"Greška prilikom brisanja!","trnslr015":"Zapis uspješno obrisan!","trnslr016":"Brisanje zapisa","trnslr017":"Izbriši","trnslr018":"Unesite \"Da\" za nastavak","trnslr019":"Odustani","trnslr020":"Nastavi"},"settings":{"trnslr001":"Postavke prikaza","trnslr002":"Kartični prikaz rezultata testova","trnslr003":"Postavke jezika","trnslr004":"Bosanski jezik","trnslr005":"Hrvatski jezik","trnslr006":"Srpski jezik","trnslr007":"Engleski jezik","trnslr008":"Greška prilikom upisa!","trnslr009":"Izmjena uspješno obavljena!","trnslr010":"10 minuta","trnslr011":"30 minuta","trnslr012":"120 minuta","trnslr013":"480 minuta","trnslr014":"Automatska odjava u slučaju neaktivnosti"}}},"reports":{},"rezultati":{},"uzorci":{},"vuestic-components":{"trnslr001":"Pretraga"}}

/***/ }),

/***/ "V5XA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tag-group"},_vm._l((_vm.value),function(item,index){return _c('vuestic-tag',{key:index,attrs:{"name":item.name || item,"type":_vm.type || item.type,"removable":_vm.removable,"bundle":item.bundle || false},on:{"remove":function($event){_vm.removeTag(index, item, _vm.uzorak)}}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V7LR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datatable_components_FilterBar_vue__ = __webpack_require__("YhNO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datatable_components_ItemsPerPage_vue__ = __webpack_require__("IbS2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_local_data__ = __webpack_require__("zlyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuestic_components_vuestic_datatable_data_data_table_styles__ = __webpack_require__("CHUl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_main_js__ = __webpack_require__("NHnr");













var originalData = __WEBPACK_IMPORTED_MODULE_6__data_local_data__["a" /* default */].data;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-data-table-pacijent",

  components: {
    FilterBar: __WEBPACK_IMPORTED_MODULE_3__datatable_components_FilterBar_vue__["default"],
    Vuetable: __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    ItemsPerPage: __WEBPACK_IMPORTED_MODULE_4__datatable_components_ItemsPerPage_vue__["default"]
  },
  props: {
    site: {
      type: String
    },
    token: {
      type: String
    },
    sekcija: {
      type: String
    },
    apiUrl: {
      type: String
    },
    tableFields: {
      type: Array,
      required: true
    },
    itemsPerPage: {
      type: Array,
      required: true
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    },
    apiMode: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Array
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      prikazi: false,
      tableData: __WEBPACK_IMPORTED_MODULE_6__data_local_data__["a" /* default */],
      perPage: "",
      brStr: 10,
      colorClasses: {},
      moreParams: {},
      dataCount: 0,
      css: __WEBPACK_IMPORTED_MODULE_7__vuestic_components_vuestic_datatable_data_data_table_styles__["a" /* default */],
      pacijent: {},
      imaData: true,
      show: true,
      potvrdi: "SAČUVAJ",
      odustani: "ZATVORI",
      spolovi: ["MUŠKI", "ŽENSKI"],
      duhani: ["NE", "NEPOZNATO", "DA"],

      dijabetesi: ["NE", "NEPOZNATO", "DA"]
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "pacijent", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "citiesList", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "header", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "id", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "jmbg", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "ime", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "prezime", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "spol", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "telefon", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "adresa", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "email", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "duhan", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dijabetes", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tmpJmbg", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tmpIme", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tmpPrezime", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tmpIzvor", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tmpSpol", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tmpAdresa", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tmpTelefon", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "izvor", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "izvori", ["Lična karta", "Vozačka dozvola", "Saobraćajna dozvola", "Zdravstvena knjižica", "Pasoš", "Usmeno"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tmpEmail", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tmpDuhan", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tmpDijabetes", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "edit", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "uslovispunjen", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "jmbgTmp", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "uredi", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "refresh_yes", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "toastText", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "toastIcon", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "toastPosition", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "toastDuration", 2500), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "isToastFullWidth", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "className", ""), _ref;
  },
  mounted: function mounted() {
    var _this = this;

    this.dohvatiMjesta();
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$on("PatientDetails", function (data) {
      _this.pacijent = data;
      _this.getPAtient();
    });

    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$on("tableData", function (data) {
      _this.imaData = false;
    });
    this.onFilterSet(this.$store.state.filter);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("tableData");
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("PatientDetails");
  },

  watch: {},
  methods: {
    Edit: function Edit() {
      this.edit = true;
      this.uredi = false;
    },
    refresh: function refresh() {
      var _this2 = this;

      if (this.refresh_yes) {
        __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].get("pacijenti/detalji/" + this.pacijent + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
          if (res.data.pacijent.jmbg != undefined) {
            _this2.header = "Pregled detalja pacijenta: ";

            _this2.id = res.data.pacijent._id;
            _this2.jmbg = res.data.pacijent.jmbg;
            _this2.jmbgTmp = res.data.pacijent.jmbg;
            _this2.ime = res.data.pacijent.ime;
            _this2.prezime = res.data.pacijent.prezime;
            _this2.adresa = res.data.pacijent.adresa;
            _this2.izvor = res.data.pacijent.izvor;
            _this2.spol = res.data.pacijent.spol;
            _this2.duhan = res.data.pacijent.duhan;
            _this2.dijabetes = res.data.pacijent.dijabetes;
            _this2.telefon = res.data.pacijent.telefon;
            _this2.email = res.data.pacijent.email;

            _this2.tmpJmbg = res.data.pacijent.jmbg;
            _this2.tmpIme = res.data.pacijent.ime;
            _this2.tmpPrezime = res.data.pacijent.prezime;
            _this2.tmpIzvor = res.data.pacijent.izvor;
            _this2.tmpSpol = res.data.pacijent.spol;
            _this2.tmpAdresa = res.data.pacijent.adresa;
            _this2.tmpTelefon = res.data.pacijent.telefon;
            _this2.tmpEmail = res.data.pacijent.email;
            _this2.tmpDuhan = res.data.pacijent.duhan;
            _this2.tmpDijabetes = res.data.pacijent.dijabetes;
          }
        });
      }
    },

    validateEmail: function validateEmail(mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true;
      } else {
        return false;
      }
    },
    validatePhone: function validatePhone(telefon) {
      return true;
    },
    vratiPregled: function vratiPregled() {
      __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/prijem/");
    },
    jmbgValidate: function jmbgValidate(jmbg) {
      return (/^\d{4}[9,0]{1}\d{8}$/.test(String(jmbg)) || /^\d{4}[9,0]{1}\d{7}[P]{1}$/.test(String(jmbg))
      );
    },
    sacuvaj: function sacuvaj() {
      var _this3 = this;

      this.uslovispunjen = true;
      var item = true;

      if (this.jmbg.trim() === this.tmpJmbg && this.adresa.trim() === this.tmpAdresa && this.ime.trim() === this.tmpIme && this.prezime.trim() === this.tmpPrezime && this.izvor.trim() === this.tmpIzvor && this.spol.trim() === this.tmpSpol && this.telefon.trim() === this.tmpTelefon && this.email.trim() === this.tmpEmail && this.duhan.trim() === this.tmpDuhan && this.dijabetes.trim() === this.tmpDijabetes) {
        item = false;
        this.uredi = true;
        this.edit = false;
        setTimeout(function () {
          _this3.refresh();
        }, 3000);
      } else if (this.jmbg.trim() === "" || this.ime.trim() === "" || this.prezime.trim() === "" || this.spol.trim() === "") {
        item = false;
        this.toastText = this.$t("pacijenti.pregled.detalji.trnslr018");
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
        setTimeout(function () {
          _this3.refresh();
        }, 3000);
      } else if (!this.jmbgValidate(this.jmbg)) {
        item = false;
        this.toastText = this.$t("pacijenti.pregled.detalji.trnslr019");
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
        setTimeout(function () {
          _this3.refresh();
        }, 3000);
      } else if (this.email.trim() != "" && this.email.trim() != "NEPOZNATO" && !this.validateEmail(this.email)) {
        item = false;
        this.toastText = this.$t("pacijenti.pregled.detalji.trnslr020");
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
        setTimeout(function () {
          _this3.refresh();
        }, 3000);
      } else if (this.telefon.trim() != "" && this.telefon.trim() != "NEPOZNATO" && !this.validatePhone(this.telefon)) {
        item = false;
        this.toastText = this.$t("pacijenti.pregled.detalji.trnslr021");
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
        setTimeout(function () {
          _this3.refresh();
        }, 3000);
      } else if (this.spol.toUpperCase().trim() != "MUŠKI" && this.spol.toUpperCase().trim() != "ŽENSKI") {
        item = false;
        this.toastText = this.$t("pacijenti.pregled.detalji.trnslr022");
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
        setTimeout(function () {
          _this3.refresh();
        }, 3000);
      } else if (this.duhan.trim() != "" && this.duhan.trim() != "NEPOZNATO") {
        if (this.duhan.toUpperCase().trim() != "DA" && this.duhan.toUpperCase().trim() != "NE") {
          item = false;
          this.toastText = this.$t("pacijenti.pregled.detalji.trnslr023");
          this.toastIcon = "fa-warning";
          this.toastPosition = "top-right";
          this.className = "vuestic-toast-warning";

          this.showToast(this.toastText, {
            icon: this.toastIcon,
            position: this.toastPosition,
            duration: this.toastDuration,
            fullWidth: this.isToastFullWidth,
            className: this.className
          });
          setTimeout(function () {
            _this3.refresh();
          }, 3000);
        }
      }

      if (this.dijabetes.trim() != "" && this.dijabetes.trim() != "NEPOZNATO") {
        if (this.dijabetes.toUpperCase().trim() != "DA" && this.dijabetes.toUpperCase().trim() != "NE") {
          item = false;
          this.toastText = this.$t("pacijenti.pregled.detalji.trnslr024");
          this.toastIcon = "fa-warning";
          this.toastPosition = "top-right";
          this.className = "vuestic-toast-warning";

          this.showToast(this.toastText, {
            icon: this.toastIcon,
            position: this.toastPosition,
            duration: this.toastDuration,
            fullWidth: this.isToastFullWidth,
            className: this.className
          });
          setTimeout(function () {
            _this3.refresh();
          }, 3000);
        }
      }

      if (item) {
        __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].post("pacijenti/unos/find", {
          jmbg: this.jmbg,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (_this3.jmbgTmp != _this3.jmbg) {
            if (res.data.message === "Pacijent postoji") {
              _this3.toastText = _this3.$t("pacijenti.pregled.detalji.trnslr025");
              _this3.toastIcon = "fa-warning";
              _this3.toastPosition = "top-right";
              _this3.className = "vuestic-toast-warning";

              _this3.showToast(_this3.toastText, {
                icon: _this3.toastIcon,
                position: _this3.toastPosition,
                duration: _this3.toastDuration,
                fullWidth: _this3.isToastFullWidth,
                className: _this3.className
              });
              _this3.uslovispunjen = false;
              setTimeout(function () {
                _this3.refresh();
              }, 3000);
            } else {}
          }
        }).then(function (res) {
          if (_this3.duhan.trim() === "") {
            _this3.duhan = "NEPOZNATO";
          }
          if (_this3.dijabetes.trim() === "") {
            _this3.dijabetes = "NEPOZNATO";
          }
          if (_this3.telefon.trim() === "") {
            _this3.telefon = "NEPOZNATO";
          }
          if (_this3.email.trim() === "") {
            _this3.email = "NEPOZNATO";
          }

          if (_this3.uslovispunjen) {
            __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].post("pacijenti/detalji/update/" + _this3.pacijent, {
              id: _this3.id.trim(),
              jmbg: _this3.jmbg.trim(),
              ime: _this3.ime.toUpperCase().trim(),
              prezime: _this3.prezime.toUpperCase().trim(),
              spol: _this3.spol.toUpperCase().trim(),
              adresa: _this3.adresa.trim(),
              duhan: _this3.duhan.toUpperCase().trim(),
              dijabetes: _this3.dijabetes.toUpperCase().trim(),
              izvor: _this3.izvor,
              telefon: _this3.telefon.trim(),
              email: _this3.email.trim(),
              token: _this3.$store.state.token,
              site: _this3.$store.state.site
            }).then(function (res) {
              if (res.data.success === false) {
                _this3.toastText = _this3.$t("pacijenti.pregled.detalji.trnslr026");
                _this3.toastIcon = "fa-remove";
                _this3.toastPosition = "top-right";
                _this3.className = "vuestic-toast-danger";

                _this3.showToast(_this3.toastText, {
                  icon: _this3.toastIcon,
                  position: _this3.toastPosition,
                  duration: _this3.toastDuration,
                  fullWidth: _this3.isToastFullWidth,
                  className: _this3.className
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
                  return _this3.$refs.vuetable.refresh();
                });

                _this3.toastText = "Izmjena uspješno obavljena.";
                _this3.toastIcon = "fa-check";
                _this3.toastPosition = "top-right";
                _this3.className = "vuestic-toast-primary";

                _this3.showToast(_this3.toastText, {
                  icon: _this3.toastIcon,
                  position: _this3.toastPosition,
                  duration: _this3.toastDuration,
                  fullWidth: _this3.isToastFullWidth,
                  className: _this3.className
                });

                setTimeout(function () {
                  _this3.refresh();
                }, 3000);

                _this3.uredi = true;
                _this3.edit = false;
              }
            });
          }
        });
      }
    },

    dohvatiMjesta: function dohvatiMjesta() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].post("/postavke/sajtovi/" + this.$store.state.site, {
        token: this.$store.state.token
      }).then(function (res) {
        if (res.data.sajt.mjesta != undefined) {
          _this4.citiesList = res.data.sajt.mjesta.sort(function (a, b) {
            return a.toLowerCase() == b.toLowerCase() ? 0 : +(a.toLowerCase() > b.toLowerCase()) || -1;
          });
        }
      }).then(function (res) {});
    },
    getPAtient: function getPAtient() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].get("pacijenti/detalji/" + this.pacijent + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
        if (res.data.pacijent.jmbg != undefined) {
          _this5.header = "Pregled detalja pacijenta: ";

          _this5.id = res.data.pacijent._id;
          _this5.jmbg = res.data.pacijent.jmbg;
          _this5.jmbgTmp = res.data.pacijent.jmbg;
          _this5.ime = res.data.pacijent.ime;
          _this5.prezime = res.data.pacijent.prezime;
          _this5.adresa = res.data.pacijent.adresa;
          _this5.izvor = res.data.pacijent.izvor;
          _this5.spol = res.data.pacijent.spol;
          _this5.duhan = res.data.pacijent.duhan;
          _this5.dijabetes = res.data.pacijent.dijabetes;
          _this5.telefon = res.data.pacijent.telefon;
          _this5.email = res.data.pacijent.email;

          _this5.tmpJmbg = res.data.pacijent.jmbg;
          _this5.tmpIme = res.data.pacijent.ime;
          _this5.tmpPrezime = res.data.pacijent.prezime;
          _this5.tmpIzvor = res.data.pacijent.izvor;
          _this5.tmpSpol = res.data.pacijent.spol;
          _this5.tmpAdresa = res.data.pacijent.adresa;
          _this5.tmpTelefon = res.data.pacijent.telefon;
          _this5.tmpEmail = res.data.pacijent.email;
          _this5.tmpDuhan = res.data.pacijent.duhan;
          _this5.tmpDijabetes = res.data.pacijent.dijabetes;
          _this5.prikazi = true;
        }
      });
    },
    unosPacijenta: function unosPacijenta() {
      this.$refs.largeModalPatient.open();
    },
    notice: function notice(type, text, desc) {
      this.$notice[type]({
        title: text,
        description: desc,
        closable: false,
        styles: {
          width: "500px",
          marginLeft: "-195px"
        },
        duration: 2.0
      });
    },

    prikaziDetalje: function prikaziDetalje(event) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].post("pacijenti/unos/findid", {
        id: event.target.id,
        token: this.$store.state.token,
        site: this.$store.state.site
      }).then(function (res) {
        if (res.data.message === "Pacijent postoji") {
          _this6.pacijent = res.data.pacijent;
        } else {}
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$emit("emitime", _this6.pacijent);
      });
    },
    prikaziDetaljeM: function prikaziDetaljeM(args) {
      var niz = args[0];
      if (args[0][2].srcElement.cellIndex === undefined && !args[0][2].srcElement.classList.contains("disabled")) {
        if (niz[1].name === "akcija") {
          __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$emit("PatientDetails", niz[0].id);
        }
        if (niz[1].name === "prijem") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/samples/entry/" + args[0][0].id);
        }
        if (niz[1].name === "badge") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/samples/entry/" + args[0][0].id);
        }
      }
    },
    onFilterSet: function onFilterSet(filterText) {
      var _this7 = this;

      this.imaData = true;

      this.filterString = "";

      this.filterString = filterText;

      if (event != undefined && filterText.trim() != "") {
        if (event.keyCode == 13) {
          if (this.apiMode) {
            this.moreParams = {
              filter: filterText
            };
          } else {
            var txt = new RegExp(filterText, "i");
            this.tableData.data = originalData.filter(function (item) {
              return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
            });
          }

          __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
            return _this7.$refs.vuetable.refresh();
          });
        } else {}
      } else {
        if (this.apiMode) {
          this.moreParams = {
            filter: filterText
          };
        } else {
          var _txt = new RegExp(filterText, "i");
          this.tableData.data = originalData.filter(function (item) {
            return item.name.search(_txt) >= 0 || item.email.search(_txt) >= 0;
          });
        }
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
          return _this7.$refs.vuetable.refresh();
        });
      }
    },
    onItemsPerPage: function onItemsPerPage(itemsPerPageValue) {
      var _this8 = this;

      this.imaData = true;
      this.perPage = itemsPerPageValue;
      __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
        return _this8.$refs.vuetable.refresh();
      });
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.tableData.data;
      var sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function (item1, item2) {
          var sortField = sortOrder[0].sortField;
          var fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === "desc") {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
});

/***/ }),

/***/ "VAWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPreLoader_vue__ = __webpack_require__("e8Tw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c424f6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPreLoader_vue__ = __webpack_require__("6glc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPreLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c424f6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPreLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "VLQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AtomSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: 'red'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        color: this.color,
        fontSize: this.size * 0.24 + 'px'
      };
    },
    lineStyle: function lineStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderLeftWidth: this.size / 25 + 'px',
        borderTopWidth: this.size / 25 + 'px',
        borderLeftColor: this.color
      };
    }
  }
});

/***/ }),

/***/ "VVeD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_expanding_src_Expanding__ = __webpack_require__("OPFe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sidebar",

  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_expanding_src_Expanding__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    expand: "toggleExpandMenuItem"
  }), {
    toggleMenuItem: function toggleMenuItem(item) {
      if (item.children) {
        this.expand({
          menuItem: item,
          expand: !item.meta.expanded
        });
      }
    },
    setDropdownDefaultIzbor: function setDropdownDefaultIzbor() {
      var current = this.$router.currentRoute.path;

      if (current.includes("rezultati/verifikacija") || current.includes("obrada/pregled")) {
        this.$store.dispatch("dropdownChange", "RADNA LISTA");
        this.$store.dispatch("filterChange", "");
      } else {
          this.$store.dispatch("dropdownChange", "DANAS");
          this.$store.dispatch("filterChange", "");
        }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    menuItems: "menuItems"
  })),
  beforeCreate: function beforeCreate() {
    var _this = this;

    var link = this.$store.state.userId;
    var token = this.$store.state.token;

    if (token != null) {
      var index = link.indexOf("@");
      link = link.substring(0, index);

      __WEBPACK_IMPORTED_MODULE_3__config_config_js__["o" /* http */].post("users/" + link, {
        email: this.$store.state.userId,
        token: this.$store.state.token,
        site: this.$store.state.site
      }).then(function (res) {
        _this.userImage = res.data.data.link;
        _this.isRole = res.data.data.role;
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].i18n.set(res.data.user.postavke.language);
      });
    }
  },
  watch: {
    $route: function $route(route) {
      var _this2 = this;

      var parent = _findMatchingParentMenuItem.call(this, route.name) || {};
      this.menuItems.forEach(function (item) {
        _this2.expand({
          menuItem: item,
          expand: parent.name === item.name
        });
      });
    }
  },
  data: function data() {
    return {
      show: false,
      isRole: ""
    };
  }
});

function _findMatchingParentMenuItem(itemName) {
  var parentItem = void 0;
  this.menuItems.forEach(function (item) {
    parentItem = item.children && item.children.find(function (child) {
      return child.name === itemName;
    }) ? item : parentItem;
  });
  return parentItem;
}

/***/ }),

/***/ "Vo2z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    onChange: {
      type: Function,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  methods: {
    _handleClick: function _handleClick(e) {
      e.target.value = null;
    },
    _handleChange: function _handleChange(e) {
      this.onChange(e.target.files[0]);
    }
  }
};

/***/ }),

/***/ "W5Tp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intersecting-circles-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinnerBlock",style:(_vm.spinnerBlockStyle)},_vm._l((_vm.circleStyles),function(cs,index){return _c('span',{key:index,staticClass:"circle",style:(cs)})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WAyp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-accordion"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WBzP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordion_vue__ = __webpack_require__("nUDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc4f0648_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordion_vue__ = __webpack_require__("ruol");
function injectStyle (ssrContext) {
  __webpack_require__("5RVu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc4f0648_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WHJM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),

/***/ "WQZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserInput_vue__ = __webpack_require__("1q7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_61ba18a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UserInput_vue__ = __webpack_require__("N84j");
function injectStyle (ssrContext) {
  __webpack_require__("xQbh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserInput_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_61ba18a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UserInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _mutations;



var state = {
  sidebar: {
    opened: false,
    withoutAnimation: false
  },
  config: {
    googleMaps: {
      apiKey: 'AIzaSyBNAqPrTQoz9P4NBlDDyfxrnKiafkaL8iQ'
    },
    windowMatchSizeLg: '(min-width: 992px)',
    palette: {
      primary: '#4ae387',
      danger: '#e34a4a',
      info: '#4ab2e3',
      success: '#db76df',
      warning: '#f7cc36',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd'
    }
  },
  isLoading: true
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CLOSE_MENU */], function (state) {
  if (document.documentElement.clientWidth < 992) {
    state.sidebar.opened = false;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* TOGGLE_SIDEBAR */], function (state, opened) {
  state.sidebar.opened = opened;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* TOGGLE_WITHOUT_ANIMATION */], function (state, value) {
  state.sidebar.withoutAnimation = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'setLoading', function setLoading(state, isLoading) {
  state.isLoading = isLoading;
}), _mutations);

var actions = {
  closeMenu: function closeMenu(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CLOSE_MENU */]);
  },
  toggleSidebar: function toggleSidebar(_ref2, opened) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* TOGGLE_SIDEBAR */], opened);
  },
  isToggleWithoutAnimation: function isToggleWithoutAnimation(_ref3, value) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* TOGGLE_WITHOUT_ANIMATION */], value);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "Wc+Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "WuQK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WubP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wvsm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMedium_vue__ = __webpack_require__("1ZnP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410d8480_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMedium_vue__ = __webpack_require__("D8td");
function injectStyle (ssrContext) {
  __webpack_require__("zFx3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-410d8480"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMedium_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410d8480_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMedium_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Wzot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FlowerSpinner_vue__ = __webpack_require__("N6Uh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d5534554_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FlowerSpinner_vue__ = __webpack_require__("ghd7");
function injectStyle (ssrContext) {
  __webpack_require__("BGuh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5534554"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FlowerSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d5534554_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FlowerSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "X11v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XDv4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMail_vue__ = __webpack_require__("/+s4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6df47e17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMail_vue__ = __webpack_require__("vVNf");
function injectStyle (ssrContext) {
  __webpack_require__("bOzn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6df47e17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XEVv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _escapeGoat = __webpack_require__("ZSNP");

var _escapeGoat2 = _interopRequireDefault(_escapeGoat);

var _autolinker = __webpack_require__("k/Ns");

var _autolinker2 = _interopRequireDefault(_autolinker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    }
  },
  computed: {
    messageText: function messageText() {
      return _autolinker2.default.link(_escapeGoat2.default.escape(this.data.text), {
        className: 'chatLink',
        truncate: { length: 50, location: 'smart' }
      });
    }
  }
};

/***/ }),

/***/ "XG+M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'animatedValue', 'min', 'max', 'color', 'startColor', 'backgroundColor', 'isActive'],
  computed: {
    backgroundImage: function backgroundImage() {
      var result = {};
      if (this.animatedValue < 50) {
        var nextDeg = 90 + 3.6 * this.animatedValue + 'deg';
        result = 'linear-gradient(90deg, ' + this.startColor + ' 50%, transparent 50%, transparent), linear-gradient(' + nextDeg + ', ' + this.color + ' 50%, ' + this.startColor + ' 50%, ' + this.startColor + ')';
      } else {
        var _nextDeg = -90 + 3.6 * (this.animatedValue - 50) + 'deg';
        result = 'linear-gradient(' + _nextDeg + ', ' + this.color + ' 50%, transparent 50%, transparent), linear-gradient(270deg, ' + this.color + ' 50%, ' + this.startColor + ' 50%, ' + this.startColor + ')';
      }
      return result;
    }
  }
});

/***/ }),

/***/ "XLEJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fieldset',[(!_vm.postoji)?_c('vuestic-simple-select',{ref:"izvorSelect",attrs:{"label":"Izvor identifikacije","name":"izvor","required":true,"title":" ","options":_vm.izvori},model:{value:(_vm.izvor),callback:function ($$v) {_vm.izvor=$$v},expression:"izvor"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jmbg),expression:"jmbg"}],attrs:{"id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.jmbg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.jmbg=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s(_vm._f("translate")('pacijenti.unos.UnosPacijenta.trnslr002')))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),(_vm.postoji)?_c('div',[_c('h5',[_vm._v("Uneseni JMBG je već registriran!")]),_vm._v(" "),_c('h5',[_vm._v("\n                          Pacijent:\n                          "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s(_vm.imePrezime))])]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(!_vm.postoji)?_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ime),expression:"ime"}],attrs:{"id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.ime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ime=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s(_vm._f("translate")('pacijenti.unos.UnosPacijenta.trnslr003')))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]):_vm._e(),_vm._v(" "),(!_vm.postoji)?_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prezime),expression:"prezime"}],attrs:{"id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.prezime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prezime=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s(_vm._f("translate")('pacijenti.unos.UnosPacijenta.trnslr004')))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]):_vm._e(),_vm._v(" "),(!_vm.postoji)?_c('vuestic-simple-select',{ref:"spolSelect",attrs:{"label":_vm._f("translate")('pacijenti.unos.UnosPacijenta.trnslr005'),"name":"spol","required":true,"title":" ","options":_vm.spolovi},model:{value:(_vm.spol),callback:function ($$v) {_vm.spol=$$v},expression:"spol"}}):_vm._e(),_vm._v(" "),(!_vm.postoji)?_c('vuestic-simple-select',{ref:"adresaSelect",attrs:{"label":"Mjesto stanovanja","name":"adresa","required":true,"title":" ","options":_vm.citiesList},model:{value:(_vm.chosenAdress),callback:function ($$v) {_vm.chosenAdress=$$v},expression:"chosenAdress"}}):_vm._e(),_vm._v(" "),(!_vm.postoji)?_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telefon),expression:"telefon"}],attrs:{"id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.telefon)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telefon=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s(_vm._f("translate")('pacijenti.unos.UnosPacijenta.trnslr008')))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]):_vm._e(),_vm._v(" "),(!_vm.postoji)?_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s(_vm._f("translate")('pacijenti.unos.UnosPacijenta.trnslr009')))]),_vm._v(" "),_c('i',{staticClass:"bar"})])]):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-6"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"on-cancel":_vm.onCancel,"color":"#4ae387","is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(false)?_c('button',{on:{"click":function($event){$event.preventDefault();_vm.Test($event)}}},[_vm._v(_vm._s('Loading...'))]):_vm._e()])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && !_vm.postoji)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons && _vm.postoji)?_c('button',{staticClass:"btn btn-secondary-info btn-sm",attrs:{"type":"button"},on:{"click":_vm.prijem}},[_c('span',{staticClass:"fa fa-flask"}),_vm._v(" PRIJEM\n                ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XVNF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-medium-editor"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XYPe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XZgk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XxK+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XznE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProgressBar_vue__ = __webpack_require__("KGMZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e19bb34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProgressBar_vue__ = __webpack_require__("JWHP");
function injectStyle (ssrContext) {
  __webpack_require__("uSXz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e19bb34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YHML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HalfCircleSpinner_vue__ = __webpack_require__("2u3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3b648864_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HalfCircleSpinner_vue__ = __webpack_require__("zvUs");
function injectStyle (ssrContext) {
  __webpack_require__("7yFm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b648864"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HalfCircleSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3b648864_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HalfCircleSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "YJBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'prijem',
  path: '/prijem',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('prijem/PregledPacijenta'),
  meta: {
    default: false,
    title: 'Prijem',
    iconClass: 'fa fa-users',
    requiredAuth: true
  }
});

/***/ }),

/***/ "YUx5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoopingRhombusesSpinner_vue__ = __webpack_require__("zkRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2cfbe115_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LoopingRhombusesSpinner_vue__ = __webpack_require__("NoRX");
function injectStyle (ssrContext) {
  __webpack_require__("LlPC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cfbe115"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoopingRhombusesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2cfbe115_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LoopingRhombusesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_store_modules_menu__ = __webpack_require__("ZEli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lazyLoading__ = __webpack_require__("77C1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_config_js__ = __webpack_require__("1wn0");








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: "history",
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(generateRoutesFromMenu(__WEBPACK_IMPORTED_MODULE_3_vuex_store_modules_menu__["a" /* default */].state.items)), [{
    path: "*",
    redirect: { name: getDefaultRoute(__WEBPACK_IMPORTED_MODULE_3_vuex_store_modules_menu__["a" /* default */].state.items).name }
  }])
});
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var predracun = {
    path: "/rezultati/predracun/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("rezultati/verifikacija/predracun"),
    props: true,
    meta: {
      title: "predracun",
      requiredAuth: true
    }
  };
  var racRuta = {
    path: "/uzorci/racuni/racun/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("uzorci/racuni/racun"),
    props: true,
    meta: {
      title: "predRacun",
      requiredAuth: true
    }
  };
  var samplesEntry = {
    path: "/samples/entry/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("samples/entry/SamplesEntry"),
    props: true,
    meta: {
      title: "samplesEntry",
      requiredAuth: true
    }
  };
  var detRuta = {
    path: "/uzorci/pregled/:sekcija/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("uzorci/detalji"),
    props: true,
    meta: {
      title: "pregledDetalji",
      requiredAuth: true
    }
  };
  var urediRuta = {
    path: "/uzorci/uredi/:sekcija/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("uzorci/uredi"),
    props: true,
    meta: {
      title: "uzorakUredi",
      requiredAuth: true
    }
  };
  var nalRuta = {
    path: "/nalazi/pregled/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("nalazi/pregled/nalaz"),
    props: true,
    meta: {
      title: "nalazPregled",
      requiredAuth: true
    }
  };
  var nalOutbox = {
    path: "/nalazi/outbox/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("nalazi/outbox/nalaz"),
    props: true,
    meta: {
      title: "nalazOutbox",
      requiredAuth: true
    }
  };
  var nalveRuta = {
    path: "/nalazi/verifikacija/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("nalazi/verifikacija/nalaz"),
    props: true,
    meta: {
      title: "nalazVerifikacija",
      requiredAuth: true
    }
  };
  var printRuta = {
    path: "/rezultati/pregled/nalaz/:sekcija/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("nalaz/nalaz"),
    props: true,
    meta: {
      title: "printanjeNalaza",
      requiredAuth: true
    }
  };
  var rezRuta = {
    path: "/rezultati/pregled/:sekcija/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("rezultati/pregled/detalji"),
    props: true,
    meta: {
      title: "rezDetalji",
      requiredAuth: true
    }
  };
  var contrDet = {
    path: "/kontrole/pregled/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("kontrole/pregled/detalji"),
    props: true,
    meta: {
      title: "contrDetalji",
      requiredAuth: true
    }
  };
  var patientDet = {
    path: "/pacijenti/detalji/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("pacijenti/pregled/detalji"),
    props: true,
    meta: {
      title: "patientDetalji",
      requiredAuth: true
    }
  };
  var orezRuta = {
    path: "/rezultati/verifikacija/:patient/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("rezultati/verifikacija/detalji"),
    props: true,
    meta: {
      title: "orezDetalji",
      requiredAuth: true
    }
  };
  var authLogin = {
    path: "/auth/login",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("auth/login/Login"),
    meta: {
      default: false,
      title: "login",
      requiredAuth: false
    }
  };
  var authSignup = {
    path: "/postavke/newuser",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("postavke/user/newUser"),
    meta: {
      default: false,
      title: "signUp",
      requiredAuth: false
    }
  };
  var avatarAdd = {
    path: "/postavke/avatar",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("postavke/user/avatar"),
    meta: {
      default: false,
      title: "avatar",
      requiredAuth: false
    }
  };
  var chPwd = {
    path: "/postavke/chpwd",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("postavke/user/chpwd"),
    meta: {
      default: false,
      title: "chpwd",
      requiredAuth: false
    }
  };
  var editUser = {
    path: "/postavke/edit",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("postavke/user/edit"),
    meta: {
      default: false,
      title: "edit",
      requiredAuth: false
    }
  };
  var mojePostavke = {
    path: "/postavke/settings",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("postavke/user/settings"),
    meta: {
      default: false,
      title: "edit",
      requiredAuth: false
    }
  };
  var acme = {
    path: "/.well-known/acme-challenge/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("/postavke/user/chpwd"),
    props: true,
    meta: {
      title: "acme",
      requiredAuth: true
    }
  };

  var obrada = {
    path: "/rezultati/obrada/:patient/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("obrada/Obrada"),
    props: true,
    meta: {
      title: "obrada",
      requiredAuth: true
    }
  };
  var racun = {
    path: "/obrada/racun/:id",
    component: Object(__WEBPACK_IMPORTED_MODULE_4__lazyLoading__["a" /* default */])("obrada/racun"),
    props: true,
    meta: {
      title: "racun",
      requiredAuth: true
    }
  };


  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (item.children) {
      generateRoutesFromMenu(item.children, routes);
    }
  }

  routes.push(samplesEntry);
  routes.push(printRuta);
  routes.push(detRuta);
  routes.push(rezRuta);
  routes.push(orezRuta);
  routes.push(authLogin);
  routes.push(authSignup);
  routes.push(chPwd);
  routes.push(editUser);
  routes.push(contrDet);
  routes.push(nalRuta);
  routes.push(patientDet);
  routes.push(acme);
  routes.push(nalveRuta);
  routes.push(urediRuta);
  routes.push(avatarAdd);
  routes.push(nalOutbox);
  routes.push(mojePostavke);
  routes.push(racRuta);
  routes.push(predracun);

  routes.push(obrada);
  routes.push(racun);


  return routes;
}

function getDefaultRoute() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var defaultRoute = void 0;

  menu.forEach(function (item) {
    if (item.meta.default) {
      defaultRoute = item;
    } else if (item.children) {
      var defaultChild = item.children.find(function (i) {
        return i.meta.default;
      });
      defaultRoute = defaultChild || defaultRoute;
    }
  });

  return defaultRoute;
}

router.beforeEach(function (to, from, next) {
  if (localStorage.getItem("token")) {
    next();
  } else {
    if (to.path !== "/auth/login") {
      if (to.path.indexOf("acme-challenge") !== -1) {
        __WEBPACK_IMPORTED_MODULE_5__config_config_js__["o" /* http */].get(to.path, {}).then(function (res) {});
      } else {
        router.push("/auth/login");
      }
    } else {
      next();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YeH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TrinityRingsSpinner_vue__ = __webpack_require__("l92n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3ebf7639_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TrinityRingsSpinner_vue__ = __webpack_require__("qKqw");
function injectStyle (ssrContext) {
  __webpack_require__("11Ui")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ebf7639"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TrinityRingsSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3ebf7639_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TrinityRingsSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "YhNO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__("ZTcl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53e040b3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__("dwXW");
function injectStyle (ssrContext) {
  __webpack_require__("c/Oz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53e040b3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53e040b3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YirT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ChatWindow = __webpack_require__("Jf5X");

var _ChatWindow2 = _interopRequireDefault(_ChatWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    showEmoji: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    open: {
      type: Function,
      required: true
    },
    close: {
      type: Function,
      required: true
    },
    showFile: {
      type: Boolean,
      default: false
    },
    participants: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    titleImageUrl: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    onMessageWasSent: {
      type: Function,
      required: true
    },
    messageList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    newMessagesCount: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    placeholder: {
      type: String,
      default: 'Write a reply'
    },
    showTypingIndicator: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    colors: {
      type: Object,
      required: false,
      validator: function validator(c) {
        return 'header' in c && 'bg' in c.header && 'text' in c.header && 'launcher' in c && 'bg' in c.launcher && 'messageList' in c && 'bg' in c.messageList && 'sentMessage' in c && 'bg' in c.sentMessage && 'text' in c.sentMessage && 'receivedMessage' in c && 'bg' in c.receivedMessage && 'text' in c.receivedMessage && 'userInput' in c && 'bg' in c.userInput && 'text' in c.userInput;
      },
      default: function _default() {
        return {
          header: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          launcher: {
            bg: '#4e8cff'
          },
          messageList: {
            bg: '#ffffff'
          },
          sentMessage: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          receivedMessage: {
            bg: '#f4f7f9',
            text: '#ffffff'
          },
          userInput: {
            bg: '#f4f7f9',
            text: '#565867'
          }
        };
      }
    },
    alwaysScrollToBottom: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  computed: {
    chatWindowTitle: function chatWindowTitle() {
      if (this.title !== '') {
        return this.title;
      }

      if (this.participants.length > 1) {
        return 'You, ' + this.participants[0].name + ' & others';
      } else {
        return 'You & ' + this.participants[0].name;
      }
    }
  },
  components: {
    ChatWindow: _ChatWindow2.default
  }
};

/***/ }),

/***/ "YtSv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z3JB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2)])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{class:_vm.cancelClass,attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]),_vm._v(" "),(!_vm.okText.includes('!SHOW'))?_c('button',{class:_vm.okClass,attrs:{"type":"button"},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZCHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZEli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard__ = __webpack_require__("Bueh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prijem__ = __webpack_require__("YJBj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pacijenti__ = __webpack_require__("682E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__uzorci__ = __webpack_require__("2FxJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rezultati__ = __webpack_require__("QH5Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__obrada__ = __webpack_require__("p5Q8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__nalazi__ = __webpack_require__("HmjV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__postavke__ = __webpack_require__("27rI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mjesta__ = __webpack_require__("9zCG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__postavke_testova__ = __webpack_require__("gWbf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__postavke_aparata__ = __webpack_require__("feTR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__analize__ = __webpack_require__("Mwi8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__labassays__ = __webpack_require__("cPlS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assays__ = __webpack_require__("NWbm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reports__ = __webpack_require__("mFVy");




















var state = {
  items: [__WEBPACK_IMPORTED_MODULE_2__dashboard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__prijem__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__pacijenti__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__uzorci__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__rezultati__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__obrada__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__nalazi__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__reports__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__postavke__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__assays__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__postavke_testova__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__postavke_aparata__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__labassays__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__analize__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mjesta__["a" /* default */]]
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* TOGGLE_EXPAND_MENU_ITEM */], function (state, payload) {
  var menuItem = payload.menuItem;
  var expand = payload.expand;
  if (menuItem.children && menuItem.meta) {
    menuItem.meta.expanded = expand;
  }
});

var actions = {
  toggleExpandMenuItem: function toggleExpandMenuItem(_ref, payload) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* TOGGLE_EXPAND_MENU_ITEM */], payload);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "ZQWp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle progress-bar",style:('background-image: ' + _vm.backgroundImage)},[_c('div',{staticClass:"overlay",style:('background-color: ' + _vm.backgroundColor + '; color: ' + _vm.color)},[_c('span',[_vm._v(_vm._s(_vm.animatedValue+'%'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZQsF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    participants: {
      type: Array,
      required: true
    }
  }
};

/***/ }),

/***/ "ZTcl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "filterBar",
  data: function data() {
    return {
      filterText: ""
    };
  },

  methods: {
    doFilter: function doFilter(event) {
      this.$emit("filter", this.filterText, event);
    }
  }
});

/***/ }),

/***/ "ZctM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalDelete_vue__ = __webpack_require__("CMJy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8df49bea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalDelete_vue__ = __webpack_require__("3Kyx");
function injectStyle (ssrContext) {
  __webpack_require__("CWyX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalDelete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8df49bea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalDelete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Zgjs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zjk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-checkbox form-check abc-checkbox",class:_vm.additionalClasses},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":_vm.id,"name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[_c('span',{staticClass:"abc-label-text"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZoX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PixelSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'pixel-spinner-animation',
      currentAnimationName: ''
    };
  },


  computed: {
    pixelSize: function pixelSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentAnimationName,
        width: this.pixelSize + 'px',
        height: this.pixelSize + 'px',
        backgroundColor: this.color,
        color: this.color,
        boxShadow: '\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      0 ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px 0 0 0,\n                      ' + this.pixelSize * -1.5 + 'px 0 0 0,\n                      0 ' + this.pixelSize * -1.5 + 'px 0 0\n                    '
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentAnimationName, this.generateKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentAnimationName = this.animationBaseName + '-' + Date.now();
    },
    generateKeyframes: function generateKeyframes() {
      return '\n      50% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n\n      75% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n      100% {\n        transform: rotate(360deg);\n      }';
    }
  }
});

/***/ }),

/***/ "a5v7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-feed"},[(_vm.posts.length == 0)?_c('div',{staticClass:"empty"},[_vm._v("Your feed is empty.")]):_vm._e(),_vm._v(" "),_vm._l((_vm.posts),function(post){return _c('div',{staticClass:"post",class:{last: _vm.posts.indexOf(post) === _vm.posts.length - 1}},[_c('div',{staticClass:"photo-container"},[_c('div',{staticClass:"photo",style:(("background: url(" + (post.photoURL) + ")"))})]),_vm._v(" "),_c('div',{staticClass:"underscored"},[_c('span',{staticClass:"text"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(post.name))]),_vm._v(" "+_vm._s(post.text)+".")]),_vm._v(" "),_c('button',{staticClass:"btn btn-micro btn-primary btn-with-icon close-btn rounded-icon",on:{"click":function($event){_vm.removePost(post)}}},[_c('i',{staticClass:"ion-md-close ion"})])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aCP/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileIcons_vue__ = __webpack_require__("Vo2z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileIcons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileIcons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0e0f3962_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FileIcons_vue__ = __webpack_require__("cd9N");
function injectStyle (ssrContext) {
  __webpack_require__("Gz5b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e0f3962"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileIcons_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0e0f3962_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FileIcons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aLFs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNDcuOTcxIDQ3Ljk3MSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDcuOTcxIDQ3Ljk3MTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGQ9Ik0yOC4yMjgsMjMuOTg2TDQ3LjA5Miw1LjEyMmMxLjE3Mi0xLjE3MSwxLjE3Mi0zLjA3MSwwLTQuMjQyYy0xLjE3Mi0xLjE3Mi0zLjA3LTEuMTcyLTQuMjQyLDBMMjMuOTg2LDE5Ljc0NEw1LjEyMSwwLjg4CgkJYy0xLjE3Mi0xLjE3Mi0zLjA3LTEuMTcyLTQuMjQyLDBjLTEuMTcyLDEuMTcxLTEuMTcyLDMuMDcxLDAsNC4yNDJsMTguODY1LDE4Ljg2NEwwLjg3OSw0Mi44NWMtMS4xNzIsMS4xNzEtMS4xNzIsMy4wNzEsMCw0LjI0MgoJCUMxLjQ2NSw0Ny42NzcsMi4yMzMsNDcuOTcsMyw0Ny45N3MxLjUzNS0wLjI5MywyLjEyMS0wLjg3OWwxOC44NjUtMTguODY0TDQyLjg1LDQ3LjA5MWMwLjU4NiwwLjU4NiwxLjM1NCwwLjg3OSwyLjEyMSwwLjg3OQoJCXMxLjUzNS0wLjI5MywyLjEyMS0wLjg3OWMxLjE3Mi0xLjE3MSwxLjE3Mi0zLjA3MSwwLTQuMjQyTDI4LjIyOCwyMy45ODZ6Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+"

/***/ }),

/***/ "aTa4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTag_vue__ = __webpack_require__("+XJn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66bb064b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTag_vue__ = __webpack_require__("nYsG");
function injectStyle (ssrContext) {
  __webpack_require__("TgKh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66bb064b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aV7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps rich-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ width: 100/_vm.steps.length + '%' })},[_c('i',{staticClass:"ion ion-md-close step-icon icon-cross"}),_vm._v(" "),_c('i',{staticClass:"ion ion-md-checkmark step-icon icon-check"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-line"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aXY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-radio-button',
  props: {
    label: String,
    value: {
      type: String,
      default: '',
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    modelValue: {
      default: undefined
    },
    brandColor: {
      type: String,
      default: 'primary',
      validator: function validator(value) {
        return ['primary', 'secondary', 'success', 'info', 'warning', 'danger'].indexOf(value) >= 0;
      }
    }
  },
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  mounted: function mounted() {
    if (this.checked && !this.checkState) {
      this.toggle();
    }
  },

  methods: {
    onChange: function onChange() {
      this.toggle();
    },
    toggle: function toggle() {
      this.$emit('input', this.checkState ? '' : this.value);
    }
  },
  computed: {
    checkState: function checkState() {
      if (this.modelValue === undefined) {
        return this.checked;
      }
      return this.modelValue === this.value;
    },
    additionalClasses: function additionalClasses() {
      return ['abc-radio-' + this.brandColor];
    }
  },
  watch: {
    checked: function checked(newValue) {
      if (newValue !== this.checkState) {
        this.toggle();
      }
    }
  }
});

/***/ }),

/***/ "aXvH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalStatic_vue__ = __webpack_require__("8sJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7fac20e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalStatic_vue__ = __webpack_require__("REdK");
function injectStyle (ssrContext) {
  __webpack_require__("+H61")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalStatic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7fac20e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalStatic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aemv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTrash),expression:"showTrash"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aj+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticRadioButton_vue__ = __webpack_require__("aXY5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd9d7ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticRadioButton_vue__ = __webpack_require__("kZ+r");
function injectStyle (ssrContext) {
  __webpack_require__("0umV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticRadioButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd9d7ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticRadioButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "anct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSocialNews_vue__ = __webpack_require__("yuAZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48ba4918_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSocialNews_vue__ = __webpack_require__("s66l");
function injectStyle (ssrContext) {
  __webpack_require__("NkBS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSocialNews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48ba4918_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSocialNews_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "awPS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-typing-indicator",style:(_vm.messageColors)},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "axM2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalProgressBar_vue__ = __webpack_require__("yDzF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b28e769_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalProgressBar_vue__ = __webpack_require__("4+0S");
function injectStyle (ssrContext) {
  __webpack_require__("se34")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b28e769_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "b/Jo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b0BD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b0IY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b2iP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],attrs:{"type":"text","id":"simple-textarea","required":""},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"simple-textarea"}},[_vm._v(_vm._s('Unesite komentar'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b6wd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chart_types_PieChart__ = __webpack_require__("NoHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart_types_BubbleChart__ = __webpack_require__("AKm5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chart_types_DonutChart__ = __webpack_require__("+S+3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_types_HorizontalBarChart__ = __webpack_require__("+UQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chart_types_VerticalBarChart__ = __webpack_require__("q30D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chart_types_LineChart__ = __webpack_require__("eDOj");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-chart',
  props: ['data', 'options', 'type'],
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_0__chart_types_PieChart__["a" /* default */],
    LineChart: __WEBPACK_IMPORTED_MODULE_5__chart_types_LineChart__["a" /* default */],
    VerticalBarChart: __WEBPACK_IMPORTED_MODULE_4__chart_types_VerticalBarChart__["a" /* default */],
    HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_3__chart_types_HorizontalBarChart__["a" /* default */],
    DonutChart: __WEBPACK_IMPORTED_MODULE_2__chart_types_DonutChart__["a" /* default */],
    BubbleChart: __WEBPACK_IMPORTED_MODULE_1__chart_types_BubbleChart__["a" /* default */]
  }
});

/***/ }),

/***/ "bGbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SpringSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 3000
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'spring-spinner-animation',
      currentAnimationName: ''
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    spinnerPartStyle: function spinnerPartStyle() {
      return {
        height: this.size / 2 + 'px',
        width: this.size + 'px'
      };
    },
    rotatorStyle: function rotatorStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderRightColor: this.color,
        borderTopColor: this.color,
        borderWidth: this.size / 7 + 'px',
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentAnimationName
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentAnimationName, this.generateKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentAnimationName = this.animationBaseName + '-' + Date.now();
    },
    generateKeyframes: function generateKeyframes() {
      return '\n        0% {\n          border-width: ' + this.size / 7 + 'px;\n        }\n        25% {\n          border-width: ' + this.size / 23.33 + 'px;\n        }\n        50% {\n          transform: rotate(115deg);\n          border-width: ' + this.size / 7 + 'px;\n        }\n        75% {\n          border-width: ' + this.size / 23.33 + 'px;\n         }\n        100% {\n         border-width: ' + this.size / 7 + 'px;\n        }';
    }
  }
});

/***/ }),

/***/ "bNsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-uzorak",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    sample: {
      type: String,
      default: ""
    },
    noHeader: Boolean
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      clientHeight: ""
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    },
    clientHeight: function clientHeight() {}
  },
  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.clientHeight;
      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;
      this.show = false;
    },
    emitHeader: function emitHeader(event) {
      var data = {};
      data.sample = this.sample;
      data.pdf = 'samples/' + this.sample + '.pdf';
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("UzorakFromCollapse", data);
    },
    onHeaderClick: function onHeaderClick() {},
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "bOzn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bPlI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sc-user-input--send-icon-wrapper",on:{"click":function($event){$event.preventDefault();_vm.onClick($event)}}},[_c('svg',{staticClass:"sc-user-input--send-icon",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","width":"37.393px","height":"37.393px","viewBox":"0 0 37.393 37.393","enableBackground":"new 0 0 37.393 37.393"}},[_c('g',{attrs:{"id":"Layer_2"}},[_c('path',{style:({fill: _vm.color}),attrs:{"d":"M36.511,17.594L2.371,2.932c-0.374-0.161-0.81-0.079-1.1,0.21C0.982,3.43,0.896,3.865,1.055,4.241l5.613,13.263\n        L2.082,32.295c-0.115,0.372-0.004,0.777,0.285,1.038c0.188,0.169,0.427,0.258,0.67,0.258c0.132,0,0.266-0.026,0.392-0.08\n        l33.079-14.078c0.368-0.157,0.607-0.519,0.608-0.919S36.879,17.752,36.511,17.594z M4.632,30.825L8.469,18.45h8.061\n        c0.552,0,1-0.448,1-1s-0.448-1-1-1H8.395L3.866,5.751l29.706,12.757L4.632,30.825z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bhip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");



var toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 2500
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vue_toasted___default.a, toastOptions);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    showToast: function showToast(msg, options) {
      this.$toasted.show(msg, options);
    }
  }
});

/***/ }),

/***/ "biUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalError_vue__ = __webpack_require__("pThx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_793ff058_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalError_vue__ = __webpack_require__("KyZu");
function injectStyle (ssrContext) {
  __webpack_require__("tflt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_793ff058_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "c/Oz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c4i4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-building-square-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:{'clear': index && index % 3 === 0},style:(ss)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c6WB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cD2K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    title: {
      type: String
    },
    onClose: {
      type: Function,
      required: true
    },
    colors: {
      type: Object,
      required: true
    }
  },
  methods: {
    toggleUserList: function toggleUserList() {
      this.inUserList = !this.inUserList;
      this.$emit("userList", this.inUserList);
    }
  },
  data: function data() {
    return {
      inUserList: false
    };
  }
};

/***/ }),

/***/ "cPlS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'labassays',
  path: '/postavke/labassays',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('postavke/labassays/LabAssays'),
  meta: {
    default: false,
    expanded: false,
    title: 'Testovi',
    iconClass: 'fa fa-flask',
    requiredAuth: true
  }
});

/***/ }),

/***/ "cWTx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tree-node',
  props: {
    selected: {
      type: Boolean,
      default: false
    }

  }
});

/***/ }),

/***/ "cbJ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tree-node",class:{'vuestic-tree-node-selected': _vm.selected}},[(_vm.$slots.checkbox)?_c('div',{staticClass:"vuestic-tree-node-checkbox"},[_vm._t("checkbox")],2):_vm._e(),_vm._v(" "),(_vm.$slots.icon)?_c('div',{staticClass:"vuestic-tree-node-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vuestic-tree-node-label"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.iconRight)?_c('div',{staticClass:"vuestic-tree-node-icon-right"},[_vm._t("iconRight")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cd9N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"htmlFor":"file-input"}},[_c('button',{staticClass:"sc-user-input--file-icon-wrapper",attrs:{"type":"button"}},[_c('svg',{staticClass:"sc-user-input--file-icon",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 37.393 37.393","enableBackground":"new 0 0 37.393 37.393"}},[_c('path',{style:({fill: _vm.color}),attrs:{"d":"M20.807 10.22l-2.030-2.029-10.15 10.148c-1.682 1.681-1.682 4.408 0 6.089s4.408 1.681 6.090 0l12.18-12.178c2.804-2.802 2.804-7.346 0-10.148-2.802-2.803-7.347-2.803-10.149 0l-12.788 12.787c-0.009 0.009-0.019 0.018-0.027 0.026-3.909 3.909-3.909 10.245 0 14.153 3.908 3.908 10.246 3.908 14.156 0 0.009-0.009 0.016-0.018 0.026-0.027l0.001 0.001 8.729-8.728-2.031-2.029-8.729 8.727c-0.009 0.008-0.018 0.018-0.026 0.026-2.784 2.783-7.312 2.783-10.096 0-2.783-2.783-2.783-7.31 0-10.093 0.010-0.009 0.019-0.018 0.028-0.026l-0.001-0.002 12.79-12.786c1.678-1.679 4.411-1.679 6.090 0s1.678 4.411 0 6.089l-12.18 12.178c-0.56 0.56-1.47 0.56-2.030 0-0.559-0.559-0.559-1.47 0-2.029l10.15-10.149z"}})])]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"file-input"},on:{"change":_vm._handleChange,"click":_vm._handleClick}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ceX3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cfdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAlert_vue__ = __webpack_require__("y3Nu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d61a0b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAlert_vue__ = __webpack_require__("62HC");
function injectStyle (ssrContext) {
  __webpack_require__("b0IY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49d61a0b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d61a0b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "d1QR":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSItNDc0OS40OCAtNTAyMCAzNS4wMzYgMzUuMDM2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntmaWxsOiM0ZThjZmY7fS5je2NsaXAtcGF0aDp1cmwoI2EpO30uZHtmaWxsOiNmZmY7fS5le2ZpbGw6I2VmZjRmOTt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGNsYXNzPSJhIiBkPSJNMC0zOTkuNDc5SDE3LjU1NXYxNy41NTVIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMzk5LjQ3OSkiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDg4NiAtNTA3NSkiPjxjaXJjbGUgY2xhc3M9ImIiIGN4PSIxNy41MTgiIGN5PSIxNy41MTgiIHI9IjE3LjUxOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM2LjUyIDU1KSIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NS4xMyA2NCkiPjxnIGNsYXNzPSJjIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj48cGF0aCBjbGFzcz0iZCIgZD0iTS0zODEuOTI0LTE5MC45NjJhOC43NzgsOC43NzgsMCwwLDAtOC43NzgtOC43NzgsOC43NzgsOC43NzgsMCwwLDAtOC43NzgsOC43NzgsOC43NDUsOC43NDUsMCwwLDAsMi4yNiw1Ljg3OXYxLjQ0MmMwLC44LjQ5MiwxLjQ1NywxLjEsMS40NTdoNS44M2EuODQzLjg0MywwLDAsMCwuMTgzLS4wMiw4Ljc3OCw4Ljc3OCwwLDAsMCw4LjE4NC04Ljc1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzk5LjQ3OSAxOTkuNzQpIi8+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiPjxwYXRoIGNsYXNzPSJlIiBkPSJNLTY4Ljc2My0xOTQuMDc5YTkuMjkyLDkuMjkyLDAsMCwxLDYuMzgtOC44ODhjLS4yNTItLjAyMi0uNTA2LS4wMzMtLjc2My0uMDMzYTguNzc0LDguNzc0LDAsMCwwLTguNzc4LDguNzc4QTkuNTA4LDkuNTA4LDAsMCwwLTY5LjctMTg4LjNjLjAwNSwwLDAsLjAwOSwwLC4wMS0uMzExLjM1Mi0xLjkyNCwyLjg0OS4wMjEsMi44NDloMi4yNWMtMS4yMy0uMDIyLDEuMjYzLTIuMTA3LjI2OS0zLjQ5NGE4LjIyNSw4LjIyNSwwLDAsMS0xLjYtNS4xNDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcxLjkyNCAyMDMpIi8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ "d4/x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMediumEditor_vue__ = __webpack_require__("whi/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c226368_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMediumEditor_vue__ = __webpack_require__("XVNF");
function injectStyle (ssrContext) {
  __webpack_require__("64Yn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMediumEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c226368_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMediumEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dIvT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichHorizontalIndicator_vue__ = __webpack_require__("fom4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e532aca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichHorizontalIndicator_vue__ = __webpack_require__("aV7n");
function injectStyle (ssrContext) {
  __webpack_require__("+vGB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e532aca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichHorizontalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e532aca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichHorizontalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dRu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-profile-card',
  props: ['photoSource', 'name', 'location', 'social']
});

/***/ }),

/***/ "dq31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__ = __webpack_require__("kl3E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e287e912_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__ = __webpack_require__("OtBJ");
function injectStyle (ssrContext) {
  __webpack_require__("Lk68")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e287e912"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e287e912_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dtfx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-modal',
  props: {
    transition: {
      type: String,
      default: 'modal'
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: 'POTVRDI'
    },
    cancelText: {
      type: String,
      default: 'ODUSTANI'
    },
    okClass: {
      type: String,
      default: 'btn btn-primary btn-sm'
    },
    cancelClass: {
      type: String,
      default: 'btn btn-warning btn-sm'
    },
    zatvori: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      zatvor: this.zatvori
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        'modal-lg': this.large,
        'modal-sm': this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += ' modal-open';
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, '');
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += ' modal-open';
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, '');
        }, this.duration);
      }
    }
  },
  methods: {
    ok: function ok() {

      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('sacuvajAnalite');
      this.$emit('ok');
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('yes', true);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('yesRacun', true, this.transition);

      this.show = false;
    },
    cancel: function cancel() {
      this.$emit('cancel');
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('no', false);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('viseNo', false);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('viseKo', false);
      this.show = false;
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
    }
  }
});

/***/ }),

/***/ "dwXW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],attrs:{"onpaste":"return false;","autocomplete":"off","id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.filterText)},on:{"keyup":function($event){_vm.doFilter($event)},"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-search icon-left input-icon search-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s('Pretraga'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e8Tw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_kewler__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-pre-loader',
  methods: {
    getPrevious: function getPrevious(index) {
      if (index === 0) return this.points.length - 1;else return index - 1;
    },
    getNext: function getNext(index) {
      if (index + 1 === this.points.length) {
        return 0;
      } else {
        return index + 1;
      }
    },
    setNextLighten: function setNextLighten(index) {
      var lighten = this.points[index].lighten;
      this.points[index].lighten = lighten === 8 ? 1 : lighten + 1;
    },
    draw: function draw() {
      var _this = this;

      var ctx = this.context;
      ctx.clearRect(0, 0, 140, 104);
      var padding = 4;
      this.points.forEach(function (point) {
        ctx.beginPath();
        var delta = _this.radius + padding;
        ctx.arc(point.x + delta, point.y + delta, _this.radius, 0, Math.PI * 2, false);
        ctx.fillStyle = _this.color(Object(__WEBPACK_IMPORTED_MODULE_1_kewler__["lightness"])(point.lighten / 10 * 35))();
        ctx.fill();
      });
      var main = this.points[this.mainIndex];
      var delta = this.mainRadius - this.radius + padding;
      ctx.beginPath();
      ctx.arc(main.x + delta, main.y + delta, this.mainRadius, 0, Math.PI * 2, false);
      ctx.fillStyle = this.color();
      ctx.fill();
      ctx.closePath();
    },
    calculate: function calculate() {
      this.mainIndex = this.getNext(this.mainIndex);
      var prevIndex = this.mainIndex;
      for (var i = 0; i <= 7; i++) {
        prevIndex = this.getPrevious(prevIndex);
        this.setNextLighten(prevIndex);
      }
    },
    update: function update() {
      this.calculate();
      this.draw();
    },
    animate: function animate() {
      this.interval = setInterval(this.update, 30);
    },
    stop: function stop() {
      clearInterval(this.interval);
    }
  },
  mounted: function mounted() {
    this.context = this.$refs.canvas.getContext('2d');
    this.points = this.points.map(function (point) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        lighten: 8
      }, point);
    });
    for (var i = 1; i <= 7; i++) {
      this.points[this.mainIndex - i].lighten = i;
    }
    this.draw();
    this.animate();
  },
  data: function data() {
    return {
      points: __webpack_require__("/QL9"),
      color: Object(__WEBPACK_IMPORTED_MODULE_1_kewler__["color"])(this.$store.state.app.config.palette.primary),
      mainIndex: 7,
      context: {},
      radius: 4,
      mainRadius: 8,
      interval: {}
    };
  }
});

/***/ }),

/***/ "eBYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HollowDotsSpinner_vue__ = __webpack_require__("laTA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a6f2b1d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HollowDotsSpinner_vue__ = __webpack_require__("4J7k");
function injectStyle (ssrContext) {
  __webpack_require__("mQ62")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a6f2b1d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HollowDotsSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a6f2b1d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HollowDotsSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "eDOj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Line"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], _this.defaultOptions, _this.options);
      _this.renderChart(_this.data, options);
    }, 600);
  }
}));

/***/ }),

/***/ "eG8r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eSeH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tabs"},[_c('div',{staticClass:"d-none d-md-block dm-lg-block dm-xl-block"},[_c('nav',{staticClass:"nav nav-pills row"},_vm._l((_vm.names),function(name){return _c('div',{staticClass:"nav-item col",class:{active: name === _vm.currentActive},on:{"click":function($event){_vm.setActive(name)}}},[_c('span',{staticClass:"nav-link"},[_c('h5',[_vm._v(_vm._s(name))])])])})),_vm._v(" "),_c('div',{staticClass:"track"},[_c('div',{class:_vm.underscoreClass})])]),_vm._v(" "),_c('vuestic-simple-select',{staticClass:"d-flex d-md-none d-lg-none d-xl-none simple-select",attrs:{"options":_vm.names},model:{value:(_vm.currentActive),callback:function ($$v) {_vm.currentActive=$$v},expression:"currentActive"}}),_vm._v(" "),_c('div',{staticClass:"tab-content"},_vm._l((_vm.names),function(name){return _c('div',{staticClass:"tab-pane",class:{active: name === _vm.currentActive}},[_vm._t(name)],2)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "edCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-accordion-obrada",
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastClickedTab: {}
    };
  },
  provide: function provide() {
    var _this = this;

    return {
      accordion: {
        onChildChange: function onChildChange(child, state) {
          return _this.onChildChange(child, state);
        }
      }
    };
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeUpdate: function beforeUpdate() {},
  updated: function updated() {},
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},

  methods: {
    onChildChange: function onChildChange(child, state) {
      if (this.expand) {
        return;
      }

      if (state === false) {
        return;
      }

      this.$children.forEach(function (collapse) {
        if (collapse === child) {
          return;
        }
        collapse.collapse();
      });
    }
  }
});

/***/ }),

/***/ "f6HS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scaling-squares-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:("square-" + (index + 1)),style:(ss)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fIK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-accordion"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fYdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalPatientsData_vue__ = __webpack_require__("r7J/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ea30a6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalPatientsData_vue__ = __webpack_require__("oGML");
function injectStyle (ssrContext) {
  __webpack_require__("gIm7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalPatientsData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ea30a6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalPatientsData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "feTR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postavke-aparata',
  meta: {
    expanded: false,
    title: 'Postavke aparata',
    iconClass: 'glyphicon glyphicon-object-align-bottom'
  },

  children: [{
    name: 'aparati',
    path: '/postavke/aparati',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('postavke/aparati/Aparati'),
    meta: {
      title: 'Aparati',
      requiredAuth: true
    }
  }, {
    name: 'testovi-aparata',
    path: '/postavke/aptestovi',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('postavke/aptestovi/Aptestovi'),
    meta: {
      title: 'Testovi aparata',
      requiredAuth: true
    }
  }]
});

/***/ }),

/***/ "fjgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar"},[_c('vuestic-scrollbar',[_c('ul',{staticClass:"sidebar-menu"},_vm._l((_vm.menuItems),function(item){return _c('li',{directives:[{name:"show",rawName:"v-show",value:((
          ((item.meta.title != 'Kontrole') && (item.meta.title != 'Pacijenti')  && (item.meta.title != 'Opšte postavke')
            && (item.meta.title != 'Postavke aparata') && (item.meta.title != 'Definicija kontrola') && (item.meta.title != 'Pomoć')
            && (item.meta.title != 'Uzorci') && (item.meta.title != 'Rezultati') && (item.meta.title != 'Assays')  
            && (item.meta.title != 'Definicija testova') && (_vm.$store.state.userId != 'admin@atom.ba') && (_vm.$store.state.userId != 'prijem')
          ) 
          || (_vm.$store.state.userId === 'admin@atom.ba') 
          || (_vm.$store.state.userId === 'prijem' && item.meta.title === 'Prijem')
        )),expression:"(\n          ((item.meta.title != 'Kontrole') && (item.meta.title != 'Pacijenti')  && (item.meta.title != 'Opšte postavke')\n            && (item.meta.title != 'Postavke aparata') && (item.meta.title != 'Definicija kontrola') && (item.meta.title != 'Pomoć')\n            && (item.meta.title != 'Uzorci') && (item.meta.title != 'Rezultati') && (item.meta.title != 'Assays')  \n            && (item.meta.title != 'Definicija testova') && ($store.state.userId != 'admin@atom.ba') && ($store.state.userId != 'prijem')\n          ) \n          || ($store.state.userId === 'admin@atom.ba') \n          || ($store.state.userId === 'prijem' && item.meta.title === 'Prijem')\n        )"}],key:item.name,on:{"click":function($event){_vm.setDropdownDefaultIzbor()}}},[(item.path)?_c('router-link',{class:{'sidebar-link': item.meta.title != 'Mjesta', 
            'sidebar-link-warning': (item.meta.title === 'Mjesta' || item.meta.title === 'Testovi') || item.meta.title === 'Reference'},attrs:{"to":item.path,"target":item.meta.newWindow ? '_blank' : '_self'},on:{"click":function($event){_vm.toggleMenuItem(item)}}},[_c('i',{staticClass:"sidebar-menu-item-icon",class:item.meta.iconClass}),_vm._v("\n          "+_vm._s(_vm._f("translate")(item.meta.title))+"\n        ")]):_c('a',{staticClass:"sidebar-link",class:{expanded: item.meta.expanded},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleMenuItem(item)}}},[_c('i',{staticClass:"sidebar-menu-item-icon",class:item.meta.iconClass}),_vm._v("\n          "+_vm._s(_vm._f("translate")(item.meta.title))+"\n          "),_c('i',{staticClass:"expand-icon fa fa-angle-down"})]),_vm._v(" "),_c('expanding',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(item.meta.expanded),expression:"item.meta.expanded"}],staticClass:"sidebar-submenu in"},_vm._l((item.children),function(childItem){return _c('li',{directives:[{name:"show",rawName:"v-show",value:((                  
                (_vm.$store.state.userId != 'admin@atom.ba' 
                  && (!(childItem.meta.title === 'Predračun' && item.meta.title === 'Uzorci')
                    && !(childItem.meta.title === 'Pregled' && item.meta.title === 'Rezultati')                      
                    && !(childItem.meta.title === 'Unos' && item.meta.title === 'Uzorci')
                    && !(childItem.meta.title === 'Prijem' && item.meta.title === 'Pacijenti')
                    && !(childItem.meta.title === 'Verifikacija' && item.meta.title === 'Nalazi')
                  )
                )
                || (_vm.$store.state.userId === 'admin@atom.ba')                  
              )),expression:"(                  \n                ($store.state.userId != 'admin@atom.ba' \n                  && (!(childItem.meta.title === 'Predračun' && item.meta.title === 'Uzorci')\n                    && !(childItem.meta.title === 'Pregled' && item.meta.title === 'Rezultati')                      \n                    && !(childItem.meta.title === 'Unos' && item.meta.title === 'Uzorci')\n                    && !(childItem.meta.title === 'Prijem' && item.meta.title === 'Pacijenti')\n                    && !(childItem.meta.title === 'Verifikacija' && item.meta.title === 'Nalazi')\n                  )\n                )\n                || ($store.state.userId === 'admin@atom.ba')                  \n              )"}],key:childItem.name,on:{"click":function($event){_vm.setDropdownDefaultIzbor()}}},[_c('router-link',{staticClass:"sidebar-link sidebar-submenu-link",attrs:{"to":childItem.path,"target":childItem.meta.newWindow ? '_blank' : '_self'}},[_vm._v(_vm._s(_vm._f("translate")(childItem.meta.title)))])],1)}))])],1)}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fm8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group with-icon-left"},[(_vm.show_datepicker)?_c('div',{staticClass:"input-group"},[_c('vuestic-date-picker',{staticStyle:{"min-width":"18rem"},attrs:{"id":"date-picker-range","config":_vm.config},on:{"on-change":_vm.doSomethingOnChangeDateRange},model:{value:(_vm.datepicker.range),callback:function ($$v) {_vm.$set(_vm.datepicker, "range", $$v)},expression:"datepicker.range"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-calendar icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"date-picker-range"}},[_vm._v(_vm._s('Unesite opseg datuma'))]),_vm._v(" "),_c('i',{staticClass:"bar"})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fom4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-rich-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "fsNc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__("NHnr");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-trash",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: "SAČUVAJ"
    },
    cancelText: {
      type: String,
      default: "ZATVORI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sid: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      showTrash: false,
      duration: 500,

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.showTrash) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    showTrash: function showTrash(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");

      this.sampleDelete();

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.showTrash = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.showTrash = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.showTrash = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },

    sampleDelete: function sampleDelete() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__config_config_js__["o" /* http */].post("uzorci/delete", {
        id: this.sid,
        email: this.$store.state.user,
        token: this.$store.state.token,
        site: this.$store.state.site
      }).then(function (res) {
        if (res.data.success === false) {
          _this.toastText = "Greška prilikom brisanja!";
          _this.toastIcon = "fa-remove";
          _this.toastPosition = "top-right";
          _this.className = "vuestic-toast-danger";

          _this.showToast(_this.toastText, {
            icon: _this.toastIcon,
            position: _this.toastPosition,
            duration: _this.toastDuration,
            fullWidth: _this.isToastFullWidth,
            className: _this.className
          });
        } else {
          _this.toastText = "Zapis uspješno obrisan!";
          _this.toastIcon = "fa-check";
          _this.toastPosition = "top-right";
          _this.className = "vuestic-toast-primary";

          _this.showToast(_this.toastText, {
            icon: _this.toastIcon,
            position: _this.toastPosition,
            duration: _this.toastDuration,
            fullWidth: _this.isToastFullWidth,
            className: _this.className
          });

          _this.showTrash = false;
          __WEBPACK_IMPORTED_MODULE_4__main__["bus"].$emit("showTrashRefresh");
        }
      });
    }
  }
});

/***/ }),

/***/ "g9jP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"nav d-lg-none"},[_c('router-link',{staticClass:"i-vuestic",attrs:{"to":{path: '/'}}})],1),_vm._v(" "),_c('div',{staticClass:"main row"},[_c('div',{staticClass:"auth-content col-lg-6 col-12"},[_c('router-view',{key:_vm.$route.fullPath})],1),_vm._v(" "),_c('div',{staticClass:"auth-wallpaper col-6 d-none d-lg-flex"},[_c('div',{staticClass:"oblique"}),_vm._v(" "),_c('router-link',{staticClass:"i-vuestic",attrs:{"to":{path: '/'}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gBU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swapping-squares-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:("square-" + (index + 1)),style:(ss)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gHiU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gIm7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gWbf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'definicija-testova',
  meta: {
    expanded: false,
    title: 'Definicija testova',
    iconClass: 'fa fa-flask'
  },

  children: [{
    name: 'laboratorijski-testovi',
    path: '/postavke/testovi',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('postavke/testovi/Testovi'),
    meta: {
      title: 'Laboratorijski testovi',
      requiredAuth: true
    }
  }, {
    name: 'rucni-testovi',
    path: '/postavke/manual/testovi',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('postavke/testovi/Manual'),
    meta: {
      title: 'Ručni testovi',
      requiredAuth: true
    }
  }, {
    name: 'kalkulisani-testovi',
    path: '/postavke/calculated/testovi',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('postavke/testovi/Calculated'),
    meta: {
      title: 'Kalkulisani testovi',
      requiredAuth: true
    }
  }]
});

/***/ }),

/***/ "gZ+0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget",class:{'no-header': !_vm.headerText}},[(_vm.headerText)?_c('div',{staticClass:"widget-header",staticStyle:{"position":"relative"}},[(_vm.spol === 'MUŠKI')?_c('span',{staticStyle:{"color":"#4ab2e3"}},[_c('i',{staticClass:"fa fa-mars"}),_vm._v(" \n    ")]):_vm._e(),_vm._v(" "),(_vm.spol === 'ŽENSKI')?_c('span',{staticStyle:{"color":"#db76df"}},[_c('i',{staticClass:"fa fa-venus"}),_vm._v(" \n    ")]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.headerText)+"\n    "),(_vm.datum != '')?_c('span',{class:{'green': _vm.datum.trim() === _vm.today.trim(), 'red': _vm.datum.trim() != _vm.today.trim()},attrs:{"id":_vm.datum}},[_vm._v("\n       "+_vm._s(' | ')+_vm._s(_vm.datum)+"\n      "),(false)?_c('i',{staticClass:"fa fa-check"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.pagination && _vm.main && _vm.window.width > 800)?_c('div',{staticClass:"col-md-2 pull-right",staticStyle:{"position":"absolute","right":"20px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"left"},[(_vm.rezultati_length > 1 && _vm.data_pid > _vm.data_min)?_c('i',{staticClass:"fa fa-backward pull-left",on:{"click":function($event){$event.preventDefault();_vm.Prethodni()}}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e(),_vm._v(" "),(_vm.rezultati_length > 1 && _vm.data_pid === _vm.data_min)?_c('i',{staticClass:"fa fa-step-backward pull-left stop",staticStyle:{"color":"#e34a4a"}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e()]),_vm._v(" "),(_vm.rezultati_length > 1)?_c('div',{class:{'center green': _vm.datum.trim() === _vm.today.trim(), 'center red': _vm.datum.trim() != _vm.today.trim()},staticStyle:{"font-size":"22px"},on:{"click":function($event){$event.preventDefault();_vm.Find()}}},[_c('sup',[_vm._v(_vm._s(_vm.data_pid)+"/"+_vm._s(_vm.data_length))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"right"},[(_vm.rezultati_length > 1 && _vm.data_length > _vm.data_pid)?_c('i',{staticClass:"fa fa-forward pull-right",on:{"click":function($event){$event.preventDefault();_vm.Sljedeci()}}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e(),_vm._v(" "),(_vm.rezultati_length > 1 && _vm.data_length == _vm.data_pid && _vm.data_pid > 0)?_c('i',{staticClass:"fa fa-step-forward pull-right stop",staticStyle:{"color":"#e34a4a"}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e()])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.pagination && _vm.main && _vm.window.width <= 800)?_c('div',{staticClass:"widget-header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"left"},[(_vm.rezultati_length > 1 && _vm.data_pid > _vm.data_min)?_c('i',{staticClass:"fa fa-backward pull-left",on:{"click":function($event){$event.preventDefault();_vm.Prethodni()}}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e(),_vm._v(" "),(_vm.rezultati_length > 1 && _vm.data_pid === _vm.data_min)?_c('i',{staticClass:"fa fa-step-backward pull-left stop",staticStyle:{"color":"#e34a4a"}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e()]),_vm._v(" "),(_vm.rezultati_length > 1)?_c('div',{class:{'center green': _vm.datum.trim() === _vm.today.trim(), 'center red': _vm.datum.trim() != _vm.today.trim()},staticStyle:{"font-size":"22px"},on:{"click":function($event){$event.preventDefault();_vm.Find()}}},[_c('sup',[_vm._v(_vm._s(_vm.data_pid)+"/"+_vm._s(_vm.data_length))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"right"},[(_vm.rezultati_length > 1 && _vm.data_length > _vm.data_pid)?_c('i',{staticClass:"fa fa-forward pull-right",on:{"click":function($event){$event.preventDefault();_vm.Sljedeci()}}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e(),_vm._v(" "),(_vm.rezultati_length > 1 && _vm.data_length == _vm.data_pid && _vm.data_pid > 0)?_c('i',{staticClass:"fa fa-step-forward pull-right stop",staticStyle:{"color":"#e34a4a"}},[_c('span',{staticStyle:{"font-size":"15px","color":"#acb5be"}},[_vm._v(_vm._s(''))])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"widget-body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gZZu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ghd7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flower-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"dots-container",style:(_vm.dotsContainerStyle)},[_c('div',{staticClass:"bigger-dot",style:(_vm.biggerDotStyle)},[_c('div',{staticClass:"smaller-dot",style:(_vm.smallerDotStyle)})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gvyn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-feed',
  props: ['initialPosts'],
  methods: {
    removePost: function removePost(target) {
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var post = _step.value;

          if (post !== target) {
            result.push(post);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.posts = result;
    }
  },
  data: function data() {
    return {
      posts: this.initialPosts
    };
  }
});

/***/ }),

/***/ "h+W8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SwappingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'swapping-squares-animation-child',
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delay = this.animationDuration * 0.5;

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: (i % 2 === 0 ? delay : 0) + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "hF3+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component__ = __webpack_require__("B+20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-date-picker',
  components: {
    VueFlatpickrComponent: __WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component___default.a
  },
  props: {
    value: {
      required: true
    },
    config: {
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    valueProxy: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    fullConfig: function fullConfig() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultConfig, this.config);
    },
    defaultConfig: function defaultConfig() {
      return {
        nextArrow: '<span aria-hidden="true" class="ion ion-ios-arrow-forward"></span>',
        prevArrow: '<span aria-hidden="true" class="ion ion-ios-arrow-back"></span>'
      };
    }
  }
});

/***/ }),

/***/ "hF5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeRoot_vue__ = __webpack_require__("8yMI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056bd54e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeRoot_vue__ = __webpack_require__("CcVb");
function injectStyle (ssrContext) {
  __webpack_require__("qQGN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeRoot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056bd54e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeRoot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hRNN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i/0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__("MEVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd9d2b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__("wxRo");
function injectStyle (ssrContext) {
  __webpack_require__("phUr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd9d2b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "i/C3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"domNode",staticClass:"sc-emoji-picker",attrs:{"tabIndex":"0"},on:{"blur":_vm.onBlur}},[_c('div',{staticClass:"sc-emoji-picker--content"},_vm._l((_vm.emojiData),function(category){return _c('div',{key:category.name,staticClass:"sc-emoji-picker--category"},[_c('div',{staticClass:"sc-emoji-picker--category-title"},[_vm._v(_vm._s(category.name))]),_vm._v(" "),_vm._l((category.emojis),function(emoji){return _c('span',{key:emoji,staticClass:"sc-emoji-picker--emoji",on:{"click":function($event){_vm.emojiClicked(emoji)}}},[_vm._v("\n          "+_vm._s(emoji)+"\n        ")])})],2)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iGdN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iLsn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichVerticalIndicator_vue__ = __webpack_require__("GI4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cd37289_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichVerticalIndicator_vue__ = __webpack_require__("85yt");
function injectStyle (ssrContext) {
  __webpack_require__("JFBt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cd37289"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichVerticalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cd37289_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichVerticalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iZBt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__ = __webpack_require__("OR0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  directives: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__["a" /* default */]
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    defaultPerPage: {
      type: String
    },
    range_max: {
      type: String,
      default: ""
    },
    range_min: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      selected: this.defaultPerPage
    };
  },

  watch: {
    range_min: function range_min() {
      if (this.range_min != "") {
        this.selected = "Svi Rezultati";
      }
    }
  },
  methods: {
    selectedItemsPerPage: function selectedItemsPerPage(optionValue) {
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("selectedItemsPerPage");
      this.selected = optionValue;
      this.$emit("items-per-page", this.selected);
    }
  }
});

/***/ }),

/***/ "ibxE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipOptions),expression:"tooltipOptions"}],staticClass:"vuestic-tooltip-target"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jEUr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("VVeD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2576a2f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("fjgI");
function injectStyle (ssrContext) {
  __webpack_require__("TGxb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2576a2f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jSLc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"atom-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinner-inner"},[_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-circle",style:(_vm.circleStyle)},[_vm._v("\n      ●\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jbjO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breeding-rhombus-spinner",style:(_vm.spinnerStyle)},[_vm._l((_vm.rhombusesStyles),function(rs,index){return _c('div',{key:index,staticClass:"rhombus",class:("child-" + (index + 1)),style:(rs)})}),_vm._v(" "),_c('div',{staticClass:"rhombus big",style:(_vm.bigRhombusStyle)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jfpW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-patient",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      jmbg: "",
      ime: "",
      prezime: "",
      spol: "",
      spolovi: ["MUŠKI", "ŽENSKI"],
      duhan: "",
      duhani: ["NE", "DA"],
      dijabetes: "",
      dijabetesi: ["NE", "DA"],
      telefon: "",
      email: "",
      citiesList: [],
      chosenAdress: "",
      chosenAdressTmp: "",
      uspjesno: false,
      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: "",
      maticni: "",
      postoji: false,
      pacijentID: "",
      imePrezime: "",
      izvor: "",
      izvori: ["Lična karta", "Vozačka dozvola", "Saobraćajna dozvola", "Zdravstvena knjižica", "Pasoš", "Usmeno"],
      isLoading: false,
      fullPage: true
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  mounted: function mounted() {
    this.dohvatiMjesta();
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    },

    jmbg: function jmbg() {
      var _this = this;

      if (this.jmbg.length < 13) {
        this.postoji = false;
        this.pacijentID = "";
        this.imePrezime = "";
      }

      if (this.jmbg.length === 13) {
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["o" /* http */].post("/uzorci/patient", {
          jmbg: this.jmbg,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.success) {
            _this.postoji = true;
            _this.pacijentID = res.data.pacijent._id;
            _this.imePrezime = res.data.pacijent.ime + " " + res.data.pacijent.prezime;
          } else {
            _this.postoji = false;
            _this.pacijentID = "";
            _this.imePrezime = "";
          }
        });
      }
      if (this.jmbg.length > 13) {
        this.jmbg = this.jmbg.slice(0, 13);
      }
    }
  },
  methods: {
    Test: function Test() {
      var _this2 = this;

      this.isLoading = true;

      setTimeout(function () {
        _this2.isLoading = false;
      }, 2000);
    },
    onCancel: function onCancel() {},
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");

      this.dodajPacijenta();
      if (this.uspjesno) {
        this.show = false;
        window.removeEventListener("keyup", this.listenKeyUp);
      }
    },
    prijem: function prijem() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/samples/entry/" + this.pacijentID);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },

    dohvatiMjesta: function dohvatiMjesta() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__config_config_js__["o" /* http */].post("/postavke/sajtovi/" + this.$store.state.site, {
        token: this.$store.state.token
      }).then(function (res) {
        if (res.data.sajt.mjesta != undefined) {
          res.data.sajt.mjesta.forEach(function (element) {
            if (element != "NEPOZNATO") {
              _this3.citiesList.push(element);
            }
          });
        }
      }).then(function (res) {
        _this3.citiesList.sort(function (a, b) {
          return a.toLowerCase() == b.toLowerCase() ? 0 : +(a.toLowerCase() > b.toLowerCase()) || -1;
        });
      });
    },
    validateEmail: function validateEmail(mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true;
      } else {
        return false;
      }
    },
    validatePhone: function validatePhone(telefon) {
      return true;
    },
    getRandomInt: function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min;
    },
    dodajPacijenta: function dodajPacijenta() {
      var _this4 = this;

      if (this.jmbg.length === 7 && this.jmbgValidateP(this.jmbg)) {
        var jmbgPost = this.jmbg + this.getRandomInt(10000, 99999) + "P";
      } else {
        var jmbgPost = this.jmbg;
      }
      var item = true;

      if (this.jmbg.trim() === "" || this.ime.trim() === "" || this.prezime.trim() === "" || this.spol.trim() === "" || this.izvor.trim() === "") {
        item = false;
        this.toastText = "Polja Izvor identifikacije, JMBG, Ime, Prezime i Spol su obavezna!";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      } else if (!this.jmbgValidate(jmbgPost)) {
        item = false;
        this.toastText = this.$t("pacijenti.unos.UnosPacijenta.trnslr012");
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      } else if (this.email.trim() != "" && !this.validateEmail(this.email)) {
        item = false;
        this.toastText = this.$t("pacijenti.unos.UnosPacijenta.trnslr013");
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      } else if (this.telefon.trim() != "" && !this.validatePhone(this.telefon)) {
        item = false;
        this.toastText = this.$t("pacijenti.unos.UnosPacijenta.trnslr014");
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__config_config_js__["o" /* http */].post("pacijenti/unos/find", {
          jmbg: this.jmbg,
          token: this.$store.state.token,
          site: this.$store.state.site
        }).then(function (res) {
          if (res.data.message === "Pacijent postoji") {
            item = false;
            _this4.toastText = _this4.$t("pacijenti.unos.UnosPacijenta.trnslr015");
            _this4.toastIcon = "fa-warning";
            _this4.toastPosition = "top-right";
            _this4.className = "vuestic-toast-warning";

            _this4.showToast(_this4.toastText, {
              icon: _this4.toastIcon,
              position: _this4.toastPosition,
              duration: _this4.toastDuration,
              fullWidth: _this4.isToastFullWidth,
              className: _this4.className
            });
          } else {}
        }).then(function (res) {
          if (item) {
            if (_this4.duhan === "") {
              _this4.duhan = "NEPOZNATO";
            }
            if (_this4.dijabetes === "") {
              _this4.dijabetes = "NEPOZNATO";
            }
            if (_this4.telefon === "") {
              _this4.telefon = "NEPOZNATO";
            }
            if (_this4.email === "") {
              _this4.email = "NEPOZNATO";
            }
            if (_this4.chosenAdress === "") {
              _this4.chosenAdressTmp = "NEPOZNATO";
            } else {
              _this4.chosenAdressTmp = _this4.chosenAdress;
            }

            _this4.isLoading = true;

            __WEBPACK_IMPORTED_MODULE_2__config_config_js__["o" /* http */].post("pacijenti/unos/save", {
              jmbg: jmbgPost,
              ime: _this4.ime.toUpperCase().trim(),
              prezime: _this4.prezime.toUpperCase().trim(),
              spol: _this4.spol,
              izvor: _this4.izvor,
              duhan: _this4.duhan,
              dijabetes: _this4.dijabetes,
              telefon: _this4.telefon,
              adresa: _this4.chosenAdressTmp,
              email: _this4.email,
              token: _this4.$store.state.token,
              site: _this4.$store.state.site
            }).then(function (res) {
              if (res.data.success === false) {
                _this4.toastText = _this4.$t("pacijenti.unos.UnosPacijenta.trnslr016");
                _this4.toastIcon = "fa-remove";
                _this4.toastPosition = "top-right";
                _this4.className = "vuestic-toast-danger";

                _this4.showToast(_this4.toastText, {
                  icon: _this4.toastIcon,
                  position: _this4.toastPosition,
                  duration: _this4.toastDuration,
                  fullWidth: _this4.isToastFullWidth,
                  className: _this4.className
                });
              } else {
                _this4.isLoading = false;


                _this4.maticni = _this4.jmbg;

                _this4.jmbg = "";
                _this4.ime = "";
                _this4.prezime = "";
                _this4.spol = "";
                _this4.duhan = "";
                _this4.dijabetes = "";
                _this4.telefon = "";
                _this4.email = "";
                _this4.chosenAdress = "";

                __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/samples/entry/" + res.data.pacijent._id);
              }
            });
          }
        });
      }
    },
    jmbgValidate: function jmbgValidate(jmbg) {
      return (/^\d{4}[9,0]{1}\d{8}$/.test(String(jmbg)) || /^\d{4}[9,0]{1}\d{7}[P]{1}$/.test(String(jmbg))
      );
    },
    jmbgValidateP: function jmbgValidateP(jmbg) {
      return (/^\d{4}[9,0]{1}\d{2}$/.test(String(jmbg))
      );
    }
  }
});

/***/ }),

/***/ "jgw1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popover',{attrs:{"popover-class":_vm.popoverClass,"open":_vm.open,"disabled":_vm.disabled,"placement":_vm.placement,"auto-hide":_vm.autoHide}},[_vm._t("trigger"),_vm._v(" "),_c('template',{attrs:{"slot":"popover"},slot:"popover"},[(_vm.isIconPresent)?_c('div',{staticClass:"popover-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popover-content"},[_c('div',{staticClass:"popover-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"popover-body"},[_vm._t("body")],2)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jtO9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jzLZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleHorizontalIndicator_vue__ = __webpack_require__("lfQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd5f405_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleHorizontalIndicator_vue__ = __webpack_require__("wcXn");
function injectStyle (ssrContext) {
  __webpack_require__("b/Jo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bd5f405"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleHorizontalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd5f405_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleHorizontalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kEJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue__ = __webpack_require__("0Ohc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_44c303c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmojiIcon_vue__ = __webpack_require__("7anH");
function injectStyle (ssrContext) {
  __webpack_require__("/WYu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44c303c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiIcon_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_44c303c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmojiIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kFeL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-samples-entry",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    noHeader: Boolean,
    uzorak: {
      type: String,
      default: ""
    },
    komentar: {
      type: String,
      default: ""
    },
    vrijeme: {
      type: String,
      default: ""
    },
    tags: {
      type: Array,
      default: []
    }
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      hitan: false
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    },

    tags: function tags(newVal, oldVal) {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("headerKlik", this.uzorak);
    }
  },
  mounted: function mounted() {
    this.toggle();
    this.accordion.onChildChange(this, this.show);
  },

  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.$slots.body[0].elm.clientHeight + "px";

      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;

      this.show = false;
    },
    onHeaderClick: function onHeaderClick(event) {
      switch (event.target.id) {
        case "remove":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SamplesEntryRemove", this.uzorak);
          break;
        case "commenting":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SamplesEntryCommenting", this.uzorak, this.komentar);
          break;
        case "calendar":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SamplesEntryCalendar", this.uzorak, this.vrijeme);
          break;
        case "star-o":
          this.hitan = true;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SamplesEntryUrgent", this.uzorak);
          break;
        case "star":
          this.hitan = false;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("SamplesEntryRemoveUrgent", this.uzorak);
          break;
        case "":
          break;
        default:
          this.toggle();
          this.accordion.onChildChange(this, this.show);
          break;
      }
    },
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "kH5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SemipolarSpinner_vue__ = __webpack_require__("NpL0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_829d59fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SemipolarSpinner_vue__ = __webpack_require__("DJ83");
function injectStyle (ssrContext) {
  __webpack_require__("8cpX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-829d59fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SemipolarSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_829d59fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SemipolarSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "kT3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-simple-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "kZ+r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-radio-button form-check radio abc-radio",class:_vm.additionalClasses},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.name,"id":_vm.id,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checkState},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[_c('span',{staticClass:"abc-label-text"},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kl3E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_main_js__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fields: {
      type: Array,
      required: true
    },
    loadOnStart: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: ''
    },
    httpMethod: {
      type: String,
      default: 'get',
      validator: function validator(value) {
        return ['get', 'post'].indexOf(value) > -1;
      }
    },
    reactiveApiUrl: {
      type: Boolean,
      default: true
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    data: {
      type: [Array, Object],
      default: function _default() {
        return null;
      }
    },
    dataTotal: {
      type: Number,
      default: 0
    },
    dataManager: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    paginationPath: {
      type: [String],
      default: 'links.pagination'
    },
    queryParams: {
      type: Object,
      default: function _default() {
        return {
          sort: 'sort',
          page: 'page',
          perPage: 'per_page',
          datum: 'datum',
          token: 'token',
          site: 'site'
        };
      }
    },
    appendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpFetch: {
      type: Function,
      default: null
    },
    perPage: {
      type: Number,
      default: function _default() {
        return 10;
      }
    },
    datum: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    token: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    site: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    initialPage: {
      type: Number,
      default: function _default() {
        return 1;
      }
    },
    sortOrder: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiSort: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    tableHeight: {
      type: String,
      default: null
    },

    multiSortKey: {
      type: String,
      default: 'alt'
    },

    rowClassCallback: {
      type: [String, Function],
      default: ''
    },
    rowClass: {
      type: [String, Function],
      default: ''
    },
    detailRowComponent: {
      type: String,
      default: ''
    },
    detailRowTransition: {
      type: String,
      default: ''
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    css: {
      type: Object,
      default: function _default() {
        return {
          tableClass: 'ui blue selectable celled stackable attached table',
          loadingClass: 'loading',
          ascendingIcon: 'blue chevron up icon',
          descendingIcon: 'blue chevron down icon',
          ascendingClass: 'sorted-asc',
          descendingClass: 'sorted-desc',
          sortableIcon: '',
          detailRowClass: 'vuetable-detail-row',
          handleIcon: 'grey sidebar icon',
          tableBodyClass: 'vuetable-semantic-no-top vuetable-fixed-layout',
          tableHeaderClass: 'vuetable-fixed-layout'
        };
      }
    },
    minRows: {
      type: Number,
      default: 0
    },
    silent: {
      type: Boolean,
      default: false
    },
    noDataTemplate: {
      type: String,
      default: function _default() {

        return '<br><h6 style="color: #4ae387">Nema dostupnih podataka.</h6>';
      }
    },
    showSortIcons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable:',
      tableFields: [],
      tableData: null,
      tablePagination: null,
      currentPage: this.initialPage,
      selectedTo: [],
      visibleDetailRows: [],
      lastScrollPosition: 0,
      scrollBarWidth: '17px',
      scrollVisible: false
    };
  },
  mounted: function mounted() {
    this.normalizeFields();
    this.normalizeSortOrder();
    if (this.isFixedHeader) {
      this.scrollBarWidth = this.getScrollBarWidth() + 'px';
    }
    this.$nextTick(function () {
      this.fireEvent('initialized', this.tableFields);
    });

    if (this.loadOnStart) {
      this.loadData();
    }
    if (this.isFixedHeader) {
      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        elem.addEventListener('scroll', this.handleScroll);
      }
    }
  },
  destroyed: function destroyed() {
    var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
    if (elem != null) {
      elem.removeEventListener('scroll', this.handleScroll);
    }
  },

  computed: {
    useDetailRow: function useDetailRow() {
      if (this.tableData && this.tableData[0] && this.detailRowComponent !== '' && typeof this.tableData[0][this.trackBy] === 'undefined') {
        this.warn('You need to define unique row identifier in order for detail-row feature to work. Use `track-by` prop to define one!');
        return false;
      }

      return this.detailRowComponent !== '';
    },
    countVisibleFields: function countVisibleFields() {
      return this.tableFields.filter(function (field) {
        return field.visible;
      }).length;
    },
    countTableData: function countTableData() {
      if (this.tableData === null) {

        return 0;
      }
      return this.tableData.length;
    },
    displayEmptyDataRow: function displayEmptyDataRow() {

      if (this.tableData != null && this.tableData.length < 1) {
        __WEBPACK_IMPORTED_MODULE_1__src_main_js__["bus"].$emit('tableData', this.tableData.length);
      }

      if (this.tableData != null) {
        __WEBPACK_IMPORTED_MODULE_1__src_main_js__["bus"].$emit('noData', this.tableData.length);
      }

      return this.countTableData === 0 && this.noDataTemplate.length > 0;
    },
    lessThanMinRows: function lessThanMinRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return true;
      }
      return this.tableData.length < this.minRows;
    },
    blankRows: function blankRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return this.minRows;
      }
      if (this.tableData.length >= this.minRows) {
        return 0;
      }

      return this.minRows - this.tableData.length;
    },
    isApiMode: function isApiMode() {
      return this.apiMode;
    },
    isDataMode: function isDataMode() {
      return !this.apiMode;
    },
    isFixedHeader: function isFixedHeader() {
      return this.tableHeight != null;
    }
  },
  methods: {
    getScrollBarWidth: function getScrollBarWidth() {
      var outer = document.createElement('div');
      var inner = document.createElement('div');

      outer.style.visibility = 'hidden';
      outer.style.width = '100px';

      inner.style.width = '100%';

      outer.appendChild(inner);
      document.body.appendChild(outer);

      var widthWithoutScrollbar = outer.offsetWidth;

      outer.style.overflow = 'scroll';

      var widthWithScrollbar = inner.offsetWidth;

      document.body.removeChild(outer);

      return widthWithoutScrollbar - widthWithScrollbar;
    },
    handleScroll: function handleScroll(e) {
      var horizontal = e.currentTarget.scrollLeft;
      if (horizontal != this.lastScrollPosition) {
        var header = this.$el.getElementsByClassName('vuetable-head-wrapper')[0];
        if (header != null) {
          header.scrollLeft = horizontal;
        }
        this.lastScrollPosition = horizontal;
      }
    },
    normalizeFields: function normalizeFields() {
      if (typeof this.fields === 'undefined') {
        this.warn('You need to provide "fields" prop.');
        return;
      }

      this.tableFields = [];
      var self = this;
      var obj = void 0;
      this.fields.forEach(function (field, i) {
        if (typeof field === 'string') {
          obj = {
            name: field,
            title: self.setTitle(field),
            titleClass: '',
            dataClass: '',
            callback: null,
            visible: true
          };
        } else {
          obj = {
            name: field.name,
            width: field.width,
            title: field.title === undefined ? self.setTitle(field.name) : field.title,
            sortField: field.sortField,
            titleClass: field.titleClass === undefined ? '' : field.titleClass,
            dataClass: field.dataClass === undefined ? '' : field.dataClass,
            callback: field.callback === undefined ? '' : field.callback,
            visible: field.visible === undefined ? true : field.visible
          };
        }
        self.tableFields.push(obj);
      });
    },
    setData: function setData(data) {
      this.apiMode = false;
      if (Array.isArray(data)) {
        this.tableData = data;
        return;
      }

      this.fireEvent('loading');

      this.tableData = this.getObjectValue(data, this.dataPath, null);
      this.tablePagination = this.getObjectValue(data, this.paginationPath, null);

      this.$nextTick(function () {
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    setTitle: function setTitle(str) {
      if (this.isSpecialField(str)) {
        return '';
      }

      return this.titleCase(str);
    },
    getTitle: function getTitle(field) {
      if (typeof field.title === 'function') return field.title();

      return typeof field.title === 'undefined' ? field.name.replace('.', ' ') : field.title;
    },
    renderTitle: function renderTitle(field) {
      var title = this.getTitle(field);

      if (title.length > 0 && this.isInCurrentSortGroup(field) || this.hasSortableIcon(field)) {
        var style = 'opacity:' + this.sortIconOpacity(field) + ';position:relative;float:right';
        return title + ' ' + this.renderIconTag(['sort-icon', this.sortIcon(field)], 'style="' + style + '"');
      }

      return title;
    },
    renderSequence: function renderSequence(index) {
      return this.tablePagination ? this.tablePagination.from + index : index;
    },
    renderNormalField: function renderNormalField(field, item) {
      return this.hasCallback(field) ? this.callCallback(field, item) : this.getObjectValue(item, field.name, '');
    },
    isSpecialField: function isSpecialField(fieldName) {
      return fieldName.slice(0, 2) === '__';
    },
    titleCase: function titleCase(str) {
      return str.replace(/\w+/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    camelCase: function camelCase(str) {
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

      var self = this;
      return str.split(delimiter).map(function (item) {
        return self.titleCase(item);
      }).join('');
    },
    notIn: function notIn(str, arr) {
      return arr.indexOf(str) === -1;
    },
    loadData: function loadData() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.loadSuccess;
      var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.loadFailed;

      if (this.isDataMode) {
        this.callDataManager();
        return;
      }

      this.fireEvent('loading');

      this.httpOptions['params'] = this.getAllQueryParams();

      this.fetch(this.apiUrl, this.httpOptions).then(success, failed).catch(function () {
        return failed();
      });
    },
    fetch: function fetch(apiUrl, httpOptions) {
      return this.httpFetch ? this.httpFetch(apiUrl, httpOptions) : __WEBPACK_IMPORTED_MODULE_0_axios___default.a[this.httpMethod](apiUrl, httpOptions);
    },
    loadSuccess: function loadSuccess(response) {
      this.fireEvent('load-success', response);

      var body = this.transform(response.data);

      this.tableData = this.getObjectValue(body, this.dataPath, null);
      this.tablePagination = this.getObjectValue(body, this.paginationPath, null);

      if (this.tablePagination === null) {
        this.warn('vuetable: pagination-path "' + this.paginationPath + '" not found. ' + 'It looks like the data returned from the sever does not have pagination information ' + "or you may have set it incorrectly.\n" + 'You can explicitly suppress this warning by setting pagination-path="".');
      }

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    fixHeader: function fixHeader() {
      if (!this.isFixedHeader) {
        return;
      }

      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        if (elem.scrollHeight > elem.clientHeight) {
          this.scrollVisible = true;
        } else {
          this.scrollVisible = false;
        }
      }
    },
    loadFailed: function loadFailed(response) {
      console.error('load-error', response);
      this.fireEvent('load-error', response);
      this.fireEvent('loaded');
    },
    transform: function transform(data) {
      var func = 'transform';

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, data);
      }

      return data;
    },
    parentFunctionExists: function parentFunctionExists(func) {
      return func !== '' && typeof this.$parent[func] === 'function';
    },
    callParentFunction: function callParentFunction(func, args) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, args);
      }

      return defaultValue;
    },
    fireEvent: function fireEvent(eventName, args) {
      this.$emit(this.eventPrefix + eventName, args);
    },
    warn: function warn(msg) {
      if (!this.silent) {
        console.warn(msg);
      }
    },
    getAllQueryParams: function getAllQueryParams() {
      var params = {};
      params[this.queryParams.sort] = this.getSortParam();
      params[this.queryParams.page] = this.currentPage;
      params[this.queryParams.perPage] = this.perPage;
      params[this.queryParams.datum] = this.datum;
      params[this.queryParams.token] = this.token;
      params[this.queryParams.site] = this.site;
      for (var x in this.appendParams) {
        params[x] = this.appendParams[x];
      }

      return params;
    },
    getSortParam: function getSortParam() {
      if (!this.sortOrder || this.sortOrder.field == '') {
        return '';
      }

      if (typeof this.$parent['getSortParam'] == 'function') {
        return this.$parent['getSortParam'].call(this.$parent, this.sortOrder);
      }

      return this.getDefaultSortParam();
    },
    getDefaultSortParam: function getDefaultSortParam() {
      var result = '';

      for (var i = 0; i < this.sortOrder.length; i++) {
        var fieldName = typeof this.sortOrder[i].sortField === 'undefined' ? this.sortOrder[i].field : this.sortOrder[i].sortField;

        result += fieldName + '|' + this.sortOrder[i].direction + (i + 1 < this.sortOrder.length ? ',' : '');
      }

      return result;
    },
    extractName: function extractName(string) {
      return string.split(':')[0].trim();
    },
    extractArgs: function extractArgs(string) {
      return string.split(':')[1];
    },
    isSortable: function isSortable(field) {
      return !(typeof field.sortField === 'undefined');
    },
    isInCurrentSortGroup: function isInCurrentSortGroup(field) {
      return this.currentSortOrderPosition(field) !== false;
    },
    hasSortableIcon: function hasSortableIcon(field) {
      return this.isSortable(field) && this.css.sortableIcon != '';
    },
    currentSortOrderPosition: function currentSortOrderPosition(field) {
      if (!this.isSortable(field)) {
        return false;
      }

      for (var i = 0; i < this.sortOrder.length; i++) {
        if (this.fieldIsInSortOrderPosition(field, i)) {
          return i;
        }
      }

      return false;
    },
    fieldIsInSortOrderPosition: function fieldIsInSortOrderPosition(field, i) {
      return this.sortOrder[i].field === field.name && this.sortOrder[i].sortField === field.sortField;
    },
    orderBy: function orderBy(field, event) {
      if (!this.isSortable(field)) return;

      var key = this.multiSortKey.toLowerCase() + 'Key';

      if (this.multiSort && event[key]) {
        this.multiColumnSort(field);
      } else {
        this.singleColumnSort(field);
      }

      this.currentPage = 1;
      this.loadData();
    },
    multiColumnSort: function multiColumnSort(field) {
      var i = this.currentSortOrderPosition(field);

      if (i === false) {
        this.sortOrder.push({
          field: field.name,
          sortField: field.sortField,
          direction: 'asc'
        });
      } else {
        if (this.sortOrder[i].direction === 'asc') {
          this.sortOrder[i].direction = 'desc';
        } else {
          this.sortOrder.splice(i, 1);
        }
      }
    },
    singleColumnSort: function singleColumnSort(field) {
      if (this.sortOrder.length === 0) {
        this.clearSortOrder();
      }

      this.sortOrder.splice(1);

      if (this.fieldIsInSortOrderPosition(field, 0)) {
        this.sortOrder[0].direction = this.sortOrder[0].direction === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder[0].direction = 'asc';
      }
      this.sortOrder[0].field = field.name;
      this.sortOrder[0].sortField = field.sortField;
    },
    clearSortOrder: function clearSortOrder() {
      this.sortOrder.push({
        field: '',
        sortField: '',
        direction: 'asc'
      });
    },
    sortIcon: function sortIcon(field) {
      var cls = this.css.sortableIcon;
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingIcon : this.css.descendingIcon;
      }

      return cls;
    },
    sortIconOpacity: function sortIconOpacity(field) {
      var max = 1.0,
          min = 0.3,
          step = 0.3;

      var count = this.sortOrder.length;
      var current = this.currentSortOrderPosition(field);

      if (max - count * step < min) {
        step = (max - min) / (count - 1);
      }

      var opacity = max - current * step;

      return opacity;
    },
    hasCallback: function hasCallback(item) {
      return item.callback ? true : false;
    },
    callCallback: function callCallback(field, item) {
      if (!this.hasCallback(field)) return;

      if (typeof field.callback == 'function') {
        return field.callback(this.getObjectValue(item, field.name));
      }

      var args = field.callback.split('|');
      var func = args.shift();

      if (typeof this.$parent[func] === 'function') {
        var value = this.getObjectValue(item, field.name);

        return args.length > 0 ? this.$parent[func].apply(this.$parent, [value].concat(args)) : this.$parent[func].call(this.$parent, value);
      }

      return null;
    },
    getObjectValue: function getObjectValue(object, path, defaultValue) {
      defaultValue = typeof defaultValue === 'undefined' ? null : defaultValue;

      var obj = object;
      if (path.trim() != '') {
        var keys = path.split('.');
        keys.forEach(function (key) {
          if (obj !== null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
            obj = obj[key];
          } else {
            obj = defaultValue;
            return;
          }
        });
      }
      return obj;
    },
    toggleCheckbox: function toggleCheckbox(dataItem, fieldName, event) {
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (dataItem[idColumn] === undefined) {
        this.warn('__checkbox field: The "' + this.trackBy + '" field does not exist! Make sure the field you specify in "track-by" prop does exist.');
        return;
      }

      var key = dataItem[idColumn];
      if (isChecked) {
        this.selectId(key);
      } else {
        this.unselectId(key);
      }
      this.$emit('vuetable:checkbox-toggled', isChecked, dataItem);
    },
    selectId: function selectId(key) {
      if (!this.isSelectedRow(key)) {
        this.selectedTo.push(key);
      }
    },
    unselectId: function unselectId(key) {
      this.selectedTo = this.selectedTo.filter(function (item) {
        return item !== key;
      });
    },
    isSelectedRow: function isSelectedRow(key) {
      return this.selectedTo.indexOf(key) >= 0;
    },
    rowSelected: function rowSelected(dataItem, fieldName) {
      var idColumn = this.trackBy;
      var key = dataItem[idColumn];

      return this.isSelectedRow(key);
    },
    checkCheckboxesState: function checkCheckboxesState(fieldName) {
      if (!this.tableData) return;

      var self = this;
      var idColumn = this.trackBy;
      var selector = 'th.vuetable-th-checkbox-' + idColumn + ' input[type=checkbox]';
      var els = document.querySelectorAll(selector);

      if (els.forEach === undefined) els.forEach = function (cb) {
        [].forEach.call(els, cb);
      };

      var selected = this.tableData.filter(function (item) {
        return self.selectedTo.indexOf(item[idColumn]) >= 0;
      });

      if (selected.length <= 0) {
        els.forEach(function (el) {
          el.indeterminate = false;
        });
        return false;
      } else if (selected.length < this.perPage) {
          els.forEach(function (el) {
            el.indeterminate = true;
          });
          return true;
        } else {
            els.forEach(function (el) {
              el.indeterminate = false;
            });
            return true;
          }
    },
    toggleAllCheckboxes: function toggleAllCheckboxes(fieldName, event) {
      var self = this;
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (isChecked) {
        this.tableData.forEach(function (dataItem) {
          self.selectId(dataItem[idColumn]);
        });
      } else {
        this.tableData.forEach(function (dataItem) {
          self.unselectId(dataItem[idColumn]);
        });
      }
      this.$emit('vuetable:checkbox-toggled-all', isChecked);
    },
    gotoPreviousPage: function gotoPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadData();
      }
    },
    gotoNextPage: function gotoNextPage() {
      if (this.currentPage < this.tablePagination.last_page) {
        this.currentPage++;
        this.loadData();
      }
    },
    gotoPage: function gotoPage(page) {
      if (page != this.currentPage && page > 0 && page <= this.tablePagination.last_page) {
        this.currentPage = page;
        this.loadData();
      }
    },
    isVisibleDetailRow: function isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetailRow: function showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow: function hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow: function toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    showField: function showField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = true;
    },
    hideField: function hideField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = false;
    },
    toggleField: function toggleField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = !this.tableFields[index].visible;
    },
    renderIconTag: function renderIconTag(classes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return typeof this.css.renderIcon === 'undefined' ? '<i class="' + classes.join(' ') + '" ' + options + '></i>' : this.css.renderIcon(classes, options);
    },
    makePagination: function makePagination() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var currentPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var pagination = {};
      total = total === null ? this.dataTotal : total;
      perPage = perPage === null ? this.perPage : perPage;
      currentPage = currentPage === null ? this.currentPage : currentPage;

      return {
        'total': total,
        'per_page': perPage,
        'current_page': currentPage,
        'last_page': Math.ceil(total / perPage) || 0,
        'next_page_url': '',
        'prev_page_url': '',
        'from': (currentPage - 1) * perPage + 1,
        'to': Math.min(currentPage * perPage, total)
      };
    },
    normalizeSortOrder: function normalizeSortOrder() {
      this.sortOrder.forEach(function (item) {
        item.sortField = item.sortField || item.field;
      });
    },
    callDataManager: function callDataManager() {
      if (this.dataManager === null && this.data === null) return;

      if (Array.isArray(this.data)) {
        console.log('data mode: array');
        this.setData(this.data);
      } else {
        this.normalizeSortOrder();
        this.setData(this.dataManager(this.sortOrder, this.makePagination()));
      }
    },
    onRowClass: function onRowClass(dataItem, index) {
      if (this.rowClassCallback !== '') {
        this.warn('"row-class-callback" prop is deprecated, please use "row-class" prop instead.');
        return;
      }

      if (typeof this.rowClass === 'function') {
        return this.rowClass(dataItem, index);
      }

      return this.rowClass;
    },
    onRowChanged: function onRowChanged(dataItem) {
      this.fireEvent('row-changed', dataItem);
      return true;
    },
    onRowClicked: function onRowClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-clicked', dataItem, event);
      return true;
    },
    onRowDoubleClicked: function onRowDoubleClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-dblclicked', dataItem, event);
    },
    onDetailRowClick: function onDetailRowClick(dataItem, event) {
      this.$emit(this.eventPrefix + 'detail-row-clicked', dataItem, event);
    },
    onCellClicked: function onCellClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-clicked', dataItem, field, event);
    },
    onCellDoubleClicked: function onCellDoubleClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-dblclicked', dataItem, field, event);
    },
    changePage: function changePage(page) {
      if (page === 'prev') {
        this.gotoPreviousPage();
      } else if (page === 'next') {
        this.gotoNextPage();
      } else {
        this.gotoPage(page);
      }
    },
    reload: function reload() {
      this.loadData();
    },
    refresh: function refresh() {
      this.currentPage = 1;
      this.loadData();
    },
    resetData: function resetData() {
      this.tableData = null;
      this.tablePagination = null;
      this.fireEvent('data-reset');
    }
  },
  watch: {
    'multiSort': function multiSort(newVal, oldVal) {
      if (newVal === false && this.sortOrder.length > 1) {
        this.sortOrder.splice(1);
        this.loadData();
      }
    },
    'apiUrl': function apiUrl(newVal, oldVal) {
      if (this.reactiveApiUrl && newVal !== oldVal) this.refresh();
    }
  }
});

/***/ }),

/***/ "ksoB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l/id":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateRange_vue__ = __webpack_require__("z3ES");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b965132_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateRange_vue__ = __webpack_require__("fm8l");
function injectStyle (ssrContext) {
  __webpack_require__("ZCHQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b965132"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateRange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b965132_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateRange_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "l4dW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar app-navbar navbar-toggleable-md"},[_c('div',{staticClass:"navbar-brand-container d-flex align-items-center justify-content-start"},[_c('atom-spinner',{attrs:{"animation-duration":1000,"size":40,"color":'#4ae387'}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('span',{staticStyle:{"color":"#333","font-size":"12px"}},[_c('sup',[_vm._v(_vm._s('Build')+" 22.9.020")])])],1),_vm._v(" "),_c('div',{staticClass:"row navbar-container"},[_c('div',{staticClass:"menu-icon-container d-flex align-items-center justify-content-center justify-content-lg-start col"},[(_vm.sidebarOpened)?_c('a',{staticClass:"menu-icon i-menu-expanded",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSidebar(false)}}}):_c('a',{staticClass:"menu-icon i-menu-collapsed",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSidebar(true)}}})]),_vm._v(" "),_c('div',{staticClass:"offset-lg-6"}),_vm._v(" "),_c('site-dropdown',{staticStyle:{"flex-direction":"row","display":"flex","white-space":"nowrap"}}),_vm._v(" "),_c('div',{staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"},[_c('a',{staticClass:"nav-link dropdown-toggle d-flex align-items-center justify-content"},[_c('span',{ref:"zatvori",staticClass:"i-nav-messages"})])]),_vm._v(" "),(false)?_c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"},[_c('a',{staticClass:"nav-link dropdown-toggle d-flex align-items-center justify-content",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.closeMenu($event)}}},[(_vm.$store.state.notify)?_c('span',{ref:"zatvori",staticClass:"i-nav-messages notify"}):_vm._e(),_vm._v(" "),(!_vm.$store.state.notify)?_c('span',{ref:"zatvori",staticClass:"i-nav-messages"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((((_vm.$store.state.alarms.length > 2) ? _vm.$store.state.alarms.slice(_vm.$store.state.alarms.length-3, _vm.$store.state.alarms.length) : _vm.$store.state.alarms)),function(poruka){return _c('a',{staticClass:"dropdown-item",attrs:{"id":poruka},on:{"click":function($event){_vm.pregledOdobrenih($event)}}},[_c('span',{staticClass:"ellipsis",attrs:{"id":poruka}},[_vm._v(_vm._s(poruka[0])+" "+_vm._s('odobren'))])])}))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"},[_c('a',{staticClass:"nav-link dropdown-toggle d-flex align-items-center justify-content",attrs:{"href":"#"}},[(true)?_c('span',{ref:"zatvori2",staticClass:"i-nav-notification"}):_vm._e()]),_vm._v(" "),(false)?_c('div',{staticClass:"dropdown-menu"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((((_vm.$store.state.messages.length > 2) ? _vm.$store.state.messages.slice(_vm.$store.state.messages.length-3, _vm.$store.state.messages.length) : _vm.$store.state.messages)),function(poruka){return _c('a',{staticClass:"dropdown-item",attrs:{"id":poruka},on:{"click":function($event){_vm.pregledRealizovanih($event)}}},[_c('span',{staticClass:"ellipsis",attrs:{"id":poruka}},[_vm._v(_vm._s(poruka[0])+" "+_vm._s('realizovan'))])])}))]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"},[_c('a',{staticClass:"nav-link dropdown-toggle d-flex align-items-center justify-content",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.closeMenu($event)}}},[(_vm.reload)?_c('span',{ref:"close",staticClass:"avatar-container"},[_c('img',{attrs:{"src":_vm.userImage+'?'+ new Date().getTime()}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu last"},[_c('div',{staticClass:"dropdown-menu-content"},[_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"},on:{"click":_vm.promjeniSifru}},[_vm._v(_vm._s('Promjena šifre'))])]),_vm._v(" "),(_vm.$store.state.userId === 'admin@atom.ba')?_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"},on:{"click":_vm.avatarChange}},[_vm._v(_vm._s('Dodajte sliku'))])]):_vm._e(),_vm._v(" "),(_vm.$store.state.userId === 'admin@atom.ba')?_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"},on:{"click":_vm.signUp}},[_vm._v(_vm._s('Dodajte korisnika'))])]):_vm._e(),_vm._v(" "),(_vm.$store.state.userId === 'admin@atom.ba')?_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"},on:{"click":_vm.editUser}},[_vm._v(_vm._s('Uredite korisnike'))])]):_vm._e(),_vm._v(" "),(_vm.$store.state.userId === 'admin@atom.ba')?_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"},on:{"click":_vm.mojePostavke}},[_vm._v(_vm._s('Moje postavke'))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"},on:{"click":_vm.onLogout}},[_vm._v(_vm._s(' Odjava'))])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-brand"},[_c('i',{staticClass:"i-vuestic"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l7Wu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l92n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrinityRingsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      containerPadding: 3
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ring1Style: function ring1Style() {
      return {
        height: this.outerRingSize + 'px',
        width: this.outerRingSize + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring2Style: function ring2Style() {
      return {
        height: this.outerRingSize * 0.65 + 'px',
        width: this.outerRingSize * 0.65 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring3Style: function ring3Style() {
      return {
        height: this.outerRingSize * 0.1 + 'px',
        width: this.outerRingSize * 0.1 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "lIal":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lPhB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "laTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HollowDotsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    dotSize: {
      type: Number,
      default: 15
    },
    dotsNum: {
      type: Number,
      default: 3
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    horizontalMargin: function horizontalMargin() {
      return this.dotSize / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.dotSize + 'px',
        width: (this.dotSize + this.horizontalMargin * 2) * this.dotsNum + 'px'
      };
    },
    dotStyle: function dotStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.dotSize + 'px',
        height: this.dotSize + 'px',
        margin: '0 ' + this.horizontalMargin + 'px',
        borderWidth: this.dotSize / 5 + 'px',
        borderColor: this.color
      };
    },
    dotsStyles: function dotsStyles() {
      var dotsStyles = [];
      var delayModifier = 0.3;
      var basicDelay = 1000;

      for (var i = 1; i <= this.dotsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: basicDelay * i * delayModifier + 'ms'
        }, this.dotStyle);

        dotsStyles.push(style);
      }

      return dotsStyles;
    }
  }
});

/***/ }),

/***/ "lasC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lfQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-simple-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "lhlx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpringSpinner_vue__ = __webpack_require__("bGbP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_14af1b38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SpringSpinner_vue__ = __webpack_require__("ypkI");
function injectStyle (ssrContext) {
  __webpack_require__("SFyI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14af1b38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpringSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_14af1b38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SpringSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "liXm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{'vuestic-collapse__header--no-header': _vm.noHeader},attrs:{"id":_vm.id},on:{"click":function($event){_vm.emitHeader($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{class:{'vuestic-collapse__header__button btn btn-secondary' : _vm.final && _vm.final_pdf,
    'vuestic-collapse__header__button btn btn-secondary-danger' : _vm.final && !_vm.final_pdf }},[_vm._t("header"),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px","color":"#f7cc36"}},[_vm._v(_vm._s(' | ')+_vm._s(_vm.pacijent))]),_vm._v(" "),_c('div',{staticClass:"col-md-7 pull-right",staticStyle:{"margin-right":"20px"}},[_c('span',[(_vm.final_pdf)?_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px","color":"#f7cc36"},attrs:{"id":"nalaz"}}):_vm._e(),_vm._v(" "),(!_vm.final_pdf)?_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px","color":"#e34a4a"},attrs:{"id":"nalaz"}}):_vm._e()])])],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ll94":
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.8.7","C:\\apps\\node\\atom\\client"]],"_from":"vue-chartjs@2.8.7","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.8.7","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.8.7","saveSpec":null,"fetchSpec":"2.8.7"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_spec":"2.8.7","_where":"C:\\apps\\node\\atom\\client","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),

/***/ "lptX":
/***/ (function(module, exports) {



function odrediDefaultSelection(manual, calculated) {
  if (!manual && !calculated) {
    return ["Lab", true, true];
  } else if (manual && !calculated) {
    return ["Man", true, true];
  } else if (!manual && calculated) {
    return ["Calc", true, true];
  } else if (manual && calculated) {
    return ["Calc", true, true];
  }
}

module.exports = {
  carovaclab: function carovaclab(test, godina, spol, drstanje, menopauza, manual, calculated) {
    switch (test) {
      case "HbA1c - IFCC":
        return ["Lab", true, false];
        break;
      case "Kompletna krvna slika, 5 diff":
        return ["Lab", false, false];
        break;
      case "Double test":
        if (drstanje != "NE") {
          return ["Man", true, true];
        } else {
          return ["Man", false, false];
        }
        break;
      case "Triple test":
        if (drstanje != "NE") {
          return ["Man", true, true];
        } else {
          return ["Man", false, false];
        }
        break;
      case "eGFR":
        if (Number(godina) > 18) {
          return ["Calc", true, true];
        } else {
          return ["Calc", false, false];
        }
        break;
      case "PSA ratio":
        if (spol === "MUŠKI") {
          return ["Calc", true, true];
        } else {
          return ["Calc", false, false];
        }
        break;
      case "ROMA index - pre":
        if (spol === "ŽENSKI" && menopauza === "Premenopauza") {
          return ["Calc", true, true];
        } else {
          return ["Calc", false, false];
        }
        break;
      case "ROMA index - pos":
        if (spol === "ŽENSKI" && menopauza === "Postmenopauza") {
          return ["Calc", true, true];
        } else {
          return ["Calc", false, false];
        }
        break;

      default:
        return odrediDefaultSelection(manual, calculated);
        break;
    }
  }
};

/***/ }),

/***/ "lwql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("cD2K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_614b9f59_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("TwIB");
function injectStyle (ssrContext) {
  __webpack_require__("FQl4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-614b9f59"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_614b9f59_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mBmn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mC5g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emojiJs = __webpack_require__("mwJQ");

var _emojiJs2 = _interopRequireDefault(_emojiJs);

var _emojiData = __webpack_require__("VMA9");

var _emojiData2 = _interopRequireDefault(_emojiData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      emojiData: _emojiData2.default,
      emojiConvertor: new _emojiJs2.default()
    };
  },

  props: {
    onBlur: {
      type: Function,
      required: true
    },
    onEmojiPicked: {
      type: Function,
      required: true
    }
  },
  methods: {
    emojiClicked: function emojiClicked(emoji) {
      this.onEmojiPicked(emoji);
      this.$refs.domNode.blur();
    }
  },
  mounted: function mounted() {
    var elem = this.$refs.domNode;
    elem.style.opacity = 0;
    window.requestAnimationFrame(function () {
      elem.style.transition = 'opacity 350ms';
      elem.style.opacity = 1;
    });
    this.$refs.domNode.focus();
    this.emojiConvertor.init_env();
  }
};

/***/ }),

/***/ "mFVy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'izvjestaji',
  path: '/reports',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('reports/Reports'),
  meta: {
    default: false,
    title: 'Izvještaji',
    iconClass: 'fa fa-area-chart',
    requiredAuth: true
  }
});

/***/ }),

/***/ "mNxl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12 info-widget-inner"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"input-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.komentar),expression:"komentar"}],attrs:{"type":"text","required":""},domProps:{"value":(_vm.komentar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.komentar=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s('Komentar'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mQ62":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mUJ2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./assays/Assays.vue": [
		"NW75",
		84
	],
	"./auth/login/Acme.vue": [
		"6kRY",
		92
	],
	"./auth/login/Login.vue": [
		"mEJK",
		83
	],
	"./dashboard/Dashboard.vue": [
		"UE3e",
		4
	],
	"./dashboard/DashboardInfoWidgets.vue": [
		"8D9j",
		82
	],
	"./dashboard/DataVisualisation.vue": [
		"bE8b",
		81
	],
	"./dashboard/Support.vue": [
		"A7kt",
		80
	],
	"./dashboard/VuesticModalPatientsData.vue": [
		"fYdP"
	],
	"./kontrole/pregled/BadgeColumn.vue": [
		"SWvW",
		79
	],
	"./kontrole/pregled/Levey.vue": [
		"f6IS",
		38
	],
	"./kontrole/pregled/Pregled.vue": [
		"CtFX",
		24
	],
	"./kontrole/pregled/detalji.vue": [
		"iqgw",
		15
	],
	"./kontrole/unos/Unos.vue": [
		"ODub",
		78
	],
	"./layout/AuthLayout.vue": [
		"v6Pz"
	],
	"./layout/Layout.vue": [
		"i/0a"
	],
	"./layout/navbar/Navbar.vue": [
		"QI9S"
	],
	"./layout/sidebar/Sidebar.vue": [
		"jEUr"
	],
	"./nalaz/nalaz.vue": [
		"3WKH",
		8
	],
	"./nalazi/outbox/BadgeColumn.vue": [
		"k/kZ",
		77
	],
	"./nalazi/outbox/nalaz.vue": [
		"jYLl",
		14
	],
	"./nalazi/outbox/outbox.vue": [
		"0GYA",
		13
	],
	"./nalazi/pregled/BadgeColumn.vue": [
		"tl1j",
		76
	],
	"./nalazi/pregled/nalaz.vue": [
		"e2jv",
		12
	],
	"./nalazi/pregled/pregled.vue": [
		"RHzI",
		11
	],
	"./nalazi/verifikacija/BadgeColumn.vue": [
		"3lFq",
		75
	],
	"./nalazi/verifikacija/nalaz.vue": [
		"Ibec",
		23
	],
	"./nalazi/verifikacija/verifikacija.vue": [
		"xN8s",
		22
	],
	"./obrada/BadgeColumn.vue": [
		"XMpX",
		74
	],
	"./obrada/Obrada.vue": [
		"0fl9",
		2
	],
	"./obrada/VuesticAccordionObrada.vue": [
		"7uh9"
	],
	"./obrada/VuesticCollapseNalaz.vue": [
		"DqnR"
	],
	"./obrada/VuesticCollapseObrada.vue": [
		"stge"
	],
	"./obrada/VuesticCollapseUzorak.vue": [
		"5JeB"
	],
	"./obrada/VuesticModalComment.vue": [
		"n9oL"
	],
	"./obrada/VuesticModalDelete.vue": [
		"ZctM"
	],
	"./obrada/VuesticModalEdit.vue": [
		"6Dsq"
	],
	"./obrada/VuesticModalError.vue": [
		"biUo"
	],
	"./obrada/VuesticModalFind.vue": [
		"/Djh"
	],
	"./obrada/VuesticModalMail.vue": [
		"XDv4"
	],
	"./obrada/VuesticModalMulti.vue": [
		"yJZO"
	],
	"./obrada/VuesticModalUzorci.vue": [
		"xBqa"
	],
	"./obrada/racun.vue": [
		"AbIy",
		25
	],
	"./obrada/table.vue": [
		"puYy",
		21
	],
	"./pacijenti/pregled/BadgeColumn.vue": [
		"/R1S",
		73
	],
	"./pacijenti/pregled/PregledPacijenta.vue": [
		"PqjS",
		20
	],
	"./pacijenti/pregled/detalji.vue": [
		"Rkwk",
		19
	],
	"./pacijenti/prijem/_prijem.vue": [
		"4D2C",
		34
	],
	"./pacijenti/prijem/prijem.vue": [
		"JgV7",
		33
	],
	"./pacijenti/unos/UnosPacijenta.vue": [
		"dFIO",
		72
	],
	"./pages/collapse/Collapse.vue": [
		"AQx7",
		71
	],
	"./pages/modals/Modals.vue": [
		"Q4HU",
		70
	],
	"./pages/search/VuesticPageNotFoundSearch.vue": [
		"KzkO",
		37
	],
	"./pomoc/Pomoc.vue": [
		"mC2D",
		36
	],
	"./postavke/analize/Analize.vue": [
		"8Hel",
		69
	],
	"./postavke/aparati/Aparati.vue": [
		"K2X1",
		68
	],
	"./postavke/aptestovi/Aptestovi.vue": [
		"pfDl",
		67
	],
	"./postavke/doktori/Doktori.vue": [
		"Dzc0",
		66
	],
	"./postavke/email/Email.vue": [
		"de4l",
		65
	],
	"./postavke/generalno/Generalno.vue": [
		"yG2B",
		64
	],
	"./postavke/kontrole/Kontrole.vue": [
		"4/n9",
		63
	],
	"./postavke/labassays/LabAssays.vue": [
		"0Z/d",
		62
	],
	"./postavke/lokacije/Lokacije.vue": [
		"BDZh",
		61
	],
	"./postavke/mjesta/Mjesta.vue": [
		"ICzo",
		60
	],
	"./postavke/pacijenti/Pacijenti.vue": [
		"qAGk",
		59
	],
	"./postavke/paneli/Paneli.vue": [
		"6Q2A",
		58
	],
	"./postavke/sekcije/Sekcije.vue": [
		"0UOF",
		57
	],
	"./postavke/sites/Sites.vue": [
		"9dCU",
		56
	],
	"./postavke/testovi/Calculated.vue": [
		"+5YN",
		55
	],
	"./postavke/testovi/Manual.vue": [
		"NgLz",
		54
	],
	"./postavke/testovi/Testovi.vue": [
		"Bnnr",
		53
	],
	"./postavke/user/avatar.vue": [
		"ZnWx",
		52
	],
	"./postavke/user/chpwd.vue": [
		"lGOX",
		51
	],
	"./postavke/user/edit.vue": [
		"xm2U",
		50
	],
	"./postavke/user/newUser.vue": [
		"uusD",
		49
	],
	"./postavke/user/settings.vue": [
		"S25R",
		48
	],
	"./postavke/uzorci/Uzorci.vue": [
		"fw6H",
		47
	],
	"./prijem/BadgeColumn.vue": [
		"Z6/Z",
		46
	],
	"./prijem/PregledPacijenta.vue": [
		"CAFZ",
		18
	],
	"./prijem/detalji.vue": [
		"KxS8",
		17
	],
	"./prijem/prijem/_prijem.vue": [
		"8URc",
		32
	],
	"./prijem/prijem/prijem.vue": [
		"/fYm",
		31
	],
	"./prijem/unos/UnosPacijenta.vue": [
		"A1lz",
		45
	],
	"./reports/Reports.vue": [
		"GFu2",
		30
	],
	"./rezultati/pregled/BadgeColumn.vue": [
		"XYA3",
		44
	],
	"./rezultati/pregled/_detalji.vue": [
		"659q",
		3
	],
	"./rezultati/pregled/detalji.vue": [
		"IU73",
		7
	],
	"./rezultati/pregled/pregled.vue": [
		"lWoQ",
		10
	],
	"./rezultati/verifikacija/BadgeColumn.vue": [
		"ZZhK",
		43
	],
	"./rezultati/verifikacija/_detalji.vue": [
		"Sei2",
		1
	],
	"./rezultati/verifikacija/detalji.vue": [
		"5wW/",
		5
	],
	"./rezultati/verifikacija/predracun.vue": [
		"juuy",
		29
	],
	"./rezultati/verifikacija/verifikacija.vue": [
		"0Ygf",
		9
	],
	"./samples/entry/SamplesEntry.vue": [
		"lHTm",
		0
	],
	"./tables/BadgeColumn.vue": [
		"csLD",
		42
	],
	"./uzorci/BadgeColumn.vue": [
		"vd7r",
		41
	],
	"./uzorci/detalji.vue": [
		"S5We",
		28
	],
	"./uzorci/pregled.vue": [
		"MecH",
		6
	],
	"./uzorci/racuni/BadgeColumn.vue": [
		"UTLX",
		40
	],
	"./uzorci/racuni/racun.vue": [
		"XY8L",
		26
	],
	"./uzorci/racuni/racuni.vue": [
		"92Q0",
		16
	],
	"./uzorci/unos.vue": [
		"xTSQ",
		35
	],
	"./uzorci/uredi.vue": [
		"v2Pi",
		27
	],
	"./vuestic-components/vuestic-alert/VuesticAlert.vue": [
		"cfdX"
	],
	"./vuestic-components/vuestic-chart/VuesticChart.vue": [
		"+Uuv"
	],
	"./vuestic-components/vuestic-chat/VuesticChat.vue": [
		"oXux"
	],
	"./vuestic-components/vuestic-checkbox/VuesticCheckbox.vue": [
		"2653"
	],
	"./vuestic-components/vuestic-collapse/VuesticAccordion.demo.vue": [
		"bBaH",
		91
	],
	"./vuestic-components/vuestic-collapse/VuesticAccordion.vue": [
		"WBzP"
	],
	"./vuestic-components/vuestic-collapse/VuesticAccordionPatientInfo.vue": [
		"xAVG"
	],
	"./vuestic-components/vuestic-collapse/VuesticAccordionSamplesEntry.vue": [
		"4S38"
	],
	"./vuestic-components/vuestic-collapse/VuesticCollapse.demo.vue": [
		"7WZr",
		90
	],
	"./vuestic-components/vuestic-collapse/VuesticCollapse.vue": [
		"x598"
	],
	"./vuestic-components/vuestic-collapse/VuesticCollapsePatientInfo.vue": [
		"TS+I"
	],
	"./vuestic-components/vuestic-collapse/VuesticCollapseSamplesEntry.vue": [
		"pmVg"
	],
	"./vuestic-components/vuestic-datatable/VuesticDataTable.vue": [
		"tZ2u"
	],
	"./vuestic-components/vuestic-datatable/VuesticDataTablePacijent.vue": [
		"Jops"
	],
	"./vuestic-components/vuestic-datatable/datatable-components/DateRange.vue": [
		"l/id"
	],
	"./vuestic-components/vuestic-datatable/datatable-components/FilterBar.vue": [
		"YhNO"
	],
	"./vuestic-components/vuestic-datatable/datatable-components/ItemsPerPage.vue": [
		"IbS2"
	],
	"./vuestic-components/vuestic-date-picker/VuesticDatePicker.demo.vue": [
		"rAWp",
		89
	],
	"./vuestic-components/vuestic-date-picker/VuesticDatePicker.vue": [
		"UfMP"
	],
	"./vuestic-components/vuestic-date-picker/_VuesticDatePicker.vue": [
		"EGeE",
		39
	],
	"./vuestic-components/vuestic-feed/VuesticFeed.vue": [
		"Q4Rp"
	],
	"./vuestic-components/vuestic-input-select/VuesticInputSelect.vue": [
		"P2Ka"
	],
	"./vuestic-components/vuestic-medium-editor/VuesticMediumEditor.vue": [
		"d4/x"
	],
	"./vuestic-components/vuestic-modal/VuesticModal.vue": [
		"NG7M"
	],
	"./vuestic-components/vuestic-modal/VuesticModalBarcode.vue": [
		"6L27"
	],
	"./vuestic-components/vuestic-modal/VuesticModalCommenting.vue": [
		"NKe1"
	],
	"./vuestic-components/vuestic-modal/VuesticModalDrugoStanje.vue": [
		"8eHK"
	],
	"./vuestic-components/vuestic-modal/VuesticModalMedium.vue": [
		"Wvsm"
	],
	"./vuestic-components/vuestic-modal/VuesticModalPatient.vue": [
		"C7Zy"
	],
	"./vuestic-components/vuestic-modal/VuesticModalPlus.vue": [
		"TGVY"
	],
	"./vuestic-components/vuestic-modal/VuesticModalSamplesEntryCalendar.vue": [
		"J6aD"
	],
	"./vuestic-components/vuestic-modal/VuesticModalSamplesEntryCommenting.vue": [
		"u983"
	],
	"./vuestic-components/vuestic-modal/VuesticModalStatic.vue": [
		"aXvH"
	],
	"./vuestic-components/vuestic-modal/VuesticModalTrash.vue": [
		"0Zwo"
	],
	"./vuestic-components/vuestic-multi-select/VuesticMultiSelect.vue": [
		"IqWy"
	],
	"./vuestic-components/vuestic-popover/VuesticPopover.vue": [
		"wf/P"
	],
	"./vuestic-components/vuestic-preloader/VuesticPreLoader.vue": [
		"VAWW"
	],
	"./vuestic-components/vuestic-profile-card/VuesticProfileCard.vue": [
		"74xX"
	],
	"./vuestic-components/vuestic-progress-bar/VuesticProgressBar.vue": [
		"XznE"
	],
	"./vuestic-components/vuestic-progress-bar/progress-types/CircleProgressBar.vue": [
		"pqzW"
	],
	"./vuestic-components/vuestic-progress-bar/progress-types/HorizontalProgressBar.vue": [
		"CneO"
	],
	"./vuestic-components/vuestic-progress-bar/progress-types/VerticalProgressBar.vue": [
		"axM2"
	],
	"./vuestic-components/vuestic-radio-button/VuesticRadioButton.vue": [
		"aj+k"
	],
	"./vuestic-components/vuestic-scrollbar/VuesticScrollbar.vue": [
		"/7ZL"
	],
	"./vuestic-components/vuestic-simple-select/VuesticSimpleSelect.vue": [
		"/LRh"
	],
	"./vuestic-components/vuestic-site/SiteDropdown.vue": [
		"4ZaD"
	],
	"./vuestic-components/vuestic-social-news/VuesticSocialNews.vue": [
		"anct"
	],
	"./vuestic-components/vuestic-switch/VuesticSwitch.vue": [
		"rhzU"
	],
	"./vuestic-components/vuestic-tabs/VuesticTabs.vue": [
		"LtNJ"
	],
	"./vuestic-components/vuestic-tag/VuesticTag.vue": [
		"aTa4"
	],
	"./vuestic-components/vuestic-tag/VuesticTagGroup.vue": [
		"L2/I"
	],
	"./vuestic-components/vuestic-tooltip/VuesticTooltip.vue": [
		"PpPr"
	],
	"./vuestic-components/vuestic-tree-view/VuesticTreeCategory.demo.vue": [
		"go2Q",
		88
	],
	"./vuestic-components/vuestic-tree-view/VuesticTreeCategory.vue": [
		"MCoA"
	],
	"./vuestic-components/vuestic-tree-view/VuesticTreeNode.demo.vue": [
		"tQYc",
		87
	],
	"./vuestic-components/vuestic-tree-view/VuesticTreeNode.vue": [
		"FY6O"
	],
	"./vuestic-components/vuestic-tree-view/VuesticTreeRoot.demo.vue": [
		"3gam",
		86
	],
	"./vuestic-components/vuestic-tree-view/VuesticTreeRoot.vue": [
		"hF5N"
	],
	"./vuestic-components/vuestic-tree-view/vuestic-div-checkbox/SquareWithIcon.demo.vue": [
		"606c",
		85
	],
	"./vuestic-components/vuestic-tree-view/vuestic-div-checkbox/SquareWithIcon.vue": [
		"2c2N"
	],
	"./vuestic-components/vuestic-widget/VuesticWidget.vue": [
		"Dmbe"
	],
	"./vuestic-components/vuestic-wizard/VuesticWizard.vue": [
		"8/T/"
	],
	"./vuestic-components/vuestic-wizard/indicators/RichHorizontalIndicator.vue": [
		"dIvT"
	],
	"./vuestic-components/vuestic-wizard/indicators/RichVerticalIndicator.vue": [
		"iLsn"
	],
	"./vuestic-components/vuestic-wizard/indicators/SimpleHorizontalIndicator.vue": [
		"jzLZ"
	],
	"./vuestic-components/vuestic-wizard/indicators/SimpleVerticalIndicator.vue": [
		"0GMg"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "mUJ2";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "mWYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('ba', __webpack_require__("zCGx"));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('en', __webpack_require__("UpdR"));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('hr', __webpack_require__("2uUy"));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('rs', __webpack_require__("z6FP"));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.set('ba');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.fallback('ba');

/***/ }),

/***/ "mbV8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    noHeader: Boolean,
    id: {
      type: String,
      default: ""
    },
    ide: {
      type: String,
      default: ""
    }
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      mutableId: this.id,
      clientHeight: "",
      odobren: false,
      u_obradi: false,
      zaprimljen: false,
      realizovan: false,
      enable_toggle: false,
      vise: true,
      status: ""
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    },
    clientHeight: function clientHeight() {}
  },
  mounted: function mounted() {
    var _this = this;

    switch (this.$slots.header[0].elm.id) {
      case "ZAPRIMLJEN":
        this.zaprimljen = true;
        this.status = "ZAPRIMLJEN";
        break;
      case "U OBRADI":
        this.u_obradi = true;
        this.status = "U OBRADI";
        break;
      case "REALIZOVAN":
        this.realizovan = true;
        this.status = "REALIZOVAN";
        break;
      case "ODOBREN":
        this.odobren = true;
        this.status = "ODOBREN";
        break;
    }
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("SetClientHeight", function (sid) {
      if (_this.$slots.header[0].children[0].text.trim() === sid) {
        var bodyContent = _this.$refs.collapseBody;
        _this.clientHeight = _this.$slots.body[0].elm.clientHeight + 5 + "px";

        _this.onHeaderClick();
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("SetClass", function (data) {
      data.forEach(function (element) {
        if (_this.$slots.header[0].children[0].text.trim() === element.sid) {
          _this.zaprimljen = false;
          _this.u_obradi = false;
          _this.realizovan = false;
          _this.odobren = false;
          switch (element.status) {
            case "ZAPRIMLJEN":
              _this.zaprimljen = true;
              _this.status = "ZAPRIMLJEN";
              break;
            case "U OBRADI":
              _this.u_obradi = true;
              _this.status = "U OBRADI";
              break;
            case "REALIZOVAN":
              _this.realizovan = true;
              _this.status = "REALIZOVAN";
              break;
            case "ODOBREN":
              _this.odobren = true;
              _this.status = "ODOBREN";
              break;
          }
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("SetClientHeight");
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("SetClass");
  },

  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.clientHeight;
      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;

      this.show = false;
    },
    emitHeader: function emitHeader(event) {
      switch (event.target.id) {
        case "check":
          this.enable_toggle = false;
          this.vise = true;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Check");
          break;
        case "save":
          this.enable_toggle = false;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Save");
          break;
        case "undo":
          this.enable_toggle = false;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Undo");
          break;
        case "file":
          this.enable_toggle = false;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("File", this.ide);
          break;
        case "forward":
          this.enable_toggle = false;
          this.vise = false;

          break;
        case "step-backward":
          this.enable_toggle = false;
          this.vise = true;

          break;
        case "trash":
          this.enable_toggle = false;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Trash");
          break;
        case "plus":
          this.enable_toggle = false;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Plus");
          break;
        case "commenting":
          this.enable_toggle = false;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Commenting");
          break;
        case "barcode":
          this.enable_toggle = false;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Barcode");
          break;
        case "":
          this.enable_toggle = false;
          break;
        default:
          this.enable_toggle = true;
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("OdaberiUzorak", this.mutableId);
          break;
      }
    },
    onHeaderClick: function onHeaderClick() {
      if (this.enable_toggle) {
        this.vise = true;
        this.toggle();
        this.accordion.onChildChange(this, this.show);
      }
    },
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "mjU6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "moC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list"},[_c('table',{staticStyle:{"padding-top":"5px"}},[_c('tbody',_vm._l((_vm.participants),function(user){return _c('tr',{key:user.id},[_c('td',{staticStyle:{"text-align":"center"}},[_c('img',{staticClass:"img-msg",attrs:{"src":user.imageUrl}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.name))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mpGX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mpwI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indicators_SimpleHorizontalIndicator_vue__ = __webpack_require__("jzLZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__indicators_RichHorizontalIndicator_vue__ = __webpack_require__("dIvT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indicators_RichVerticalIndicator_vue__ = __webpack_require__("iLsn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__indicators_SimpleVerticalIndicator_vue__ = __webpack_require__("0GMg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WizardOrientationHandler__ = __webpack_require__("41de");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard',
  props: {
    steps: {},
    wizardType: {
      type: String,
      default: 'simple'
    },
    wizardLayout: {
      type: String,
      default: 'horizontal'
    },
    lastStepLabel: {
      default: ' Završi'
    },
    onNext: {},
    onBack: {},
    sekcija: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      currentStep: 0,
      wizardCompleted: false,
      wizardCompletedSlotName: 'Unos Kompletan',
      orientationBreakPoint: 767,
      computedLayout: this.wizardLayout,
      stepTri: true
    };
  },

  components: {
    SimpleHorizontalIndicator: __WEBPACK_IMPORTED_MODULE_0__indicators_SimpleHorizontalIndicator_vue__["default"],
    RichHorizontalIndicator: __WEBPACK_IMPORTED_MODULE_1__indicators_RichHorizontalIndicator_vue__["default"],
    RichVerticalIndicator: __WEBPACK_IMPORTED_MODULE_2__indicators_RichVerticalIndicator_vue__["default"],
    SimpleVerticalIndicator: __WEBPACK_IMPORTED_MODULE_3__indicators_SimpleVerticalIndicator_vue__["default"]
  },
  directives: {
    orientationHandler: __WEBPACK_IMPORTED_MODULE_4__WizardOrientationHandler__["a" /* default */]
  },
  computed: {
    currentSlot: function currentSlot() {
      var slotName = this.steps[this.currentStep].slot;
      if (this.wizardCompleted) {
        slotName = this.wizardCompletedSlotName;
      }
      return slotName;
    },
    backEnabled: function backEnabled() {
      return this.currentStep !== 0;
    }
  },
  created: function created() {
    this.$on('wizardLayoutChange', this.updateLayout);
  },

  methods: {
    updateLayout: function updateLayout(layout) {
      this.computedLayout = layout;
    },
    goNext: function goNext() {
      this.currentStepOnNext();
      if (!this.isLastStep() && this.isCurrentStepValid()) {
        this.currentStep++;
      }
      if (this.stepTri === false) {
        this.$emit('uzorakUnesen');

        if (this.$route.path === '/kontrole/unos') {
          __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push('/kontrole/pregled');
        } else {
          __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push('/uzorci/pregled/?sekcija=' + this.sekcija);
        }

        this.stepTri = true;
      }
      if (this.currentStep === 3) {
        this.stepTri = false;
      }
    },
    goBack: function goBack() {
      this.currentStepOnBack();
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    goBack2: function goBack2() {
      this.goBack();
      this.goBack();
      this.stepTri = !this.stepTri;
    },
    completeWizard: function completeWizard() {
      this.wizardCompleted = true;
      this.goNext();
    },
    isLastStep: function isLastStep() {
      return this.currentStep === this.steps.length - 1;
    },
    currentStepOnNext: function currentStepOnNext() {
      var step = this.steps[this.currentStep];
      if (step.onNext) {
        step.onNext();
      }
    },
    currentStepOnBack: function currentStepOnBack() {
      var step = this.steps[this.currentStep];
      if (step.onBack) {
        step.onBack();
      }
    },
    isCurrentStepValid: function isCurrentStepValid() {
      return this.steps[this.currentStep].isValid();
    },
    isStepShown: function isStepShown(step) {
      return step.slot === this.currentSlot && !this.wizardCompleted;
    }
  }
});

/***/ }),

/***/ "muhW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"form-group with-icon-right dropdown select-form-group multiselect-form-group",class:{'has-error': _vm.hasErrors()}},[_c('div',{staticClass:"input-group dropdown-toggle",on:{"click":function($event){_vm.$refs.scrollbar.onContainerResize()}}},[_c('input',{class:{'has-value': !!_vm.displayValue},attrs:{"readonly":"","required":""},domProps:{"value":_vm.displayValue}}),_vm._v(" "),_c('i',{staticClass:"ion ion-chevron-down icon-right input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v(_vm._s(_vm.showRequiredError()))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('div',{staticClass:"dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.toggleSelection(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.optionKey ? option[_vm.optionKey] : option))]),_vm._v(" "),_c('i',{staticClass:"fa fa-check selected-icon"})])}))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n56d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--file",style:(_vm.messageColors)},[_c('div',{staticClass:"sc-message--file-icon"},[_c('a',{attrs:{"href":_vm.data.file.url || '#',"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("w+sz"),"alt":"generic file icon","height":"60"}})])]),_vm._v(" "),_c('div',{staticClass:"sc-message--file-name",style:(_vm.messageColors)},[_c('a',{attrs:{"href":_vm.data.file.url ? _vm.data.file.url : '#',"target":"_blank"}},[_vm._v(_vm._s(_vm.data.file.name || ''))])]),_vm._v(" "),_c('div',{staticClass:"sc-message--file-text",style:(_vm.messageColors)},[_vm._v(_vm._s(_vm.data.text)),(_vm.data.meta)?_c('p',{staticClass:"sc-message--meta",style:(_vm.messageColors)},[_vm._v(_vm._s(_vm.data.meta))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n9oL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalComment_vue__ = __webpack_require__("TcP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a8ffb2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalComment_vue__ = __webpack_require__("mNxl");
function injectStyle (ssrContext) {
  __webpack_require__("BAax")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalComment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a8ffb2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalComment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nUDF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-accordion',
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastClickedTab: {}
    };
  },
  provide: function provide() {
    var _this = this;

    return {
      accordion: {
        onChildChange: function onChildChange(child, state) {
          return _this.onChildChange(child, state);
        }
      }
    };
  },
  mounted: function mounted() {},


  methods: {
    onChildChange: function onChildChange(child, state) {
      if (this.expand) {
        return;
      }

      if (state === false) {
        return;
      }

      this.$children.forEach(function (collapse) {
        if (collapse === child) {
          return;
        }
        collapse.collapse();
      });
    }
  }
});

/***/ }),

/***/ "nYsG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vuestic-tag",class:_vm.tagClass},[_vm._v("\n  "+_vm._s(_vm.name)+"\n  "),(_vm.removable)?_c('span',{staticClass:"vuestic-tag-button",on:{"click":_vm.remove}},[_c('i',{staticClass:"ion-md-close ion"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "noJ4":
/***/ (function(module, exports) {



function odrediDefaultSelection(manual, calculated) {
  if (!manual && !calculated) {
    return ["Lab", true, true];
  } else if (manual && !calculated) {
    return ["Man", true, true];
  } else if (!manual && calculated) {
    return ["Calc", true, true];
  } else if (manual && calculated) {
    return ["Calc", true, true];
  }
}

module.exports = {
  medlab: function medlab(test, godina, spol, drstanje, menopauza, manual, calculated) {
    switch (test) {
      case "Kompletna krvna slika, 5 diff":
        return ["Lab", false, false];
        break;
      case "Protr. vrijeme – INR":
        return ["Lab", false, false];
        break;
      case "eGFR":
        return ["Lab", true, false];
        break;
      default:
        return odrediDefaultSelection(manual, calculated);
        break;
    }
  }
};

/***/ }),

/***/ "noQ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_store__ = __webpack_require__("IcnI");


/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: function inserted(el) {
    var getWindowMatch = function getWindowMatch() {
      return window.matchMedia(__WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].getters.config.windowMatchSizeLg).matches;
    };

    var prevMatchlg = getWindowMatch();

    el.addEventListener('transitionend', function () {
      __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('isToggleWithoutAnimation', false);
    });

    window.addEventListener('resize', function () {
      if (getWindowMatch() && !prevMatchlg) {
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('toggleSidebar', true);
      } else if (!getWindowMatch() && prevMatchlg) {
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('isToggleWithoutAnimation', true);
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('toggleSidebar', false);
      }
      prevMatchlg = getWindowMatch();
    });
  }
});

/***/ }),

/***/ "o0ll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-drugo-stanje",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: "SAČUVAJ"
    },
    cancelText: {
      type: String,
      default: "ODUSTANI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    zatvori: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500,
      zatvor: this.zatvori
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    ok: function ok() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("DrugoStanjeOn");

      this.$emit("ok");

      this.show = false;
    },
    cancel: function cancel() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("DrugoStanjeOff");
      this.$emit("cancel");

      this.show = false;
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
    }
  }
});

/***/ }),

/***/ "oGML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.window.width > 800 && _vm.lokacije.length > 1)?_c('div',{staticClass:"col-md-4 pull-right",staticStyle:{"position":"absolute","right":"0px","top":"8px"}},[_c('vuestic-simple-select',{ref:"lokacijaSelect",staticStyle:{"margin-right":"20px"},attrs:{"label":'Izaberite lokaciju',"name":"lokacija","title":" ","options":_vm.lokacije},model:{value:(_vm.lokacija),callback:function ($$v) {_vm.lokacija=$$v},expression:"lokacija"}})],1):_vm._e(),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"min-height":"460px"},attrs:{"id":"content"}},[_vm._t("default"),_vm._v(" "),(_vm.loadedChart )?_c('div',[(_vm.renderData)?_c('line-chart',{attrs:{"options":_vm.LineChartOptions,"data":_vm.LineChartData,"type":"line"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.loadedChart )?_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"}},[_c('div',{staticStyle:{"float":"left"}}),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"middle"}},[_c('atom-spinner',{attrs:{"animation-duration":1000,"size":370,"color":'#4ae387'}})],1),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}})]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oK+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_directives_Dropdown__ = __webpack_require__("OR0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_epic_spinners__ = __webpack_require__("pyJd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_socket_io__ = __webpack_require__("hMcO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_socket_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_socket_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuestic_components_vuestic_site_SiteDropdown_vue__ = __webpack_require__("4ZaD");













/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      userImage: "",
      isRole: "",
      socketConnected: false,
      socketMessage: [],
      socketAlarm: [],
      notify: this.$store.state.notify,
      reload: true
    };
  },

  name: "navbar",

  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_3_directives_Dropdown__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["sidebarOpened", "toggleWithoutAnimation"]), {
    currentLanguage: function currentLanguage() {}
  }),
  components: {
    AtomSpinner: __WEBPACK_IMPORTED_MODULE_4_epic_spinners__["a" /* AtomSpinner */],
    SiteDropdown: __WEBPACK_IMPORTED_MODULE_9__vuestic_components_vuestic_site_SiteDropdown_vue__["default"]
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["closeMenu", "toggleSidebar", "isToggleWithoutAnimation"]), {
    onLogout: function onLogout() {
      this.$store.dispatch("logout");
    },
    setSite: function setSite(site) {
      this.$refs.languageModal.cancel();
    },

    signUp: function signUp() {
      this.$refs.close.click();
      this.$router.push("/postavke/newuser");
    },
    avatarChange: function avatarChange() {
      this.$refs.close.click();
      this.$router.push("/postavke/avatar");
    },
    promjeniSifru: function promjeniSifru() {
      this.$refs.close.click();
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push("/postavke/chpwd");
    },
    editUser: function editUser() {
      this.$refs.close.click();
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push("/postavke/edit");
    },
    mojePostavke: function mojePostavke() {
      this.$refs.close.click();
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push("/postavke/settings");
    },
    pregledOdobrenih: function pregledOdobrenih(event) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6__config_config_js__["o" /* http */].get("rezultati/sekcija/" + this.$route.params.id + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
        var sekcija = res.data.sekcija;
        _this.$store.state.alarms.forEach(function (element) {
          if (event.target.id.split(",")[0] === element[0]) {
            var ruta = "/rezultati/pregled/" + element[1] + "/" + event.target.id.split(",")[0];
            if (event.target.id.split(",")[0].toString().length < 11) {
              __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push(ruta);
              _this.$store.dispatch("izbaciElement", element);
            }
          }
        });
        _this.$refs.zatvori.click();
      });
    },
    pregledRealizovanih: function pregledRealizovanih(event) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6__config_config_js__["o" /* http */].get("rezultati/sekcija/" + this.$route.params.id + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
        var sekcija = res.data.sekcija;
        _this2.$store.state.messages.forEach(function (element) {
          if (event.target.id.split(",")[0] === element[0]) {
            var ruta = "/rezultati/verifikacija/" + element[1] + "/" + event.target.id.split(",")[0];
            if (event.target.id.split(",")[0].toString().length < 11) {
              __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push(ruta);
              _this2.$store.dispatch("izbaciElement2", element);
            }
          }
        });
        _this2.$refs.zatvori2.click();
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_8__main__["bus"].$on("noviAvatar", function (data, role) {
      _this3.userImage = data;
      _this3.isRole = role;
      _this3.reload = false;
      _this3.reload = true;
    });

    this.socketMessage = this.$store.state.alarms;
    this.notify = this.$store.state.notify;
    var link = this.$store.state.userId;
    var token = this.$store.state.token;

    if (token === null) {} else {
      if (!this.$store.state.userId.includes("@")) {
        link = link + "@";
      }
      var index = link.indexOf("@");
      link = link.substring(0, index);

      __WEBPACK_IMPORTED_MODULE_6__config_config_js__["o" /* http */].post("users/" + link, {
        email: this.$store.state.userId,
        token: this.$store.state.token,
        site: this.$store.state.site
      }).then(function (res) {
        _this3.userImage = res.data.data.link;
        _this3.isRole = res.data.data.role;
      });
    }
  },
  watch: {
    notify: function notify() {
      this.notify = this.$store.state.notify;
    },
    socketMessage: function socketMessage() {
      this.socketMessage = this.$store.state.alarms;
    }
  }
});

/***/ }),

/***/ "oSDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue__ = __webpack_require__("8UFG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_57812418_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TypingMessage_vue__ = __webpack_require__("awPS");
function injectStyle (ssrContext) {
  __webpack_require__("2jJz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57812418"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TypingMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_57812418_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TypingMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oXux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChat_vue__ = __webpack_require__("zt5/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_012750c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChat_vue__ = __webpack_require__("EbRv");
function injectStyle (ssrContext) {
  __webpack_require__("z+iQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-012750c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_012750c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ooJ3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    data: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    }
  }
};

/***/ }),

/***/ "otT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datatable_components_FilterBar_vue__ = __webpack_require__("YhNO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datatable_components_DateRange_vue__ = __webpack_require__("l/id");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datatable_components_ItemsPerPage_vue__ = __webpack_require__("IbS2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_local_data__ = __webpack_require__("zlyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuestic_components_vuestic_datatable_data_data_table_styles__ = __webpack_require__("CHUl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_main_js__ = __webpack_require__("NHnr");















var originalData = __WEBPACK_IMPORTED_MODULE_6__data_local_data__["a" /* default */].data;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-data-table",
  components: {
    FilterBar: __WEBPACK_IMPORTED_MODULE_2__datatable_components_FilterBar_vue__["default"],
    DateRange: __WEBPACK_IMPORTED_MODULE_3__datatable_components_DateRange_vue__["default"],
    Vuetable: __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    ItemsPerPage: __WEBPACK_IMPORTED_MODULE_4__datatable_components_ItemsPerPage_vue__["default"]
  },
  props: {
    site: {
      type: String
    },
    token: {
      type: String
    },
    sekcija: {
      type: String
    },
    apiUrl: {
      type: String
    },
    tableFields: {
      type: Array,
      required: true
    },
    itemsPerPage: {
      type: Array,
      required: true
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    },
    apiMode: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Array
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {
      klijent: '',
      tableData: __WEBPACK_IMPORTED_MODULE_6__data_local_data__["a" /* default */],
      perPage: "RADNA LISTA",
      brStr: 10,
      colorClasses: {},
      moreParams: {},
      dataCount: 0,
      css: __WEBPACK_IMPORTED_MODULE_7__vuestic_components_vuestic_datatable_data_data_table_styles__["a" /* default */],
      show: true,
      potvrdi: "POTVRDI",
      odustani: "ODUSTANI",
      patient: "",
      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: "",
      checkboxSixModel: "",
      samples: [],
      includedSamples: [],
      danas: "",
      modalTitle: "Izbor uzoraka ",
      izbor: "",
      uzorci: [],
      nouzorci: [],
      partials: {},
      partials_array: [],
      date_range: {
        min: '',
        max: ''
      },
      filterString: ""
    };
  },
  created: function created() {
    this.datum();
    var current = this.$router.currentRoute.path;

    if (current.includes("rezultati/verifikacija") || current.includes("obrada/pregled")) {
      this.$store.dispatch("dropdownChange", "RADNA LISTA");
      this.$store.dispatch("filterChange", "");
    } else if (current.includes("nalazi/verifikacija")) {
      this.$store.dispatch("dropdownChange", "RADNA LISTA");
      this.$store.dispatch("filterChange", "");
    } else {
      this.$store.dispatch("dropdownChange", "DANAS");
      this.$store.dispatch("filterChange", "");
    }
    this.perPage = this.$store.state.dropdown;
    this.onFilterSet(this.$store.state.filter);
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$on("yesRacun", function (bool, patient) {
      var index = null;
      _this.includedSamples = [];
      _this.samples.forEach(function (element) {
        if (document.getElementById(element._id).checked) {
          _this.includedSamples.push(element._id);
        } else {
          index = _this.includedSamples.indexOf(element._id);
          if (index > -1) {
            _this.includedSamples.splice(index, 1);
          }
        }
      });
      if (_this.includedSamples.length) {
        __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/uzorci/racuni/racun/" + _this.patient + "?uzorci=" + _this.includedSamples);
      }
    });
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$on("yesNalaz", function (bool, patient) {
      __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/verifikacija/" + patient + "?uzorci=" + _this.nouzorci);
    });
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$on("noData", function (data) {});
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$on("Partials", function () {});
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$on("UzorakFromCollapse", function (data) {
      __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/pregled/" + data.sample);
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("noData");
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("yesRacun");
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("tabChanged");
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("yesNalaz");
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("Partials");
    __WEBPACK_IMPORTED_MODULE_10__src_main_js__["bus"].$off("UzorakFromCollapse");
  },

  methods: {
    UpdateSamples: function UpdateSamples() {},
    convertUTCDateToLocalDate: function convertUTCDateToLocalDate(date) {
      var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
      var offset = date.getTimezoneOffset() / 60;
      var hours = date.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = date.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var sec = date.getSeconds();
      if (sec < 10) {
        sec = "0" + sec;
      }
      newDate.setHours(hours - offset);
      return hours + ":" + minutes + ":" + sec;
    },
    Test: function Test(date) {
      var datum = this.convertUTCDateToLocalDate(new Date(date));
      return datum;
    },

    catchDialog: function catchDialog(event) {
      var _this2 = this;

      this.$dialog.confirm('Jeste li sigurni da želite obrisati zapis? <strong style="color: #E34A4A;"><br>Brisanjem uzorka, brišete i pripadajuće mu rezultate!</strong>', {
        type: "hard",
        html: true,
        verification: "Da"
      }).then(function () {
        var uzorakid = event.target.id;

        __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].post("uzorci/delete", {
          id: event.target.id,
          email: _this2.$store.state.user,
          token: _this2.$store.state.token,
          site: _this2.$store.state.site
        }).then(function (res) {
          if (res.data.success === false) {
            _this2.toastText = "Greška prilikom brisanja!";
            _this2.toastIcon = "fa-remove";
            _this2.toastPosition = "top-right";
            _this2.className = "vuestic-toast-danger";

            _this2.showToast(_this2.toastText, {
              icon: _this2.toastIcon,
              position: _this2.toastPosition,
              duration: _this2.toastDuration,
              fullWidth: _this2.isToastFullWidth,
              className: _this2.className
            });
          } else {
            _this2.toastText = "Zapis uspješno obrisan!";
            _this2.toastIcon = "fa-check";
            _this2.toastPosition = "top-right";
            _this2.className = "vuestic-toast-primary";

            _this2.showToast(_this2.toastText, {
              icon: _this2.toastIcon,
              position: _this2.toastPosition,
              duration: _this2.toastDuration,
              fullWidth: _this2.isToastFullWidth,
              className: _this2.className
            });
            _this2.onFilterSet("");
          }
        });
      }).catch(function () {});
    },
    catchDialogKontrola: function catchDialogKontrola(event) {
      var _this3 = this;

      this.$dialog.confirm("Jeste li sigurni da želite obrisati zapis?", {
        type: "hard",
        html: true,
        verification: "Da"
      }).then(function () {
        var kontrolaid = event.target.id;

        __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].post("kontrole/pregled/delete/", {
          _id: event.target.id,
          site: _this3.$store.state.site,
          token: _this3.$store.state.token
        }).then(function (res) {
          if (res.data.success === false) {
            _this3.toastText = "Greška prilikom brisanja!";
            _this3.toastIcon = "fa-remove";
            _this3.toastPosition = "top-right";
            _this3.className = "vuestic-toast-danger";

            _this3.showToast(_this3.toastText, {
              icon: _this3.toastIcon,
              position: _this3.toastPosition,
              duration: _this3.toastDuration,
              fullWidth: _this3.isToastFullWidth,
              className: _this3.className
            });
          } else {
            _this3.toastText = "Zapis uspješno obrisan!";
            _this3.toastIcon = "fa-check";
            _this3.toastPosition = "top-right";
            _this3.className = "vuestic-toast-primary";

            _this3.showToast(_this3.toastText, {
              icon: _this3.toastIcon,
              position: _this3.toastPosition,
              duration: _this3.toastDuration,
              fullWidth: _this3.isToastFullWidth,
              className: _this3.className
            });
            _this3.onFilterSet("");
          }
        });
      }).catch(function () {});
    },
    catchDialogOutbox: function catchDialogOutbox(event) {
      var _this4 = this;

      this.$dialog.confirm("Jeste li sigurni da želite obrisati zapis?", {
        type: "hard",
        html: true,
        verification: "Da"
      }).then(function () {
        var idNalaza = event.target.id;
        var eNalaz = event.target.getAttribute("name");

        __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].post("outbox/delete", {
          email: _this4.$store.state.userId,
          token: _this4.$store.state.token,
          site: _this4.$store.state.site,
          status: true,
          idNalaza: idNalaza,
          eNalaz: eNalaz,
          flag: true
        }).then(function (res) {
          if (res.data.success === false) {
            _this4.toastText = "Greška prilikom brisanja!";
            _this4.toastIcon = "fa-remove";
            _this4.toastPosition = "top-right";
            _this4.className = "vuestic-toast-danger";

            _this4.showToast(_this4.toastText, {
              icon: _this4.toastIcon,
              position: _this4.toastPosition,
              duration: _this4.toastDuration,
              fullWidth: _this4.isToastFullWidth,
              className: _this4.className
            });
          } else {
            _this4.toastText = "Zapis uspješno obrisan!";
            _this4.toastIcon = "fa-check";
            _this4.toastPosition = "top-right";
            _this4.className = "vuestic-toast-primary";

            _this4.showToast(_this4.toastText, {
              icon: _this4.toastIcon,
              position: _this4.toastPosition,
              duration: _this4.toastDuration,
              fullWidth: _this4.isToastFullWidth,
              className: _this4.className
            });
            _this4.onFilterSet("");
          }
        });
      }).catch(function () {});
    },
    catchDialogNalaz: function catchDialogNalaz(event) {
      var _this5 = this;

      this.$dialog.confirm("Jeste li sigurni da želite obrisati zapis?", {
        type: "hard",
        html: true,
        verification: "Da"
      }).then(function () {
        var idNalaza = event.target.id;

        __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].post("nalazi/delete", {
          email: _this5.$store.state.userId,
          token: _this5.$store.state.token,
          site: _this5.$store.state.site,
          status: true,
          idNalaza: idNalaza,
          flag: true
        }).then(function (res) {
          if (res.data.success === false) {
            _this5.toastText = "Greška prilikom brisanja!";
            _this5.toastIcon = "fa-remove";
            _this5.toastPosition = "top-right";
            _this5.className = "vuestic-toast-danger";

            _this5.showToast(_this5.toastText, {
              icon: _this5.toastIcon,
              position: _this5.toastPosition,
              duration: _this5.toastDuration,
              fullWidth: _this5.isToastFullWidth,
              className: _this5.className
            });
          } else {
            _this5.toastText = "Zapis uspješno obrisan!";
            _this5.toastIcon = "fa-check";
            _this5.toastPosition = "top-right";
            _this5.className = "vuestic-toast-primary";

            _this5.showToast(_this5.toastText, {
              icon: _this5.toastIcon,
              position: _this5.toastPosition,
              duration: _this5.toastDuration,
              fullWidth: _this5.isToastFullWidth,
              className: _this5.className
            });
            _this5.onFilterSet("");
          }
        });
      }).catch(function () {});
    },
    objToString: function objToString(obj) {
      var str = "";
      for (var p in obj) {
        if (obj.hasOwnProperty(p)) {
          str += p + "::" + obj[p] + "\n";
        }
      }
      return str;
    },

    prikaziDetalje: function prikaziDetalje(args) {
      var _this6 = this;

      var niz = args[0];

      if (args[0][2].srcElement.cellIndex === undefined && !args[0][2].srcElement.classList.contains("disabled")) {
        if (niz[1].name === "barkod") {
          this.printajBarcode(args, niz[2]);
        }
        if (niz[1].name === "izbrisi") {
          this.catchDialog(niz[2]);
        }
        if (niz[1].name === "izbrisiKontrolu") {
          this.catchDialogKontrola(niz[2]);
        }
        if (niz[1].name === "brisanje") {
          this.catchDialogNalaz(niz[2]);
        }
        if (niz[1].name === "brisanjeOutbox") {
          this.catchDialogOutbox(niz[2]);
        }
        if (niz[1].name === "pregled") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/uzorci/pregled/" + this.sekcija + "/" + niz[0].id);
        }
        if (niz[1].name === "detalji") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/uzorci/pregled/" + this.sekcija + "/" + niz[0].id);
        }
        if (niz[1].name === "uredi") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/uzorci/uredi/" + this.sekcija + "/" + niz[0].id);
        }
        if (niz[1].name === "detaljiKontrole") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/kontrole/pregled/" + niz[0].id);
        }
        if (niz[1].name === "rezultati") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/rezultati/pregled/" + this.sekcija + "/" + niz[0].id);
        }
        if (niz[1].name === "odobravanje") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/rezultati/verifikacija/" + niz[0]._id + "/" + niz[0].id + "?date=" + niz[0].date);
        }
        if (niz[1].name === "verifikacija") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/rezultati/verifikacija/" + this.sekcija + "/" + niz[0].id);
        }
        if (niz[1].name === "nalaz") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/rezultati/pregled/nalaz/" + this.sekcija + "/" + niz[0].id);
        }
        if (niz[1].name === "nalazi") {
          this.patient = niz[2].target.id;

          var datePost = niz[0].datum;
          if (datePost[3] === '0') {

            datePost = datePost.substring(0, 3) + '' + datePost.substring(3 + 1);
          }

          if (datePost[0] === '0') {

            datePost = datePost.substring(0, 0) + '' + datePost.substring(0 + 1);
          }

          __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].post("/nalazi/check/" + niz[0].pacijent + "/" + niz[2].target.id, {
            token: this.$store.state.token,
            site: this.$store.state.site,
            datum: datePost.replace(/\./g, '-')
          }).then(function (res) {
            var check = false;
            _this6.uzorci = [];
            _this6.samples = [];

            res.data.rezultati.forEach(function (element) {
              if (element.status != "ODOBREN") {
                check = true;
                _this6.samples.push(element);
              } else {
                _this6.nouzorci.push(element._id);
              }
              _this6.uzorci.push(element._id);
            });
            if (check) {
              var pacijent = res.data.rezultati[0].patient.ime + " " + res.data.rezultati[0].patient.prezime;
              _this6.modalTitle = "UPOZORENJE ";
              _this6.klijent = pacijent;

              _this6.$refs.upozoriModal.open();
            } else {
              __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/verifikacija/" + niz[2].target.id + "?uzorci=" + _this6.uzorci);
            }
          });
        }
        if (niz[1].name === "barcodes") {
          __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].get("/rezultati/odobravanje/barcodes/" + niz[2].target.id + "/" + niz[0].id + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site + "&date=" + niz[0].datum.replace(/\./g, '-'), {}).then(function (res) {

            res.data.results.forEach(function (element) {
              var godiste = element.patient.jmbg.substring(4, 7);
              switch (godiste[0]) {
                case "9":
                  godiste = "1" + godiste;
                  break;
                case "0":
                  godiste = "2" + godiste;
                  break;

                default:
                  break;
              }

              var datum = element.created_at.substring(0, 10).split("-");
              var vrijeme = element.created_at.split("T")[1].substring(0, 5);
              datum = datum[2] + "." + datum[1] + "." + datum[0].substring(2, 4);
              datum = datum + "" + vrijeme;
              var link = __WEBPACK_IMPORTED_MODULE_9__config_config_js__["p" /* server */] + "images/barcodes/" + element.id + ".png";
              printEPL(element.patient.ime + " " + element.patient.prezime, element.id, element.sample.pid, godiste, datum, link, element.sample.code, _this6.$store.state.site, element.patient.jmbg);
            });
          });
        }
        if (niz[1].name === "nalazipregled") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/pregled/" + niz[2].target.id);
        }
        if (niz[1].name === "outbox") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/nalazi/outbox/" + niz[2].target.id);
        }

        if (niz[1].name === "predracun") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/rezultati/predracun/" + niz[2].target.id);
        }

        if (niz[1].name === "racun") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/obrada/racun/" + niz[2].target.id);
        }

        if (niz[1].name === "partials") {
          this.partials = {};
          this.partials_array = [];
          this.partials.uzorci = niz[2].target.id;
          this.partials_array = this.partials.uzorci.split(",");
          this.partials.pacijent = niz[2].target.getAttribute('name');
          this.$refs.staticModalUzorci.open();
        }

        if (niz[1].name === "obrada") {
          __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push("/rezultati/obrada/" + niz[0]._id + "/" + niz[0].id + "?date=" + niz[0].date);
        }

        if (niz[1].name === "racuni") {
          this.modalTitle = "Izbor uzoraka ";
          __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].post("uzorci/racuni/" + niz[2].target.id, {
            token: this.$store.state.token,
            site: this.$store.state.site
          }).then(function (res) {
            _this6.samples = res.data;
            var today = new Date();
            var year = today.getFullYear();
            var month = today.getMonth() + 1;
            var day = today.getDate();
            if (day < 10) {
              day = "0" + day;
            }
            if (month < 10) {
              month = "0" + month;
            }
            _this6.danas = day + "." + month + "." + year;
            _this6.modalTitle += "za pacijenta: " + _this6.samples[0].patient.ime + " " + _this6.samples[0].patient.prezime;
            _this6.$refs.largeModalComment.open();

            _this6.patient = niz[2].target.id;
          });
        }
      }
    },
    izbrisiUzorak: function izbrisiUzorak(event) {
      var uzorakid = event.target.id;
    },
    printajBarcode: function printajBarcode(args, event) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_9__config_config_js__["o" /* http */].get("uzorci/barcode/" + args[0][0].id + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
        printEPL(args[0][0].ime + " " + args[0][0].prezime, args[0][0].id, res.data.pacijentRBr, res.data.godiste, res.data.datum, event.target.id, res.data.code, _this7.$store.state.site, res.data.jmbg);
      });
    },
    datum: function datum() {
      var d = new Date();
      var mjesec = d.getMonth() + 1;
      var dan = d.getUTCDate();
      if (dan < 10) {
        dan = "0" + dan;
      }
      if (mjesec < 10) {
        mjesec = "0" + mjesec;
      }
      this.perPage = d.getFullYear() + "-" + mjesec + "-" + dan;
      this.perPage = "RADNA LISTA";
    },
    onFilterSet: function onFilterSet(filterText, event) {
      var _this8 = this;

      this.filterString = "";

      this.filterString = filterText;

      if (event != undefined && filterText.trim() != '') {
        if (event.keyCode == 13) {

          if (this.apiMode) {
            this.moreParams = {
              filter: filterText,
              dateRangeMin: this.date_range.min,
              dateRangeMax: this.date_range.max
            };
          } else {
            var txt = new RegExp(filterText, "i");
            this.tableData.data = originalData.filter(function (item) {
              return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
            });
          }

          __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
            return _this8.$refs.vuetable.refresh();
          });
        } else {}
      } else {

        if (this.apiMode) {
          this.moreParams = {
            filter: filterText,
            dateRangeMin: this.date_range.min,
            dateRangeMax: this.date_range.max
          };
        } else {
          var _txt = new RegExp(filterText, "i");
          this.tableData.data = originalData.filter(function (item) {
            return item.name.search(_txt) >= 0 || item.email.search(_txt) >= 0;
          });
        }
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
          return _this8.$refs.vuetable.refresh();
        });
      }
    },
    onDateRangeSet: function onDateRangeSet(val1, val2) {
      var _this9 = this;

      this.date_range.min = val1;
      this.date_range.max = val2;
      if (this.apiMode) {
        this.moreParams = {
          filter: this.filterString,
          dateRangeMin: this.date_range.min,
          dateRangeMax: this.date_range.max
        };
      } else {
        var txt = new RegExp(filterText, "i");
        this.tableData.data = originalData.filter(function (item) {
          return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
        });
      }
      if (this.date_range.min != '' && this.date_range.max != '') {
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
          return _this9.$refs.vuetable.refresh();
        });
      }
    },
    onItemsPerPage: function onItemsPerPage(itemsPerPageValue) {
      var _this10 = this;

      this.date_range = {
        min: '',
        max: ''
      };

      this.moreParams = {
        filter: this.filterString,
        dateRangeMin: this.date_range.min,
        dateRangeMax: this.date_range.max

      };

      this.perPage = itemsPerPageValue;
      this.$store.dispatch("dropdownChange", this.perPage);

      __WEBPACK_IMPORTED_MODULE_5_vue__["default"].nextTick(function () {
        return _this10.$refs.vuetable.refresh();
      });
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.tableData.data;
      var sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function (item1, item2) {
          var sortField = sortOrder[0].sortField;
          var fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });
        if (sortOrder[0].direction === "desc") {
          data.reverse();
        }
      }
      pagination = this.$refs.vuetable.makePagination(data.length);
      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
});

/***/ }),

/***/ "p3Qa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-patient-info",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    noHeader: Boolean,
    godiste: {
      type: String,
      default: ""
    },
    cijena: {
      type: Number,
      default: 0
    }
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    }
  },
  mounted: function mounted() {},

  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.$slots.body[0].elm.clientHeight + "px";

      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;

      this.show = false;
    },
    onHeaderClick: function onHeaderClick() {
      this.toggle();
      this.accordion.onChildChange(this, this.show);
    },
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "p5Q8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "obrada",
  path: "/obrada/pregled",
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])("obrada/table"),
  meta: {
    default: false,
    expanded: false,
    title: "Obrada",
    iconClass: "vuestic-icon vuestic-icon-files",
    requiredAuth: true
  }
});

/***/ }),

/***/ "p8mx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pAjY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileMessage_vue__ = __webpack_require__("ooJ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_03c83bcf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FileMessage_vue__ = __webpack_require__("n56d");
function injectStyle (ssrContext) {
  __webpack_require__("NQTJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03c83bcf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FileMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_03c83bcf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FileMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pGYK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--emoji"},[_vm._v(_vm._s(_vm.data.emoji))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pMA6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".flatpickr-calendar{background:transparent;opacity:0;display:none;text-align:center;visibility:hidden;padding:0;-webkit-animation:none;animation:none;direction:ltr;border:0;font-size:14px;line-height:24px;border-radius:5px;position:absolute;width:307.875px;-webkit-box-sizing:border-box;box-sizing:border-box;-ms-touch-action:manipulation;touch-action:manipulation;background:#fff;-webkit-box-shadow:1px 0 0 #e6e6e6,-1px 0 0 #e6e6e6,0 1px 0 #e6e6e6,0 -1px 0 #e6e6e6,0 3px 13px rgba(0,0,0,.08);box-shadow:1px 0 0 #e6e6e6,-1px 0 0 #e6e6e6,0 1px 0 #e6e6e6,0 -1px 0 #e6e6e6,0 3px 13px rgba(0,0,0,.08)}.flatpickr-calendar.inline,.flatpickr-calendar.open{opacity:1;max-height:640px;visibility:visible}.flatpickr-calendar.open{display:inline-block;z-index:99999}.flatpickr-calendar.animate.open{-webkit-animation:fpFadeInDown .3s cubic-bezier(.23,1,.32,1);animation:fpFadeInDown .3s cubic-bezier(.23,1,.32,1)}.flatpickr-calendar.inline{display:block;position:relative;top:2px}.flatpickr-calendar.static{position:absolute;top:calc(100% + 2px)}.flatpickr-calendar.static.open{z-index:999;display:block}.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7){-webkit-box-shadow:none!important;box-shadow:none!important}.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1){-webkit-box-shadow:-2px 0 0 #e6e6e6,5px 0 0 #e6e6e6;box-shadow:-2px 0 0 #e6e6e6,5px 0 0 #e6e6e6}.flatpickr-calendar .hasTime .dayContainer,.flatpickr-calendar .hasWeeks .dayContainer{border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.flatpickr-calendar .hasWeeks .dayContainer{border-left:0}.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time{height:40px;border-top:1px solid #e6e6e6}.flatpickr-calendar.noCalendar.hasTime .flatpickr-time{height:auto}.flatpickr-calendar:after,.flatpickr-calendar:before{position:absolute;display:block;pointer-events:none;border:solid transparent;content:\"\";height:0;width:0;left:22px}.flatpickr-calendar.rightMost:after,.flatpickr-calendar.rightMost:before{left:auto;right:22px}.flatpickr-calendar:before{border-width:5px;margin:0 -5px}.flatpickr-calendar:after{border-width:4px;margin:0 -4px}.flatpickr-calendar.arrowTop:after,.flatpickr-calendar.arrowTop:before{bottom:100%}.flatpickr-calendar.arrowTop:before{border-bottom-color:#e6e6e6}.flatpickr-calendar.arrowTop:after{border-bottom-color:#fff}.flatpickr-calendar.arrowBottom:after,.flatpickr-calendar.arrowBottom:before{top:100%}.flatpickr-calendar.arrowBottom:before{border-top-color:#e6e6e6}.flatpickr-calendar.arrowBottom:after{border-top-color:#fff}.flatpickr-calendar:focus{outline:0}.flatpickr-wrapper{position:relative;display:inline-block}.flatpickr-months{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-months .flatpickr-month{background:transparent;color:rgba(0,0,0,.9);fill:rgba(0,0,0,.9);height:28px;line-height:1;text-align:center;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;overflow:hidden;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}.flatpickr-months .flatpickr-next-month,.flatpickr-months .flatpickr-prev-month{text-decoration:none;cursor:pointer;position:absolute;top:0;line-height:16px;height:28px;padding:10px;z-index:3;color:rgba(0,0,0,.9);fill:rgba(0,0,0,.9)}.flatpickr-months .flatpickr-next-month.disabled,.flatpickr-months .flatpickr-prev-month.disabled{display:none}.flatpickr-months .flatpickr-next-month i,.flatpickr-months .flatpickr-prev-month i{position:relative}.flatpickr-months .flatpickr-next-month.flatpickr-prev-month,.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month{left:0}.flatpickr-months .flatpickr-next-month.flatpickr-next-month,.flatpickr-months .flatpickr-prev-month.flatpickr-next-month{right:0}.flatpickr-months .flatpickr-next-month:hover,.flatpickr-months .flatpickr-prev-month:hover{color:#959ea9}.flatpickr-months .flatpickr-next-month:hover svg,.flatpickr-months .flatpickr-prev-month:hover svg{fill:#f64747}.flatpickr-months .flatpickr-next-month svg,.flatpickr-months .flatpickr-prev-month svg{width:14px;height:14px}.flatpickr-months .flatpickr-next-month svg path,.flatpickr-months .flatpickr-prev-month svg path{-webkit-transition:fill .1s;transition:fill .1s;fill:inherit}.numInputWrapper{position:relative;height:auto}.numInputWrapper input,.numInputWrapper span{display:inline-block}.numInputWrapper input{width:100%}.numInputWrapper input::-ms-clear{display:none}.numInputWrapper span{position:absolute;right:0;width:14px;padding:0 4px 0 2px;height:50%;line-height:50%;opacity:0;cursor:pointer;border:1px solid rgba(57,57,57,.15);-webkit-box-sizing:border-box;box-sizing:border-box}.numInputWrapper span:hover{background:rgba(0,0,0,.1)}.numInputWrapper span:active{background:rgba(0,0,0,.2)}.numInputWrapper span:after{display:block;content:\"\";position:absolute}.numInputWrapper span.arrowUp{top:0;border-bottom:0}.numInputWrapper span.arrowUp:after{border-left:4px solid transparent;border-right:4px solid transparent;border-bottom:4px solid rgba(57,57,57,.6);top:26%}.numInputWrapper span.arrowDown{top:50%}.numInputWrapper span.arrowDown:after{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid rgba(57,57,57,.6);top:40%}.numInputWrapper span svg{width:inherit;height:auto}.numInputWrapper span svg path{fill:rgba(0,0,0,.5)}.numInputWrapper:hover{background:rgba(0,0,0,.05)}.numInputWrapper:hover span{opacity:1}.flatpickr-current-month{font-size:135%;line-height:inherit;font-weight:300;color:inherit;position:absolute;width:75%;left:12.5%;padding:6.16px 0 0;line-height:1;height:28px;display:inline-block;text-align:center;-webkit-transform:translateZ(0);transform:translateZ(0)}.flatpickr-current-month span.cur-month{font-family:inherit;font-weight:700;color:inherit;display:inline-block;margin-left:.5ch;padding:0}.flatpickr-current-month span.cur-month:hover{background:rgba(0,0,0,.05)}.flatpickr-current-month .numInputWrapper{width:6ch;width:7ch\\0;display:inline-block}.flatpickr-current-month .numInputWrapper span.arrowUp:after{border-bottom-color:rgba(0,0,0,.9)}.flatpickr-current-month .numInputWrapper span.arrowDown:after{border-top-color:rgba(0,0,0,.9)}.flatpickr-current-month input.cur-year{background:transparent;-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;cursor:text;padding:0 0 0 .5ch;margin:0;display:inline-block;font-size:inherit;font-family:inherit;font-weight:300;line-height:inherit;height:auto;border:0;border-radius:0;vertical-align:initial}.flatpickr-current-month input.cur-year:focus{outline:0}.flatpickr-current-month input.cur-year[disabled],.flatpickr-current-month input.cur-year[disabled]:hover{font-size:100%;color:rgba(0,0,0,.5);background:transparent;pointer-events:none}.flatpickr-weekdays{background:transparent;text-align:center;overflow:hidden;width:100%;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;height:28px}.flatpickr-weekdays,.flatpickr-weekdays .flatpickr-weekdaycontainer{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-weekdays .flatpickr-weekdaycontainer,span.flatpickr-weekday{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}span.flatpickr-weekday{cursor:default;font-size:90%;background:transparent;color:rgba(0,0,0,.54);line-height:1;margin:0;text-align:center;display:block;font-weight:bolder}.dayContainer,.flatpickr-weeks{padding:1px 0 0}.flatpickr-days{position:relative;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start;width:307.875px}.flatpickr-days:focus{outline:0}.dayContainer{padding:0;outline:0;text-align:left;width:307.875px;min-width:307.875px;max-width:307.875px;-webkit-box-sizing:border-box;box-sizing:border-box;display:inline-block;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-wrap:wrap;-ms-flex-pack:justify;-webkit-justify-content:space-around;justify-content:space-around;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}.dayContainer+.dayContainer{-webkit-box-shadow:-1px 0 0 #e6e6e6;box-shadow:-1px 0 0 #e6e6e6}.flatpickr-day{background:none;border:1px solid transparent;border-radius:150px;-webkit-box-sizing:border-box;box-sizing:border-box;color:#393939;cursor:pointer;font-weight:400;width:14.2857143%;-webkit-flex-basis:14.2857143%;-ms-flex-preferred-size:14.2857143%;flex-basis:14.2857143%;max-width:39px;height:39px;line-height:39px;margin:0;display:inline-block;position:relative;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center}.flatpickr-day.inRange,.flatpickr-day.nextMonthDay.inRange,.flatpickr-day.nextMonthDay.today.inRange,.flatpickr-day.nextMonthDay:focus,.flatpickr-day.nextMonthDay:hover,.flatpickr-day.prevMonthDay.inRange,.flatpickr-day.prevMonthDay.today.inRange,.flatpickr-day.prevMonthDay:focus,.flatpickr-day.prevMonthDay:hover,.flatpickr-day.today.inRange,.flatpickr-day:focus,.flatpickr-day:hover{cursor:pointer;outline:0;background:#e6e6e6;border-color:#e6e6e6}.flatpickr-day.today{border-color:#959ea9}.flatpickr-day.today:focus,.flatpickr-day.today:hover{border-color:#959ea9;background:#959ea9;color:#fff}.flatpickr-day.endRange,.flatpickr-day.endRange.inRange,.flatpickr-day.endRange.nextMonthDay,.flatpickr-day.endRange.prevMonthDay,.flatpickr-day.endRange:focus,.flatpickr-day.endRange:hover,.flatpickr-day.selected,.flatpickr-day.selected.inRange,.flatpickr-day.selected.nextMonthDay,.flatpickr-day.selected.prevMonthDay,.flatpickr-day.selected:focus,.flatpickr-day.selected:hover,.flatpickr-day.startRange,.flatpickr-day.startRange.inRange,.flatpickr-day.startRange.nextMonthDay,.flatpickr-day.startRange.prevMonthDay,.flatpickr-day.startRange:focus,.flatpickr-day.startRange:hover{background:#569ff7;-webkit-box-shadow:none;box-shadow:none;color:#fff;border-color:#569ff7}.flatpickr-day.endRange.startRange,.flatpickr-day.selected.startRange,.flatpickr-day.startRange.startRange{border-radius:50px 0 0 50px}.flatpickr-day.endRange.endRange,.flatpickr-day.selected.endRange,.flatpickr-day.startRange.endRange{border-radius:0 50px 50px 0}.flatpickr-day.endRange.startRange+.endRange:not(:nth-child(7n+1)),.flatpickr-day.selected.startRange+.endRange:not(:nth-child(7n+1)),.flatpickr-day.startRange.startRange+.endRange:not(:nth-child(7n+1)){-webkit-box-shadow:-10px 0 0 #569ff7;box-shadow:-10px 0 0 #569ff7}.flatpickr-day.endRange.startRange.endRange,.flatpickr-day.selected.startRange.endRange,.flatpickr-day.startRange.startRange.endRange{border-radius:50px}.flatpickr-day.inRange{border-radius:0;-webkit-box-shadow:-5px 0 0 #e6e6e6,5px 0 0 #e6e6e6;box-shadow:-5px 0 0 #e6e6e6,5px 0 0 #e6e6e6}.flatpickr-day.disabled,.flatpickr-day.disabled:hover,.flatpickr-day.nextMonthDay,.flatpickr-day.notAllowed,.flatpickr-day.notAllowed.nextMonthDay,.flatpickr-day.notAllowed.prevMonthDay,.flatpickr-day.prevMonthDay{color:rgba(57,57,57,.3);background:transparent;border-color:transparent;cursor:default}.flatpickr-day.disabled,.flatpickr-day.disabled:hover{cursor:not-allowed;color:rgba(57,57,57,.1)}.flatpickr-day.week.selected{border-radius:0;-webkit-box-shadow:-5px 0 0 #569ff7,5px 0 0 #569ff7;box-shadow:-5px 0 0 #569ff7,5px 0 0 #569ff7}.flatpickr-day.hidden{visibility:hidden}.rangeMode .flatpickr-day{margin-top:1px}.flatpickr-weekwrapper{display:inline-block;float:left}.flatpickr-weekwrapper .flatpickr-weeks{padding:0 12px;-webkit-box-shadow:1px 0 0 #e6e6e6;box-shadow:1px 0 0 #e6e6e6}.flatpickr-weekwrapper .flatpickr-weekday{float:none;width:100%;line-height:28px}.flatpickr-weekwrapper span.flatpickr-day,.flatpickr-weekwrapper span.flatpickr-day:hover{display:block;width:100%;max-width:none;color:rgba(57,57,57,.3);background:transparent;cursor:default;border:none}.flatpickr-innerContainer{display:block;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;overflow:hidden}.flatpickr-innerContainer,.flatpickr-rContainer{-webkit-box-sizing:border-box;box-sizing:border-box}.flatpickr-rContainer{display:inline-block;padding:0}.flatpickr-time{text-align:center;outline:0;display:block;height:0;line-height:40px;max-height:40px;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-time:after{content:\"\";display:table;clear:both}.flatpickr-time .numInputWrapper{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;width:40%;height:40px;float:left}.flatpickr-time .numInputWrapper span.arrowUp:after{border-bottom-color:#393939}.flatpickr-time .numInputWrapper span.arrowDown:after{border-top-color:#393939}.flatpickr-time.hasSeconds .numInputWrapper{width:26%}.flatpickr-time.time24hr .numInputWrapper{width:49%}.flatpickr-time input{background:transparent;-webkit-box-shadow:none;box-shadow:none;border:0;border-radius:0;text-align:center;margin:0;padding:0;height:inherit;line-height:inherit;color:#393939;font-size:14px;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box}.flatpickr-time input.flatpickr-hour{font-weight:700}.flatpickr-time input.flatpickr-minute,.flatpickr-time input.flatpickr-second{font-weight:400}.flatpickr-time input:focus{outline:0;border:0}.flatpickr-time .flatpickr-am-pm,.flatpickr-time .flatpickr-time-separator{height:inherit;display:inline-block;float:left;line-height:inherit;color:#393939;font-weight:700;width:2%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-align-self:center;-ms-flex-item-align:center;align-self:center}.flatpickr-time .flatpickr-am-pm{outline:0;width:18%;cursor:pointer;text-align:center;font-weight:400}.flatpickr-time .flatpickr-am-pm:focus,.flatpickr-time .flatpickr-am-pm:hover,.flatpickr-time input:focus,.flatpickr-time input:hover{background:#f3f3f3}.flatpickr-input[readonly]{cursor:pointer}@-webkit-keyframes fpFadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes fpFadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}", "", {"version":3,"sources":["D:/Poliklinika Muminović Bihać/muminovic_client/node_modules/flatpickr/dist/flatpickr.css"],"names":[],"mappings":"AAAA,oBACE,uBAAwB,AACxB,UAAW,AACX,aAAc,AACd,kBAAmB,AACnB,kBAAmB,AACnB,UAAW,AACX,uBAAwB,AAChB,eAAgB,AACxB,cAAe,AACf,SAAU,AACV,eAAgB,AAChB,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,8BAA+B,AACvB,sBAAuB,AAC/B,8BAA+B,AAC3B,0BAA2B,AAC/B,gBAAiB,AACjB,gHAAsH,AAC9G,uGAA8G,CACvH,AACD,oDAEE,UAAW,AACX,iBAAkB,AAClB,kBAAoB,CACrB,AACD,yBACE,qBAAsB,AACtB,aAAe,CAChB,AACD,iCACE,6DAAqE,AAC7D,oDAA6D,CACtE,AACD,2BACE,cAAe,AACf,kBAAmB,AACnB,OAAS,CACV,AACD,2BACE,kBAAmB,AACnB,oBAAsB,CACvB,AACD,gCACE,YAAa,AACb,aAAe,CAChB,AACD,mHACE,kCAAoC,AAC5B,yBAA4B,CACrC,AACD,mHACE,oDAAsD,AAC9C,2CAA8C,CACvD,AACD,uFAEE,gBAAiB,AACjB,6BAA8B,AAC9B,2BAA6B,CAC9B,AACD,4CACE,aAAe,CAChB,AACD,0DACE,YAAa,AACb,4BAA8B,CAC/B,AACD,uDACE,WAAa,CACd,AACD,qDAEE,kBAAmB,AACnB,cAAe,AACf,oBAAqB,AACrB,yBAA0B,AAC1B,WAAY,AACZ,SAAU,AACV,QAAS,AACT,SAAW,CACZ,AACD,yEAEE,UAAW,AACX,UAAY,CACb,AACD,2BACE,iBAAkB,AAClB,aAAe,CAChB,AACD,0BACE,iBAAkB,AAClB,aAAe,CAChB,AACD,uEAEE,WAAa,CACd,AACD,oCACE,2BAA6B,CAC9B,AACD,mCACE,wBAA0B,CAC3B,AACD,6EAEE,QAAU,CACX,AACD,uCACE,wBAA0B,CAC3B,AACD,sCACE,qBAAuB,CACxB,AACD,0BACE,SAAW,CACZ,AACD,mBACE,kBAAmB,AACnB,oBAAsB,CACvB,AACD,kBACE,oBAAqB,AACrB,qBAAsB,AACtB,oBAAqB,AACrB,YAAc,CACf,AACD,mCACE,uBAAwB,AACxB,qBAAuB,AACvB,oBAAsB,AACtB,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,kBAAmB,AACnB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,gBAAiB,AACjB,mBAAoB,AACpB,eAAgB,AACZ,WAAY,AACR,MAAQ,CACjB,AACD,gFAEE,qBAAsB,AACtB,eAAgB,AAChB,kBAAmB,AACnB,MAAS,AACT,iBAAkB,AAClB,YAAa,AACb,aAAc,AACd,UAAW,AACX,qBAAuB,AACvB,mBAAsB,CACvB,AACD,kGAEE,YAAc,CACf,AACD,oFAEE,iBAAmB,CACpB,AACD,0HAME,MAAQ,CAKT,AAKD,0HAME,OAAS,CAKV,AAKD,4FAEE,aAAe,CAChB,AACD,oGAEE,YAAc,CACf,AACD,wFAEE,WAAY,AACZ,WAAa,CACd,AACD,kGAEE,4BAA8B,AAC9B,oBAAsB,AACtB,YAAc,CACf,AACD,iBACE,kBAAmB,AACnB,WAAa,CACd,AACD,6CAEE,oBAAsB,CACvB,AACD,uBACE,UAAY,CACb,AACD,kCACE,YAAc,CACf,AACD,sBACE,kBAAmB,AACnB,QAAS,AACT,WAAY,AACZ,oBAAqB,AACrB,WAAY,AACZ,gBAAiB,AACjB,UAAW,AACX,eAAgB,AAChB,oCAAsC,AACtC,8BAA+B,AACvB,qBAAuB,CAChC,AACD,4BACE,yBAA4B,CAC7B,AACD,6BACE,yBAA4B,CAC7B,AACD,4BACE,cAAe,AACf,WAAY,AACZ,iBAAmB,CACpB,AACD,8BACE,MAAO,AACP,eAAiB,CAClB,AACD,oCACE,kCAAmC,AACnC,mCAAoC,AACpC,0CAA4C,AAC5C,OAAS,CACV,AACD,gCACE,OAAS,CACV,AACD,sCACE,kCAAmC,AACnC,mCAAoC,AACpC,uCAAyC,AACzC,OAAS,CACV,AACD,0BACE,cAAe,AACf,WAAa,CACd,AACD,+BACE,mBAAsB,CACvB,AACD,uBACE,0BAA6B,CAC9B,AACD,4BACE,SAAW,CACZ,AACD,yBACE,eAAgB,AAChB,oBAAqB,AACrB,gBAAiB,AACjB,cAAe,AACf,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,mBAAsB,AACtB,cAAe,AACf,YAAa,AACb,qBAAsB,AACtB,kBAAmB,AACnB,gCAA8C,AACtC,uBAAsC,CAC/C,AACD,wCACE,oBAAqB,AACrB,gBAAiB,AACjB,cAAe,AACf,qBAAsB,AACtB,iBAAmB,AACnB,SAAW,CACZ,AACD,8CACE,0BAA6B,CAC9B,AACD,0CACE,UAAW,AACX,YAAa,AACb,oBAAsB,CACvB,AACD,6DACE,kCAAqC,CACtC,AACD,+DACE,+BAAkC,CACnC,AACD,wCACE,uBAAwB,AACxB,8BAA+B,AACvB,sBAAuB,AAC/B,cAAe,AACf,YAAa,AACb,mBAAqB,AACrB,SAAU,AACV,qBAAsB,AACtB,kBAAmB,AACnB,oBAAqB,AACrB,gBAAiB,AACjB,oBAAqB,AACrB,YAAa,AACb,SAAU,AACV,gBAAiB,AACjB,sBAAwB,CACzB,AACD,8CACE,SAAW,CACZ,AACD,0GAEE,eAAgB,AAChB,qBAAuB,AACvB,uBAAwB,AACxB,mBAAqB,CACtB,AACD,oBACE,uBAAwB,AACxB,kBAAmB,AACnB,gBAAiB,AACjB,WAAY,AAKZ,yBAA0B,AAC1B,2BAA4B,AACxB,sBAAuB,AACnB,mBAAoB,AAC5B,WAAa,CACd,AACD,oEAVE,oBAAqB,AACrB,qBAAsB,AACtB,oBAAqB,AACrB,YAAc,CAgBf,AACD,uEALE,mBAAoB,AACpB,eAAgB,AACZ,WAAY,AACR,MAAQ,CAgBjB,AAdD,uBACE,eAAgB,AAChB,cAAe,AACf,uBAAwB,AACxB,sBAAwB,AACxB,cAAe,AACf,SAAU,AACV,kBAAmB,AACnB,cAAe,AAKf,kBAAoB,CACrB,AACD,+BAEE,eAAmB,CACpB,AACD,gBACE,kBAAmB,AACnB,gBAAiB,AACjB,oBAAqB,AACrB,qBAAsB,AACtB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACzB,+BAAgC,AAC5B,qBAAsB,AAClB,uBAAwB,AAChC,eAAiB,CAClB,AACD,sBACE,SAAW,CACZ,AACD,cACE,UAAW,AACX,UAAW,AACX,gBAAiB,AACjB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,8BAA+B,AACvB,sBAAuB,AAC/B,qBAAsB,AACtB,oBAAqB,AACrB,oBAAqB,AACrB,qBAAsB,AACtB,aAAc,AACd,uBAAwB,AAChB,eAAgB,AACxB,mBAAoB,AACpB,sBAAuB,AACvB,qCAAsC,AAC9B,6BAA8B,AACtC,gCAA8C,AACtC,wBAAsC,AAC9C,SAAW,CACZ,AACD,4BACE,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,eACE,gBAAiB,AACjB,6BAA8B,AAC9B,oBAAqB,AACrB,8BAA+B,AACvB,sBAAuB,AAC/B,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,+BAAgC,AAC5B,oCAAqC,AACjC,uBAAwB,AAChC,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,SAAU,AACV,qBAAsB,AACtB,kBAAmB,AACnB,wBAAyB,AACzB,+BAAgC,AAC5B,qBAAsB,AAClB,uBAAwB,AAChC,iBAAmB,CACpB,AACD,kYAYE,eAAgB,AAChB,UAAW,AACX,mBAAoB,AACpB,oBAAsB,CACvB,AACD,qBACE,oBAAsB,CACvB,AACD,sDAEE,qBAAsB,AACtB,mBAAoB,AACpB,UAAY,CACb,AACD,skBAkBE,mBAAoB,AACpB,wBAAyB,AACjB,gBAAiB,AACzB,WAAY,AACZ,oBAAsB,CACvB,AACD,2GAGE,2BAA6B,CAC9B,AACD,qGAGE,2BAA6B,CAC9B,AACD,2MAGE,qCAAsC,AAC9B,4BAA8B,CACvC,AACD,sIAGE,kBAAoB,CACrB,AACD,uBACE,gBAAiB,AACjB,oDAAsD,AAC9C,2CAA8C,CACvD,AACD,sNAOE,wBAA0B,AAC1B,uBAAwB,AACxB,yBAA0B,AAC1B,cAAgB,CACjB,AACD,sDAEE,mBAAoB,AACpB,uBAA0B,CAC3B,AACD,6BACE,gBAAiB,AACjB,oDAAsD,AAC9C,2CAA8C,CACvD,AACD,sBACE,iBAAmB,CACpB,AACD,0BACE,cAAgB,CACjB,AACD,uBACE,qBAAsB,AACtB,UAAY,CACb,AACD,wCACE,eAAgB,AAChB,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,0CACE,WAAY,AACZ,WAAY,AACZ,gBAAkB,CACnB,AACD,0FAEE,cAAe,AACf,WAAY,AACZ,eAAgB,AAChB,wBAA0B,AAC1B,uBAAwB,AACxB,eAAgB,AAChB,WAAa,CACd,AACD,0BACE,cAAe,AACf,oBAAqB,AACrB,qBAAsB,AACtB,oBAAqB,AACrB,aAAc,AAGd,eAAiB,CAClB,AACD,gDAJE,8BAA+B,AACvB,qBAAuB,CAQhC,AALD,sBACE,qBAAsB,AACtB,SAAW,CAGZ,AACD,gBACE,kBAAmB,AACnB,UAAW,AACX,cAAe,AACf,SAAU,AACV,iBAAkB,AAClB,gBAAiB,AACjB,8BAA+B,AACvB,sBAAuB,AAC/B,gBAAiB,AACjB,oBAAqB,AACrB,qBAAsB,AACtB,oBAAqB,AACrB,YAAc,CACf,AACD,sBACE,WAAY,AACZ,cAAe,AACf,UAAY,CACb,AACD,iCACE,mBAAoB,AACpB,eAAgB,AACZ,WAAY,AACR,OAAQ,AAChB,UAAW,AACX,YAAa,AACb,UAAY,CACb,AACD,oDACE,2BAA6B,CAC9B,AACD,sDACE,wBAA0B,CAC3B,AACD,4CACE,SAAW,CACZ,AACD,0CACE,SAAW,CACZ,AACD,sBACE,uBAAwB,AACxB,wBAAyB,AACjB,gBAAiB,AACzB,SAAU,AACV,gBAAiB,AACjB,kBAAmB,AACnB,SAAU,AACV,UAAW,AACX,eAAgB,AAChB,oBAAqB,AACrB,cAAe,AACf,eAAgB,AAChB,kBAAmB,AACnB,8BAA+B,AACvB,qBAAuB,CAChC,AACD,qCACE,eAAkB,CACnB,AACD,8EAEE,eAAiB,CAClB,AACD,4BACE,UAAW,AACX,QAAU,CACX,AACD,2EAEE,eAAgB,AAChB,qBAAsB,AACtB,WAAY,AACZ,oBAAqB,AACrB,cAAe,AACf,gBAAkB,AAClB,SAAU,AACV,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,0BAA2B,AACvB,2BAA4B,AACxB,iBAAmB,CAC5B,AACD,iCACE,UAAW,AACX,UAAW,AACX,eAAgB,AAChB,kBAAmB,AACnB,eAAiB,CAClB,AACD,sIAIE,kBAAoB,CACrB,AACD,2BACE,cAAgB,CACjB,AACD,gCACE,GACE,UAAW,AACX,yCAA4C,AACpC,gCAAoC,CAC7C,AACD,GACE,UAAW,AACX,gCAAwC,AAChC,uBAAgC,CACzC,CACF,AACD,wBACE,GACE,UAAW,AACX,yCAA4C,AACpC,gCAAoC,CAC7C,AACD,GACE,UAAW,AACX,gCAAwC,AAChC,uBAAgC,CACzC,CACF","file":"flatpickr.css","sourcesContent":[".flatpickr-calendar {\n  background: transparent;\n  opacity: 0;\n  display: none;\n  text-align: center;\n  visibility: hidden;\n  padding: 0;\n  -webkit-animation: none;\n          animation: none;\n  direction: ltr;\n  border: 0;\n  font-size: 14px;\n  line-height: 24px;\n  border-radius: 5px;\n  position: absolute;\n  width: 307.875px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n  background: #fff;\n  -webkit-box-shadow: 1px 0 0 #e6e6e6, -1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6, 0 -1px 0 #e6e6e6, 0 3px 13px rgba(0,0,0,0.08);\n          box-shadow: 1px 0 0 #e6e6e6, -1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6, 0 -1px 0 #e6e6e6, 0 3px 13px rgba(0,0,0,0.08);\n}\n.flatpickr-calendar.open,\n.flatpickr-calendar.inline {\n  opacity: 1;\n  max-height: 640px;\n  visibility: visible;\n}\n.flatpickr-calendar.open {\n  display: inline-block;\n  z-index: 99999;\n}\n.flatpickr-calendar.animate.open {\n  -webkit-animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n          animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.flatpickr-calendar.inline {\n  display: block;\n  position: relative;\n  top: 2px;\n}\n.flatpickr-calendar.static {\n  position: absolute;\n  top: calc(100% + 2px);\n}\n.flatpickr-calendar.static.open {\n  z-index: 999;\n  display: block;\n}\n.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {\n  -webkit-box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n          box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n}\n.flatpickr-calendar .hasWeeks .dayContainer,\n.flatpickr-calendar .hasTime .dayContainer {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.flatpickr-calendar .hasWeeks .dayContainer {\n  border-left: 0;\n}\n.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time {\n  height: 40px;\n  border-top: 1px solid #e6e6e6;\n}\n.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {\n  height: auto;\n}\n.flatpickr-calendar:before,\n.flatpickr-calendar:after {\n  position: absolute;\n  display: block;\n  pointer-events: none;\n  border: solid transparent;\n  content: '';\n  height: 0;\n  width: 0;\n  left: 22px;\n}\n.flatpickr-calendar.rightMost:before,\n.flatpickr-calendar.rightMost:after {\n  left: auto;\n  right: 22px;\n}\n.flatpickr-calendar:before {\n  border-width: 5px;\n  margin: 0 -5px;\n}\n.flatpickr-calendar:after {\n  border-width: 4px;\n  margin: 0 -4px;\n}\n.flatpickr-calendar.arrowTop:before,\n.flatpickr-calendar.arrowTop:after {\n  bottom: 100%;\n}\n.flatpickr-calendar.arrowTop:before {\n  border-bottom-color: #e6e6e6;\n}\n.flatpickr-calendar.arrowTop:after {\n  border-bottom-color: #fff;\n}\n.flatpickr-calendar.arrowBottom:before,\n.flatpickr-calendar.arrowBottom:after {\n  top: 100%;\n}\n.flatpickr-calendar.arrowBottom:before {\n  border-top-color: #e6e6e6;\n}\n.flatpickr-calendar.arrowBottom:after {\n  border-top-color: #fff;\n}\n.flatpickr-calendar:focus {\n  outline: 0;\n}\n.flatpickr-wrapper {\n  position: relative;\n  display: inline-block;\n}\n.flatpickr-months {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.flatpickr-months .flatpickr-month {\n  background: transparent;\n  color: rgba(0,0,0,0.9);\n  fill: rgba(0,0,0,0.9);\n  height: 28px;\n  line-height: 1;\n  text-align: center;\n  position: relative;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  overflow: hidden;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.flatpickr-months .flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month {\n  text-decoration: none;\n  cursor: pointer;\n  position: absolute;\n  top: 0px;\n  line-height: 16px;\n  height: 28px;\n  padding: 10px;\n  z-index: 3;\n  color: rgba(0,0,0,0.9);\n  fill: rgba(0,0,0,0.9);\n}\n.flatpickr-months .flatpickr-prev-month.disabled,\n.flatpickr-months .flatpickr-next-month.disabled {\n  display: none;\n}\n.flatpickr-months .flatpickr-prev-month i,\n.flatpickr-months .flatpickr-next-month i {\n  position: relative;\n}\n.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {\n/*\n      /*rtl:begin:ignore*/\n/*\n      */\n  left: 0;\n/*\n      /*rtl:end:ignore*/\n/*\n      */\n}\n/*\n      /*rtl:begin:ignore*/\n/*\n      /*rtl:end:ignore*/\n.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,\n.flatpickr-months .flatpickr-next-month.flatpickr-next-month {\n/*\n      /*rtl:begin:ignore*/\n/*\n      */\n  right: 0;\n/*\n      /*rtl:end:ignore*/\n/*\n      */\n}\n/*\n      /*rtl:begin:ignore*/\n/*\n      /*rtl:end:ignore*/\n.flatpickr-months .flatpickr-prev-month:hover,\n.flatpickr-months .flatpickr-next-month:hover {\n  color: #959ea9;\n}\n.flatpickr-months .flatpickr-prev-month:hover svg,\n.flatpickr-months .flatpickr-next-month:hover svg {\n  fill: #f64747;\n}\n.flatpickr-months .flatpickr-prev-month svg,\n.flatpickr-months .flatpickr-next-month svg {\n  width: 14px;\n  height: 14px;\n}\n.flatpickr-months .flatpickr-prev-month svg path,\n.flatpickr-months .flatpickr-next-month svg path {\n  -webkit-transition: fill 0.1s;\n  transition: fill 0.1s;\n  fill: inherit;\n}\n.numInputWrapper {\n  position: relative;\n  height: auto;\n}\n.numInputWrapper input,\n.numInputWrapper span {\n  display: inline-block;\n}\n.numInputWrapper input {\n  width: 100%;\n}\n.numInputWrapper input::-ms-clear {\n  display: none;\n}\n.numInputWrapper span {\n  position: absolute;\n  right: 0;\n  width: 14px;\n  padding: 0 4px 0 2px;\n  height: 50%;\n  line-height: 50%;\n  opacity: 0;\n  cursor: pointer;\n  border: 1px solid rgba(57,57,57,0.15);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.numInputWrapper span:hover {\n  background: rgba(0,0,0,0.1);\n}\n.numInputWrapper span:active {\n  background: rgba(0,0,0,0.2);\n}\n.numInputWrapper span:after {\n  display: block;\n  content: \"\";\n  position: absolute;\n}\n.numInputWrapper span.arrowUp {\n  top: 0;\n  border-bottom: 0;\n}\n.numInputWrapper span.arrowUp:after {\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-bottom: 4px solid rgba(57,57,57,0.6);\n  top: 26%;\n}\n.numInputWrapper span.arrowDown {\n  top: 50%;\n}\n.numInputWrapper span.arrowDown:after {\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid rgba(57,57,57,0.6);\n  top: 40%;\n}\n.numInputWrapper span svg {\n  width: inherit;\n  height: auto;\n}\n.numInputWrapper span svg path {\n  fill: rgba(0,0,0,0.5);\n}\n.numInputWrapper:hover {\n  background: rgba(0,0,0,0.05);\n}\n.numInputWrapper:hover span {\n  opacity: 1;\n}\n.flatpickr-current-month {\n  font-size: 135%;\n  line-height: inherit;\n  font-weight: 300;\n  color: inherit;\n  position: absolute;\n  width: 75%;\n  left: 12.5%;\n  padding: 6.16px 0 0 0;\n  line-height: 1;\n  height: 28px;\n  display: inline-block;\n  text-align: center;\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n}\n.flatpickr-current-month span.cur-month {\n  font-family: inherit;\n  font-weight: 700;\n  color: inherit;\n  display: inline-block;\n  margin-left: 0.5ch;\n  padding: 0;\n}\n.flatpickr-current-month span.cur-month:hover {\n  background: rgba(0,0,0,0.05);\n}\n.flatpickr-current-month .numInputWrapper {\n  width: 6ch;\n  width: 7ch\\0;\n  display: inline-block;\n}\n.flatpickr-current-month .numInputWrapper span.arrowUp:after {\n  border-bottom-color: rgba(0,0,0,0.9);\n}\n.flatpickr-current-month .numInputWrapper span.arrowDown:after {\n  border-top-color: rgba(0,0,0,0.9);\n}\n.flatpickr-current-month input.cur-year {\n  background: transparent;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: inherit;\n  cursor: text;\n  padding: 0 0 0 0.5ch;\n  margin: 0;\n  display: inline-block;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: 300;\n  line-height: inherit;\n  height: auto;\n  border: 0;\n  border-radius: 0;\n  vertical-align: initial;\n}\n.flatpickr-current-month input.cur-year:focus {\n  outline: 0;\n}\n.flatpickr-current-month input.cur-year[disabled],\n.flatpickr-current-month input.cur-year[disabled]:hover {\n  font-size: 100%;\n  color: rgba(0,0,0,0.5);\n  background: transparent;\n  pointer-events: none;\n}\n.flatpickr-weekdays {\n  background: transparent;\n  text-align: center;\n  overflow: hidden;\n  width: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 28px;\n}\n.flatpickr-weekdays .flatpickr-weekdaycontainer {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\nspan.flatpickr-weekday {\n  cursor: default;\n  font-size: 90%;\n  background: transparent;\n  color: rgba(0,0,0,0.54);\n  line-height: 1;\n  margin: 0;\n  text-align: center;\n  display: block;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  font-weight: bolder;\n}\n.dayContainer,\n.flatpickr-weeks {\n  padding: 1px 0 0 0;\n}\n.flatpickr-days {\n  position: relative;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  width: 307.875px;\n}\n.flatpickr-days:focus {\n  outline: 0;\n}\n.dayContainer {\n  padding: 0;\n  outline: 0;\n  text-align: left;\n  width: 307.875px;\n  min-width: 307.875px;\n  max-width: 307.875px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: inline-block;\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n          flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  -ms-flex-pack: justify;\n  -webkit-justify-content: space-around;\n          justify-content: space-around;\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  opacity: 1;\n}\n.dayContainer + .dayContainer {\n  -webkit-box-shadow: -1px 0 0 #e6e6e6;\n          box-shadow: -1px 0 0 #e6e6e6;\n}\n.flatpickr-day {\n  background: none;\n  border: 1px solid transparent;\n  border-radius: 150px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #393939;\n  cursor: pointer;\n  font-weight: 400;\n  width: 14.2857143%;\n  -webkit-flex-basis: 14.2857143%;\n      -ms-flex-preferred-size: 14.2857143%;\n          flex-basis: 14.2857143%;\n  max-width: 39px;\n  height: 39px;\n  line-height: 39px;\n  margin: 0;\n  display: inline-block;\n  position: relative;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  text-align: center;\n}\n.flatpickr-day.inRange,\n.flatpickr-day.prevMonthDay.inRange,\n.flatpickr-day.nextMonthDay.inRange,\n.flatpickr-day.today.inRange,\n.flatpickr-day.prevMonthDay.today.inRange,\n.flatpickr-day.nextMonthDay.today.inRange,\n.flatpickr-day:hover,\n.flatpickr-day.prevMonthDay:hover,\n.flatpickr-day.nextMonthDay:hover,\n.flatpickr-day:focus,\n.flatpickr-day.prevMonthDay:focus,\n.flatpickr-day.nextMonthDay:focus {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.flatpickr-day.today {\n  border-color: #959ea9;\n}\n.flatpickr-day.today:hover,\n.flatpickr-day.today:focus {\n  border-color: #959ea9;\n  background: #959ea9;\n  color: #fff;\n}\n.flatpickr-day.selected,\n.flatpickr-day.startRange,\n.flatpickr-day.endRange,\n.flatpickr-day.selected.inRange,\n.flatpickr-day.startRange.inRange,\n.flatpickr-day.endRange.inRange,\n.flatpickr-day.selected:focus,\n.flatpickr-day.startRange:focus,\n.flatpickr-day.endRange:focus,\n.flatpickr-day.selected:hover,\n.flatpickr-day.startRange:hover,\n.flatpickr-day.endRange:hover,\n.flatpickr-day.selected.prevMonthDay,\n.flatpickr-day.startRange.prevMonthDay,\n.flatpickr-day.endRange.prevMonthDay,\n.flatpickr-day.selected.nextMonthDay,\n.flatpickr-day.startRange.nextMonthDay,\n.flatpickr-day.endRange.nextMonthDay {\n  background: #569ff7;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #fff;\n  border-color: #569ff7;\n}\n.flatpickr-day.selected.startRange,\n.flatpickr-day.startRange.startRange,\n.flatpickr-day.endRange.startRange {\n  border-radius: 50px 0 0 50px;\n}\n.flatpickr-day.selected.endRange,\n.flatpickr-day.startRange.endRange,\n.flatpickr-day.endRange.endRange {\n  border-radius: 0 50px 50px 0;\n}\n.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),\n.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),\n.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {\n  -webkit-box-shadow: -10px 0 0 #569ff7;\n          box-shadow: -10px 0 0 #569ff7;\n}\n.flatpickr-day.selected.startRange.endRange,\n.flatpickr-day.startRange.startRange.endRange,\n.flatpickr-day.endRange.startRange.endRange {\n  border-radius: 50px;\n}\n.flatpickr-day.inRange {\n  border-radius: 0;\n  -webkit-box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n          box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n}\n.flatpickr-day.disabled,\n.flatpickr-day.disabled:hover,\n.flatpickr-day.prevMonthDay,\n.flatpickr-day.nextMonthDay,\n.flatpickr-day.notAllowed,\n.flatpickr-day.notAllowed.prevMonthDay,\n.flatpickr-day.notAllowed.nextMonthDay {\n  color: rgba(57,57,57,0.3);\n  background: transparent;\n  border-color: transparent;\n  cursor: default;\n}\n.flatpickr-day.disabled,\n.flatpickr-day.disabled:hover {\n  cursor: not-allowed;\n  color: rgba(57,57,57,0.1);\n}\n.flatpickr-day.week.selected {\n  border-radius: 0;\n  -webkit-box-shadow: -5px 0 0 #569ff7, 5px 0 0 #569ff7;\n          box-shadow: -5px 0 0 #569ff7, 5px 0 0 #569ff7;\n}\n.flatpickr-day.hidden {\n  visibility: hidden;\n}\n.rangeMode .flatpickr-day {\n  margin-top: 1px;\n}\n.flatpickr-weekwrapper {\n  display: inline-block;\n  float: left;\n}\n.flatpickr-weekwrapper .flatpickr-weeks {\n  padding: 0 12px;\n  -webkit-box-shadow: 1px 0 0 #e6e6e6;\n          box-shadow: 1px 0 0 #e6e6e6;\n}\n.flatpickr-weekwrapper .flatpickr-weekday {\n  float: none;\n  width: 100%;\n  line-height: 28px;\n}\n.flatpickr-weekwrapper span.flatpickr-day,\n.flatpickr-weekwrapper span.flatpickr-day:hover {\n  display: block;\n  width: 100%;\n  max-width: none;\n  color: rgba(57,57,57,0.3);\n  background: transparent;\n  cursor: default;\n  border: none;\n}\n.flatpickr-innerContainer {\n  display: block;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow: hidden;\n}\n.flatpickr-rContainer {\n  display: inline-block;\n  padding: 0;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.flatpickr-time {\n  text-align: center;\n  outline: 0;\n  display: block;\n  height: 0;\n  line-height: 40px;\n  max-height: 40px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.flatpickr-time:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.flatpickr-time .numInputWrapper {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  width: 40%;\n  height: 40px;\n  float: left;\n}\n.flatpickr-time .numInputWrapper span.arrowUp:after {\n  border-bottom-color: #393939;\n}\n.flatpickr-time .numInputWrapper span.arrowDown:after {\n  border-top-color: #393939;\n}\n.flatpickr-time.hasSeconds .numInputWrapper {\n  width: 26%;\n}\n.flatpickr-time.time24hr .numInputWrapper {\n  width: 49%;\n}\n.flatpickr-time input {\n  background: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border: 0;\n  border-radius: 0;\n  text-align: center;\n  margin: 0;\n  padding: 0;\n  height: inherit;\n  line-height: inherit;\n  color: #393939;\n  font-size: 14px;\n  position: relative;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.flatpickr-time input.flatpickr-hour {\n  font-weight: bold;\n}\n.flatpickr-time input.flatpickr-minute,\n.flatpickr-time input.flatpickr-second {\n  font-weight: 400;\n}\n.flatpickr-time input:focus {\n  outline: 0;\n  border: 0;\n}\n.flatpickr-time .flatpickr-time-separator,\n.flatpickr-time .flatpickr-am-pm {\n  height: inherit;\n  display: inline-block;\n  float: left;\n  line-height: inherit;\n  color: #393939;\n  font-weight: bold;\n  width: 2%;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-align-self: center;\n      -ms-flex-item-align: center;\n          align-self: center;\n}\n.flatpickr-time .flatpickr-am-pm {\n  outline: 0;\n  width: 18%;\n  cursor: pointer;\n  text-align: center;\n  font-weight: 400;\n}\n.flatpickr-time input:hover,\n.flatpickr-time .flatpickr-am-pm:hover,\n.flatpickr-time input:focus,\n.flatpickr-time .flatpickr-am-pm:focus {\n  background: #f3f3f3;\n}\n.flatpickr-input[readonly] {\n  cursor: pointer;\n}\n@-webkit-keyframes fpFadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -20px, 0);\n            transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes fpFadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -20px, 0);\n            transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "pThx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-error",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("Error");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "pZN+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "phUr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pmVg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseSamplesEntry_vue__ = __webpack_require__("kFeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f535b52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseSamplesEntry_vue__ = __webpack_require__("P8iw");
function injectStyle (ssrContext) {
  __webpack_require__("PNnd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseSamplesEntry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f535b52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseSamplesEntry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pqzW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleProgressBar_vue__ = __webpack_require__("XG+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34fadf0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgressBar_vue__ = __webpack_require__("ZQWp");
function injectStyle (ssrContext) {
  __webpack_require__("26I1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34fadf0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pr2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kewler__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'animatedValue', 'min', 'max', 'color', 'size', 'isActive'],
  mounted: function mounted() {
    var progressBar = this.$refs.progressBar;
    var progressColor = Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["color"])(this.color);
    var current = progressColor;
    setInterval(function () {
      if (progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30))() !== current()) {
        current = progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30));
      } else {
        current = progressColor;
      }
      progressBar.style.backgroundColor = current();
    }, 500);
  }
});

/***/ }),

/***/ "pzlW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_store__ = __webpack_require__("IcnI");


var palette = __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].getters.palette;

/* harmony default export */ __webpack_exports__["a"] = ({
  legend: {
    position: 'bottom',
    labels: {
      fontColor: palette.fontColor,
      fontFamily: 'sans-serif',
      fontSize: 14,
      padding: 20,
      usePointStyle: true
    }
  },
  tooltips: {
    bodyFontSize: 14,
    bodyFontFamily: 'sans-serif'
  },
  responsive: true,
  maintainAspectRatio: false
});

/***/ }),

/***/ "q30D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Bar"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], _this.defaultOptions, _this.options);
      _this.renderChart(_this.data, options);
    }, 600);
  }
}));

/***/ }),

/***/ "qHzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SwappingSquaresSpinner_vue__ = __webpack_require__("h+W8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_48bf3180_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SwappingSquaresSpinner_vue__ = __webpack_require__("gBU1");
function injectStyle (ssrContext) {
  __webpack_require__("GKsR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48bf3180"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SwappingSquaresSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_48bf3180_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SwappingSquaresSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "qKqw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trinity-rings-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle circle1",style:(_vm.ring1Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle2",style:(_vm.ring2Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle3",style:(_vm.ring3Style)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qQGN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r7J/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuestic_components_vuestic_chart_chart_types_LineChart__ = __webpack_require__("eDOj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_epic_spinners__ = __webpack_require__("pyJd");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-patients-data",

  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_3__vuestic_components_vuestic_chart_chart_types_LineChart__["a" /* default */],
    AtomSpinner: __WEBPACK_IMPORTED_MODULE_4_epic_spinners__["a" /* AtomSpinner */]
  },

  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      minHeight: 0,
      renderData: false,
      duration: 500,
      loadedChart: false,
      LineChartOptions: {},
      LineChartData: {},
      initLineChartOptions: {},
      initLineChartData: {},
      lokacije: [],
      lokacija: "",
      window: {
        width: 0,
        height: 0
      }
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },

  created: function created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    },
    lokacija: function lokacija() {}
  },
  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.show = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      if (this.loadedChart) {
        this.renderData = true;
        this.show = true;
        var elmnt = document.getElementById("content");

        this.minHeight = elmnt.offsetHeight;
      }

      window.addEventListener("keyup", this.listenKeyUp);
    },
    close: function close() {
      this.show = false;
      this.renderData = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },


    pripremiPodatkeLineChart: function pripremiPodatkeLineChart(callback) {
      var _this = this;

      this.loadedChart = false;
      __WEBPACK_IMPORTED_MODULE_0__config_config_js__["o" /* http */].get("/dashboard/line" + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site + "&adresa=" + this.lokacija, {}).then(function (res) {
        var palette = __WEBPACK_IMPORTED_MODULE_2_vuex_store__["a" /* default */].getters.palette;

        if (res.data) {
          _this.lokacije = res.data.mjesta;
          if (res.data.barData.data.length < 1) {
            var _palette = __WEBPACK_IMPORTED_MODULE_2_vuex_store__["a" /* default */].getters.palette;
            var LineChartData = {
              labels: res.data.barData.labela,
              datasets: [{
                label: "Pacijenata",
                fill: true,
                backgroundColor: _palette.pale,
                borderColor: _palette.transparent,
                data: res.data.barData.patients
              }]
            };
            _this.loadedChart = true;
            _this.LineChartOptions = {
              responsive: true,
              maintainAspectRatio: false,
              title: {
                display: true,
                text: "Zadnja 3 mjeseca"
              },
              scales: {
                xAxes: [{
                  display: true,
                  gridLines: {
                    display: true,
                    color: "#eee"
                  }
                }],
                yAxes: [{
                  display: true,
                  gridLines: {
                    display: true,
                    color: "#eee"
                  }
                }]
              }
            };
          } else {
            var _palette2 = __WEBPACK_IMPORTED_MODULE_2_vuex_store__["a" /* default */].getters.palette;
            var LineChartData = {
              labels: res.data.barData.labela,
              datasets: [{
                label: "Pacijenata",
                fill: true,
                backgroundColor: _this.hex2rgb(_palette2.info, 0.5).css,
                pointBorderColor: _palette2.danger,
                borderColor: _palette2.transparent,
                data: res.data.barData.patients
              }]
            };
            _this.loadedChart = true;
            _this.LineChartOptions = {
              responsive: true,
              maintainAspectRatio: false,
              title: {
                display: true,
                text: "Zadnja 3 mjeseca" },
              scales: {
                xAxes: [{
                  display: true,
                  gridLines: {
                    display: true,
                    color: "#eee"
                  }
                }],
                yAxes: [{
                  display: true,
                  gridLines: {
                    display: true,
                    color: "#eee"
                  }
                }]
              }
            };
          }
          callback(LineChartData);
        }
      });
    },
    hex2rgb: function hex2rgb(hex, opacity) {
      hex = (hex + "").trim();

      var rgb = null;
      var match = hex.match(/^#?(([0-9a-zA-Z]{3}){1,3})$/);

      if (!match) {
        return null;
      }

      rgb = {};

      hex = match[1];

      if (hex.length === 6) {
        rgb.r = parseInt(hex.substring(0, 2), 16);
        rgb.g = parseInt(hex.substring(2, 4), 16);
        rgb.b = parseInt(hex.substring(4, 6), 16);
      } else if (hex.length === 3) {
        rgb.r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16);
        rgb.g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16);
        rgb.b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16);
      }

      rgb.css = "rgb" + (opacity ? "a" : "") + "(";
      rgb.css += rgb.r + "," + rgb.g + "," + rgb.b;
      rgb.css += (opacity ? "," + opacity : "") + ")";

      return rgb;
    }
  }
});

/***/ }),

/***/ "r8Mc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelfBuildingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 6000
    },
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 9
    };
  },


  computed: {
    squareSize: function squareSize() {
      return this.size / 4;
    },
    initialTopPosition: function initialTopPosition() {
      return -this.squareSize * 2 / 3;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        top: -this.initialTopPosition + 'px',
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.squareSize + 'px',
        width: this.squareSize + 'px',
        top: this.initialTopPosition + 'px',
        marginRight: this.squareSize / 3 + 'px',
        marginTop: this.squareSize / 3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        background: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delaysMultipliers = [6, 7, 8, 3, 4, 5, 0, 1, 2];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 0; i < this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * delaysMultipliers[i] + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "rZpX":
/***/ (function(module, exports) {



function odrediDefaultSelection(manual, calculated) {
  if (!manual && !calculated) {
    return ["Lab", true, true];
  } else if (manual && !calculated) {
    return ["Man", true, true];
  } else if (!manual && calculated) {
    return ["Calc", true, true];
  } else if (manual && calculated) {
    return ["Calc", true, true];
  }
}

module.exports = {
  muminovic: function muminovic(test, godina, spol, drstanje, menopauza, manual, calculated) {
    switch (test) {
      case "HbA1c":
        return ["Lab", true, false];
        break;
      case "Total Hb":
        return ["Lab", true, false];
        break;
      case "OGTT - 60 min":
        return ["Lab", true, false];
        break;
      case "OGTT - 120 min":
        return ["Lab", true, false];
        break;
      case "Kreatinin, urin":
        return ["Lab", true, false];
        break;
      case "Ukupni proteini, urin":
        return ["Lab", true, false];
        break;

      case "Prolaktin 2":
        return ["Lab", true, false];
        break;
      case "Prolaktin 3":
        return ["Lab", true, false];
        break;
      default:
        return odrediDefaultSelection(manual, calculated);
        break;
    }
  }
};

/***/ }),

/***/ "rhzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSwitch_vue__ = __webpack_require__("u1r+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f594552_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSwitch_vue__ = __webpack_require__("OPCq");
function injectStyle (ssrContext) {
  __webpack_require__("eG8r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSwitch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f594552_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSwitch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rl1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-dropdown dropdown navbar-dropdown"},[(_vm.allSitesID.length  > 1)?_c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}]},[_c('a',{staticClass:"language-dropdown-button dropdown-toggle",attrs:{"href":"#"}},[_c('span',{ref:"close",staticClass:"flag-icon flag-icon-large",class:_vm.sitePickClass(_vm.currentSite())},[_vm._v(_vm._s(_vm.izbor === '' ? _vm.initSiteName : _vm.izborPrikaz))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_vm._l((_vm.options),function(option,id){return (_vm.izbor === '')?_c('a',{key:id,staticClass:"dropdown-item",class:{ 'active': option.sifra === _vm.initSite[0].sifra },on:{"click":function($event){_vm.setSite(option.sifra)}}},[_c('span',{staticClass:"flag-icon flag-icon-small",class:_vm.sitePickClass(option.sifra)}),_vm._v(" "),_c('span',{staticClass:"dropdown-item__text ellipsis"},[_vm._v("\n          "+_vm._s(option.name)+"\n        ")])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.options),function(option,id){return (_vm.izbor != '')?_c('a',{key:id,staticClass:"dropdown-item",class:{ 'active': option.id === _vm.izabraniSiteId },on:{"click":function($event){_vm.setSite(option.sifra)}}},[_c('span',{staticClass:"flag-icon flag-icon-small",class:_vm.sitePickClass(option.sifra)}),_vm._v(" "),_c('span',{staticClass:"dropdown-item__text ellipsis"},[_vm._v("\n          "+_vm._s(option.name)+"\n        ")])]):_vm._e()})],2)]):_vm._e(),_vm._v(" "),(_vm.allSitesID.length < 2)?_c('div',[_c('a',{staticClass:"language-dropdown-button dropdown-toggle",attrs:{"href":"#"}},[_c('span',{ref:"close",staticClass:"flag-icon flag-icon-large",class:_vm.sitePickClass(_vm.currentSite())},[_vm._v(_vm._s(_vm.initSiteName))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_vm._l((_vm.options),function(option,id){return (_vm.izbor === '')?_c('a',{key:id,staticClass:"dropdown-item",class:{ 'active': option.sifra === _vm.initSite[0].sifra }},[_c('span',{staticClass:"flag-icon flag-icon-small",class:_vm.sitePickClass(option.sifra)}),_vm._v(" "),_c('span',{staticClass:"dropdown-item__text ellipsis"},[_vm._v("\n          "+_vm._s(option.name)+"\n        ")])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.options),function(option,id){return (_vm.izbor != '')?_c('a',{key:id,staticClass:"dropdown-item",class:{ 'active': option.sifra === _vm.currentSite() }},[_c('span',{staticClass:"flag-icon flag-icon-small",class:_vm.sitePickClass(option.sifra)}),_vm._v(" "),_c('span',{staticClass:"dropdown-item__text ellipsis"},[_vm._v("\n          "+_vm._s(option.name)+"\n        ")])]):_vm._e()})],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ruol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-accordion"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s66l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-social-news"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center text-w-btn"},[_c('span',{staticClass:"text"},[_vm._v("That what users have posted about your business.")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('button',{staticClass:"btn btn-micro btn-primary"},[_vm._v("VIEW")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-around photos"},_vm._l((_vm.news),function(pieceOfNews){return _c('div',{staticClass:"photo",style:(("background: url(" + (pieceOfNews.photoURL) + ")"))})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "se34":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sidr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__funkcije_shared_samples_js__ = __webpack_require__("R0++");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__funkcije_shared_samples_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__funkcije_shared_samples_js__);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-modal-plus",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: "SAČUVAJ"
    },
    cancelText: {
      type: String,
      default: "ZATVORI"
    },
    okClass: {
      type: String,
      default: "btn btn-primary btn-sm"
    },
    cancelClass: {
      type: String,
      default: "btn btn-warning btn-sm"
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sid: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      showPlus: false,
      duration: 500,

      ime: "",
      prezime: "",
      jmbg: "",
      spol: "",
      lokacija: "",
      drstanje: "",
      menstc: "",
      anticoag: "",
      menopauza: "",
      jmbgObj: {},
      jmbgDan: "",
      jmbgMjesec: "",
      jmbgGodina: "",
      ukGodina: "",
      tip: "",
      ruler: false,
      sekcija: [],
      izabraniTestovi: [],
      sviTestovi: [],
      sviRezultati: [],
      basSviTestovi: [],
      testovi: [],

      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: ""
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small
      };
    }
  },
  created: function created() {
    if (this.showPlus) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, "");
  },

  watch: {
    showPlus: function showPlus(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, "");
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === "Escape") {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit("ok");
      this.sacuvajIzmjene();

      window.removeEventListener("keyup", this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit("cancel");
      this.showPlus = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      var _this = this;

      this.showPlus = true;
      window.addEventListener("keyup", this.listenKeyUp);

      this.ruler = false;
      this.izabraniTestovi = [];
      this.sviTestovi = [];
      this.basSviTestovi = [];
      this.testovi = [];

      __WEBPACK_IMPORTED_MODULE_3__config_config_js__["o" /* http */].get("uzorci/show/" + this.sid + "?token=" + this.$store.state.token + "&site=" + this.$store.state.site, {}).then(function (res) {
        _this.ime = res.data.uzorak.patient.ime;
        _this.prezime = res.data.uzorak.patient.prezime;
        _this.jmbg = res.data.uzorak.patient.jmbg;
        _this.spol = res.data.uzorak.patient.spol;

        _this.lokacija = res.data.uzorak.lokacija.lokacija;
        _this.drstanje = res.data.uzorak.trudnica;
        _this.menstc = res.data.uzorak.menstc;
        _this.anticoag = res.data.uzorak.anticoag;
        _this.menopauza = res.data.uzorak.menopauza;
        _this.tip = res.data.uzorak.type;
        _this.sekcija = res.data.uzorak.sekcija;
        _this.izabraniTestovi = res.data.uzorak.tests;
        _this.sviRezultati = res.data.rezultat.rezultati;
        _this.ukupnaStarost();

        __WEBPACK_IMPORTED_MODULE_3__config_config_js__["o" /* http */].post("/uzorci/sekcije/list", {
          sekcija: _this.sekcija,
          token: _this.$store.state.token,
          tip: _this.tip,
          site: _this.$store.state.site
        }).then(function (res) {
          if (res.data.success === false) {
            _this.sviTestovi = [];
          } else {
            _this.sviTestovi = [];

            res.data.testovi.forEach(function (element) {
              _this.basSviTestovi.push({
                labassay: element._id,
                ime_testa: element.naziv,
                cijena: element.price,
                analit: element.analit,
                sekcija: element.sekcija,
                manual: element.manual,
                calculated: element.calculated,
                calculatedTests: element.calculatedTests
              });

              if (Object(__WEBPACK_IMPORTED_MODULE_5__funkcije_shared_samples_js__["sampleSelection"])(_this.$store.state.site, element.analit, _this.ukGodina, _this.spol, _this.drstanje, _this.menopauza)[1]) {
                _this.sviTestovi.push({
                  disabled: element.disabled,
                  labassay: element._id,
                  ime_testa: element.naziv,
                  cijena: element.price,
                  analit: element.analit,
                  sekcija: element.sekcija,
                  manual: element.manual,
                  calculated: element.calculated,
                  calculatedTests: element.calculatedTests
                });
              }
            });
          }
        }).then(function (res) {
          var editable = true;
          _this.sviTestovi.forEach(function (element) {
            _this.izabraniTestovi.forEach(function (izabrani) {
              if (izabrani.labassay._id === element.labassay) {

                editable = false;

                _this.sviRezultati.forEach(function (rez) {

                  if (rez.labassay._id === element.labassay) {
                    if (rez.rezultat[rez.rezultat.length - 1].rezultat_f != '') {
                      editable = true;
                    }
                  }
                });

                _this.dodajTestInit(element.labassay, element.ime_testa, izabrani.labassay.manual, izabrani.status_t, editable);
              }
            });
          });

          for (var i = _this.sviTestovi.length - 1; i >= 0; i--) {
            for (var j = 0; j < _this.izabraniTestovi.length; j++) {
              if (_this.sviTestovi[i] && _this.sviTestovi[i].labassay === _this.izabraniTestovi[j].labassay._id) {
                _this.sviTestovi.splice(i, 1);
              }
            }
          }
        }).then(function (res) {
          _this.ruler = true;
        });
      });
    },
    close: function close() {
      this.showPlus = false;
      window.removeEventListener("keyup", this.listenKeyUp);
    },
    removeDuplicates: function removeDuplicates(originalArray, prop) {
      var newArray = [];
      var lookupObject = {};

      for (var i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
      }

      for (i in lookupObject) {
        newArray.push(lookupObject[i]);
      }
      return newArray;
    },


    sacuvajIzmjene: function sacuvajIzmjene() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__config_config_js__["o" /* http */].post("/uzorci/update", {
        sid: this.sid,
        jmbg: this.jmbg,
        testovi: this.testovi,
        token: this.$store.state.token,
        site: this.$store.state.site,
        spol: this.spol,
        trudnica: this.drstanje,
        menstc: this.menstc,
        anticoag: this.anticoag,
        menopauza: this.menopauza,
        jmbgObj: this.jmbgObj
      }).then(function (res) {
        if (res.data.success === true) {
          _this2.toastText = "Uzorak uspješno izmijenjen!";
          _this2.toastIcon = "fa-check";
          _this2.toastPosition = "top-right";
          _this2.className = "vuestic-toast-primary";

          _this2.showToast(_this2.toastText, {
            icon: _this2.toastIcon,
            position: _this2.toastPosition,
            duration: _this2.toastDuration,
            fullWidth: _this2.isToastFullWidth,
            className: _this2.className
          });

          _this2.showPlus = false;
          __WEBPACK_IMPORTED_MODULE_4__main__["bus"].$emit("showPlusRefresh");
        } else {
          _this2.toastText = "Greška prilikom izmjene uzorka!";
          _this2.toastIcon = "fa-remove";
          _this2.toastPosition = "top-right";
          _this2.className = "vuestic-toast-danger";

          _this2.showToast(_this2.toastText, {
            icon: _this2.toastIcon,
            position: _this2.toastPosition,
            duration: _this2.toastDuration,
            fullWidth: _this2.isToastFullWidth,
            className: _this2.className
          });
        }
      });
    },

    ukupnaStarost: function ukupnaStarost() {
      var str = "";
      var tmp = "";
      this.jmbgDan = this.jmbg.slice(0, 2);
      this.jmbgMjesec = this.jmbg.slice(2, 4);
      this.jmbgGodina = this.jmbg.slice(4, 7);

      if (this.jmbgGodina[0] === "9") {
        str = "1";
        tmp = this.jmbgGodina;
        this.jmbgGodina = str.concat(tmp);
      } else if (this.jmbgGodina[0] === "0") {
        str = "2";
        tmp = this.jmbgGodina;
        this.jmbgGodina = str.concat(tmp);
      } else {}

      var date = this.jmbgGodina + "-" + this.jmbgMjesec + "-" + this.jmbgDan;
      this.jmbgObj = this.dateDiff(date);
      this.ukGodina = this.jmbgObj.years + 1;
    },

    dateDiff: function dateDiff(date) {
      date = date.split("-");
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth() + 1;
      var day = today.getDate();
      var yy = parseInt(date[0]);
      var mm = parseInt(date[1]);
      var dd = parseInt(date[2]);
      var years, months, days;

      months = month - mm;

      if (day < dd) {
        months = months - 1;
      }

      years = year - yy;

      if (month * 100 + day < mm * 100 + dd) {
        years = years - 1;
        months = months + 12;
      }

      days = Math.floor((today.getTime() - new Date(yy + years, mm + months - 1, dd).getTime()) / (24 * 60 * 60 * 1000));

      return {
        years: years,
        months: months,
        days: days
      };
    },
    dodajTestInit: function dodajTestInit(event, ime, manual, status, editable) {
      var _this3 = this;

      if (this.testovi.length < 1) {
        this.placeholder = "";
      }

      var manual = false;
      var calculated = false;
      var kalkuliraniTestovi = [];
      var sekc = "";
      var anlit = "";
      var cost = "";

      if (!this.testovi.filter(function (test) {
        return test.labassay === event;
      }).length > 0) {
        this.sviTestovi.forEach(function (element) {
          if (event === element.labassay) {
            sekc = element.sekcija;
            anlit = element.analit;
            cost = element.cijena;
          }

          if (element.manual && event === element.labassay) {
            manual = true;
          }

          if (element.calculated && event === element.labassay) {
            calculated = true;

            element.calculatedTests.forEach(function (kalk) {
              kalk.sekcija = element.sekcija;
              kalk.calculated = false;
              kalk.calculatedTests = [];
              kalk.cijena = "0";
              kalk.disable = true;

              _this3.basSviTestovi.forEach(function (bastest) {
                if (bastest.labassay === kalk.labassay) {
                  kalk.cijena = bastest.cijena;
                  kalk.analit = bastest.analit;
                }
              });

              if (!_this3.testovi.filter(function (test) {
                return test.labassay === kalk.labassay;
              }).length > 0) {
                _this3.testovi.push(kalk);
              }

              kalkuliraniTestovi.push(kalk);
            });
          }
        });

        this.testovi.push({
          disable: editable,
          labassay: event,
          ime_testa: ime,
          cijena: cost,
          analit: anlit,
          sekcija: sekc,
          manual: manual,
          calculated: calculated,
          calculatedTests: kalkuliraniTestovi
        });
      }
    },
    dodajTest: function dodajTest(event) {
      var _this4 = this;

      if (this.testovi.length < 1) {
        this.placeholder = "";
      }
      var manual = false;
      var calculated = false;
      var kalkuliraniTestovi = [];
      var sekc = "";
      var anlit = "";
      var cost = "";

      if (!this.testovi.filter(function (test) {
        return test.labassay === event.target.id;
      }).length > 0) {
        this.sviTestovi.forEach(function (element) {
          if (event.target.id === element.labassay) {
            sekc = element.sekcija;
            anlit = element.analit;
            cost = element.cijena;
          }
          if (element.manual && event.target.id === element.labassay) {
            manual = true;
          }
          if (element.calculated && event.target.id === element.labassay) {
            calculated = true;

            element.calculatedTests.forEach(function (kalk) {
              kalk.sekcija = element.sekcija;
              kalk.calculated = false;
              kalk.calculatedTests = [];
              kalk.cijena = "0";

              _this4.basSviTestovi.forEach(function (bastest) {
                if (bastest.labassay === kalk.labassay) {
                  kalk.cijena = bastest.cijena;
                  kalk.analit = bastest.analit;
                }
              });

              if (!_this4.testovi.filter(function (test) {
                return test.labassay === kalk.labassay;
              }).length > 0) {
                _this4.testovi.push(kalk);
              }

              kalkuliraniTestovi.push(kalk);
              document.getElementById(kalk.labassay).className = "btn btn-info btn-micro";
            });
          }
        });

        this.testovi.push({
          labassay: event.target.id,
          ime_testa: event.target.innerText,
          cijena: cost,
          analit: anlit,
          sekcija: sekc,
          manual: manual,
          calculated: calculated,
          calculatedTests: kalkuliraniTestovi
        });

        document.getElementById(event.target.id).className = "btn btn-info btn-micro";
      }
    },
    izbaciTest: function izbaciTest(event, disable) {

      if (disable != undefined && disable) {
        this.toastText = "Test nije moguće ukloniti!";
        this.toastIcon = "fa-warning";
        this.toastPosition = "top-right";
        this.className = "vuestic-toast-warning";

        this.showToast(this.toastText, {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration,
          fullWidth: this.isToastFullWidth,
          className: this.className
        });
      } else {

        if (this.testovi.length < 2) {
          this.toastText = "Test nije moguće ukloniti! Zatvorite prozor i obrišite uzorak.";
          this.toastIcon = "fa-warning";
          this.toastPosition = "top-right";
          this.className = "vuestic-toast-warning";

          this.showToast(this.toastText, {
            icon: this.toastIcon,
            position: this.toastPosition,
            duration: this.toastDuration,
            fullWidth: this.isToastFullWidth,
            className: this.className
          });
        } else {
          var alert = false;
          var izbaciti = event.target.getAttribute("name");
          var count = 0;

          this.testovi.forEach(function (element) {
            if (element.calculated) {
              element.calculatedTests.forEach(function (kalk) {
                if (izbaciti === kalk.labassay) {
                  count++;
                }
              });
            }
          });

          if (count > 0) {
            alert = false;
            this.toastText = "Test nije moguće ukloniti!";
            this.toastIcon = "fa-warning";
            this.toastPosition = "top-right";
            this.className = "vuestic-toast-warning";

            this.showToast(this.toastText, {
              icon: this.toastIcon,
              position: this.toastPosition,
              duration: this.toastDuration,
              fullWidth: this.isToastFullWidth,
              className: this.className
            });
          } else {
            alert = true;
          }

          if (alert) {
            if (this.testovi.length < 2) {
              this.placeholder = "Izaberite testove";
            }
            this.test = event.target.innerText;
            for (var i = 0; i < this.testovi.length; i++) {
              if (this.testovi[i].labassay === event.target.getAttribute("name")) {
                this.testovi.splice(i, 1);
                break;
              }
            }
            if (event.target.className === "btn btn-primary btn-micro") {
              document.getElementById(event.target.getAttribute("name")).className = "btn btn-primary btn-micro";
            }
            if (event.target.className === "btn btn-secondary btn-micro") {
              document.getElementById(event.target.getAttribute("name")).className = "btn btn-secondary btn-micro";
            }
            if (event.target.className === "btn btn-warning btn-micro") {
              document.getElementById(event.target.getAttribute("name")).className = "btn btn-warning btn-micro";
            }
          }
        }
      }
    },

    klasaTesta: function klasaTesta(naziv, manual, calculated) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__funkcije_shared_samples_js__["sampleSelection"])(this.$store.state.site, naziv, "", "", "", "", manual, calculated);
    },
    showTest: function showTest(site, analit, godina, spol, drstanje, menopauza, manual, calculated) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__funkcije_shared_samples_js__["sampleSelection"])(site, analit, godina, spol, drstanje, menopauza, manual, calculated);
    }
  }
});

/***/ }),

/***/ "stge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseObrada_vue__ = __webpack_require__("ugiO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61cc9b49_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseObrada_vue__ = __webpack_require__("vRnW");
function injectStyle (ssrContext) {
  __webpack_require__("MjgR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61cc9b49"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapseObrada_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61cc9b49_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapseObrada_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "szBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-accordion-patient-info",
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastClickedTab: {}
    };
  },
  provide: function provide() {
    var _this = this;

    return {
      accordion: {
        onChildChange: function onChildChange(child, state) {
          return _this.onChildChange(child, state);
        }
      }
    };
  },

  methods: {
    onChildChange: function onChildChange(child, state) {
      if (this.expand) {
        return;
      }

      if (state === false) {
        return;
      }

      this.$children.forEach(function (collapse) {
        if (collapse === child) {
          return;
        }
        collapse.collapse();
      });
    }
  }
});

/***/ }),

/***/ "t4Qc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-profile-card d-flex flex-column align-items-center"},[_c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.photoSource}})]),_vm._v(" "),_c('h5',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('span',{staticClass:"location"},[_c('span',{staticClass:"icon glyphicon glyphicon-map-marker"}),_vm._v(" "+_vm._s(_vm.location))]),_vm._v(" "),_c('div',{staticClass:"social"},[(_vm.social.facebook)?_c('a',{staticClass:"icon brandico brandico-facebook-rect",attrs:{"href":'http://' + _vm.social.facebook,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.social.instagram)?_c('a',{staticClass:"icon brandico brandico-instagram",attrs:{"href":'http://' + _vm.social.instagram,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.social.twitter)?_c('a',{staticClass:"icon brandico brandico-twitter",attrs:{"href":'http://' + _vm.social.twitter,"target":"_blank"}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tO3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radar-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.circlesStyles),function(cs,index){return _c('div',{key:index,staticClass:"circle",style:(cs)},[_c('div',{staticClass:"circle-inner-container",style:(_vm.circleInnerContainerStyle)},[_c('div',{staticClass:"circle-inner",style:(_vm.circleInnerStyle)})])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tZ2u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__ = __webpack_require__("otT+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fc1e62a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__ = __webpack_require__("7uax");
function injectStyle (ssrContext) {
  __webpack_require__("YtSv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fc1e62a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tb/+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tcEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FulfillingBouncingCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        borderWidth: this.size * 0.03 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleStyle: function circleStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        color: this.color,
        borderWidth: this.size * 0.1 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "tdfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{'vuestic-collapse__header--no-header': _vm.noHeader},on:{"click":function($event){_vm.emitHeader($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{class:{'vuestic-collapse__header__button btn btn-primary' : true}},[_vm._t("header")],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tflt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tgT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-chart"},[(_vm.type === 'pie')?_c('pie-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'donut')?_c('donut-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'bubble')?_c('bubble-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'line')?_c('line-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'horizontal-bar')?_c('horizontal-bar-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'vertical-bar')?_c('vertical-bar-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tj1/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u1r+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-switch',
  props: {
    value: Boolean
  },
  mounted: function mounted() {
    this.$emit('input', this.value);
  },

  methods: {
    setValue: function setValue(newVal) {
      this.$emit('input', newVal);
      if (newVal === true) {
        __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('odobren', newVal);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('neodobren', newVal);
      }
    }
  }
});

/***/ }),

/***/ "u983":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalSamplesEntryCommenting_vue__ = __webpack_require__("Qe9Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_578a7777_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalSamplesEntryCommenting_vue__ = __webpack_require__("b2iP");
function injectStyle (ssrContext) {
  __webpack_require__("WubP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalSamplesEntryCommenting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_578a7777_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalSamplesEntryCommenting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uM+q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      izbor: '',
      izborPrikaz: '',
      izborPrikazTmpSifra: '',
      izborPrikazTmpIme: '',
      izabraniSiteId: '',
      initSiteName: '',
      initSiteNameTmpSifra: '',
      initSiteNameTmpIme: '',
      initSite: [],
      rawSites: [],
      currentSiteID: '',
      allSitesID: [],
      window: {
        width: 0,
        height: 0
      },
      tmpSiteIzbor: ''
    };
  },

  name: 'site-dropdown',

  props: {
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {
    var _this = this;

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    this.currentSiteID = this.$store.state.site;
    __WEBPACK_IMPORTED_MODULE_2__config_config_js__["o" /* http */].post('users/' + this.$store.state.userId, {
      email: this.$store.state.userId,
      token: this.$store.state.token,
      site: this.$store.state.site
    }).then(function (res) {
      if (res.data.message != undefined && res.data.message === 'Niste autorizirani') {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/auth/login');
      }

      if (res.data.user != undefined) {
        _this.allSitesID = res.data.user.sites;
        _this.catchSection();
      }
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      if (this.window.width > 1000) {
        __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit('version', true);
      } else {
        __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit('version', false);
      }

      if (this.window.width > 600) {
        this.izborPrikaz = this.izborPrikazTmpIme;
        this.initSiteName = this.initSiteNameTmpIme;
      } else if (this.window.width <= 600) {
        this.izborPrikaz = this.izborPrikazTmpSifra;
        this.initSiteName = this.initSiteNameTmpSifra;
      }
    },
    isPortrait: function isPortrait() {
      if (window.screen.width < window.screen.height) {
        return true;
      } else {
        return false;
      }
    },
    setSite: function setSite(locale) {
      var _this2 = this;

      this.izbor = locale;
      this.options.forEach(function (element) {
        if (element.sifra === locale) {
          if (_this2.isPortrait()) {
            _this2.izborPrikaz = element.sifra;
            _this2.izabraniSiteId = element.id;
            _this2.izborPrikazTmpSifra = element.sifra;
            _this2.izborPrikazTmpIme = element.name;
          } else {
            _this2.izborPrikaz = element.name;
            _this2.izabraniSiteId = element.id;
            _this2.izborPrikazTmpSifra = element.sifra;
            _this2.izborPrikazTmpIme = element.name;
          }
        }
      });
      this.handleResize();

      this.$store.dispatch('siteChange', this.izabraniSiteId);
      this.$store.dispatch('siteClear');
      var current = this.$router.currentRoute.path;

      if (current.includes('rezultati/verifikacija')) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/rezultati/verifikacija/' + '?site=' + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes('rezultati/pregled')) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/rezultati/pregled/' + '?site=' + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes('nalazi/verifikacija')) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/nalazi/verifikacija/' + '?site=' + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes('nalazi/pregled')) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/nalazi/pregled/' + '?site=' + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes('nalazi/outbox')) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/nalazi/outbox/' + '?site=' + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes('kontrole/pregled')) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/kontrole/pregled/' + '?site=' + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes('kontrole/unos')) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/kontrole/unos/' + '?site=' + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes('kontrole/levey')) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/kontrole/levey/' + '?site=' + this.$store.state.site);
        this.$refs.close.click();
      } else if (current.includes('pacijenti/pregled') || current.includes('pacijenti/detalji')) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/pacijenti/pregled/' + '?site=' + this.$store.state.site);
        this.$refs.close.click();
      } else {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push(current + '?site=' + this.$store.state.site);
        this.$refs.close.click();
      }
    },
    currentSite: function currentSite() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.locale();
    },
    sitePickClass: function sitePickClass(sifra) {
      return 'flag-icon-' + name;
    },

    catchSection: function catchSection() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__config_config_js__["o" /* http */].get('postavke/sajtovi/list?token=' + this.$store.state.token + '&site=' + this.$store.state.site, {}).then(function (res) {
        _this3.rawSites = res.data.sajtovi;
        var tmp = {};
        var tmpAll = {};
        if (_this3.rawSites != undefined) {}

        _this3.rawSites.forEach(function (element) {
          _this3.allSitesID.forEach(function (asite) {
            if (element._id === asite) {
              tmpAll.sifra = element.sifra;
              tmpAll.name = element.naziv;
              tmpAll.id = element._id;
              _this3.options.push(tmpAll);
              tmpAll = {};
            }
          });

          if (element._id === _this3.currentSiteID) {
            tmp.sifra = element.sifra;
            tmp.name = element.naziv;
            tmp.id = element._id;
            if (_this3.isPortrait()) {
              _this3.initSiteName = element.sifra;
              _this3.initSiteNameTmpSifra = element.sifra;
              _this3.initSiteNameTmpIme = element.naziv;
            } else {
              _this3.initSiteName = element.naziv;
              _this3.initSiteNameTmpSifra = element.sifra;
              _this3.initSiteNameTmpIme = element.naziv;
            }
            _this3.initSite.push(tmp);
          }
        });
        _this3.handleResize();
      });
    }
  }
});

/***/ }),

/***/ "uSXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uezS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserList_vue__ = __webpack_require__("ZQsF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_26b8f4d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UserList_vue__ = __webpack_require__("moC5");
function injectStyle (ssrContext) {
  __webpack_require__("3lQg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26b8f4d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UserList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_26b8f4d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UserList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ugiO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-obrada",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    sample: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    noHeader: Boolean
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      expanded: false,
      clientHeight: ""
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    },
    clientHeight: function clientHeight() {}
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("SetClientHeight", function (sid) {
      if (_this.$slots.header[0].elm.id === sid) {
        var bodyContent = _this.$refs.collapseBody;
        _this.clientHeight = _this.$slots.body[0].elm.clientHeight + 5 + "px";
        _this.onHeaderClick();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("SetClientHeight");
  },

  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.clientHeight;
      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;

      this.show = false;
    },
    emitHeader: function emitHeader(event) {
      switch (event.target.id) {
        case "forward":
          this.expanded = true;
          break;
        case "trash":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("trash", this.sample);
          break;
        case "edit":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("edit", this.sample);
          break;
        case "comment":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("comment", this.sample);
          break;
        case "barcode":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("barcode", this.sample);
          break;
        case "backward":
          this.expanded = false;
          break;
        case "save":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("save", this.sample);
          break;
        case "check":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("check", this.sample);
          break;
        case "verify":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("verify", this.sample);
          break;
        case "undo":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("undo", this.sample);
          break;
        case "unlock":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("unlock", this.sample);
          if (!this.show) {
            __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Sample", this.sample);
          } else {}
          break;
        case "pdf":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("pdf", this.sample);
          break;
        case "block":
          break;
        case "":
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Sample", this.sample);
          break;
        default:
          __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Sample", this.sample);
          break;
      }
    },
    onHeaderClick: function onHeaderClick() {
      this.toggle();
      this.accordion.onChildChange(this, this.show);
    },
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v4fJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{on:{"beforeEnter":_vm.beforeEnter,"afterEnter":_vm.afterEnter,"beforeLeave":_vm.beforeLeave,"afterLeave":_vm.afterLeave}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v6Pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__ = __webpack_require__("GB0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13938c0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__ = __webpack_require__("g9jP");
function injectStyle (ssrContext) {
  __webpack_require__("jtO9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13938c0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vE+0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_directives_Dropdown__ = __webpack_require__("OR0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("/7ZL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-simple-select',
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__["default"]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0_directives_Dropdown__["a" /* default */]
  },
  data: function data() {
    return {
      displayValue: '',
      validated: false
    };
  },

  props: {
    label: String,
    options: Array,
    value: {},
    optionKey: String,
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'simple-select'
    }
  },
  mounted: function mounted() {
    this.updateDisplayValue(this.value);
    this.$emit('input', this.value);
  },


  updated: function updated() {
    this.updateDisplayValue(this.value);
  },

  methods: {
    isOptionSelected: function isOptionSelected(option) {
      return this.value === option;
    },
    selectOption: function selectOption(option) {
      this.updateDisplayValue(option);
      this.$emit('input', option);
    },
    updateDisplayValue: function updateDisplayValue(val) {
      this.displayValue = this.optionKey ? val[this.optionKey] : val;
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.displayValue;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.displayValue;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return 'The ' + this.name + ' field is required';
    }
  }
});

/***/ }),

/***/ "vRnW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{'vuestic-collapse__header--no-header': _vm.noHeader},on:{"click":function($event){_vm.emitHeader($event)}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{class:{'vuestic-collapse__header__button btn btn-primary' : _vm.sample.status === 'ODOBREN' || _vm.sample.status === 'VERIFICIRAN', 
      'vuestic-collapse__header__button btn btn-warning': _vm.sample.status === 'U OBRADI',
      'vuestic-collapse__header__button btn btn-danger': _vm.sample.status === 'ZAPRIMLJEN',
      'vuestic-collapse__header__button btn btn-info': _vm.sample.status === 'REALIZOVAN'
    },staticStyle:{"text-transform":"none"}},[_vm._t("header"),_vm._v(" "),(_vm.sample.status === 'VERIFICIRAN')?_c('span',{staticStyle:{"font-size":"12px","color":"#f7cc36"},attrs:{"id":_vm.id}},[_vm._v("\n        "+_vm._s(' | ')+_vm._s(_vm.sample.status)+"\n        "),(false)?_c('i',{staticClass:"fa fa-check"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.sample.status != 'VERIFICIRAN')?_c('span',{staticStyle:{"font-size":"12px"},attrs:{"id":_vm.id}},[_vm._v(_vm._s(' | ')+_vm._s(_vm.sample.status))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-7 pull-right",staticStyle:{"margin-right":"20px"},attrs:{"id":"block"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.expanded && _vm.sample.status != 'ODOBREN' && _vm.sample.status != 'VERIFICIRAN'),expression:"show && !expanded && sample.status != 'ODOBREN' && sample.status != 'VERIFICIRAN'"}]},[_c('i',{staticClass:"fa fa-forward fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"forward","title":"Više opcija"}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && _vm.expanded && _vm.sample.status === 'ZAPRIMLJEN'),expression:"show && expanded && sample.status === 'ZAPRIMLJEN'"}]},[_c('i',{staticClass:"fa fa-trash fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"trash","title":"Brisanje uzorka"}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && _vm.expanded && _vm.sample.status === 'ZAPRIMLJEN'),expression:"show && expanded && sample.status === 'ZAPRIMLJEN'"}],staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && _vm.expanded && _vm.sample.status != 'ODOBREN' && _vm.sample.status != 'VERIFICIRAN'),expression:"show && expanded && sample.status != 'ODOBREN' && sample.status != 'VERIFICIRAN'"}]},[_c('i',{staticClass:"fa fa-edit fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"edit","title":"Uređivanje uzorka"}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && _vm.expanded && _vm.sample.status != 'ODOBREN' && _vm.sample.status != 'VERIFICIRAN'),expression:"show && expanded && sample.status != 'ODOBREN' && sample.status != 'VERIFICIRAN'"}]},[_c('i',{staticClass:"fa fa-commenting fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"comment","title":"Unos komentara"}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && _vm.expanded && _vm.sample.status != 'ODOBREN' && _vm.sample.status != 'VERIFICIRAN'),expression:"show && expanded && sample.status != 'ODOBREN' && sample.status != 'VERIFICIRAN'"}]},[_c('i',{staticClass:"fa fa-barcode fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"barcode","title":"Printanje naljepnice"}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"col-md-3 pull-left",staticStyle:{"diplay":"inline-block","width":"25px"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && _vm.expanded && _vm.sample.status != 'ODOBREN' && _vm.sample.status != 'VERIFICIRAN'),expression:"show && expanded && sample.status != 'ODOBREN' && sample.status != 'VERIFICIRAN'"}]},[_c('i',{staticClass:"fa fa-step-backward fa-lg icon-left wizard-back pull-left",staticStyle:{"font-size":"20px"},attrs:{"id":"backward","title":"Manje opcija"}})]),_vm._v(" "),(_vm.show && _vm.sample.status != 'ODOBREN' && _vm.sample.status != 'VERIFICIRAN')?_c('span',[_c('i',{staticClass:"fa fa-check fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px"},attrs:{"id":"check","title":"Odobrite rezultate"}})]):_vm._e(),_vm._v(" "),(_vm.show && _vm.sample.status === 'ODOBREN')?_c('span',[_c('i',{staticClass:"fa fa-undo fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px"},attrs:{"id":"undo","title":"Uklonite odobrenje"}})]):_vm._e(),_vm._v(" "),(_vm.show && _vm.sample.status === 'VERIFICIRAN' && _vm.sample.pdf_exists)?_c('span',[_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px"},attrs:{"id":"pdf","title":"Prikaz nalaza"}})]):_vm._e(),_vm._v(" "),(!_vm.show && _vm.sample.status === 'VERIFICIRAN' && _vm.sample.pdf_exists)?_c('span',[_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px","color":"#f7cc36"},attrs:{"id":"pdf","title":"Prikaz nalaza"}})]):_vm._e(),_vm._v(" "),(_vm.show && _vm.sample.status === 'VERIFICIRAN' && !_vm.sample.pdf_exists)?_c('span',[_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px","color":"#e34a4a"},attrs:{"id":"pdf","title":"Nije dostupno"}})]):_vm._e(),_vm._v(" "),(!_vm.show && _vm.sample.status === 'VERIFICIRAN' && !_vm.sample.pdf_exists)?_c('span',[_c('i',{staticClass:"fa fa-file-pdf-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px","color":"#e34a4a"},attrs:{"id":"pdf","title":"Nije dostupno"}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"col-md-3 pull-right",staticStyle:{"diplay":"inline-block","width":"25px"}}),_vm._v(" "),(_vm.show && _vm.sample.status === 'ODOBREN')?_c('span',[_c('i',{staticClass:"fa fa-check-square-o fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px","color":"#f7cc36"},attrs:{"id":"verify","title":"Verificirajte rezultate"}})]):_vm._e(),_vm._v(" "),(_vm.show && _vm.sample.status === 'VERIFICIRAN')?_c('span',[_c('i',{staticClass:"fa fa-lock fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"22px"},attrs:{"id":"unlock","title":"Uklonite verifikaciju"}})]):_vm._e(),_vm._v(" "),(!_vm.show && _vm.sample.status === 'VERIFICIRAN')?_c('span',[_c('i',{staticClass:"fa fa-lock fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"22px","color":"#f7cc36"},attrs:{"id":"unlock","title":"Uklonite verifikaciju"}})]):_vm._e(),_vm._v(" "),(_vm.show && _vm.sample.status != 'ODOBREN' && _vm.sample.status != 'VERIFICIRAN')?_c('span',[_c('i',{staticClass:"fa fa-save fa-lg icon-right wizard-back pull-right",staticStyle:{"font-size":"20px"},attrs:{"id":"save","title":"Sačuvajte rezultate"}})]):_vm._e()])],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vTUu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vVNf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vW50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntersectingCirclesSpinner_vue__ = __webpack_require__("TqEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4ddf185e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_IntersectingCirclesSpinner_vue__ = __webpack_require__("W5Tp");
function injectStyle (ssrContext) {
  __webpack_require__("9Hnf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ddf185e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntersectingCirclesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4ddf185e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_IntersectingCirclesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "vYUl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "va7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "vuestic-collapse-nalaz",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    samples: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    lokacija: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    final: {
      type: Boolean,
      default: true
    },
    final_pdf: {
      type: Boolean,
      default: true
    },
    pdf: {
      type: String,
      default: ""
    },
    pacijent: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    noHeader: Boolean
  },
  inject: {
    accordion: {
      default: function _default() {
        return {
          onChildChange: function onChildChange() {}
        };
      }
    }
  },
  data: function data() {
    return {
      show: this.value,
      clientHeight: ""
    };
  },

  watch: {
    show: function show(_show) {
      if (_show) {
        this.expand();
      } else {
        this.collapse();
      }
    },
    clientHeight: function clientHeight() {}
  },
  methods: {
    expand: function expand() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = this.clientHeight;
      this.show = true;
    },
    collapse: function collapse() {
      var bodyContent = this.$refs.collapseBody;
      bodyContent.style.height = 0;
      this.show = false;
    },
    emitHeader: function emitHeader(event) {
      var data = {};
      data.samples = this.samples;
      data.pdf = this.pdf;
      data.final = this.final;
      data.final_pdf = this.final_pdf;
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit("Nalaz", data);
    },
    onHeaderClick: function onHeaderClick() {
      this.toggle();
      this.accordion.onChildChange(this, this.show);
    },
    toggle: function toggle() {
      this.show ? this.collapse() : this.expand();
    }
  }
});

/***/ }),

/***/ "vbMg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),(_vm.closeIconShown)?_c('i',{staticClass:"ion ion-md-close close-modal",on:{"click":function($event){$event.preventDefault();_vm.cancel($event)}}}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default"),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('vuestic-date-picker',{attrs:{"id":"date-picker-time","config":_vm.config},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"date-picker-range"}},[_vm._v(_vm._s('Datum i vrijeme'))])],1)])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[(!_vm.noButtons)?_c('button',{class:_vm.cancelClass,attrs:{"type":"button","disabled":_vm.cancelDisabled},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]):_vm._e(),_vm._v(" "),(!_vm.noButtons)?_c('button',{class:_vm.okClass,attrs:{"type":"button","disabled":_vm.okDisabled},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w+sz":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "wEYn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-3 pull-left"},[_c('filter-bar',{on:{"filter":_vm.onFilterSet}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-secondary-danger btn-micro pull-right",attrs:{"title":"Unos novog pacijenta"},on:{"click":function($event){$event.preventDefault();_vm.unosPacijenta($event)}}},[_c('span',{staticClass:"fa fa-user"}),_vm._v("\n          "+_vm._s(' Novi pacijent')+"\n        ")])])]),_vm._v(" "),_c('vuestic-modal-patient',{ref:"largeModalPatient",attrs:{"show":_vm.show,"medium":true,"okText":_vm.potvrdi,"cancelText":_vm.odustani},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s('Unos pacijenta'))]),_vm._v(" "),_c('div',{staticClass:"form-elements"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"})])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('vuetable',{ref:"vuetable",attrs:{"apiUrl":_vm.apiUrl,"apiMode":_vm.apiMode,"fields":_vm.tableFields,"data":_vm.tableData,"dataTotal":_vm.dataCount,"dataManager":_vm.dataManager,"css":_vm.css.table,"data-path":"data","paginationPath":_vm.paginationPath,"appendParams":_vm.moreParams,"perPage":_vm.brStr,"datum":_vm.perPage,"token":_vm.token,"site":_vm.site},on:{"vuetable:cell-clicked":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return this$1.prikaziDetaljeM([args]);
},"vuetable:pagination-data":_vm.onPaginationData}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-4"},[_c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"onEachSide":_vm.onEachSide},on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[(_vm.prikazi)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("\n            "+_vm._s(_vm.header)+"\n            "),_c('span',{staticStyle:{"color":"#e34a4a"}},[_vm._v(_vm._s(_vm.ime)+" "+_vm._s(_vm.prezime))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('vuestic-simple-select',{ref:"izvorSelect",attrs:{"label":"Izvor identifikacije","name":"izvor","required":true,"title":" ","options":_vm.izvori},model:{value:(_vm.izvor),callback:function ($$v) {_vm.izvor=$$v},expression:"izvor"}}),_vm._v(" "),_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jmbg),expression:"jmbg"}],attrs:{"id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.jmbg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.jmbg=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s('JMBG pacijenta'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ime),expression:"ime"}],attrs:{"id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.ime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ime=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s('Ime pacijenta'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prezime),expression:"prezime"}],attrs:{"id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.prezime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prezime=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s('Prezime pacijenta'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('vuestic-simple-select',{ref:"spolSelect",attrs:{"label":"Spol pacijenta","name":"spol","required":true,"title":" ","options":_vm.spolovi},model:{value:(_vm.spol),callback:function ($$v) {_vm.spol=$$v},expression:"spol"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('vuestic-simple-select',{ref:"adresaSelect",attrs:{"label":"Mjesto stanovanja","name":"adresa","required":true,"title":" ","options":_vm.citiesList},model:{value:(_vm.adresa),callback:function ($$v) {_vm.adresa=$$v},expression:"adresa"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('vuestic-simple-select',{ref:"duhanSelect",attrs:{"label":"Konzumira duhan","name":"duhan","title":" ","options":_vm.duhani},model:{value:(_vm.duhan),callback:function ($$v) {_vm.duhan=$$v},expression:"duhan"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('vuestic-simple-select',{ref:"dijabetesSelect",attrs:{"label":"Dijabetes","name":"dijabetes","title":" ","options":_vm.dijabetesi},model:{value:(_vm.dijabetes),callback:function ($$v) {_vm.dijabetes=$$v},expression:"dijabetes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telefon),expression:"telefon"}],attrs:{"id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.telefon)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telefon=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s('Kontakt telefon'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"id":"input-icon-left","title":" ","name":"input-icon-left","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil icon-left input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s('Email adresa'))]),_vm._v(" "),_c('i',{staticClass:"bar"})])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"disabled":_vm.edit},on:{"click":function($event){$event.preventDefault();_vm.sacuvaj($event)}}},[_c('span',{staticClass:"fa fa-save"}),_vm._v("\n              "+_vm._s(' Sačuvaj')+"\n            ")])])])]):_vm._e(),_vm._v(" "),(false)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped first-td-padding"},[_c('tbody',[_c('tr',[(this.$store.state.site != '5bd40c16020d6d21bbaf610c')?_c('td',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit === false),expression:"edit === false"}]},[_c('label',[_c('strong',[_vm._v(_vm._s(_vm.duhan))])])]),_vm._v(" "),_c('select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit === true),expression:"edit === true"},{name:"model",rawName:"v-model",value:(_vm.duhan),expression:"duhan"}],staticClass:"table-info",staticStyle:{"width":"100%"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.duhan=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"NE"}},[_vm._v("NE")]),_vm._v(" "),_c('option',{attrs:{"value":"NEPOZNATO"}},[_vm._v("NEPOZNATO")]),_vm._v(" "),_c('option',{attrs:{"value":"DA"}},[_vm._v("DA")])])]):_vm._e(),_vm._v(" "),(this.$store.state.site != '5bd40c16020d6d21bbaf610c')?_c('td',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit === false),expression:"edit === false"}]},[_c('label',[_c('strong',[_vm._v(_vm._s(_vm.dijabetes))])])]),_vm._v(" "),_c('select',{directives:[{name:"show",rawName:"v-show",value:(_vm.edit === true),expression:"edit === true"},{name:"model",rawName:"v-model",value:(_vm.dijabetes),expression:"dijabetes"}],staticClass:"table-info",staticStyle:{"width":"100%"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dijabetes=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"NE"}},[_vm._v("NE")]),_vm._v(" "),_c('option',{attrs:{"value":"NEPOZNATO"}},[_vm._v("NEPOZNATO")]),_vm._v(" "),_c('option',{attrs:{"value":"DA"}},[_vm._v("DA")])])]):_vm._e(),_vm._v(" "),_c('td',[(_vm.uredi)?_c('button',{staticClass:"btn btn-micro btn-info",attrs:{"title":_vm._f("translate")('pacijenti.pregled.detalji.trnslr014')},on:{"click":function($event){$event.preventDefault();_vm.Edit($event)}}},[_c('span',{staticClass:"glyphicon glyphicon-edit"}),_vm._v("\n                  "+_vm._s('')+"\n                ")]):_vm._e(),_vm._v(" "),(!_vm.uredi)?_c('button',{staticClass:"btn btn-micro btn-secondary",attrs:{"title":_vm._f("translate")('pacijenti.pregled.detalji.trnslr015')},on:{"click":function($event){$event.preventDefault();_vm.sacuvaj($event)}}},[_c('span',{staticClass:"fa fa-save"}),_vm._v("\n                  "+_vm._s('')+"\n                ")]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.prikazi)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('hr'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.prikazi = false}}},[_vm._v(_vm._s('Sakrij detalje pacijenta'))])])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wK+U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wXxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vuesticScrollbar",staticClass:"vuestic-scrollbar"},[_c('div',{ref:"scrollbarWrapper",staticClass:"scrollbar-wrapper"},[_c('div',{ref:"scrollbarContent",staticClass:"scrollbar-content",on:{"wheel":_vm.scroll,"touchstart":_vm.startDrag,"touchmove":_vm.onDrag,"touchend":_vm.stopDrag,"transitionend":_vm.onContentResize}},[_vm._t("default")],2),_vm._v(" "),_c('div',{ref:"track",staticClass:"track"},[_c('div',{ref:"thumb",staticClass:"thumb"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wcXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps simple-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ width: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-line completed-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-indicator"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wf/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPopover_vue__ = __webpack_require__("AWw/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc71202a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPopover_vue__ = __webpack_require__("jgw1");
function injectStyle (ssrContext) {
  __webpack_require__("XxK+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc71202a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPopover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc71202a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPopover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "whi/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_medium_editor__ = __webpack_require__("kLCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_medium_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_medium_editor__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-medium-editor',

  props: {
    editorOptions: {
      type: Object,
      default: function _default() {
        return {
          buttonLabels: 'fontawesome',
          autoLink: true,
          toolbar: {
            buttons: ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3']
          }
        };
      }
    }
  },

  data: function data() {
    return {
      editor: null
    };
  },
  mounted: function mounted() {
    this.initEditor();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyEditor();
  },


  methods: {
    initEditor: function initEditor() {
      this.editor = new __WEBPACK_IMPORTED_MODULE_0_medium_editor___default.a(this.$el, this.editorOptions);
      this.$emit('initialized', this.editor);
    },
    destroyEditor: function destroyEditor() {
      this.editor.destroy();
    }
  }
});

/***/ }),

/***/ "wxA5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wxRo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize"}],class:_vm.classObject},[_c('navbar'),_vm._v(" "),_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"content-wrap",attrs:{"id":"content-wrap"}},[_c('main',{staticClass:"content",attrs:{"id":"content","role":"main"}},[_c('vuestic-pre-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],ref:"preLoader",staticClass:"pre-loader"}),_vm._v(" "),_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],key:_vm.$route.fullPath})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wyO6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MessageList_vue__ = __webpack_require__("+N1L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MessageList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MessageList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3a818929_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MessageList_vue__ = __webpack_require__("9mWQ");
function injectStyle (ssrContext) {
  __webpack_require__("y5Fs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a818929"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MessageList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3a818929_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_MessageList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "x2GM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var browser = __webpack_require__("bJUU");
var erd = __webpack_require__("uk2G")();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-scrollbar',
  props: {
    speed: {
      default: 20
    }
  },
  methods: {
    calcSize: function calcSize() {
      this.isDown = this.isUp = false;
      this.maxHeight = parseFloat(this.wrapper.offsetHeight, 10);
      this.contentHeight = parseFloat(this.content.offsetHeight, 10);
      this.trackHeight = parseFloat(this.track.offsetHeight, 10);

      if (this.maxHeight / this.contentHeight * this.trackHeight < 10) {
        this.thumb.style.height = 10 + 'px';
      } else {
        this.thumb.style.height = this.maxHeight / this.contentHeight * this.trackHeight + 'px';
      }

      if (this.maxHeight / this.contentHeight < 1) {
        this.thumb.classList.add('active');
      } else {
        this.thumb.classList.remove('active');
      }
    },
    calcThumb: function calcThumb() {
      var currentMT = this.content.style.marginTop === '' ? 0 : parseInt(this.content.style.marginTop, 10);
      this.thumb.style.top = -currentMT / this.contentHeight * this.trackHeight + 'px';
    },
    onContentResize: function onContentResize() {
      var _this = this;

      var prevHeight = this.contentHeight;
      this.calcSize();
      this.calcThumb();

      this.content.style.transition = 'margin-top .3s linear';
      this.thumb.style.transition = 'top .3s linear';
      var handler = function handler(e) {
        if (e.propertyName === 'margin-top') {
          _this.content.style.transition = '';
          _this.calcSize();
          _this.calcThumb();
          _this.content.removeEventListener('transitionend', handler);
          _this.thumb.style.transition = '';
        }
      };
      this.content.addEventListener('transitionend', handler);

      this.setVertical(this.contentHeight - prevHeight);
    },
    startDrag: function startDrag(e) {
      this.isDragging = true;
      this.prevTouch = e.touches[0];
    },
    onDrag: function onDrag(e) {
      if (this.isDragging) {
        e.preventDefault();
        var touch = e.touches[0];
        var delta = this.prevTouch.clientY - touch.clientY;
        this.setVertical(delta);
        this.prevTouch = touch;
      }
    },
    stopDrag: function stopDrag(e) {
      this.isDragging = false;
    },
    scroll: function scroll(e) {
      var delta = e.deltaY * 0.01 * this.speed;
      if (browser.name === 'firefox') {
        delta *= 10;
      }
      this.setVertical(delta);
      e.preventDefault();
    },
    setVertical: function setVertical(delta) {
      if (this.isDown && delta > 0 || this.isUp && delta < 0 || this.contentHeight <= this.maxHeight) {
        return;
      }
      var currentMT = this.content.style.marginTop === '' ? 0 : parseFloat(this.content.style.marginTop, 10);
      var nextMT = 0;
      if (this.maxHeight - (currentMT - delta) > this.contentHeight && delta > 0) {
        nextMT = this.maxHeight - this.contentHeight;
        this.isDown = true;
      } else {
        this.isDown = false;
        if (currentMT - delta > 0) {
          this.isUp = true;
          nextMT = 0;
        } else {
          nextMT = currentMT - delta;
          this.isUp = false;
        }
      }

      this.content.style.marginTop = nextMT + 'px';
      this.calcThumb();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.track = this.$refs.track;
    this.thumb = this.$refs.thumb;
    this.content = this.$refs.scrollbarContent;
    this.wrapper = this.$refs.scrollbarWrapper;
    this.calcSize();
    this.calcThumb();
    erd.listenTo(this.content, function () {
      _this2.calcSize();
      _this2.calcThumb();
    });
  },
  beforeDestroy: function beforeDestroy() {
    erd.removeAllListeners(this.content);
  },
  data: function data() {
    return {
      wrapper: undefined,
      maxHeight: undefined,
      thumb: undefined,
      track: undefined,
      trackHeight: undefined,
      content: undefined,
      contentHeight: undefined,
      isDown: false,
      isUp: true,
      prevTouch: {},
      isDragging: false
    };
  }
});

/***/ }),

/***/ "x598":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapse_vue__ = __webpack_require__("mbV8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2c7816e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapse_vue__ = __webpack_require__("0jj4");
function injectStyle (ssrContext) {
  __webpack_require__("mBmn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCollapse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2c7816e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCollapse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xAVG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionPatientInfo_vue__ = __webpack_require__("szBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e95bb4f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionPatientInfo_vue__ = __webpack_require__("HMZT");
function injectStyle (ssrContext) {
  __webpack_require__("xO+R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAccordionPatientInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e95bb4f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAccordionPatientInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xBqa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalUzorci_vue__ = __webpack_require__("LEY3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e456e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalUzorci_vue__ = __webpack_require__("Avj+");
function injectStyle (ssrContext) {
  __webpack_require__("XYPe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalUzorci_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e456e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalUzorci_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_layout_Layout__ = __webpack_require__("i/0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_AuthLayout__ = __webpack_require__("v6Pz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__ = __webpack_require__("VAWW");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    var _this = this;

    return {
      logout: setTimeout(function () {
        _this.$store.dispatch('setLogoutTimer', 0);
      }, this.$store.state.idleTime),
      messageStr: '',

      participants: [{
        id: 'user1',
        name: 'Matteo',
        imageUrl: '' }, {
        id: 'user2',
        name: 'Support',
        imageUrl: '' }],
      titleImageUrl: '',
      messageList: [{
        type: 'text',
        author: 'me',
        data: {
          text: 'Say yes!'
        }
      }, {
        type: 'text',
        author: 'user1',
        data: {
          text: 'No.'
        }
      }],
      newMessagesCount: 2,
      isChatOpen: false,
      showTypingIndicator: '',
      colors: {
        header: {
          bg: '#4ae387',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4ae387'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4ae387',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      },
      alwaysScrollToBottom: false };
  },
  onIdle: function onIdle() {
    this.messageStr = 'Sign out';
    this.$store.dispatch('logout');
  },
  onActive: function onActive() {
    this.messageStr = 'Active';
    this.sessionExpiration();
  },

  components: {
    VuesticPreLoader: __WEBPACK_IMPORTED_MODULE_3__components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["default"],
    AuthLayout: __WEBPACK_IMPORTED_MODULE_2__components_layout_AuthLayout__["default"],
    Layout: __WEBPACK_IMPORTED_MODULE_1_components_layout_Layout__["default"]
  },
  computed: {
    isAuth: function isAuth() {
      return this.$route.path.match('auth');
    }
  },
  created: function created() {
    this.$store.dispatch('autoLogin');
  },
  mounted: function mounted() {
    window.addEventListener("beforeunload", this.clearLocalStorage);
  },

  methods: {
    sendMessage: function sendMessage(text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1;
        this.onMessageWasSent({ author: 'support', type: 'text', data: { text: text } });
      }
    },
    onMessageWasSent: function onMessageWasSent(message) {
      this.messageList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.messageList), [message]);
    },
    openChat: function openChat() {
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    closeChat: function closeChat() {
      this.isChatOpen = false;
    },
    clearLocalStorage: function clearLocalStorage(event) {
      if (event.currentTarget.performance.navigation.type == 0 || event.currentTarget.performance.navigation.type == 1) {
        this.$store.dispatch('logout');
      }
      localStorage.removeItem('userId');
      localStorage.removeItem('language');
      localStorage.removeItem('token');
      localStorage.removeItem('site');
      localStorage.removeItem('idleTime');
    },
    sessionExpiration: function sessionExpiration(event) {
      var _this2 = this;

      if (this.$store.state.idleTime != null) {

        if (!this.$route.path.includes('auth')) {
          localStorage.setItem('idleTime', this.$store.state.idleTime);
          clearTimeout(this.logout);

          this.logout = setTimeout(function () {
            _this2.$store.dispatch('setLogoutTimer', 0);
          }, this.$store.state.idleTime);
        }
      }
    }
  }
});

/***/ }),

/***/ "xO+R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xQbh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xS68":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"form-group with-icon-right dropdown select-form-group",class:{'has-error': _vm.hasErrors()}},[_c('div',{staticClass:"input-group dropdown-toggle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayValue),expression:"displayValue"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'has-value': !!_vm.displayValue},attrs:{"readonly":"","name":_vm.name,"required":""},domProps:{"value":(_vm.displayValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.displayValue=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"ion ion-chevron-down icon-right input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v(_vm._s(_vm.showRequiredError()))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('div',{staticClass:"dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.selectOption(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.optionKey ? option[_vm.optionKey] : option))])])}))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xc3+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAfCAMAAACxiD++AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUxpcf///////////////////////////////////////////////////////3EAnbYAAAAOdFJOUwADZ66SoQjEhnS7/gsNGQL7+wAAAKtJREFUKM+F01sOhCAQRNESFV/I/pc70Og0YJfyJbmHhBAbGGYHstw8IPV4EOGOmERYIhGpxyUAJxHSz/xlC+1FxE64qB1yj1ZID7oXsel+63ovnj2JXUXue+hvrcLugL+EdG+9XBG8X+Kl34J3YM1g/egvIvdx5EK691RIz78YEXdnQrst6m6JqemXmNo+D/WJNAyVePZWWL0WdlfB+l+UAQQReaAc65DB/wGsZgzLN0IQWAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "xemH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue__ = __webpack_require__("Wc+Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_34070ea6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmojiMessage_vue__ = __webpack_require__("pGYK");
function injectStyle (ssrContext) {
  __webpack_require__("WuQK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34070ea6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmojiMessage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_34070ea6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmojiMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xrBC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PixelSpinner_vue__ = __webpack_require__("ZoX0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0c4fe16a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PixelSpinner_vue__ = __webpack_require__("DOc2");
function injectStyle (ssrContext) {
  __webpack_require__("SB3Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c4fe16a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PixelSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0c4fe16a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PixelSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "y1+y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Launcher_vue__ = __webpack_require__("YirT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Launcher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Launcher_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_653fadec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Launcher_vue__ = __webpack_require__("9BNn");
function injectStyle (ssrContext) {
  __webpack_require__("p8mx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-653fadec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Launcher_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_653fadec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Launcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "y3Nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-alert',
  computed: {
    alertClass: function alertClass() {
      return {
        'with-close': this.withCloseBtn,
        'alert-success': this.type === 'success',
        'alert-danger': this.type === 'danger',
        'alert-warning': this.type === 'warning',
        'alert-info': this.type === 'info'
      };
    }
  },
  props: {
    type: {
      type: String,
      default: 'success'
    },
    withCloseBtn: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hidden: false
    };
  },

  methods: {
    hide: function hide() {
      this.hidden = true;
    }
  }
});

/***/ }),

/***/ "y5Fs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yDzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kewler__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'animatedValue', 'min', 'max', 'color', 'size', 'isActive'],
  mounted: function mounted() {
    var progressBar = this.$refs.progressBar;
    var progressColor = Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["color"])(this.color);
    var current = progressColor;
    setInterval(function () {
      if (progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30))() !== current()) {
        current = progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30));
      } else {
        current = progressColor;
      }
      progressBar.style.backgroundColor = current();
    }, 500);
  }
});

/***/ }),

/***/ "yJZO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMulti_vue__ = __webpack_require__("FaL3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1daaf309_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMulti_vue__ = __webpack_require__("B/7t");
function injectStyle (ssrContext) {
  __webpack_require__("B7xO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModalMulti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1daaf309_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModalMulti_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ypkI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spring-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spring-spinner-part top",style:(_vm.spinnerPartStyle)},[_c('div',{staticClass:"spring-spinner-rotator",style:(_vm.rotatorStyle)})]),_vm._v(" "),_c('div',{staticClass:"spring-spinner-part bottom",style:(_vm.spinnerPartStyle)},[_c('div',{staticClass:"spring-spinner-rotator",style:(_vm.rotatorStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yuAZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-social-news',
  props: ['news', 'url']
});

/***/ }),

/***/ "z+iQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z3ES":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dateRange",
  data: function data() {
    return {
      datepicker: {
        range: null
      },
      show_datepicker: true,
      config: {
        mode: "range",
        minDate: new Date("2019-02-09"),
        maxDate: new Date(),
        altFormat: "F j, Y",
        dateFormat: "d.m.Y",
        locale: {
          firstDayOfWeek: 1,
          rangeSeparator: " do ",
          weekdays: {
            shorthand: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
            longhand: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
            longhand: ["Januar‎", "Februar‎", "Mart‎", "April‎", "Maj‎", "Juni‎", "Juli‎", "August‎", "Septembar‎", "Oktobar‎", "Novembar‎", "Decembar‎"]
          }
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("selectedItemsPerPage", function () {
      _this.datepicker = {
        range: null
      };
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$off("selectedItemsPerPage");
    this.$emit("date-range", "", "");
  },


  methods: {
    doSomethingOnChangeDateRange: function doSomethingOnChangeDateRange(input) {
      if (input[1] != undefined) {
        var godina1 = input[0].toString().substring(11, 15);
        var mjesec1 = input[0].toString().substring(4, 7);
        var dan1 = input[0].toString().substring(8, 10);

        var godina2 = input[1].toString().substring(11, 15);
        var mjesec2 = input[1].toString().substring(4, 7);
        var dan2 = input[1].toString().substring(8, 10);

        switch (mjesec1) {
          case "Jan":
            mjesec1 = "01";
            break;
          case "Feb":
            mjesec1 = "02";
            break;
          case "Mar":
            mjesec1 = "03";
            break;
          case "Apr":
            mjesec1 = "04";
            break;
          case "May":
            mjesec1 = "05";
            break;
          case "Jun":
            mjesec1 = "06";
            break;
          case "Jul":
            mjesec1 = "07";
            break;
          case "Aug":
            mjesec1 = "08";
            break;
          case "Sep":
            mjesec1 = "09";
            break;
          case "Oct":
            mjesec1 = "10";
            break;
          case "Nov":
            mjesec1 = "11";
            break;
          case "Dec":
            mjesec1 = "12";
            break;
          default:
            mjesec1 = "00";
            break;
        }

        switch (mjesec2) {
          case "Jan":
            mjesec2 = "01";
            break;
          case "Feb":
            mjesec2 = "02";
            break;
          case "Mar":
            mjesec2 = "03";
            break;
          case "Apr":
            mjesec2 = "04";
            break;
          case "May":
            mjesec2 = "05";
            break;
          case "Jun":
            mjesec2 = "06";
            break;
          case "Jul":
            mjesec2 = "07";
            break;
          case "Aug":
            mjesec2 = "08";
            break;
          case "Sep":
            mjesec2 = "09";
            break;
          case "Oct":
            mjesec2 = "10";
            break;
          case "Nov":
            mjesec2 = "11";
            break;
          case "Dec":
            mjesec2 = "12";
            break;
          default:
            mjesec2 = "00";
            break;
        }

        var datum1 = godina1 + "-" + mjesec1 + "-" + dan1;
        var datum2 = godina2 + "-" + mjesec2 + "-" + dan2;

        this.$emit("date-range", datum1, datum2);
      }
    }
  }
});

/***/ }),

/***/ "z6FP":
/***/ (function(module, exports) {

module.exports = {"auth":{"login":{"Acme":{},"Login":{"trnslr001":"Добродошли!","trnslr002":"Пријава","trnslr003":"Корисничко име","trnslr004":"Шифра","trnslr005":"Грешка приликом конекције на ДБ!","trnslr006":"Корисник није пронађен!","trnslr007":"Унели сте погрешну шифру!"}}},"dashboard":{"data-visualisation-tab":{"DataVisualisation":{"trnslr001":"Статуси узорака","trnslr002":"Статуси резултата","trnslr003":"Нема запримљених узорака.","trnslr004":"Нема пристиглих резултата.","trnslr005":"Запримљен","trnslr006":"У обради","trnslr007":"Реализован","trnslr008":"Обрађен","trnslr009":"Број узорака","trnslr010":"Нема пристиглих резултата.","trnslr011":"Није одобрен","trnslr012":"Одобрен","trnslr013":"Број узорака"}},"features-tab":{"FeaturesTab":{"trnslr001":"Статуси узорака","trnslr002":"Нема запримљених узорака.","trnslr003":"Запримљено","trnslr004":"Обрађено","trnslr005":"Пацијената"}},"Dashboard":{"trnslr001":"Данас","trnslr002":"Задњих 30 дана"},"DashboardInfoWidgets":{"trnslr001":"Данас запримљено узорака","trnslr002":"Комплетирано узорака","trnslr003":"Комплетирано тестова","trnslr004":"Корисника","trnslr005":"Пацијената"}},"kontrole":{"pregled":{"detalji":{},"Levey":{},"Pregled":{}},"unos":{"Unos":{}}},"layout":{"navbar":{"Navbar":{"trnslr001":"одобрен","trnslr002":"реализован","trnslr003":"Промените шифру","trnslr004":"Додајте слику","trnslr005":"Додајте корисника","trnslr006":"Уредите кориснике","trnslr007":"Моје поставке","trnslr008":"Одjава","trnslr009":"Буилд"}},"sidebar":{"Sidebar":{"trnslr001":"Прeглeд","trnslr002":"Пацијeнти","trnslr003":"Унос","trnslr004":"Прeглeд","trnslr038":"Пријeм","trnslr005":"Узорци","trnslr006":"Унос","trnslr007":"Прeглeд","trnslr008":"Рeзултати","trnslr009":"Прeглeд","trnslr010":"Вeрификација","trnslr011":"Налази","trnslr012":"Прeглeд","trnslr013":"Вeрификација","trnslr014":"Одлазна пошта","trnslr015":"Контролe","trnslr016":"Унос","trnslr017":"Прeглeд","trnslr018":"Лeвey - Ј","trnslr019":"Извeштаји","trnslr020":"Општe поставкe","trnslr021":"Локацијe","trnslr022":"Доктори","trnslr023":"Сeкцијe","trnslr024":"Гeнeрално","trnslr025":"Панeли","trnslr026":"Ситeс","trnslr027":"Дeфиниција тeстова","trnslr028":"Лабораторијски тeстови","trnslr029":"Ручни тeстови","trnslr030":"Калкулисани тeстови","trnslr031":"Поставкe апарата","trnslr032":"Апарати","trnslr033":"Тeстови апарата","trnslr034":"Дeфиниција контрола","trnslr035":"Помоћ","trnslr036":"Места","trnslr037":"Предрачун"}},"AuthLayout":{},"Layout":{}},"nalaz":{},"nalazi":{},"pacijenti":{"pregled":{"detalji":{"trnslr001":"Јмбг","trnslr002":"Име","trnslr003":"Презиме","trnslr004":"Спол","trnslr005":"Пушач","trnslr006":"Дијабетес","trnslr007":"Телефон","trnslr008":"Емаил","trnslr009":"Уреди","__comment":"Не преводити...","trnslr010":"MUŠKI","trnslr011":"ŽENSKI","trnslr012":"DA","trnslr013":"NE","comment__":"...Kрај","trnslr014":"Уредите податке о пацијенту","trnslr015":"Сачувајте измене","trnslr016":"Назад","trnslr017":"Преглед детаља за пацијента:","trnslr018":"Вредност поља је обавезна!","trnslr019":"ЈМБГ мора бити валидан 13 цифрени број!","trnslr020":"Емаил адреса није валидна!","trnslr021":"Телефонски број није валидан!","trnslr022":"Спол може бити МУШKИ или ЖЕНСKИ!","trnslr023":"Вредност поља ПУШАЧ може бити ДА или НЕ!","trnslr024":"Вредност поља ДИЈАБЕТЕС може бити ДА или НЕ!","trnslr025":"Пацијент са унесеним ЈМБГ, већ постоји у систему!","trnslr026":"Грешка приликом уписа!","trnslr027":"Унос успешно обављен!","trnslr028":"Место становања"},"PregledPacijenta":{"trnslr001":"Претрага свих пацијената"},"fields-definition":{"trnslr001":"име","trnslr002":"презиме","trnslr007":"prijem","trnslr003":"узорак","trnslr004":"јмбг","trnslr005":"спол","trnslr006":"акција"}},"unos":{"UnosPacijenta":{"trnslr001":"Унос пацијената","trnslr002":"Унесите ЈМБГ пацијента","trnslr003":"Унесите име пацијента","trnslr004":"Унесите презиме пацијента","trnslr005":"Изаберите спол пацијента","trnslr006":"Kонзумира духан","trnslr007":"Дијабетес","trnslr008":"Унесите контакт телефон","trnslr009":"Унесите Емаил адресу","trnslr010":"Сачувај","trnslr011":"Поља ЈМБГ, Име, Презиме и Спол су обавезна!","trnslr012":"ЈМБГ мора бити валидан 13 цифрени број!","trnslr013":"Емаил адреса није валидна!","trnslr014":"Телефонски број није валидан!","trnslr015":"Пацијент већ постоји!","trnslr016":"Грешка приликом уписа!","trnslr017":"Унос успешно обављен!","trnslr018":"Место становања пацијента"}}},"pomoc":{"Pomoc":{"trnslr001":"Помоћ при кориштењу апликацијe","trnslr002":"Пријава инцидента","trnslr003":"Преглед инцидената","trnslr004":"Захтев за надоградњом","trnslr005":"Преглед захтева","trnslr006":"Kонтакт","trnslr007":"Kорисник","trnslr008":"Време","trnslr009":"Унесите назив","trnslr010":"Изаберите приоритет","trnslr011":"Опишите инцидент","trnslr012":"Изаберите локацију","trnslr013":"Изаберите статус","trnslr014":"Назив","trnslr015":"Приоритет","trnslr016":"Cтатус","trnslr017":"Нема доступних података.","trnslr018":"Унесите захтев","trnslr019":"Kонтактирајте нас","trnslr020":"Прималац","trnslr021":"Унесите контакт телефон","trnslr022":"Унесите поруку","trnslr023":"АП Солутионс д.о.о.","trnslr024":"Опишите инцидент!","trnslr025":"Унесите назив!","trnslr026":"Грешка приликом уписа!","trnslr027":"Унос успешно обављен!","trnslr028":"Унесите захтев!","trnslr029":"Унесите назив!","trnslr030":"Грешка приликом уписа!","trnslr031":"Уредите податке","trnslr032":"Унесите телефонски број!","trnslr033":"Телефонски број није валидан!","trnslr034":"Грешка приликом слања поруке!","trnslr035":"Порука успешно послана!","trnslr036":"Изборник","trnslr037":"Сачувајте измене","trnslr038":"Сачувај","trnslr039":"Пошаљи","trnslr040":"Унесите поруку!","trnslr041":"Уреди"}},"postavke":{"user":{"chpwd":{"trnslr001":"Промена шифре","trnslr002":"Унесите тренутну шифру","trnslr003":"Унесите нову шифру","trnslr004":"Потврдите нову шифру","trnslr005":"Сачувај","trnslr006":"Сва поља су обавезна!","trnslr007":"Шифра није валидна!","trnslr008":"Нова шифра није валидирана!","trnslr009":"Грешка приликом уписа!","trnslr010":"Тренутна шифра није исправна!","trnslr011":"Измена успешно обављена!"},"avatar":{"trnslr001":"Измена слике","trnslr002":"Додавање слике","trnslr003":"Изабери","trnslr004":"Сачувај","trnslr005":"Грешка приликом измене!","trnslr006":"Измена успешно обављена!"},"newUser":{"trnslr001":"Додавање корисника","trnslr002":"Унесите име","trnslr003":"Унесите презиме","trnslr004":"Унесите корисничко име","trnslr005":"Унесите шифру","trnslr006":"Врста корисничког рачуна","trnslr007":"Изаберите сајтове","trnslr008":"Сајт корисника","trnslr009":"Сачувај","trnslr010":"Корисничко име није валидно!","trnslr011":"Сва поља су обавезна!","trnslr012":"Шифра није валидна!","trnslr013":"Грешка приликом уписа!","trnslr014":"Унос успешно обављен!","trnslr015":"Корисник већ постоји!"},"edit":{"trnslr001":"Уређивање корисника","trnslr002":"Име","trnslr003":"Презиме","trnslr004":"Емаил","trnslr005":"Улога","trnslr006":"Уреди","trnslr007":"Акција","trnslr008":"Уредите податке","trnslr009":"Сачувајте измене","trnslr010":"Грешка приликом уписа!","trnslr011":"Измена успешно обављена!","trnslr012":"Јесте ли сигурни да желите обрисати запис?","trnslr013":"Да","trnslr014":"Грешка приликом брисања!","trnslr015":"Запис успешно обрисан!","trnslr016":"Брисање записа","trnslr017":"Избриши","trnslr018":"Унесите \"Да\" за наставак","trnslr019":"Одустани","trnslr020":"Настави"},"settings":{"trnslr001":"Поставке приказа","trnslr002":"Картични приказ резултата тестова","trnslr003":"Поставке језика","trnslr004":"Босански језик","trnslr005":"Хрватски језик","trnslr006":"Српски језик","trnslr007":"Енглески језик","trnslr008":"Грешка приликом уписа!","trnslr009":"Измена успешно обављена!","trnslr010":"10 минута","trnslr011":"30 минута","trnslr012":"120 минута","trnslr013":"480 минута","trnslr014":"Аутоматска одјава у случају неактивности"}}},"reports":{},"rezultati":{},"uzorci":{},"vuestic-components":{"trnslr001":"Претрага"}}

/***/ }),

/***/ "zCGx":
/***/ (function(module, exports) {

module.exports = {"auth":{"login":{"Acme":{},"Login":{"trnslr001":"Dobrodošli!","trnslr002":"Prijava","trnslr003":"Korisničko ime","trnslr004":"Šifra","trnslr005":"Greška prilikom konekcije na DB!","trnslr006":"Korisnik nije pronađen!","trnslr007":"Unijeli ste pogrešnu šifru!"}}},"dashboard":{"data-visualisation-tab":{"DataVisualisation":{"trnslr001":"Statusi uzoraka","trnslr002":"Statusi rezultata","trnslr003":"Nema zaprimljenih uzoraka.","trnslr004":"Nema pristiglih rezultata.","trnslr005":"Zaprimljen","trnslr006":"U obradi","trnslr007":"Realizovan","trnslr008":"Obrađen","trnslr009":"Broj uzoraka","trnslr010":"Nema pristiglih rezultata.","trnslr011":"Nije odobren","trnslr012":"Odobren","trnslr013":"Broj uzoraka"}},"features-tab":{"FeaturesTab":{"trnslr001":"Statusi uzoraka","trnslr002":"Nema zaprimljenih uzoraka.","trnslr003":"Zaprimljeno","trnslr004":"Obrađeno","trnslr005":"Pacijenata"}},"Dashboard":{"trnslr001":"Danas","trnslr002":"Zadnjih 30 dana"},"DashboardInfoWidgets":{"trnslr001":"Danas zaprimljeno uzoraka","trnslr002":"Kompletirano uzoraka","trnslr003":"Kompletirano testova","trnslr004":"Korisnika","trnslr005":"Pacijenata"}},"kontrole":{"pregled":{"detalji":{},"Levey":{},"Pregled":{}},"unos":{"Unos":{}}},"layout":{"navbar":{"Navbar":{"trnslr001":"odobren","trnslr002":"realizovan","trnslr003":"Promijenite šifru","trnslr004":"Dodajte sliku","trnslr005":"Dodajte korisnika","trnslr006":"Uredite korisnike","trnslr007":"Moje postavke","trnslr008":"Odjava","trnslr009":"Build"}},"sidebar":{"Sidebar":{"trnslr001":"Pregled","trnslr002":"Pacijenti","trnslr003":"Unos","trnslr004":"Pregled","trnslr038":"Prijem","trnslr005":"Uzorci","trnslr006":"Unos","trnslr007":"Pregled","trnslr008":"Rezultati","trnslr009":"Pregled","trnslr010":"Odobravanje","trnslr011":"Nalazi","trnslr012":"Pregled","trnslr013":"Verifikacija","trnslr014":"Odlazna pošta","trnslr015":"Kontrole","trnslr016":"Unos","trnslr017":"Pregled","trnslr018":"Levey - J","trnslr019":"Izvještaji","trnslr020":"Opšte postavke","trnslr021":"Lokacije","trnslr022":"Doktori","trnslr023":"Sekcije","trnslr024":"Generalno","trnslr025":"Paneli","trnslr026":"Sites","trnslr027":"Definicija testova","trnslr028":"Laboratorijski testovi","trnslr029":"Ručni testovi","trnslr030":"Kalkulisani testovi","trnslr031":"Postavke aparata","trnslr032":"Aparati","trnslr033":"Testovi aparata","trnslr034":"Definicija kontrola","trnslr035":"Pomoć","trnslr036":"Mjesta","trnslr037":"Predračun"}},"AuthLayout":{},"Layout":{}},"nalaz":{},"nalazi":{},"pacijenti":{"pregled":{"detalji":{"trnslr001":"Jmbg","trnslr002":"Ime","trnslr003":"Prezime","trnslr004":"Spol","trnslr005":"Pušač","trnslr006":"Dijabetes","trnslr007":"Telefon","trnslr008":"Email","trnslr009":"Uredi","__comment":"Ne prevoditi...","trnslr010":"MUŠKI","trnslr011":"ŽENSKI","trnslr012":"DA","trnslr013":"NE","comment__":"...Kraj","trnslr014":"Uredite podatke o pacijentu","trnslr015":"Sačuvajte izmjene","trnslr016":"Nazad","trnslr017":"Pregled detalja za pacijenta:","trnslr018":"Vrijednost polja je obavezna!","trnslr019":"JMBG mora biti validan 13 cifreni broj!","trnslr020":"Email adresa nije validna!","trnslr021":"Telefonski broj nije validan!","trnslr022":"Spol može biti MUŠKI ili ŽENSKI!","trnslr023":"Vrijednost polja PUŠAČ može biti DA ili NE!","trnslr024":"Vrijednost polja DIJABETES može biti DA ili NE!","trnslr025":"Pacijent sa unesenim JMBG, već postoji u sistemu!","trnslr026":"Greška prilikom upisa!","trnslr027":"Unos uspješno obavljen!","trnslr028":"Mjesto stanovanja"},"PregledPacijenta":{"trnslr001":"Pretraga svih pacijenata"},"fields-definition":{"trnslr001":"ime","trnslr002":"prezime","trnslr007":"prijem","trnslr003":"uzorak","trnslr004":"jmbg","trnslr005":"spol","trnslr006":"akcija"}},"unos":{"UnosPacijenta":{"trnslr001":"Unos pacijenata","trnslr002":"Unesite JMBG pacijenta","trnslr003":"Unesite ime pacijenta","trnslr004":"Unesite prezime pacijenta","trnslr005":"Izaberite spol pacijenta","trnslr006":"Konzumira duhan","trnslr007":"Dijabetes","trnslr008":"Unesite kontakt telefon","trnslr009":"Unesite Email adresu","trnslr010":"Sačuvaj","trnslr011":"Polja JMBG, Ime, Prezime i Spol su obavezna!","trnslr012":"JMBG mora biti validan 13 cifreni broj!","trnslr013":"Email adresa nije validna!","trnslr014":"Telefonski broj nije validan!","trnslr015":"Pacijent već postoji!","trnslr016":"Greška prilikom upisa!","trnslr017":"Unos uspješno obavljen!","trnslr018":"Mjesto stanovanja pacijenta"}}},"pomoc":{"Pomoc":{"trnslr001":"Pomoć pri korištenju aplikacije","trnslr002":"Prijava incidenta","trnslr003":"Pregled incidenata","trnslr004":"Zahtjev za nadogradnjom","trnslr005":"Pregled zahtjeva","trnslr006":"Kontakt","trnslr007":"Korisnik","trnslr008":"Vrijeme","trnslr009":"Unesite naziv","trnslr010":"Izaberite prioritet","trnslr011":"Opišite incident","trnslr012":"Izaberite lokaciju","trnslr013":"Izaberite status","trnslr014":"Naziv","trnslr015":"Prioritet","trnslr016":"Status","trnslr017":"Nema dostupnih podataka.","trnslr018":"Unesite zahtjev","trnslr019":"Kontaktirajte nas","trnslr020":"Primalac","trnslr021":"Unesite kontakt telefon","trnslr022":"Unesite poruku","trnslr023":"AP Solutions d.o.o.","trnslr024":"Opišite incident!","trnslr025":"Unesite naziv!","trnslr026":"Greška prilikom upisa!","trnslr027":"Unos uspješno obavljen!","trnslr028":"Unesite zahtjev!","trnslr029":"Unesite naziv!","trnslr030":"Greška prilikom upisa!","trnslr031":"Uredite podatke","trnslr032":"Unesite telefonski broj!","trnslr033":"Telefonski broj nije validan!","trnslr034":"Greška prilikom slanja poruke!","trnslr035":"Poruka uspješno poslana!","trnslr036":"Izbornik","trnslr037":"Sačuvajte izmjene","trnslr038":"Sačuvaj","trnslr039":"Pošalji","trnslr040":"Unesite poruku!","trnslr041":"Uredi"}},"postavke":{"user":{"chpwd":{"trnslr001":"Promjena šifre","trnslr002":"Unesite trenutnu šifru","trnslr003":"Unesite novu šifru","trnslr004":"Potvrdite novu šifru","trnslr005":"Sačuvaj","trnslr006":"Sva polja su obavezna!","trnslr007":"Šifra nije validna!","trnslr008":"Nova šifra nije validirana!","trnslr009":"Greška prilikom upisa!","trnslr010":"Trenutna šifra nije ispravna!","trnslr011":"Izmjena uspješno obavljena!"},"avatar":{"trnslr001":"Izmjena slike","trnslr002":"Dodavanje slike","trnslr003":"Izaberi","trnslr004":"Sačuvaj","trnslr005":"Greška prilikom izmjene!","trnslr006":"Izmjena uspješno obavljena!"},"newUser":{"trnslr001":"Dodavanje korisnika","trnslr002":"Unesite ime","trnslr003":"Unesite prezime","trnslr004":"Unesite korisničko ime","trnslr005":"Unesite šifru","trnslr006":"Vrsta korisničkog računa","trnslr007":"Izaberite sajtove","trnslr008":"Sajt korisnika","trnslr009":"Sačuvaj","trnslr010":"Korisničko ime nije validno!","trnslr011":"Sva polja su obavezna!","trnslr012":"Šifra nije validna!","trnslr013":"Greška prilikom upisa!","trnslr014":"Unos uspješno obavljen!","trnslr015":"Korisnik već postoji!"},"edit":{"trnslr001":"Uređivanje korisnika","trnslr002":"Ime","trnslr003":"Prezime","trnslr004":"Email","trnslr005":"Uloga","trnslr006":"Uredi","trnslr007":"Akcija","trnslr008":"Uredite podatke","trnslr009":"Sačuvajte izmjene","trnslr010":"Greška prilikom upisa!","trnslr011":"Izmjena uspješno obavljena!","trnslr012":"Jeste li sigurni da želite obrisati zapis?","trnslr013":"Da","trnslr014":"Greška prilikom brisanja!","trnslr015":"Zapis uspješno obrisan!","trnslr016":"Brisanje zapisa","trnslr017":"Izbriši","trnslr018":"Unesite \"Da\" za nastavak","trnslr019":"Odustani","trnslr020":"Nastavi"},"settings":{"trnslr001":"Postavke prikaza","trnslr002":"Kartični prikaz rezultata testova","trnslr003":"Postavke jezika","trnslr004":"Bosanski jezik","trnslr005":"Hrvatski jezik","trnslr006":"Srpski jezik","trnslr007":"Engleski jezik","trnslr008":"Greška prilikom upisa!","trnslr009":"Izmjena uspješno obavljena!","trnslr010":"10 minuta","trnslr011":"30 minuta","trnslr012":"120 minuta","trnslr013":"480 minuta","trnslr014":"Automatska odjava u slučaju neaktivnosti"}}},"reports":{},"rezultati":{},"uzorci":{},"vuestic-components":{"trnslr001":"Pretraga"}}

/***/ }),

/***/ "zFx3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zGUs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config_js__ = __webpack_require__("1wn0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_barcode__ = __webpack_require__("pwxT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_barcode__);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-modal-barcode',
  components: {
    'barcode': __WEBPACK_IMPORTED_MODULE_5__xkeshi_vue_barcode___default.a
  },
  props: {
    transition: {
      type: String,
      default: 'modal'
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: 'SAČUVAJ'
    },
    cancelText: {
      type: String,
      default: 'ZATVORI'
    },
    okClass: {
      type: String,
      default: 'btn btn-primary btn-sm'
    },
    cancelClass: {
      type: String,
      default: 'btn btn-warning btn-sm'
    },
    closeIconShown: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    sid: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      showBarcode: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        'modal-lg': this.large,
        'modal-sm': this.small
      };
    }
  },
  created: function created() {
    if (this.showBarcode) {
      document.body.className += ' modal-open';
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, '');
  },

  watch: {
    showBarcode: function showBarcode(value) {
      if (value) {
        document.body.className += ' modal-open';
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, '');
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === 'Escape') {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit('ok');
      window.removeEventListener('keyup', this.listenKeyUp);
      this.printajBarcode();
    },
    cancel: function cancel() {
      this.$emit('cancel');
      this.showBarcode = false;
      window.removeEventListener('keyup', this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.showBarcode = true;
      window.addEventListener('keyup', this.listenKeyUp);
    },
    close: function close() {
      this.showBarcode = false;
      window.removeEventListener('keyup', this.listenKeyUp);
    },
    printajBarcode: function printajBarcode() {
      var _this = this;

      var link = __WEBPACK_IMPORTED_MODULE_3__config_config_js__["n" /* barcode */] + this.sid + '.png';

      __WEBPACK_IMPORTED_MODULE_3__config_config_js__["o" /* http */].get('uzorci/barcode/' + this.sid + '?token=' + this.$store.state.token + '&site=' + this.$store.state.site, {}).then(function (res) {
        console.log(res.data);

        printEPL(res.data.name + ' ' + res.data.surname, _this.sid, res.data.pacijentRBr, res.data.godiste, res.data.datum, link, res.data.code, _this.$store.state.site);
        _this.showBarcode = false;
      });
    }
  }
});

/***/ }),

/***/ "zfyz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zkRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoopingRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    rhombusSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      rhombusesNum: 3
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize + 'px',
        backgroundColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        left: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delay = -this.animationDuration / 1.5;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.rhombusStyle);

        rhombusesStyles.push(style);
      }

      return rhombusesStyles;
    }
  }
});

/***/ }),

/***/ "zlyx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'pagination': {
    'total': 200,
    'per_page': 50,
    'current_page': 1,
    'last_page': 4,
    'next_page_url': 'https://vuetable.ratiw.net/api/users?per_page=50&page=2',
    'prev_page_url': null,
    'from': 1,
    'to': 50
  },
  'data': [{
    'id': 1,
    'name': 'Noelia O\'Kon',
    'nickname': 'asperiores',
    'email': 'otho.smitham@example.com',
    'birthdate': '1978-06-28 00:00:00',
    'gender': 'F',
    'salary': '13098.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 1,
      'user_id': 1,
      'line1': '0888 Aniyah Locks\nLake Bridie, NJ 51086',
      'line2': 'Cayman Islands',
      'zipcode': '92991-2805',
      'mobile': '1-742-816-9238x848',
      'fax': '(484)438-4697x8638'
    }
  }, {
    'id': 2,
    'name': 'Mr. Enid Von PhD',
    'nickname': 'alias',
    'email': 'pollich.cecilia@example.com',
    'birthdate': '1990-09-18 00:00:00',
    'gender': 'M',
    'salary': '35978.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 26,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 2,
      'user_id': 2,
      'line1': '59732 Iva Spur Suite 468\nEast Hortenseton, VA 70087',
      'line2': 'Cayman Islands',
      'zipcode': '41967',
      'mobile': '1-913-407-7558x503',
      'fax': '(388)906-8002'
    }
  }, {
    'id': 3,
    'name': 'Colton Koch',
    'nickname': 'id',
    'email': 'little.myrna@example.net',
    'birthdate': '1968-10-29 00:00:00',
    'gender': 'F',
    'salary': '26278.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 3,
      'user_id': 3,
      'line1': '539 Conn Locks Suite 801\nTobinfort, IL 37047-5508',
      'line2': 'Antigua and Barbuda',
      'zipcode': '51722-4502',
      'mobile': '557.845.1830x844',
      'fax': '1-831-304-7444x73027'
    }
  }, {
    'id': 4,
    'name': 'Gregory Vandervort',
    'nickname': 'vel',
    'email': 'dock47@example.org',
    'birthdate': '1989-12-12 00:00:00',
    'gender': 'M',
    'salary': '25537.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 4,
      'user_id': 4,
      'line1': '916 Rosemary Forge\nKreigerton, MT 24207',
      'line2': 'Uganda',
      'zipcode': '67639-6707',
      'mobile': '766.431.9121',
      'fax': '(154)336-3674x08451'
    }
  }, {
    'id': 5,
    'name': 'Miss Rahsaan Heaney IV',
    'nickname': 'qui',
    'email': 'ugrady@example.org',
    'birthdate': '1995-11-27 00:00:00',
    'gender': 'F',
    'salary': '49003.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 21,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 5,
      'user_id': 5,
      'line1': '91792 Kertzmann Prairie Apt. 376\nLake Nakiaville, DC 98189',
      'line2': 'Jamaica',
      'zipcode': '10101-1450',
      'mobile': '07507519787',
      'fax': '+24(9)5120507985'
    }
  }, {
    'id': 6,
    'name': 'Ms. Crystel Zemlak IV',
    'nickname': 'reiciendis',
    'email': 'amari.rau@example.com',
    'birthdate': '1968-09-12 00:00:00',
    'gender': 'F',
    'salary': '12383.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 6,
      'user_id': 6,
      'line1': '97650 Scot Haven Apt. 160\nCrawfordmouth, ME 39767-7003',
      'line2': 'Finland',
      'zipcode': '88917',
      'mobile': '1-851-069-9234x9566',
      'fax': '(048)445-4691x33356'
    }
  }, {
    'id': 7,
    'name': 'Nona McDermott',
    'nickname': 'quaerat',
    'email': 'adrien.baumbach@example.org',
    'birthdate': '1985-10-01 00:00:00',
    'gender': 'F',
    'salary': '18512.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 31,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 7,
      'user_id': 7,
      'line1': '4332 Alvina Radial\nPort Darbyville, IA 63357',
      'line2': 'Barbados',
      'zipcode': '79679',
      'mobile': '(736)058-1324',
      'fax': '002.234.8466x49816'
    }
  }, {
    'id': 8,
    'name': 'Miss Genoveva Murazik V',
    'nickname': 'rerum',
    'email': 'ohettinger@example.net',
    'birthdate': '1988-10-19 00:00:00',
    'gender': 'F',
    'salary': '31209.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 28,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 8,
      'user_id': 8,
      'line1': '96418 Ritchie Mall Apt. 215\nLake Jessyca, VT 65970-8256',
      'line2': 'Netherlands Antilles',
      'zipcode': '94649-6628',
      'mobile': '472.825.7183',
      'fax': '400-507-7463'
    }
  }, {
    'id': 9,
    'name': 'Beulah Huels',
    'nickname': 'non',
    'email': 'stefan99@example.com',
    'birthdate': '1963-09-04 00:00:00',
    'gender': 'F',
    'salary': '36920.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 9,
      'user_id': 9,
      'line1': '18890 Carroll Lakes Suite 355\nUptonchester, UT 94878-0739',
      'line2': 'Hong Kong',
      'zipcode': '91204',
      'mobile': '831.652.0832',
      'fax': '(688)788-8947'
    }
  }, {
    'id': 10,
    'name': 'Zoe Klein',
    'nickname': 'ex',
    'email': 'ejacobson@example.org',
    'birthdate': '1990-04-19 00:00:00',
    'gender': 'F',
    'salary': '35616.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 10,
      'user_id': 10,
      'line1': '6721 Nader Summit\nLake Alana, MS 84476',
      'line2': 'Reunion',
      'zipcode': '77124-1459',
      'mobile': '1-129-438-6148',
      'fax': '(913)441-3846'
    }
  }, {
    'id': 11,
    'name': 'Vickie Kiehn',
    'nickname': 'assumenda',
    'email': 'ayost@example.com',
    'birthdate': '1988-04-20 00:00:00',
    'gender': 'F',
    'salary': '30790.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 29,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 11,
      'user_id': 11,
      'line1': '763 McCullough Ville\nNew Thomasstad, HI 64611',
      'line2': 'Oman',
      'zipcode': '00642',
      'mobile': '1-296-172-2126x275',
      'fax': '(559)203-8694'
    }
  }, {
    'id': 12,
    'name': 'Elwyn Herzog',
    'nickname': 'praesentium',
    'email': 'ckassulke@example.net',
    'birthdate': '1990-01-22 00:00:00',
    'gender': 'M',
    'salary': '35785.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 12,
      'user_id': 12,
      'line1': '65641 Baron Spurs Suite 988\nNorth Ivah, IA 92235',
      'line2': 'Nepal',
      'zipcode': '90316-7411',
      'mobile': '064.482.9432x9456',
      'fax': '05936098280'
    }
  }, {
    'id': 13,
    'name': 'Selena Hettinger',
    'nickname': 'et',
    'email': 'bashirian.hyman@example.net',
    'birthdate': '1981-10-01 00:00:00',
    'gender': 'F',
    'salary': '31836.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 35,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 13,
      'user_id': 13,
      'line1': '42272 Stoltenberg Points Suite 006\nLake Dustin, NH 70213-2043',
      'line2': 'Uganda',
      'zipcode': '60996-2982',
      'mobile': '(508)122-5892',
      'fax': '356-682-2023x07379'
    }
  }, {
    'id': 14,
    'name': 'Edwin Beier',
    'nickname': 'eos',
    'email': 'janis71@example.org',
    'birthdate': '1978-10-13 00:00:00',
    'gender': 'M',
    'salary': '11902.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 14,
      'user_id': 14,
      'line1': '362 Trantow Loop Apt. 150\nLake Marafurt, DC 27926',
      'line2': 'Gabon',
      'zipcode': '36943-1099',
      'mobile': '033-386-4972x26066',
      'fax': '1-363-037-1381'
    }
  }, {
    'id': 15,
    'name': 'Lexi Braun MD',
    'nickname': 'autem',
    'email': 'dusty74@example.net',
    'birthdate': '1971-12-07 00:00:00',
    'gender': 'F',
    'salary': '11927.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 45,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 15,
      'user_id': 15,
      'line1': '6737 Schimmel Crossing Suite 720\nShieldsberg, AK 44558',
      'line2': 'Tanzania',
      'zipcode': '75615',
      'mobile': '338.920.3112',
      'fax': '(467)912-6668'
    }
  }, {
    'id': 16,
    'name': 'Jovany Spencer',
    'nickname': 'fugit',
    'email': 'gbogisich@example.org',
    'birthdate': '1974-04-23 00:00:00',
    'gender': 'F',
    'salary': '44686.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 43,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 16,
      'user_id': 16,
      'line1': '97237 Emory Mission\nWelchview, DE 65827-8746',
      'line2': 'Turkmenistan',
      'zipcode': '17948',
      'mobile': '(163)991-1609x963',
      'fax': '104.893.7648'
    }
  }, {
    'id': 17,
    'name': 'Prof. Maci Anderson DVM',
    'nickname': 'dolorem',
    'email': 'btorp@example.com',
    'birthdate': '1988-03-30 00:00:00',
    'gender': 'M',
    'salary': '25055.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 29,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 17,
      'user_id': 17,
      'line1': '7584 Lucinda Mill\nNew Kaitlyn, WV 63380-4289',
      'line2': 'Gibraltar',
      'zipcode': '51150-2800',
      'mobile': '(977)115-7349',
      'fax': '652-788-4860x1180'
    }
  }, {
    'id': 18,
    'name': 'Joel Kulas MD',
    'nickname': 'sed',
    'email': 'phoebe.sauer@example.org',
    'birthdate': '1992-10-26 00:00:00',
    'gender': 'F',
    'salary': '11650.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 18,
      'user_id': 18,
      'line1': '992 Williamson Passage Apt. 910\nBradleyborough, MO 93100-9439',
      'line2': 'Cambodia',
      'zipcode': '20591-3066',
      'mobile': '+64(7)3402369877',
      'fax': '08960801902'
    }
  }, {
    'id': 19,
    'name': 'Mr. Dawson Greenholt',
    'nickname': 'nostrum',
    'email': 'asawayn@example.org',
    'birthdate': '1963-08-23 00:00:00',
    'gender': 'F',
    'salary': '46962.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 19,
      'user_id': 19,
      'line1': '8444 Abraham Isle\nEast Chaunceychester, HI 78625-4417',
      'line2': 'Qatar',
      'zipcode': '47870-8012',
      'mobile': '797-274-3187x45557',
      'fax': '(461)432-8205'
    }
  }, {
    'id': 20,
    'name': 'Prof. Lloyd Green',
    'nickname': 'velit',
    'email': 'laila.hintz@example.org',
    'birthdate': '1970-10-31 00:00:00',
    'gender': 'M',
    'salary': '12928.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 46,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 20,
      'user_id': 20,
      'line1': '89766 O\'Connell Falls\nSouth Kadenshire, NJ 78754-6650',
      'line2': 'Nigeria',
      'zipcode': '37859',
      'mobile': '1-457-536-1138',
      'fax': '+98(5)0101745942'
    }
  }, {
    'id': 21,
    'name': 'Shayna Morar',
    'nickname': 'rerum',
    'email': 'wfay@example.org',
    'birthdate': '1991-01-24 00:00:00',
    'gender': 'F',
    'salary': '22638.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 26,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 21,
      'user_id': 21,
      'line1': '6066 Weissnat Run Apt. 578\nMurazikmouth, SD 62877-3174',
      'line2': 'Brunei Darussalam',
      'zipcode': '69261',
      'mobile': '(487)423-0151x5127',
      'fax': '784-058-9197'
    }
  }, {
    'id': 22,
    'name': 'Krista Schulist',
    'nickname': 'qui',
    'email': 'gregoria.jakubowski@example.com',
    'birthdate': '1974-08-16 00:00:00',
    'gender': 'F',
    'salary': '49345.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 22,
      'user_id': 22,
      'line1': '331 Gerlach Course Suite 090\nKovacekchester, RI 18017',
      'line2': 'Sri Lanka',
      'zipcode': '37165',
      'mobile': '653-487-3061x91119',
      'fax': '370-709-1750'
    }
  }, {
    'id': 23,
    'name': 'Leone Lemke',
    'nickname': 'repellat',
    'email': 'ltorphy@example.com',
    'birthdate': '1975-06-27 00:00:00',
    'gender': 'M',
    'salary': '17560.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 23,
      'user_id': 23,
      'line1': '4371 Ward Village Suite 848\nLake Madalynton, IN 44643',
      'line2': 'Ukraine',
      'zipcode': '71848',
      'mobile': '174-502-0881x50649',
      'fax': '02683328099'
    }
  }, {
    'id': 24,
    'name': 'Dr. Willie Kemmer II',
    'nickname': 'quasi',
    'email': 'ivy51@example.net',
    'birthdate': '1987-04-06 00:00:00',
    'gender': 'F',
    'salary': '35370.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 30,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 24,
      'user_id': 24,
      'line1': '235 Hassie Mountain\nAnikaborough, ID 20678-4354',
      'line2': 'Thailand',
      'zipcode': '94264-9132',
      'mobile': '624.042.8382x12243',
      'fax': '274.716.7226x171'
    }
  }, {
    'id': 25,
    'name': 'Deonte Lebsack',
    'nickname': 'nesciunt',
    'email': 'alisa83@example.net',
    'birthdate': '1993-01-26 00:00:00',
    'gender': 'M',
    'salary': '32725.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 25,
      'user_id': 25,
      'line1': '793 Lakin Haven\nLake Citlalliborough, DE 85031-4862',
      'line2': 'Chad',
      'zipcode': '52396-8822',
      'mobile': '(950)170-8013',
      'fax': '119.675.5485x79062'
    }
  }, {
    'id': 26,
    'name': 'Prof. Shayne Nader',
    'nickname': 'voluptas',
    'email': 'bosco.shaina@example.net',
    'birthdate': '1993-10-26 00:00:00',
    'gender': 'F',
    'salary': '9844.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 23,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 26,
      'user_id': 26,
      'line1': '0330 Smith Mountains\nLorinetown, NY 96547-9723',
      'line2': 'Syrian Arab Republic',
      'zipcode': '85415',
      'mobile': '1-212-704-6685',
      'fax': '516-893-8515'
    }
  }, {
    'id': 27,
    'name': 'Prof. Kennith Kertzmann',
    'nickname': 'alias',
    'email': 'satterfield.jonathan@example.com',
    'birthdate': '1992-01-31 00:00:00',
    'gender': 'F',
    'salary': '41950.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 25,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 27,
      'user_id': 27,
      'line1': '901 Hauck Extensions\nKeaganborough, VA 47392',
      'line2': 'Comoros',
      'zipcode': '54147-7615',
      'mobile': '1-274-179-2031x915',
      'fax': '867-583-0812x6728'
    }
  }, {
    'id': 28,
    'name': 'Miss Meagan O\'Keefe',
    'nickname': 'corporis',
    'email': 'tracy.barrows@example.com',
    'birthdate': '1967-05-04 00:00:00',
    'gender': 'M',
    'salary': '41803.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 50,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 28,
      'user_id': 28,
      'line1': '29077 Avis Isle Apt. 208\nGrahamberg, MI 62485-6694',
      'line2': 'Cocos (Keeling) Islands',
      'zipcode': '56090-7671',
      'mobile': '(718)856-9319x55184',
      'fax': '(777)055-4685x56167'
    }
  }, {
    'id': 29,
    'name': 'Prof. Edward Pagac MD',
    'nickname': 'quia',
    'email': 'gerhard65@example.org',
    'birthdate': '1973-09-22 00:00:00',
    'gender': 'F',
    'salary': '22896.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 43,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 29,
      'user_id': 29,
      'line1': '697 Crona Mall\nPeteville, WA 54497',
      'line2': 'Saudi Arabia',
      'zipcode': '07560-8569',
      'mobile': '788-579-8208',
      'fax': '041-521-9215'
    }
  }, {
    'id': 30,
    'name': 'Samantha Weissnat',
    'nickname': 'est',
    'email': 'crystel66@example.net',
    'birthdate': '1974-07-11 00:00:00',
    'gender': 'M',
    'salary': '18805.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 30,
      'user_id': 30,
      'line1': '79984 Deckow Run\nEast Victoria, UT 33736',
      'line2': 'Lithuania',
      'zipcode': '95964-8864',
      'mobile': '681.200.3099',
      'fax': '(567)652-4322x61475'
    }
  }, {
    'id': 31,
    'name': 'Dr. Gilbert Ward',
    'nickname': 'dolorum',
    'email': 'sandrine06@example.net',
    'birthdate': '1984-08-22 00:00:00',
    'gender': 'F',
    'salary': '16644.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 32,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 31,
      'user_id': 31,
      'line1': '996 Schuppe Glen\nTurcottetown, ID 40821-7190',
      'line2': 'Thailand',
      'zipcode': '09965-7576',
      'mobile': '1-938-263-0257x47178',
      'fax': '1-997-727-3198x4363'
    }
  }, {
    'id': 32,
    'name': 'Mike West',
    'nickname': 'laudantium',
    'email': 'jborer@example.net',
    'birthdate': '1974-11-07 00:00:00',
    'gender': 'M',
    'salary': '35728.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 32,
      'user_id': 32,
      'line1': '69942 Leannon Glen\nEast Mathilde, IL 89584-5633',
      'line2': 'Afghanistan',
      'zipcode': '02041-8706',
      'mobile': '(506)349-9443x7244',
      'fax': '1-357-689-8479x3729'
    }
  }, {
    'id': 33,
    'name': 'Prof. Isabell Cruickshank I',
    'nickname': 'recusandae',
    'email': 'ondricka.lurline@example.org',
    'birthdate': '1982-06-15 00:00:00',
    'gender': 'F',
    'salary': '44574.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 34,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 33,
      'user_id': 33,
      'line1': '875 Logan Summit Suite 033\nJerodport, NY 45166',
      'line2': 'Kiribati',
      'zipcode': '64763',
      'mobile': '1-548-943-8405x460',
      'fax': '+88(4)9493664736'
    }
  }, {
    'id': 34,
    'name': 'Prof. Lonny Rath',
    'nickname': 'nihil',
    'email': 'rfeest@example.net',
    'birthdate': '1969-04-23 00:00:00',
    'gender': 'F',
    'salary': '19949.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 34,
      'user_id': 34,
      'line1': '43006 Gaylord Drives\nCummerataville, MA 14032-6378',
      'line2': 'Georgia',
      'zipcode': '88459',
      'mobile': '(877)526-6771',
      'fax': '(724)630-5418'
    }
  }, {
    'id': 35,
    'name': 'Santina Medhurst MD',
    'nickname': 'suscipit',
    'email': 'ila24@example.net',
    'birthdate': '1965-11-04 00:00:00',
    'gender': 'F',
    'salary': '36323.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 51,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 35,
      'user_id': 35,
      'line1': '47345 Imelda Mission Suite 257\nAllyshire, IA 85430-2783',
      'line2': 'Gambia',
      'zipcode': '26853',
      'mobile': '(441)229-8922',
      'fax': '(789)908-0620x15912'
    }
  }, {
    'id': 36,
    'name': 'Jeff Lehner',
    'nickname': 'quo',
    'email': 'jarred77@example.com',
    'birthdate': '1975-05-18 00:00:00',
    'gender': 'F',
    'salary': '48462.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 36,
      'user_id': 36,
      'line1': '49133 Tremaine Cape Suite 189\nQuitzonview, SC 07967-6920',
      'line2': 'Serbia',
      'zipcode': '96642',
      'mobile': '313.254.8635x06428',
      'fax': '194.681.7297x74202'
    }
  }, {
    'id': 37,
    'name': 'Samanta Pfeffer',
    'nickname': 'officia',
    'email': 'fgoyette@example.net',
    'birthdate': '1974-08-27 00:00:00',
    'gender': 'F',
    'salary': '19601.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 37,
      'user_id': 37,
      'line1': '1313 Verdie Square\nNorth Giovanna, MI 27962',
      'line2': 'Guyana',
      'zipcode': '77776',
      'mobile': '(321)705-8910',
      'fax': '(392)460-5663x665'
    }
  }, {
    'id': 38,
    'name': 'Ofelia Torp',
    'nickname': 'a',
    'email': 'ericka44@example.net',
    'birthdate': '1981-09-01 00:00:00',
    'gender': 'M',
    'salary': '33149.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 35,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 38,
      'user_id': 38,
      'line1': '45335 Albina View\nCharlottefort, AK 57789',
      'line2': 'Afghanistan',
      'zipcode': '54947-9310',
      'mobile': '09097085723',
      'fax': '1-567-446-3094'
    }
  }, {
    'id': 39,
    'name': 'Mrs. Margarete Raynor',
    'nickname': 'quia',
    'email': 'jlegros@example.net',
    'birthdate': '1977-03-12 00:00:00',
    'gender': 'M',
    'salary': '21951.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 40,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 39,
      'user_id': 39,
      'line1': '288 Hamill Knolls\nMaximoburgh, NC 50971',
      'line2': 'Zimbabwe',
      'zipcode': '00474',
      'mobile': '1-165-445-8956x699',
      'fax': '164-395-7526x1304'
    }
  }, {
    'id': 40,
    'name': 'Mr. Brant Howell V',
    'nickname': 'perspiciatis',
    'email': 'franecki.gerald@example.org',
    'birthdate': '1964-03-01 00:00:00',
    'gender': 'M',
    'salary': '41552.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 40,
      'user_id': 40,
      'line1': '3411 Deckow Crossing\nVernonport, MI 32272-8542',
      'line2': 'Bolivia',
      'zipcode': '00960',
      'mobile': '(998)729-9537',
      'fax': '(606)461-9736'
    }
  }, {
    'id': 41,
    'name': 'Reilly Ruecker DVM',
    'nickname': 'ad',
    'email': 'ldeckow@example.net',
    'birthdate': '1975-07-17 00:00:00',
    'gender': 'M',
    'salary': '22709.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 41,
      'user_id': 41,
      'line1': '39181 Runolfsson Pines Apt. 102\nCedrickchester, MD 73430-4755',
      'line2': 'Haiti',
      'zipcode': '08208-7956',
      'mobile': '625-483-9111x773',
      'fax': '196-367-9338'
    }
  }, {
    'id': 42,
    'name': 'Zachery McDermott',
    'nickname': 'molestiae',
    'email': 'gladyce84@example.com',
    'birthdate': '1992-04-17 00:00:00',
    'gender': 'F',
    'salary': '32354.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 25,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 42,
      'user_id': 42,
      'line1': '18735 Quigley Springs\nCarterview, NE 29126-7625',
      'line2': 'Chad',
      'zipcode': '61676-5075',
      'mobile': '172.676.4844x42744',
      'fax': '129.383.7365x233'
    }
  }, {
    'id': 43,
    'name': 'Heloise Kulas',
    'nickname': 'aut',
    'email': 'kessler.helen@example.net',
    'birthdate': '1962-12-11 00:00:00',
    'gender': 'M',
    'salary': '45086.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 54,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 43,
      'user_id': 43,
      'line1': '38208 Dolores Turnpike Apt. 887\nWintheiserton, FL 72054-2578',
      'line2': 'Lithuania',
      'zipcode': '51634-6449',
      'mobile': '1-161-626-3235x57765',
      'fax': '360-278-9045x9316'
    }
  }, {
    'id': 44,
    'name': 'Norma Dibbert',
    'nickname': 'amet',
    'email': 'eudora36@example.net',
    'birthdate': '1971-01-21 00:00:00',
    'gender': 'F',
    'salary': '15661.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 46,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 44,
      'user_id': 44,
      'line1': '15405 Haag Haven Suite 047\nBrakusland, WV 81778',
      'line2': 'British Virgin Islands',
      'zipcode': '56087-0885',
      'mobile': '08227730599',
      'fax': '1-079-566-2337x670'
    }
  }, {
    'id': 45,
    'name': 'Immanuel Auer',
    'nickname': 'quia',
    'email': 'halvorson.theodora@example.org',
    'birthdate': '1978-06-06 00:00:00',
    'gender': 'M',
    'salary': '15862.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 45,
      'user_id': 45,
      'line1': '59888 Dare Ridge\nSouth Annamaeton, CA 94659',
      'line2': 'Mexico',
      'zipcode': '56689-3824',
      'mobile': '523.579.8757x9825',
      'fax': '688.695.5156x073'
    }
  }, {
    'id': 46,
    'name': 'Lamont Borer',
    'nickname': 'expedita',
    'email': 'trantow.neoma@example.com',
    'birthdate': '1992-06-26 00:00:00',
    'gender': 'M',
    'salary': '12544.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 46,
      'user_id': 46,
      'line1': '974 Brannon Circle Suite 674\nSchroedermouth, NM 66911',
      'line2': 'Malawi',
      'zipcode': '74027',
      'mobile': '887.196.2530x875',
      'fax': '220.398.6969'
    }
  }, {
    'id': 47,
    'name': 'Brooke Purdy',
    'nickname': 'cupiditate',
    'email': 'bhermiston@example.net',
    'birthdate': '1966-11-19 00:00:00',
    'gender': 'M',
    'salary': '14457.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 50,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 47,
      'user_id': 47,
      'line1': '916 Durgan Harbor\nWest Tonyborough, MN 08368',
      'line2': 'Serbia',
      'zipcode': '25234',
      'mobile': '(821)777-8137x4048',
      'fax': '(398)917-7496x84537'
    }
  }, {
    'id': 48,
    'name': 'Dr. Leo Dach',
    'nickname': 'et',
    'email': 'camila.ward@example.com',
    'birthdate': '1968-01-11 00:00:00',
    'gender': 'F',
    'salary': '40278.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 49,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 48,
      'user_id': 48,
      'line1': '434 Dariana Terrace\nSouth Brettbury, NC 66080-2445',
      'line2': 'Latvia',
      'zipcode': '81749-2523',
      'mobile': '1-988-628-9566x4627',
      'fax': '916.932.2071x569'
    }
  }, {
    'id': 49,
    'name': 'Krystal Langosh',
    'nickname': 'voluptatum',
    'email': 'pacocha.yesenia@example.org',
    'birthdate': '1983-02-18 00:00:00',
    'gender': 'M',
    'salary': '9305.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 34,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 49,
      'user_id': 49,
      'line1': '012 Josiane Flats Suite 650\nKatelynntown, MD 70053',
      'line2': 'Rwanda',
      'zipcode': '75946-8166',
      'mobile': '(556)620-0323x81232',
      'fax': '1-466-040-3197x6274'
    }
  }, {
    'id': 50,
    'name': 'Florence Greenfelder',
    'nickname': 'odit',
    'email': 'kenyatta.oconnell@example.com',
    'birthdate': '1978-08-20 00:00:00',
    'gender': 'F',
    'salary': '36980.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 50,
      'user_id': 50,
      'line1': '295 Donna Plaza Apt. 186\nHintzview, GA 44706',
      'line2': 'Greenland',
      'zipcode': '03127',
      'mobile': '1-044-098-3635x9446',
      'fax': '1-753-472-6796'
    }
  }]
});

/***/ }),

/***/ "zoLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fulfilling-bouncing-circle-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle",style:(_vm.circleStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit",style:(_vm.orbitStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zt5/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_directives_StickyScroll__ = __webpack_require__("NS1P");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-chat',
  directives: { StickyScroll: __WEBPACK_IMPORTED_MODULE_0_directives_StickyScroll__["a" /* default */] },
  props: {
    value: {
      type: Array,
      default: []
    },
    height: {
      default: '20rem'
    }
  },
  data: function data() {
    return {
      inputMessage: ''
    };
  },

  methods: {
    keyHandler: function keyHandler(event) {
      if (event.keyCode === 13) {
        this.sendMessage();
      }
    },
    sendMessage: function sendMessage() {
      if (this.inputMessage) {
        this.$emit('input', this.value.concat({
          text: this.inputMessage,
          yours: true
        }));
        this.inputMessage = '';
      }
    }
  },
  mounted: function mounted() {
    this.$emit('input', this.value);
  }
});

/***/ }),

/***/ "zvUs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"half-circle-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle circle-1",style:(_vm.circle1Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle-2",style:(_vm.circle2Style)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.cb426722cb551a70f22d.js